import { unref, ref, getCurrentInstance, onMounted, defineComponent, computed, createVNode, watch, withDirectives, Fragment, vShow, Transition, isVNode, createApp, inject, h, onUpdated, Text, Comment, onBeforeUnmount, onUnmounted, Teleport, resolveDirective, reactive, provide, readonly, toRefs, renderSlot, normalizeClass, capitalize, cloneVNode, useAttrs, useSlots, isRef, resolveComponent, mergeProps, watchEffect, onRenderTracked, createTextVNode, openBlock, createBlock, withCtx, normalizeStyle, createElementVNode, createElementBlock, createCommentVNode, renderList, TransitionGroup, toDisplayString, nextTick, withModifiers, toRef } from "vue";
var index$I = /* @__PURE__ */ (() => ':root{--w-color-primary: #2f75ff;--w-color-primary-light-0: rgb(66, 129, 255);--w-color-primary-light-1: rgb(86, 142, 255);--w-color-primary-light-2: rgb(106, 155, 255);--w-color-primary-light-3: rgb(125, 169, 255);--w-color-primary-light-4: rgb(145, 182, 255);--w-color-primary-light-5: rgb(165, 195, 255);--w-color-primary-light-6: rgb(185, 208, 255);--w-color-primary-light-7: rgb(205, 222, 255);--w-color-primary-light-8: rgb(225, 235, 255);--w-color-primary-light-9: rgb(245, 248, 255);--w-color-primary-dark-0: rgb(25, 102, 255);--w-color-primary-dark-1: rgb(4, 88, 255);--w-color-primary-dark-2: rgb(0, 79, 238);--w-color-primary-dark-3: rgb(0, 72, 217);--w-color-primary-dark-4: rgb(0, 65, 196);--w-color-warning-2: #ffda54;--w-color-danger: #eb1e1e;--w-color-danger-5: rgb(255, 112, 112, .5);--w-color-font-1: #333;--w-color-font-2: #666;--w-color-font-3: #999;--w-color-font-4: #ccc;--w-color-font-5: #eee;--w-color-placeholder: #dcdcdc;--w-color-disabled: var(--w-color-font-4);--w-color-font: var(--w-color-font-1);--w-color-border: #e1e1e1;--w-color-border-1: #c1c1c1;--w-color-border-2: #a1a1a1;--w-font-size-1: 12px;--w-font-size-2: 14px;--w-font-size-3: 16px;--w-font-size-4: 18px;--w-font-size-5: 20px;--w-font-size: var(--w-font-size-1);--w-size: 32px;--w-gap: 12px;--w-line-height: 1;--w-padding-x: var(--w-gap);--w-padding-y: 10px;--w-radius: 4px;--w-box-shadow: 0 5px 12px 0px rgba(0, 0, 0, .09), 0 0px 5px rgba(0, 0, 0, .076);--w-transition-time: .25s;--w-transition-slow-time: .5s;--w-transition-quick-time: .2s;--w-cubic-bezier-quick: cubic-bezier(.4, 1, 0, 1);--w-cubic-bezier: cubic-bezier(.01, .7, .53, 1);--w-color-bg: var(--w-color-font-5);--w-switch-width: 25px;--w-switch-height: 12px;--w-switch-valve-color: white;--w-switch-bg-color: var(--w-color-border);--w-switch-valve-box-shadow: 0 0px 5px 0 rgba(0, 0, 0, .3);--w-mask-background-color: rgba(0, 0, 0, .45);--w-tree-item-hover-color: var(--w-color-bg);--w-tree-item-current-color: var(--w-color-primary-light-5);--w-tree-icon-color: #99b8ff;--w-popup-min-width: 420px;--w-popup-min-height: 50px;--w-popup-border-color: transparent;--w-notice-box-shadow: 0 0 15px rgba(0, 0, 0, .1);--w-notice-cubic-bezier: cubic-bezier(.01, .7, .1, 1.2);--w-form-item-width: 180px;--w-form-item-disabled-color: var(--w-color-font-5);--w-form-item-border-color: var(--w-color-border);--w-form-item-border-color-hover: var(--w-color-border-1);--w-form-item-border-color-focus: var(--w-color-primary-light-3);--w-choose-background: white;--w-choose-item-gackground-active: var(--w-color-primary-light-3);--w-fade-white-background-color: rgba(255, 255, 255, .7);--w-fade-black-background-color: rgba(0, 0, 0, .45);--w-sheet-container-border-color: var(--w-color-border);--w-sheet-thead-background-color: #e7ebf4;--w-sheet-tr-background-color: white;--w-sheet-tr-checked-background-color: #fffcda;--w-sheet-tr-highlight-background-color: var(--w-color-primary-light-5);--w-sheet-tr-stripe-color: #fbfcfd;--w-sheet-tr-hover-color: var(--w-color-primary-light-8);--w-sheet-thead-th-border-color: var(--w-color-border);--w-sheet-td-border-color: #f0f2f8;--w-sheet-td-padding: 5px var(--w-gap);--w-sheet-td-narrow-padding: 3px;--w-sheet-tfoot-background-color: white;--w-sheet-tfoot-th-border-color: var(--w-color-font-5);--w-date-picker-panel-width: 260px;--w-date-picker-panel-height: 260px;--w-time-picker-panel-width: var(--w-form-item-width);--w-time-picker-panel-height: 240px;--w-pagination-border-color: var(--w-color-border);--w-pagination-border-hover-color: var(--w-color-primary-light-5);--w-pagination-pager-gap: 5px;--w-radio-icon-gap: calc(var(--w-gap) / 2.5);--w-radio-item-gap: calc(var(--w-gap) + 5px);--w-checkbox-icon-gap: calc(var(--w-gap) / 2.5);--w-checkbox-item-gap: calc(var(--w-gap) + 5px);--w-button-divide-border-color: rgba(255, 255, 255, .5)}*{outline:0;box-sizing:border-box;line-height:1;line-height:var(--w-line-height);font-size:12px;font-size:var(--w-font-size)}*:after,*:before{box-sizing:border-box}.w-display-none{display:none}.w-cursor-pointer{cursor:pointer}.w-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.w-no-select{-webkit-user-select:none;-moz-user-select:none;user-select:none}.w-text-placeholder{color:#dcdcdc;color:var(--w-color-placeholder)}.w-text-primary{color:#2f75ff;color:var(--w-color-primary)}.w-overflow-hidden{overflow:hidden}.w-overflow-auto{overflow:auto}.w-text-1{color:#333;color:var(--w-color-font-1)}.w-text-2{color:#666;color:var(--w-color-font-2)}.w-text-3{color:#999;color:var(--w-color-font-3)}.w-text-4{color:#ccc;color:var(--w-color-font-4)}.w-text-5{color:#eee;color:var(--w-color-font-5)}.w-size-1{font-size:12px;font-size:var(--w-font-size-1)}.w-size-2{font-size:14px;font-size:var(--w-font-size-2)}.w-size-3{font-size:16px;font-size:var(--w-font-size-3)}.w-size-4{font-size:18px;font-size:var(--w-font-size-4)}.w-size-5{font-size:20px;font-size:var(--w-font-size-5)}.w-fade-white-enter-active,.w-fade-white-leave-active{transition:.25s cubic-bezier(.4,1,0,1);transition:var(--w-transition-time) var(--w-cubic-bezier-quick)}.w-fade-white-leave-active{transition:.25s;transition:var(--w-transition-time)}.w-fade-white-enter-from,.w-fade-white-leave-to{background-color:#fff0!important;opacity:0}.w-fade-white-enter-to,.w-fade-white-leave-from{background-color:#ffffffb3!important;background-color:var(--w-fade-white-background-color)!important;opacity:1}.w-scale-enter-active,.w-scale-leave-active{transition:.5s cubic-bezier(.4,1,0,1);transition:var(--w-transition-slow-time) var(--w-cubic-bezier-quick)}.w-scale-leave-active{transition:.25s cubic-bezier(.01,.7,.53,1);transition:var(--w-transition-time) var(--w-cubic-bezier)}.w-scale-enter-from{transform:scale(0)}.w-scale-leave-to{transform:scale(0);opacity:0}.w-slide-y-enter-active,.w-slide-y-leave-active{transition:.5s cubic-bezier(.4,1,0,1);transition:var(--w-transition-slow-time) var(--w-cubic-bezier-quick)}.w-slide-y-leave-active{transition:.25s cubic-bezier(.01,.7,.53,1);transition:var(--w-transition-time) var(--w-cubic-bezier)}.w-slide-y-enter-from,.w-slide-y-leave-to{transform:scaleY(0);opacity:0}@font-face{font-family:iconfont-linkd;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}.iconfont-linkd{font-family:iconfont-linkd!important;font-size:16px;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.w-icon-rotate-left:before{content:"\\e63b"}.w-icon-rotate-right:before{content:"\\e63c"}.w-icon-duihao:before{content:"\\e62f"}.w-icon-close-fill:before{content:"\\e6a6"}.w-icon-empty:before{content:"\\e602"}.w-icon-close:before{content:"\\e6462"}.w-icon-sort-down:before{content:"\\e65a"}.w-icon-radio-fill:before{content:"\\a797"}.w-icon-radio:before{content:"\\a7e5"}.w-icon-search:before{content:"\\a612"}.w-icon-loading:before{content:"\\a639"}.w-icon-folder-open:before{content:"\\a708"}.w-icon-folder:before{content:"\\a709"}.w-icon-file:before{content:"\\a70c"}.w-icon-add:before{content:"\\a60a"}.w-icon-warning:before{content:"\\a634"}.w-icon-delete:before{content:"\\a63e"}.w-icon-square:before{content:"\\a6e5"}.w-icon-ball:before{content:"\\a603"}.w-icon-checkbox:before{content:"\\a684"}.w-icon-checkbox-fill:before{content:"\\a725"}.w-icon-arrow-down:before{content:"\\a8f2"}\n')();
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number4 = Number(dirtyNumber);
  if (isNaN(number4)) {
    return number4;
  }
  return number4 < 0 ? Math.ceil(number4) : Math.floor(number4);
}
function requiredArgs(required4, args) {
  if (args.length < required4) {
    throw new TypeError(required4 + " argument" + (required4 > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date4 = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    return date4;
  }
  var dayOfMonth = date4.getDate();
  var endOfDesiredMonth = new Date(date4.getTime());
  endOfDesiredMonth.setMonth(date4.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date4.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date4;
  }
}
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
function getTimezoneOffsetInMilliseconds(date4) {
  var utcDate = new Date(Date.UTC(date4.getFullYear(), date4.getMonth(), date4.getDate(), date4.getHours(), date4.getMinutes(), date4.getSeconds(), date4.getMilliseconds()));
  utcDate.setUTCFullYear(date4.getFullYear());
  return date4.getTime() - utcDate.getTime();
}
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date4 = toDate(dirtyDate);
  date4.setHours(0, 0, 0, 0);
  return date4;
}
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
function isDate$1(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate$1(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date4 = toDate(dirtyDate);
  return !isNaN(Number(date4));
}
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date4 = toDate(dirtyDate);
  date4.setDate(1);
  date4.setHours(0, 0, 0, 0);
  return date4;
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = function(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
var formatDistance$1 = formatDistance;
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = function(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$1 = formatRelative;
function buildLocalizeFn(args) {
  return function(dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = function(dirtyNumber, _options) {
  var number4 = Number(dirtyNumber);
  var rem100 = number4 % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number4 + "st";
      case 2:
        return number4 + "nd";
      case 3:
        return number4 + "rd";
    }
  }
  return number4 + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
var localize$1 = localize;
function buildMatchFn(args) {
  return function(string3) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string3.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern4) {
      return pattern4.test(matchedString);
    }) : findKey(parsePatterns, function(pattern4) {
      return pattern4.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string3.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object4, predicate) {
  for (var key in object4) {
    if (object4.hasOwnProperty(key) && predicate(object4[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array4, predicate) {
  for (var key = 0; key < array4.length; key++) {
    if (predicate(array4[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string3) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string3.match(args.matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0];
    var parseResult = string3.match(args.parsePattern);
    if (!parseResult)
      return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string3.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var match$1 = match;
var locale = {
  code: "en-US",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date4 = toDate(dirtyDate);
  var timestamp = date4.getTime();
  date4.setUTCMonth(0, 1);
  date4.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date4.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date4 = toDate(dirtyDate);
  var day = date4.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date4.setUTCDate(date4.getUTCDate() - diff);
  date4.setUTCHours(0, 0, 0, 0);
  return date4;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date4 = toDate(dirtyDate);
  var year = date4.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date4.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date4.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date4 = startOfUTCISOWeek(fourthOfJanuary);
  return date4;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date4 = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date4).getTime() - startOfUTCISOWeekYear(date4).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale2 = options.locale;
  var localeWeekStartsOn = locale2 && locale2.options && locale2.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date4 = toDate(dirtyDate);
  var day = date4.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date4.setUTCDate(date4.getUTCDate() - diff);
  date4.setUTCHours(0, 0, 0, 0);
  return date4;
}
function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date4 = toDate(dirtyDate);
  var year = date4.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale2 = options.locale;
  var localeFirstWeekContainsDate = locale2 && locale2.options && locale2.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);
  if (date4.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date4.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale2 = options.locale;
  var localeFirstWeekContainsDate = locale2 && locale2.options && locale2.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date4 = startOfUTCWeek(firstWeek, dirtyOptions);
  return date4;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date4 = toDate(dirtyDate);
  var diff = startOfUTCWeek(date4, options).getTime() - startOfUTCWeekYear(date4, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function addLeadingZeros(number4, targetLength) {
  var sign = number4 < 0 ? "-" : "";
  var output = Math.abs(number4).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign + output;
}
var formatters$2 = {
  y: function(date4, token) {
    var signedYear = date4.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  M: function(date4, token) {
    var month = date4.getUTCMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d: function(date4, token) {
    return addLeadingZeros(date4.getUTCDate(), token.length);
  },
  a: function(date4, token) {
    var dayPeriodEnumValue = date4.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  h: function(date4, token) {
    return addLeadingZeros(date4.getUTCHours() % 12 || 12, token.length);
  },
  H: function(date4, token) {
    return addLeadingZeros(date4.getUTCHours(), token.length);
  },
  m: function(date4, token) {
    return addLeadingZeros(date4.getUTCMinutes(), token.length);
  },
  s: function(date4, token) {
    return addLeadingZeros(date4.getUTCSeconds(), token.length);
  },
  S: function(date4, token) {
    var numberOfDigits = token.length;
    var milliseconds = date4.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  G: function(date4, token, localize2) {
    var era = date4.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  y: function(date4, token, localize2) {
    if (token === "yo") {
      var signedYear = date4.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$3.y(date4, token);
  },
  Y: function(date4, token, localize2, options) {
    var signedWeekYear = getUTCWeekYear(date4, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function(date4, token) {
    var isoWeekYear = getUTCISOWeekYear(date4);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function(date4, token) {
    var year = date4.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function(date4, token, localize2) {
    var quarter = Math.ceil((date4.getUTCMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function(date4, token, localize2) {
    var quarter = Math.ceil((date4.getUTCMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function(date4, token, localize2) {
    var month = date4.getUTCMonth();
    switch (token) {
      case "M":
      case "MM":
        return formatters$3.M(date4, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  L: function(date4, token, localize2) {
    var month = date4.getUTCMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  w: function(date4, token, localize2, options) {
    var week = getUTCWeek(date4, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token.length);
  },
  I: function(date4, token, localize2) {
    var isoWeek = getUTCISOWeek(date4);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function(date4, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date4.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$3.d(date4, token);
  },
  D: function(date4, token, localize2) {
    var dayOfYear = getUTCDayOfYear(date4);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function(date4, token, localize2) {
    var dayOfWeek = date4.getUTCDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function(date4, token, localize2, options) {
    var dayOfWeek = date4.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function(date4, token, localize2, options) {
    var dayOfWeek = date4.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function(date4, token, localize2) {
    var dayOfWeek = date4.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function(date4, token, localize2) {
    var hours = date4.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function(date4, token, localize2) {
    var hours = date4.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function(date4, token, localize2) {
    var hours = date4.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function(date4, token, localize2) {
    if (token === "ho") {
      var hours = date4.getUTCHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$3.h(date4, token);
  },
  H: function(date4, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date4.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$3.H(date4, token);
  },
  K: function(date4, token, localize2) {
    var hours = date4.getUTCHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function(date4, token, localize2) {
    var hours = date4.getUTCHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function(date4, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date4.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$3.m(date4, token);
  },
  s: function(date4, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date4.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$3.s(date4, token);
  },
  S: function(date4, token) {
    return formatters$3.S(date4, token);
  },
  X: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  x: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  O: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  z: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  t: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || "";
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$1 = formatters;
function dateLongFormatter(pattern4, formatLong2) {
  switch (pattern4) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
}
function timeLongFormatter(pattern4, formatLong2) {
  switch (pattern4) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
}
function dateTimeLongFormatter(pattern4, formatLong2) {
  var matchResult = pattern4.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern4, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
}
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format2, input) {
  if (token === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format$1(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale2 = options.locale || defaultLocale;
  var localeFirstWeekContainsDate = locale2.options && locale2.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var localeWeekStartsOn = locale2.options && locale2.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale2.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale2.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale2.formatLong, formatterOptions);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$1).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      return formatter(utcDate, substring, locale2.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}
function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError("assign requires that input parameter not be null or undefined");
  }
  dirtyObject = dirtyObject || {};
  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }
  return target;
}
function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date4 = toDate(dirtyDate);
  var dayOfMonth = date4.getDate();
  return dayOfMonth;
}
function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date4 = toDate(dirtyDate);
  var day = date4.getDay();
  return day;
}
function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date4 = toDate(dirtyDate);
  var year = date4.getFullYear();
  var monthIndex = date4.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date4 = toDate(dirtyDate);
  var month = date4.getMonth();
  return month;
}
function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}
function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  requiredArgs(2, arguments);
  var options = dirtyOptions || {};
  var locale2 = options.locale;
  var localeWeekStartsOn = locale2 && locale2.options && locale2.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date4 = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date4.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date4.setUTCDate(date4.getUTCDate() + diff);
  return date4;
}
function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date4 = toDate(dirtyDate);
  var currentDay = date4.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date4.setUTCDate(date4.getUTCDate() + diff);
  return date4;
}
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date4 = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date4) - isoWeek;
  date4.setUTCDate(date4.getUTCDate() - diff * 7);
  return date4;
}
function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date4 = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date4, options) - week;
  date4.setUTCDate(date4.getUTCDate() - diff * 7);
  return date4;
}
var MILLISECONDS_IN_HOUR = 36e5;
var MILLISECONDS_IN_MINUTE = 6e4;
var MILLISECONDS_IN_SECOND = 1e3;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  date: /^(3[0-1]|[0-2]?\d)/,
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  week: /^(5[0-3]|[0-4]?\d)/,
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  hour11h: /^(1[0-1]|0?\d)/,
  hour12h: /^(1[0-2]|0?\d)/,
  minute: /^[0-5]?\d/,
  second: /^[0-5]?\d/,
  singleDigit: /^\d/,
  twoDigits: /^\d{1,2}/,
  threeDigits: /^\d{1,3}/,
  fourDigits: /^\d{1,4}/,
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  twoDigitsSigned: /^-?\d{1,2}/,
  threeDigitsSigned: /^-?\d{1,3}/,
  fourDigitsSigned: /^-?\d{1,4}/
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function parseNumericPattern(pattern4, string3, valueCallback) {
  var matchResult = string3.match(pattern4);
  if (!matchResult) {
    return null;
  }
  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string3.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern4, string3) {
  var matchResult = string3.match(pattern4);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: string3.slice(1)
    };
  }
  var sign = matchResult[1] === "+" ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string3.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(string3, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string3, valueCallback);
}
function parseNDigits(n, string3, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string3, valueCallback);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string3, valueCallback);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string3, valueCallback);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string3, valueCallback);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), string3, valueCallback);
  }
}
function parseNDigitsSigned(n, string3, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string3, valueCallback);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string3, valueCallback);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string3, valueCallback);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string3, valueCallback);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), string3, valueCallback);
  }
}
function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
var parsers = {
  G: {
    priority: 140,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "G":
        case "GG":
        case "GGG":
          return match2.era(string3, {
            width: "abbreviated"
          }) || match2.era(string3, {
            width: "narrow"
          });
        case "GGGGG":
          return match2.era(string3, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return match2.era(string3, {
            width: "wide"
          }) || match2.era(string3, {
            width: "abbreviated"
          }) || match2.era(string3, {
            width: "narrow"
          });
      }
    },
    set: function(date4, flags, value, _options) {
      flags.era = value;
      date4.setUTCFullYear(value, 0, 1);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["R", "u", "t", "T"]
  },
  y: {
    priority: 130,
    parse: function(string3, token, match2, _options) {
      var valueCallback = function(year) {
        return {
          year,
          isTwoDigitYear: token === "yy"
        };
      };
      switch (token) {
        case "y":
          return parseNDigits(4, string3, valueCallback);
        case "yo":
          return match2.ordinalNumber(string3, {
            unit: "year",
            valueCallback
          });
        default:
          return parseNDigits(token.length, string3, valueCallback);
      }
    },
    validate: function(_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function(date4, flags, value, _options) {
      var currentYear = date4.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date4.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date4.setUTCHours(0, 0, 0, 0);
        return date4;
      }
      var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date4.setUTCFullYear(year, 0, 1);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]
  },
  Y: {
    priority: 130,
    parse: function(string3, token, match2, _options) {
      var valueCallback = function(year) {
        return {
          year,
          isTwoDigitYear: token === "YY"
        };
      };
      switch (token) {
        case "Y":
          return parseNDigits(4, string3, valueCallback);
        case "Yo":
          return match2.ordinalNumber(string3, {
            unit: "year",
            valueCallback
          });
        default:
          return parseNDigits(token.length, string3, valueCallback);
      }
    },
    validate: function(_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function(date4, flags, value, options) {
      var currentYear = getUTCWeekYear(date4, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date4.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date4.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date4, options);
      }
      var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date4.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date4.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date4, options);
    },
    incompatibleTokens: ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  R: {
    priority: 130,
    parse: function(string3, token, _match, _options) {
      if (token === "R") {
        return parseNDigitsSigned(4, string3);
      }
      return parseNDigitsSigned(token.length, string3);
    },
    set: function(_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    },
    incompatibleTokens: ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
  },
  u: {
    priority: 130,
    parse: function(string3, token, _match, _options) {
      if (token === "u") {
        return parseNDigitsSigned(4, string3);
      }
      return parseNDigitsSigned(token.length, string3);
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCFullYear(value, 0, 1);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]
  },
  Q: {
    priority: 120,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "Q":
        case "QQ":
          return parseNDigits(token.length, string3);
        case "Qo":
          return match2.ordinalNumber(string3, {
            unit: "quarter"
          });
        case "QQQ":
          return match2.quarter(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return match2.quarter(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return match2.quarter(string3, {
            width: "wide",
            context: "formatting"
          }) || match2.quarter(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(string3, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCMonth((value - 1) * 3, 1);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  q: {
    priority: 120,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "q":
        case "qq":
          return parseNDigits(token.length, string3);
        case "qo":
          return match2.ordinalNumber(string3, {
            unit: "quarter"
          });
        case "qqq":
          return match2.quarter(string3, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(string3, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return match2.quarter(string3, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return match2.quarter(string3, {
            width: "wide",
            context: "standalone"
          }) || match2.quarter(string3, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(string3, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCMonth((value - 1) * 3, 1);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  M: {
    priority: 110,
    parse: function(string3, token, match2, _options) {
      var valueCallback = function(value) {
        return value - 1;
      };
      switch (token) {
        case "M":
          return parseNumericPattern(numericPatterns.month, string3, valueCallback);
        case "MM":
          return parseNDigits(2, string3, valueCallback);
        case "Mo":
          return match2.ordinalNumber(string3, {
            unit: "month",
            valueCallback
          });
        case "MMM":
          return match2.month(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return match2.month(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return match2.month(string3, {
            width: "wide",
            context: "formatting"
          }) || match2.month(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(string3, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCMonth(value, 1);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  L: {
    priority: 110,
    parse: function(string3, token, match2, _options) {
      var valueCallback = function(value) {
        return value - 1;
      };
      switch (token) {
        case "L":
          return parseNumericPattern(numericPatterns.month, string3, valueCallback);
        case "LL":
          return parseNDigits(2, string3, valueCallback);
        case "Lo":
          return match2.ordinalNumber(string3, {
            unit: "month",
            valueCallback
          });
        case "LLL":
          return match2.month(string3, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(string3, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return match2.month(string3, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return match2.month(string3, {
            width: "wide",
            context: "standalone"
          }) || match2.month(string3, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(string3, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCMonth(value, 1);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  w: {
    priority: 100,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "w":
          return parseNumericPattern(numericPatterns.week, string3);
        case "wo":
          return match2.ordinalNumber(string3, {
            unit: "week"
          });
        default:
          return parseNDigits(token.length, string3);
      }
    },
    validate: function(_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function(date4, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date4, value, options), options);
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  I: {
    priority: 100,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "I":
          return parseNumericPattern(numericPatterns.week, string3);
        case "Io":
          return match2.ordinalNumber(string3, {
            unit: "week"
          });
        default:
          return parseNDigits(token.length, string3);
      }
    },
    validate: function(_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function(date4, _flags, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date4, value, options), options);
    },
    incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
  },
  d: {
    priority: 90,
    subPriority: 1,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "d":
          return parseNumericPattern(numericPatterns.date, string3);
        case "do":
          return match2.ordinalNumber(string3, {
            unit: "date"
          });
        default:
          return parseNDigits(token.length, string3);
      }
    },
    validate: function(date4, value, _options) {
      var year = date4.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date4.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCDate(value);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  D: {
    priority: 90,
    subPriority: 1,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "D":
        case "DD":
          return parseNumericPattern(numericPatterns.dayOfYear, string3);
        case "Do":
          return match2.ordinalNumber(string3, {
            unit: "date"
          });
        default:
          return parseNDigits(token.length, string3);
      }
    },
    validate: function(date4, value, _options) {
      var year = date4.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCMonth(0, value);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]
  },
  E: {
    priority: 90,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "E":
        case "EE":
        case "EEE":
          return match2.day(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(string3, {
            width: "short",
            context: "formatting"
          }) || match2.day(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return match2.day(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return match2.day(string3, {
            width: "short",
            context: "formatting"
          }) || match2.day(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return match2.day(string3, {
            width: "wide",
            context: "formatting"
          }) || match2.day(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(string3, {
            width: "short",
            context: "formatting"
          }) || match2.day(string3, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function(date4, _flags, value, options) {
      date4 = setUTCDay(date4, value, options);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["D", "i", "e", "c", "t", "T"]
  },
  e: {
    priority: 90,
    parse: function(string3, token, match2, options) {
      var valueCallback = function(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        case "e":
        case "ee":
          return parseNDigits(token.length, string3, valueCallback);
        case "eo":
          return match2.ordinalNumber(string3, {
            unit: "day",
            valueCallback
          });
        case "eee":
          return match2.day(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(string3, {
            width: "short",
            context: "formatting"
          }) || match2.day(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return match2.day(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return match2.day(string3, {
            width: "short",
            context: "formatting"
          }) || match2.day(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return match2.day(string3, {
            width: "wide",
            context: "formatting"
          }) || match2.day(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(string3, {
            width: "short",
            context: "formatting"
          }) || match2.day(string3, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function(date4, _flags, value, options) {
      date4 = setUTCDay(date4, value, options);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]
  },
  c: {
    priority: 90,
    parse: function(string3, token, match2, options) {
      var valueCallback = function(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        case "c":
        case "cc":
          return parseNDigits(token.length, string3, valueCallback);
        case "co":
          return match2.ordinalNumber(string3, {
            unit: "day",
            valueCallback
          });
        case "ccc":
          return match2.day(string3, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(string3, {
            width: "short",
            context: "standalone"
          }) || match2.day(string3, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return match2.day(string3, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return match2.day(string3, {
            width: "short",
            context: "standalone"
          }) || match2.day(string3, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return match2.day(string3, {
            width: "wide",
            context: "standalone"
          }) || match2.day(string3, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(string3, {
            width: "short",
            context: "standalone"
          }) || match2.day(string3, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function(date4, _flags, value, options) {
      date4 = setUTCDay(date4, value, options);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]
  },
  i: {
    priority: 90,
    parse: function(string3, token, match2, _options) {
      var valueCallback = function(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        case "i":
        case "ii":
          return parseNDigits(token.length, string3);
        case "io":
          return match2.ordinalNumber(string3, {
            unit: "day"
          });
        case "iii":
          return match2.day(string3, {
            width: "abbreviated",
            context: "formatting",
            valueCallback
          }) || match2.day(string3, {
            width: "short",
            context: "formatting",
            valueCallback
          }) || match2.day(string3, {
            width: "narrow",
            context: "formatting",
            valueCallback
          });
        case "iiiii":
          return match2.day(string3, {
            width: "narrow",
            context: "formatting",
            valueCallback
          });
        case "iiiiii":
          return match2.day(string3, {
            width: "short",
            context: "formatting",
            valueCallback
          }) || match2.day(string3, {
            width: "narrow",
            context: "formatting",
            valueCallback
          });
        case "iiii":
        default:
          return match2.day(string3, {
            width: "wide",
            context: "formatting",
            valueCallback
          }) || match2.day(string3, {
            width: "abbreviated",
            context: "formatting",
            valueCallback
          }) || match2.day(string3, {
            width: "short",
            context: "formatting",
            valueCallback
          }) || match2.day(string3, {
            width: "narrow",
            context: "formatting",
            valueCallback
          });
      }
    },
    validate: function(_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function(date4, _flags, value, options) {
      date4 = setUTCISODay(date4, value, options);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]
  },
  a: {
    priority: 80,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "a":
        case "aa":
        case "aaa":
          return match2.dayPeriod(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return match2.dayPeriod(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return match2.dayPeriod(string3, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string3, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["b", "B", "H", "k", "t", "T"]
  },
  b: {
    priority: 80,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "b":
        case "bb":
        case "bbb":
          return match2.dayPeriod(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return match2.dayPeriod(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return match2.dayPeriod(string3, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string3, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["a", "B", "H", "k", "t", "T"]
  },
  B: {
    priority: 80,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "B":
        case "BB":
        case "BBB":
          return match2.dayPeriod(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return match2.dayPeriod(string3, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return match2.dayPeriod(string3, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(string3, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string3, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["a", "b", "t", "T"]
  },
  h: {
    priority: 70,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "h":
          return parseNumericPattern(numericPatterns.hour12h, string3);
        case "ho":
          return match2.ordinalNumber(string3, {
            unit: "hour"
          });
        default:
          return parseNDigits(token.length, string3);
      }
    },
    validate: function(_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function(date4, _flags, value, _options) {
      var isPM = date4.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date4.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date4.setUTCHours(0, 0, 0, 0);
      } else {
        date4.setUTCHours(value, 0, 0, 0);
      }
      return date4;
    },
    incompatibleTokens: ["H", "K", "k", "t", "T"]
  },
  H: {
    priority: 70,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "H":
          return parseNumericPattern(numericPatterns.hour23h, string3);
        case "Ho":
          return match2.ordinalNumber(string3, {
            unit: "hour"
          });
        default:
          return parseNDigits(token.length, string3);
      }
    },
    validate: function(_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCHours(value, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["a", "b", "h", "K", "k", "t", "T"]
  },
  K: {
    priority: 70,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "K":
          return parseNumericPattern(numericPatterns.hour11h, string3);
        case "Ko":
          return match2.ordinalNumber(string3, {
            unit: "hour"
          });
        default:
          return parseNDigits(token.length, string3);
      }
    },
    validate: function(_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function(date4, _flags, value, _options) {
      var isPM = date4.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date4.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date4.setUTCHours(value, 0, 0, 0);
      }
      return date4;
    },
    incompatibleTokens: ["h", "H", "k", "t", "T"]
  },
  k: {
    priority: 70,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "k":
          return parseNumericPattern(numericPatterns.hour24h, string3);
        case "ko":
          return match2.ordinalNumber(string3, {
            unit: "hour"
          });
        default:
          return parseNDigits(token.length, string3);
      }
    },
    validate: function(_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function(date4, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date4.setUTCHours(hours, 0, 0, 0);
      return date4;
    },
    incompatibleTokens: ["a", "b", "h", "H", "K", "t", "T"]
  },
  m: {
    priority: 60,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "m":
          return parseNumericPattern(numericPatterns.minute, string3);
        case "mo":
          return match2.ordinalNumber(string3, {
            unit: "minute"
          });
        default:
          return parseNDigits(token.length, string3);
      }
    },
    validate: function(_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCMinutes(value, 0, 0);
      return date4;
    },
    incompatibleTokens: ["t", "T"]
  },
  s: {
    priority: 50,
    parse: function(string3, token, match2, _options) {
      switch (token) {
        case "s":
          return parseNumericPattern(numericPatterns.second, string3);
        case "so":
          return match2.ordinalNumber(string3, {
            unit: "second"
          });
        default:
          return parseNDigits(token.length, string3);
      }
    },
    validate: function(_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCSeconds(value, 0);
      return date4;
    },
    incompatibleTokens: ["t", "T"]
  },
  S: {
    priority: 30,
    parse: function(string3, token, _match, _options) {
      var valueCallback = function(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return parseNDigits(token.length, string3, valueCallback);
    },
    set: function(date4, _flags, value, _options) {
      date4.setUTCMilliseconds(value);
      return date4;
    },
    incompatibleTokens: ["t", "T"]
  },
  X: {
    priority: 10,
    parse: function(string3, token, _match, _options) {
      switch (token) {
        case "X":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string3);
        case "XX":
          return parseTimezonePattern(timezonePatterns.basic, string3);
        case "XXXX":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string3);
        case "XXXXX":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string3);
        case "XXX":
        default:
          return parseTimezonePattern(timezonePatterns.extended, string3);
      }
    },
    set: function(date4, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date4;
      }
      return new Date(date4.getTime() - value);
    },
    incompatibleTokens: ["t", "T", "x"]
  },
  x: {
    priority: 10,
    parse: function(string3, token, _match, _options) {
      switch (token) {
        case "x":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string3);
        case "xx":
          return parseTimezonePattern(timezonePatterns.basic, string3);
        case "xxxx":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string3);
        case "xxxxx":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string3);
        case "xxx":
        default:
          return parseTimezonePattern(timezonePatterns.extended, string3);
      }
    },
    set: function(date4, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date4;
      }
      return new Date(date4.getTime() - value);
    },
    incompatibleTokens: ["t", "T", "X"]
  },
  t: {
    priority: 40,
    parse: function(string3, _token, _match, _options) {
      return parseAnyDigitsSigned(string3);
    },
    set: function(_date, _flags, value, _options) {
      return [new Date(value * 1e3), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: "*"
  },
  T: {
    priority: 20,
    parse: function(string3, _token, _match, _options) {
      return parseAnyDigitsSigned(string3);
    },
    set: function(_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: "*"
  }
};
var parsers$1 = parsers;
var TIMEZONE_UNIT_PRIORITY = 10;
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale2 = options.locale || defaultLocale;
  if (!locale2.match) {
    throw new RangeError("locale must contain match property");
  }
  var localeFirstWeekContainsDate = locale2.options && locale2.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var localeWeekStartsOn = locale2.options && locale2.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (formatString === "") {
    if (dateString === "") {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2
  };
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter2 = substring[0];
    if (firstCharacter2 === "p" || firstCharacter2 === "P") {
      var longFormatter = longFormatters$1[firstCharacter2];
      return longFormatter(substring, locale2.formatLong, subFnOptions);
    }
    return substring;
  }).join("").match(formattingTokensRegExp);
  var usedTokens = [];
  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }
    if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }
    var firstCharacter = token[0];
    var parser = parsers$1[firstCharacter];
    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;
      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;
        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;
          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }
        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }
      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale2.match, subFnOptions);
      if (!parseResult) {
        return new Date(NaN);
      }
      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
      }
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      }
      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function(setter2) {
    return setter2.priority;
  }).sort(function(a, b) {
    return b - a;
  }).filter(function(priority, index2, array4) {
    return array4.indexOf(priority) === index2;
  }).map(function(priority) {
    return setters.filter(function(setter2) {
      return setter2.priority === priority;
    }).sort(function(a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function(setterArray) {
    return setterArray[0];
  });
  var date4 = toDate(dirtyReferenceDate);
  if (isNaN(date4)) {
    return new Date(NaN);
  }
  var utcDate = subMilliseconds(date4, getTimezoneOffsetInMilliseconds(date4));
  var flags = {};
  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];
    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }
    var result = setter.set(utcDate, flags, setter.value, subFnOptions);
    if (result[0]) {
      utcDate = result[0];
      assign(flags, result[1]);
    } else {
      utcDate = result;
    }
  }
  return utcDate;
}
function dateToSystemTimezone(date4, flags) {
  if (flags.timestampIsSet) {
    return date4;
  }
  var convertedDate = new Date(0);
  convertedDate.setFullYear(date4.getUTCFullYear(), date4.getUTCMonth(), date4.getUTCDate());
  convertedDate.setHours(date4.getUTCHours(), date4.getUTCMinutes(), date4.getUTCSeconds(), date4.getUTCMilliseconds());
  return convertedDate;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
const isBoolean = (val) => typeof val === "boolean";
const isString = (val) => typeof val === "string";
const isNumber$1 = (val) => typeof val === "number";
const isObject = (val) => val !== null && typeof val === "object";
const isFunction = (val) => typeof val === "function";
const isArray = (val) => Array.isArray(val);
const isDate = isDate$1;
const isInvalidValue = (v2) => v2 === "" || v2 === void 0 || v2 === null;
const isValidValue = (v2) => !isInvalidValue(v2);
function getItemValue(item, fieldOrIndex) {
  if (isNumber$1(item) || isString(item)) {
    return item;
  }
  if (fieldOrIndex === void 0) {
    return void 0;
  } else {
    if (isObject(item) || isArray(item)) {
      return item[fieldOrIndex];
    }
  }
}
const win = window;
const doc = document;
const transitionState = [
  "enter-from",
  "enter-active",
  "leave-to",
  "leave-active"
];
function isWindow(v2) {
  return v2 === window;
}
function isElement(v2) {
  return v2 && v2 instanceof HTMLElement;
}
function isId(str) {
  return str.charAt(0) === "#";
}
function isClass(str) {
  return str.charAt(0) === ".";
}
function $(str) {
  return document.querySelector(str);
}
function isDocumentBody(str) {
  return str === "body" || str === document.body;
}
function getUnit(value) {
  const unit = String(value).replace(/[\-\.\d]/gi, "").toLowerCase();
  return unit;
}
function hasUnit(value) {
  const unit = getUnit(value);
  return unit !== "";
}
function getStyle(elem, prop) {
  return win.getComputedStyle(elem, null)[prop];
}
function setStyle(elem, propValue) {
  if (propValue) {
    for (let k in propValue) {
      elem.style.setProperty(k, propValue[k]);
    }
  } else {
    const set = (prop, value) => {
      elem.style.setProperty(prop, value);
      return set;
    };
    return set;
  }
}
function setAttr(elem, attrs) {
  if (elem) {
    for (const prop in attrs) {
      elem.setAttribute("tabindex", attrs[prop]);
    }
  }
}
function getWindowSize() {
  return {
    outer: {
      height: win.outerHeight,
      width: win.outerWidth
    },
    inner: {
      height: win.innerHeight,
      width: win.innerWidth
    }
  };
}
function getPageScroll() {
  return {
    x: win.pageXOffset,
    y: win.pageYOffset
  };
}
function getPageSize() {
  return {
    height: Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight),
    width: Math.max(doc.body.scrollWidth, doc.documentElement.scrollWidth)
  };
}
function getBoundingClientRect(elem) {
  const _el = getElement(elem);
  if (_el && isElement(_el)) {
    return _el.getBoundingClientRect();
  }
  return {
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    bottom: 0,
    right: 0
  };
}
function getOffset(elem, parent) {
  let left = elem.offsetLeft, top = elem.offsetTop, cur = elem.offsetParent;
  if (!parent) {
    while (cur !== null) {
      left += cur.offsetLeft;
      top += cur.offsetTop;
      cur = cur.offsetParent;
    }
  } else {
    while (cur && cur != parent) {
      left += cur.offsetLeft;
      top += cur.offsetTop;
      cur = cur.offsetParent;
    }
  }
  return {
    left,
    top
  };
}
function getElement(elem) {
  const el = unref(elem);
  let _ = void 0;
  if (el === window) {
    _ = window;
  } else if (el === document) {
    _ = document;
  } else if (isElement(el)) {
    _ = el;
  } else if (isDocumentBody(el)) {
    _ = document.body;
  } else if (isString(el)) {
    if (isId(el) || isClass(el)) {
      _ = $(el);
    }
  } else if (isObject(el)) {
    const _el = el.$el;
    if (isElement(_el)) {
      _ = _el;
    }
  }
  return _;
}
function getElementPositionInPage(elem) {
  let _el = getElement(elem);
  const { x: left, y: top } = getPageScroll();
  if (_el && isElement(_el)) {
    const rect = getBoundingClientRect(_el);
    return {
      left: left + rect.left,
      top: top + rect.top,
      right: rect.right + left,
      bottom: rect.bottom + top,
      width: rect.width,
      height: rect.height
    };
  }
  return {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
  };
}
function getInvisibleElementSize(el, nearby = false, relate, transitionName) {
  let width = 0, height = 0;
  function _clone_calc_size(_el2) {
    let parentNode = doc.body;
    if (nearby) {
      const _relate = getElement(relate);
      if (_relate && isElement(_relate)) {
        const p = _relate.parentNode;
        if (p !== null) {
          parentNode = p;
        }
      }
    }
    const node = _el2.cloneNode(true);
    if (transitionName) {
      removeClass(node, transitionState.map((s) => transitionName + "-" + s));
    }
    node.style.display = "block";
    node.style.opacity = "0";
    parentNode.appendChild(node);
    ({ width, height } = getBoundingClientRect(node));
    parentNode.removeChild(node);
  }
  const _el = getElement(el);
  if (_el && isElement(_el)) {
    _clone_calc_size(_el);
  }
  return { width, height };
}
function hasScrollbar(el) {
  const x = getStyle(el, "overflow-x");
  const y = getStyle(el, "overflow-y");
  if (x === "hidden" && y === "hidden") {
    return { x: false, y: false };
  }
  return {
    x: el.clientWidth < el.scrollWidth,
    y: el.clientHeight < el.scrollHeight
  };
}
function getParentScrollElement(el) {
  let _el = getElement(el);
  const scrolls = [];
  const collectParent = (node) => {
    const parent = node.parentNode;
    if (parent !== null && parent !== doc.body) {
      const _p = parent;
      const { x, y } = hasScrollbar(_p);
      if (x || y) {
        scrolls.push(_p);
      }
      collectParent(_p);
    }
  };
  if (_el && isElement(_el)) {
    collectParent(_el);
  }
  return scrolls;
}
function removeClass(el, className) {
  const _el = getElement(el);
  const cls = isString(className) ? [className] : className;
  if (_el && isElement(_el))
    _el.classList.remove(...cls);
}
function filterListeners(attrs) {
  let o = {};
  if (attrs) {
    for (const k in attrs) {
      const _on = k.slice(0, 2).toLowerCase();
      if (_on === "on") {
        o[k] = attrs[k];
      }
    }
  }
  return o;
}
var EnumPlacement = /* @__PURE__ */ ((EnumPlacement2) => {
  EnumPlacement2["left"] = "left";
  EnumPlacement2["left-start"] = "left-start";
  EnumPlacement2["left-end"] = "left-end";
  EnumPlacement2["right"] = "right";
  EnumPlacement2["right-start"] = "right-start";
  EnumPlacement2["right-end"] = "right-end";
  EnumPlacement2["top"] = "top";
  EnumPlacement2["top-start"] = "top-start";
  EnumPlacement2["top-end"] = "top-end";
  EnumPlacement2["bottom"] = "bottom";
  EnumPlacement2["bottom-start"] = "bottom-start";
  EnumPlacement2["bottom-end"] = "bottom-end";
  EnumPlacement2["center"] = "center";
  EnumPlacement2["client-center"] = "client-center";
  return EnumPlacement2;
})(EnumPlacement || {});
let Placements = Object.values(EnumPlacement);
const resolveAccuracy = (v2) => Number(v2.toFixed(8));
function getPlacement({
  triggerRect,
  layerSize,
  placement = "bottom",
  adjustPosition = "auto",
  gap = 0,
  offset = { x: 0, y: 0 },
  arrowOffset = { x: 0, y: 0 },
  layer
}) {
  const badPlacement = /* @__PURE__ */ new Set();
  badPlacement.add("center").add("client-center");
  function _calc(plc) {
    const arrowSize = 3;
    const per = 0.25;
    const limit = 18;
    const r = triggerRect;
    const l = layerSize;
    const p = plc || placement;
    const minWidth = Math.min(r.width, l.width);
    const minHeight = Math.min(r.height, l.height);
    switch (p) {
      case "center":
        place.top = r.top + r.height / 2 - l.height / 2;
        place.left = r.left + r.width / 2 - l.width / 2;
        break;
      case "client-center":
        const { inner } = getWindowSize();
        const { x, y } = getPageScroll();
        const _layer = unref(layer);
        if (_layer) {
          const rect = getBoundingClientRect(layer);
          if (rect) {
            l.width = rect.width;
            l.height = rect.height;
          }
        }
        place.top = inner.height / 2 - l.height / 2;
        place.left = inner.width / 2 - l.width / 2;
        place.top = place.top < 0 ? 0 : place.top;
        place.left = place.left < 0 ? 0 : place.left;
        if (r.width === 0 || r.height === 0) {
          place.x = l.width / 2;
          place.y = l.height / 2;
        } else {
          place.x = r.left + r.width / 2 - place.left - x;
          place.y = r.top + r.height / 2 - place.top - y;
        }
        break;
      case "top":
        place.top = r.top - l.height - gap;
        place.left = r.left + r.width / 2 - l.width / 2;
        place.x = l.width * 0.5 - arrowSize;
        place.y = l.height;
        break;
      case "top-start":
        place.top = r.top - l.height - gap;
        place.left = r.left;
        place.x = minWidth * per - arrowSize;
        place.y = l.height;
        break;
      case "top-end":
        place.top = r.top - l.height - gap;
        place.left = r.right - l.width;
        place.x = l.width - minWidth * per - arrowSize;
        place.y = l.height;
        break;
      case "left":
        place.top = r.top + r.height / 2 - l.height / 2;
        place.left = r.left - l.width - gap;
        place.x = l.width;
        place.y = l.height / 2 - arrowSize;
        break;
      case "left-start":
        place.top = r.top;
        place.left = r.left - l.width - gap;
        place.x = l.width;
        place.y = minHeight * per - arrowSize;
        break;
      case "left-end":
        place.top = r.bottom - l.height;
        place.left = r.left - l.width - gap;
        place.x = l.width;
        place.y = l.height - minHeight * per - arrowSize;
        if (l.height - place.y < limit) {
          place.y = l.height - limit;
        }
        break;
      case "right-start":
        place.top = r.top;
        place.left = r.right + gap;
        place.x = arrowSize * -2;
        place.y = minHeight * per - arrowSize;
        break;
      case "right":
        place.top = r.top + r.height / 2 - l.height / 2;
        place.left = r.right + gap;
        place.x = arrowSize * -2;
        place.y = l.height / 2 - arrowSize;
        break;
      case "right-end":
        place.top = r.bottom - l.height;
        place.left = r.right + gap;
        place.x = arrowSize * -2;
        place.y = l.height - minHeight * per - arrowSize;
        if (l.height - place.y < limit) {
          place.y = l.height - limit;
        }
        break;
      case "bottom-start":
        place.top = r.bottom + gap;
        place.left = r.left;
        place.x = minWidth * per - arrowSize;
        place.y = arrowSize * -2;
        break;
      case "bottom-end":
        place.top = r.bottom + gap;
        place.left = r.right - l.width;
        place.x = l.width - minWidth * per - arrowSize;
        place.y = arrowSize * -2;
        break;
      case "bottom":
      default:
        place.top = r.bottom + gap;
        place.left = r.left + r.width / 2 - l.width / 2;
        place.x = l.width * 0.5 - arrowSize;
        place.y = arrowSize * -2;
    }
    place.top += offset.y;
    place.left += offset.x;
    place.x += arrowOffset.x;
    place.y += arrowOffset.y;
    if (adjustPosition !== "none" && p !== "center" && p !== "client-center") {
      const rect = { top: place.top, left: place.left, ...l };
      const out = isOutOfClient(rect);
      const outOfPage = isOutOfPage(rect);
      if (out.x.left < 0 || out.y.top < 0 || out.x.right > 0 || out.y.bottom > 0) {
        if (outOfPage.x.left < 0 || outOfPage.y.top < 0 || outOfPage.x.right > 0 || outOfPage.y.bottom > 0) {
          if (adjustPosition === "auto") {
            badPlacement.add(place.placement);
            if (badPlacement.size === Placements.length) {
              place.placement = "bottom";
              _calc(place.placement);
            } else {
              const p2 = get4SizeAndGetwhichPlaceIsBigger(triggerRect);
              if (!badPlacement.has(p2)) {
                place.placement = p2;
                _calc(place.placement);
              } else {
                const otherPlacement = Placements.filter((p3) => !badPlacement.has(p3));
                place.placement = otherPlacement[0];
                _calc(place.placement);
              }
            }
          } else {
            const direction = getBiggerDirectionByPlace(adjustPosition, triggerRect);
            place.placement = direction;
            _calc(place.placement);
          }
        }
      }
    }
  }
  const place = { top: 0, left: 0, x: 0, y: 0, placement };
  _calc();
  return place;
}
function isOutOfPage(rect) {
  const { width: pageWidth, height: pageHeight } = getPageSize();
  return {
    y: {
      top: rect.top - 0,
      bottom: rect.top + rect.height - pageHeight
    },
    x: {
      left: rect.left - 0,
      right: rect.width + rect.left - pageWidth
    }
  };
}
function isOutOfClient(rect) {
  const { x: px, y: py } = getPageScroll();
  const { inner } = getWindowSize();
  return {
    x: {
      left: rect.left - px,
      right: rect.width + rect.left - px - inner.width
    },
    y: {
      top: rect.top - py,
      bottom: rect.top + rect.height - py - inner.height
    }
  };
}
function getBiggerDirectionByPlace(placement, rect) {
  return get4SizeAndGetwhichPlaceIsBigger(rect, placement);
}
function get4SizeAndGetwhichPlaceIsBigger(rect, direction) {
  let p = "left";
  const { inner } = getWindowSize();
  const left = rect.left;
  const top = rect.top;
  const right = inner.width - rect.right;
  const bottom = inner.height - rect.bottom;
  const maxDirection = Math.max(left, top, bottom, right);
  if (direction) {
    if (direction === "left") {
      if (Math.abs(top - bottom) < 100) {
        p = "left";
      } else if (top > bottom) {
        p = "left-end";
      } else {
        p = "left-start";
      }
    } else if (direction === "right") {
      if (Math.abs(top - bottom) < 100) {
        p = "right";
      } else if (top > bottom) {
        p = "right-end";
      } else {
        p = "right-start";
      }
    } else if (direction === "top") {
      if (Math.abs(left - right) < 100) {
        p = "top";
      } else if (left > right) {
        p = "top-end";
      } else {
        p = "top-start";
      }
    } else {
      if (Math.abs(left - right) < 100) {
        p = "bottom";
      } else if (left > right) {
        p = "bottom-end";
      } else {
        p = "bottom-start";
      }
    }
  } else {
    if (maxDirection === left) {
      if (Math.abs(top - bottom) < 100) {
        p = "left";
      } else if (top > bottom) {
        p = "left-end";
      } else {
        p = "left-start";
      }
    } else if (maxDirection === right) {
      if (Math.abs(top - bottom) < 100) {
        p = "right";
      } else if (top > bottom) {
        p = "right-end";
      } else {
        p = "right-start";
      }
    } else if (maxDirection === top) {
      if (Math.abs(left - right) < 100) {
        p = "top";
      } else if (left > right) {
        p = "top-end";
      } else {
        p = "top-start";
      }
    } else {
      if (Math.abs(left - right) < 100) {
        p = "bottom";
      } else if (left > right) {
        p = "bottom-end";
      } else {
        p = "bottom-start";
      }
    }
  }
  return p;
}
const isNumber = (value) => typeof value === "number";
let __will_ui_global_z_index = 100;
function useGlobalZIndex() {
  const zIndex2 = ref(__will_ui_global_z_index);
  function add2(delta) {
    __will_ui_global_z_index += delta != null ? delta : 1;
    zIndex2.value = __will_ui_global_z_index;
    return zIndex2.value;
  }
  if (getCurrentInstance()) {
    onMounted(add2);
  } else {
    add2();
  }
  return {
    zIndex: zIndex2,
    add: add2,
    get: () => zIndex2.value,
    set(i) {
      zIndex2.value = i;
    }
  };
}
var Icon$1 = defineComponent({
  name: "Icon",
  props: {
    name: {
      type: String
    },
    fontClassName: {
      type: String,
      default: "iconfont-linkd"
    },
    color: String,
    size: String,
    rotate: {
      type: Boolean,
      default: false
    },
    deg: {
      type: Number,
      default: 180
    },
    direction: {
      type: String,
      default: "x"
    }
  },
  setup(props2, {
    slots
  }) {
    const iconOptions = computed(() => {
      return {
        class: [props2.fontClassName, "w-icon", props2.name, {
          ["w-icon-rotate-" + props2.direction]: props2.rotate
        }],
        style: {
          "font-size": props2.size,
          color: props2.color,
          "--w-icon-rotate-deg": props2.rotate ? `${props2.deg}deg` : 0
        }
      };
    });
    return () => {
      var _a;
      return createVNode("i", iconOptions.value, [(_a = slots.default) == null ? void 0 : _a.call(slots)]);
    };
  }
});
var index$H = /* @__PURE__ */ (() => ".w-icon{transition:var(--w-transition-time);display:inline-flex;font-size:var(--w-font-size-2);color:var(--w-color-font-4)}.w-icon.w-icon-rotate-x{transform:rotateX(180deg);transform:rotateX(var(--w-icon-rotate-deg, 180deg))}.w-icon.w-icon-rotate-y{transform:rotateY(180deg);transform:rotateY(var(--w-icon-rotate-deg, 180deg))}.w-icon.w-icon-rotate-z{transform:rotate(180deg);transform:rotate(var(--w-icon-rotate-deg, 180deg))}\n")();
function _isSlot$a(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
var Loading = defineComponent({
  name: "Loading",
  props: {
    ...Icon$1.props,
    size: {
      type: String,
      default: "15px"
    },
    show: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: "\u52AA\u529B\u52A0\u8F7D\u4E2D..."
    },
    hasTransition: {
      type: Boolean,
      default: true
    },
    transitionName: {
      type: String,
      default: "w-scale"
    }
  },
  emits: ["update:show", "update:text"],
  setup(props2, {
    slots,
    emit,
    expose
  }) {
    const root = ref();
    const _show = ref(props2.show);
    const _text = ref(props2.text);
    const _zIndex = ref(null);
    const wrapperOptions = computed(() => {
      return {
        class: "w-loading",
        ref: root,
        style: {
          "z-index": _zIndex.value
        }
      };
    });
    const iconOptions = computed(() => {
      return {
        name: props2.name || "w-icon-loading",
        color: props2.color,
        class: "w-loading-icon",
        style: {
          "--w-loading-icon-size": props2.size
        }
      };
    });
    function show() {
      _show.value = true;
    }
    function hide() {
      _show.value = false;
    }
    function setText(text) {
      _text.value = text;
    }
    function setZIndex(i) {
      var _a;
      _zIndex.value = i;
      (_a = root.value) == null ? void 0 : _a.style.setProperty("zIndex", i);
    }
    expose({
      show,
      hide,
      setText,
      setZIndex
    });
    watch(_show, (v2) => {
      emit("update:show", v2);
    });
    watch(() => props2.show, (v2) => {
      _show.value = v2;
    });
    watch(() => props2.text, (v2) => {
      _text.value = v2;
    });
    watch(_text, (t) => {
      emit("update:text", t);
    });
    return () => {
      var _a, _b;
      let comp = withDirectives(createVNode("div", wrapperOptions.value, [(_b = (_a = slots.default) == null ? void 0 : _a.call(slots)) != null ? _b : createVNode(Fragment, null, [createVNode(Icon$1, iconOptions.value, null), props2.text && createVNode("div", {
        "class": "w-loading-text"
      }, [_text.value])])]), [[vShow, _show.value]]);
      if (props2.hasTransition) {
        const _comp = function() {
          return comp;
        }();
        comp = createVNode(Transition, {
          "name": props2.transitionName
        }, _isSlot$a(comp) ? comp : {
          default: () => [_comp]
        });
      }
      return comp;
    };
  }
});
var index$G = /* @__PURE__ */ (() => ".w-loading{display:flex;flex-direction:column;align-items:center;justify-content:center}.w-loading.w-loading-mask{position:absolute;top:0;left:0;width:100%;height:100%;background-color:#ffffffbf}.w-loading .w-loading-text{color:var(--w-color-font-2);white-space:nowrap;margin-top:var(--w-gap)}.w-loading .w-loading-icon{--w-loading-icon-size: 14px;display:inline-flex;font-size:var(--w-loading-icon-size);width:var(--w-loading-icon-size);height:var(--w-loading-icon-size);color:var(--w-color-font-2);-webkit-animation:w-loading-roll 1.2s linear infinite;animation:w-loading-roll 1.2s linear infinite}@-webkit-keyframes w-loading-roll{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes w-loading-roll{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n")();
const { zIndex, add } = useGlobalZIndex();
const isStatic = (p) => p.toLowerCase() === "static";
function createLoading(el, { value }) {
  let div = document.createElement("div");
  const app = createApp(Loading, {
    class: "w-loading-mask",
    show: value.loading,
    text: value.text,
    transitionName: "w-fade-white"
  });
  const ins = app.mount(div);
  const position = getStyle(el, "position");
  if (isStatic(position)) {
    setStyle(el, { position: "relative" });
  }
  el["@loading"] = ins;
  el.appendChild(div);
}
const loadingDirective = {
  mounted(el, binding) {
    var _a;
    createLoading(el, binding);
    (_a = el["@loading"]) == null ? void 0 : _a.setZIndex(zIndex.value + "");
  },
  updated(el, binding) {
    if (el !== null) {
      if (binding.value.loading) {
        if (binding.value.text) {
          el["@loading"].setText(binding.value.text);
        }
        el["@loading"].setZIndex(add() + "");
        el["@loading"].show();
      } else {
        el["@loading"].hide();
      }
    }
  },
  beforeUnmount(el) {
    el["@loading"] = null;
  }
};
const NOOP = () => {
};
const docHandlers = /* @__PURE__ */ new Map();
function createHandler(el, bindingValue) {
  const exclude = [el];
  let handler = NOOP;
  if (isFunction(bindingValue)) {
    handler = bindingValue;
  } else if (isObject(bindingValue)) {
    const _els = [];
    let i = 0;
    const len = bindingValue.exclude.length;
    while (i < len) {
      const _el = getElement(bindingValue.exclude[i]);
      if (_el && isElement(_el)) {
        _els.push(_el);
      }
      i++;
    }
    exclude.push(..._els);
    handler = bindingValue.handler;
  }
  docHandlers.set(el, {
    exclude,
    handler,
    isOut: {
      mousedown: false,
      mouseup: false
    }
  });
}
const clickout = () => {
  const clickOutside2 = {
    mounted(el, binding) {
      createHandler(el, binding.value);
    },
    updated(el, binding) {
      createHandler(el, binding.value);
    },
    unmounted(el) {
      docHandlers.delete(el);
    }
  };
  return clickOutside2;
};
const docListener = (e) => {
  const tar = e.target;
  docHandlers.forEach(({ exclude, handler, isOut }, el) => {
    const isSelf = tar === el;
    const isContain = el.contains(tar);
    const isExclude = exclude.length && exclude.some((_el) => _el && (_el === tar || _el.contains(tar)));
    if (isSelf || isContain || isExclude) {
      if (e.type === "mousedown" || e.type === "mouseup") {
        isOut[e.type] = false;
      }
      return;
    } else {
      if (e.type === "mousedown" || e.type === "mouseup") {
        isOut[e.type] = true;
      }
    }
    if (isOut.mousedown && isOut.mouseup) {
      handler(e);
    }
  });
};
document.addEventListener("mousedown", docListener);
document.addEventListener("mouseup", docListener);
var clickOutside = clickout();
var _directives = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  vRoll: loadingDirective,
  vClickoutside: clickOutside
});
var Btn = defineComponent({
  name: "Btn",
  props: {
    tag: {
      type: String,
      default: "button"
    },
    type: {
      type: String,
      default: "default"
    },
    mode: String,
    block: Boolean,
    disabled: Boolean,
    capsule: Boolean,
    text: [String, Number, Object, Array]
  },
  setup(props2, {
    slots,
    attrs
  }) {
    const BtnGroup2 = inject("BtnGroupKey", void 0);
    const type4 = computed(() => {
      return (BtnGroup2 == null ? void 0 : BtnGroup2.type) || props2.type;
    });
    const klass = computed(() => {
      return ["w-btn", "w-btn-gap", {
        "w-btn-capsule": props2.capsule,
        "w-btn-block": props2.block,
        "w-btn-disabled": props2.disabled,
        [`w-btn-${type4.value}`]: type4.value,
        [`w-btn-mode-${props2.mode}`]: props2.mode
      }];
    });
    return () => {
      var _a;
      const mainBtn = h(props2.tag, {
        class: klass.value,
        onClick: (e) => {
          if (props2.disabled) {
            e.stopImmediatePropagation();
          }
        }
      }, ((_a = slots.default) == null ? void 0 : _a.call(slots)) || props2.text);
      return mainBtn;
    };
  }
});
var index$F = /* @__PURE__ */ (() => ".w-btn{border:none;background-color:transparent;display:inline-flex;border-radius:var(--w-radius);cursor:pointer;transition:var(--w-transition-time);padding:0 var(--w-padding-x);font-size:var(--w-font-size);height:var(--w-size);line-height:var(--w-size);align-items:center}.w-btn.w-btn-default{color:var(--w-color-font-2);background-color:var(--w-color-bg)}.w-btn.w-btn-default.w-btn-mode-text{color:var(--w-color-font-2);background-color:transparent}.w-btn.w-btn-default.w-btn-mode-text:hover{background-color:var(--w-color-bg)}.w-btn.w-btn-default.w-btn-mode-line{border-width:1px;border-color:var(--w-color-border);border-style:solid;background-color:transparent}.w-btn.w-btn-default.w-btn-mode-line:hover{background-color:var(--w-color-bg)}.w-btn.w-btn-primary{background-color:var(--w-color-primary);color:#fff}.w-btn.w-btn-primary.w-btn-mode-text{color:var(--w-color-primary);background-color:transparent}.w-btn.w-btn-primary.w-btn-mode-text:hover{background-color:var(--w-color-primary);color:#fff}.w-btn.w-btn-primary.w-btn-mode-line{border-width:1px;border-color:var(--w-color-primary);border-style:solid;background-color:transparent;color:var(--w-color-primary)}.w-btn.w-btn-primary.w-btn-mode-line:hover{background-color:var(--w-color-primary);color:#fff}.w-btn.w-btn-gap:not(:last-child){margin-right:var(--w-gap)}.w-btn.w-btn-capsule{border-radius:calc(var(--w-size) / 2)}.w-btn:hover{background-image:linear-gradient(-45deg,rgba(255,255,255,.2),rgba(255,255,255,.2));background-blend-mode:overlay}.w-btn.w-btn-block{display:flex;width:100%;justify-content:center}.w-btn.w-btn-disabled{cursor:not-allowed;opacity:.6}.w-btn *{line-height:var(--w-line-height);font-size:var(--w-font-size)}\n")();
function useTabIndex(el) {
  const _ = computed(() => getElement(el));
  function setTabindex() {
    const _el = _.value;
    if (_el && isElement(_el)) {
      const t = getStyle(_el, "tabindex");
      if (t === void 0) {
        setAttr(_el, { tabindex: -1 });
      }
    }
  }
  onMounted(setTabindex);
  onUpdated(setTabindex);
}
const isComment = (node) => node.type === Comment;
const isFragment = (node) => node.type === Fragment;
const isText = (node) => node.type === Text;
function useSlot(slotContent, isFirst = false, elementTag = "span") {
  return computed(() => {
    let c = slotContent.value;
    if (hasSlot(c)) {
      if (isFirst) {
        if (isFragment(c)) {
          c = c.children;
        }
        const first = getFirstValidChild(c);
        if (first !== void 0) {
          if (isText(first) || isFragment(first)) {
            const wrapper_c = createVNode(elementTag, {}, [first]);
            return wrapper_c;
          }
          return first;
        }
      } else {
        return c;
      }
    }
  });
}
function hasSlot(slotContent) {
  const c = slotContent;
  if (c === void 0 || c && isArray(c) && c.length === 0) {
    return false;
  }
  return true;
}
function getFirstValidChild(slotContent) {
  if (isArray(slotContent)) {
    let vnode;
    let i = 0;
    const len = slotContent.length;
    while (i < len) {
      const c = slotContent[i];
      if (!isComment(c)) {
        vnode = c;
        break;
      }
      i++;
    }
    return vnode;
  }
  return slotContent;
}
function useElement(v2) {
  const el = ref();
  const width = ref(0);
  const height = ref(0);
  function get(val) {
    const _el = getElement(val || v2);
    el.value = _el;
    return _el;
  }
  function getInvisibleElementSize$1(el2, nearby, relate, transitionName) {
    const s = getInvisibleElementSize(get(el2 || v2), nearby, relate, transitionName);
    width.value = s.width;
    height.value = s.height;
    return s;
  }
  onMounted(() => {
    v2 && get();
  });
  onUpdated(() => {
    v2 && get();
  });
  return { el, get, width, height, getInvisibleElementSize: getInvisibleElementSize$1 };
}
function useEvent(elem, type4, listener) {
  getCurrentInstance();
  const { el } = useElement(elem);
  function add2(node, eventType, handler) {
    const _el = node ? getElement(node) : el.value;
    const _type = eventType || type4;
    const fn = handler || listener;
    if (_el) {
      _el.addEventListener(_type, fn);
      el.value = _el;
    }
    return fn;
  }
  function remove(node, eventType, handler) {
    const _el = node ? getElement(node) : el.value;
    const _type = eventType || type4;
    const fn = handler || listener;
    if (_el) {
      _el.removeEventListener(_type, fn);
    }
  }
  watch(el, (v2) => {
    if (v2) {
      add2();
    }
  }, { immediate: true });
  onBeforeUnmount(() => {
    remove();
  });
  return {
    add: add2,
    remove
  };
}
function useDelay(msTime = 200) {
  const timer = ref(null);
  function clear() {
    stop();
    timer.value = null;
  }
  function stop() {
    clearTimeout(timer.value);
  }
  async function delay(handler, delayTime) {
    const len = arguments.length;
    const ms = arguments[0];
    stop();
    if (len === 1 && typeof arguments[0] === "number") {
      await new Promise((res) => {
        timer.value = setTimeout(() => {
          res(timer.value);
        }, ms != null ? ms : msTime);
      });
    } else {
      await new Promise((res) => {
        timer.value = setTimeout(() => {
          if (handler && typeof handler === "function") {
            handler();
          }
          res(timer.value);
        }, delayTime != null ? delayTime : msTime);
      });
    }
  }
  onUnmounted(clear);
  return { clear, delay, stop };
}
function _isSlot$9(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
var Mask = defineComponent({
  name: "Mask",
  props: {
    bind: {
      type: String,
      default: "v-if"
    },
    zIndex: Number,
    show: {
      type: Boolean,
      default: false
    },
    canCloseByClickSelf: {
      type: Boolean,
      default: false
    },
    to: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  emits: ["update:show", "get-ref"],
  setup(props2, {
    slots,
    emit
  }) {
    const root = ref(null);
    const {
      zIndex: zIndex2
    } = useGlobalZIndex();
    const visible = ref(props2.show);
    watch(() => props2.show, (v2) => {
      visible.value = v2;
    });
    watch(visible, (v2) => {
      emit("update:show", v2);
    });
    onMounted(() => {
      emit("get-ref", root);
    });
    const maskOptions = computed(() => {
      const o = {
        ref: root,
        class: "w-mask",
        style: {
          "--__w-mask-z-index": props2.zIndex || zIndex2.value
        },
        onClick: (e) => {
          if (e.target === root.value && props2.canCloseByClickSelf) {
            visible.value = false;
          }
        }
      };
      return o;
    });
    return () => {
      var _a;
      let main = createVNode("div", maskOptions.value, [(_a = slots.default) == null ? void 0 : _a.call(slots)]);
      if (props2.bind === "v-if") {
        main = visible.value && main;
      } else if (props2.bind === "v-show") {
        main = withDirectives(main, [[vShow, visible.value]]);
      }
      return createVNode(Teleport, {
        "to": props2.to
      }, {
        default: () => [createVNode(Transition, {
          "name": "w-mask-fade"
        }, _isSlot$9(main) ? main : {
          default: () => [main]
        })]
      });
    };
  }
});
var mask = /* @__PURE__ */ (() => ".w-mask{position:fixed;top:0;left:0;width:100%;height:100%;background-color:var(--w-mask-background-color);display:flex;align-items:center;justify-content:center;z-index:90;z-index:var(--__w-mask-z-index, 90)}.w-mask-fade-enter-active,.w-mask-fade-leave-active{transition:background-color var(--w-transition-slow-time) var(--w-cubic-bezier-quick)}.w-mask-fade-leave-active{transition:background-color var(--w-transition-time) var(--w-cubic-bezier)}.w-mask-fade-enter-from,.w-mask-fade-leave-to{background-color:#0000}\n")();
const LayerSizeKey = Symbol();
function _isSlot$8(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
const eventEnter = "mouseenter";
const eventLeave = "mouseleave";
const LayerProps = {
  bind: {
    type: String,
    default: "v-if"
  },
  show: {
    type: Boolean,
    default: false
  },
  manual: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean
  },
  placement: {
    type: String,
    default: "bottom"
  },
  gap: {
    type: Number,
    default: 6
  },
  offset: {
    type: Object,
    default: () => ({
      x: 0,
      y: 0
    })
  },
  arrowOffset: {
    type: Object,
    default: () => ({
      x: 0,
      y: 0
    })
  },
  trigger: {
    type: String,
    default: "click"
  },
  nearby: {
    type: Boolean,
    default: false
  },
  canCloseByClickOutside: {
    type: Boolean,
    default: true
  },
  exclude: {
    type: Array,
    default: () => []
  },
  transitionName: {
    type: String,
    default: "w-scale"
  },
  hasArrow: {
    type: Boolean,
    default: true
  },
  hasMask: {
    type: Boolean,
    default: false
  },
  layerCssVar: {
    type: Object,
    default: () => ({})
  },
  layerClass: {
    type: [String, Array, Object]
  },
  layerStyle: {
    type: Object,
    default: () => ({})
  },
  immediate: {
    type: Boolean,
    default: false
  },
  realTime: {
    type: Boolean,
    default: false
  },
  adjustPosition: {
    type: String,
    default: "auto"
  }
};
var Layer = defineComponent({
  name: "Layer",
  inheritAttrs: false,
  components: {
    Mask
  },
  props: LayerProps,
  emits: {
    "update:show": (v2) => true,
    "get-trigger-rect": (rect) => true,
    "get-layer-size": (size) => true,
    "get-layer-element": (elem) => true,
    "after-enter": (elem) => true
  },
  directives: {
    clickOutside
  },
  setup(props2, {
    slots,
    emit,
    expose
  }) {
    const Win = window;
    let scrollElements = [];
    const click_outside = resolveDirective("clickOutside");
    const visible = ref(props2.show);
    const {
      delay,
      stop
    } = useDelay();
    const {
      zIndex: zIndex2,
      add: addZIndex
    } = useGlobalZIndex();
    const triggerRoot = ref(null);
    const defaultRoot = ref();
    const justNow = ref(false);
    const triggerRect = reactive({
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: 0,
      height: 0
    });
    const defaultSize = reactive({
      width: 0,
      height: 0
    });
    provide(LayerSizeKey, readonly(toRefs(defaultSize)));
    const placementInfo = reactive({
      top: 0,
      left: 0,
      x: 0,
      y: 0,
      placement: props2.placement
    });
    const vnode_trigger = useSlot(computed(() => renderSlot(slots, "trigger", {
      toggle,
      hide,
      show
    })), true);
    const defaultOptions2 = computed(() => {
      const triggerType = props2.trigger;
      const pInfo = placementInfo;
      const placement = pInfo.placement;
      const options = {
        ref: defaultRoot,
        class: ["w-layer-content", `w-layer-${placement}`, {
          "w-layer-no-arrow": !props2.hasArrow || placement === "center" || placement === "client-center"
        }, props2.layerClass && normalizeClass(props2.layerClass)],
        style: {
          top: `${pInfo.top}px`,
          left: `${pInfo.left}px`,
          "z-index": zIndex2.value,
          "--_layer-arrow-x": `${pInfo.x}px`,
          "--_layer-arrow-y": `${pInfo.y}px`,
          ...props2.layerCssVar,
          ...props2.layerStyle
        }
      };
      if (triggerType === "hover") {
        options[`on${capitalize(eventEnter)}`] = () => {
          stop();
          show();
        };
        options[`on${capitalize(eventLeave)}`] = () => {
          delay(hide);
        };
      }
      return options;
    });
    if (!props2.manual) {
      useTriggerType(triggerRoot, props2.trigger, handleTriggerEvent);
    }
    useEvent(Win, "scroll", handleParentScroll);
    useEvent(Win, "resize", handleParentScroll);
    function hide() {
      visible.value = false;
    }
    function show() {
      visible.value = true;
    }
    function toggle() {
      visible.value = !visible.value;
    }
    function handleTriggerEvent(e) {
      if (props2.disabled) {
        return;
      }
      if (props2.trigger === "hover") {
        if (e.type === eventLeave) {
          delay(hide);
        } else if (e.type === eventEnter) {
          delay(() => {
            show();
          });
        }
      } else if (props2.trigger === "focus") {
        if (e.type === "focus") {
          show();
        } else if (e.type === "blur") {
          hide();
        }
      } else {
        toggle();
      }
    }
    function toGetDefaultPlacement(immediate = false) {
      if (visible.value || immediate) {
        const p = getPlacement({
          triggerRect,
          layerSize: defaultSize,
          placement: props2.placement,
          gap: props2.gap,
          offset: props2.offset,
          arrowOffset: props2.arrowOffset,
          layer: defaultRoot,
          adjustPosition: props2.adjustPosition
        });
        Object.assign(placementInfo, p);
      }
    }
    function calcTriggerRect(immediate = false) {
      if (immediate || visible.value && triggerRoot.value) {
        let rect = getElementPositionInPage(triggerRoot);
        for (const k in rect) {
          triggerRect[k] = rect[k];
        }
        emit("get-trigger-rect", readonly(rect));
        justNow.value = true;
      }
    }
    function getDefaultRootSize(maybeEl, immediate = false) {
      if (immediate || visible.value) {
        const {
          width,
          height
        } = getInvisibleElementSize(maybeEl, props2.nearby, triggerRoot.value, props2.transitionName);
        defaultSize.width = width;
        defaultSize.height = height;
        emit("get-layer-size", {
          width,
          height
        });
      }
    }
    function getScrollElementAndCalc() {
      if (visible.value && triggerRoot.value) {
        scrollElements = getParentScrollElement(triggerRoot.value);
        addEvent(scrollElements, "scroll", handleParentScroll);
      }
    }
    function handleParentScroll() {
      calcTriggerRect();
      toGetDefaultPlacement();
    }
    onBeforeUnmount(() => {
      removeEvent(scrollElements, "scroll", handleParentScroll);
      scrollElements = [];
    });
    onMounted(() => {
      calcTriggerRect(props2.immediate);
      getDefaultRootSize(defaultRoot.value, props2.immediate);
      toGetDefaultPlacement(props2.immediate);
      getScrollElementAndCalc();
    });
    onUpdated(() => {
      if (props2.realTime) {
        calcTriggerRect();
        getDefaultRootSize(defaultRoot.value);
        toGetDefaultPlacement();
      } else {
        if (!justNow.value) {
          calcTriggerRect();
        }
      }
    });
    watch(visible, (v2) => {
      emit("update:show", v2);
      if (v2) {
        addZIndex();
        calcTriggerRect();
        getScrollElementAndCalc();
      } else {
        removeEvent(scrollElements, "scroll", handleParentScroll);
      }
    });
    watch(() => props2.show, (v2) => {
      visible.value = v2;
    });
    const stopWatchLayerElement = watch(defaultRoot, (el) => {
      if (el) {
        emit("get-layer-element", el);
        stopWatchLayerElement();
      }
    });
    const dom = ref();
    expose({
      dom
    });
    function renderDefaultContent() {
      var _a;
      const _default = (_a = slots.default) == null ? void 0 : _a.call(slots, {
        toggle,
        hide,
        show
      });
      if (props2.bind === "v-show") {
        return withDirectives(createVNode("div", defaultOptions2.value, [_default]), [[vShow, visible.value]]);
      } else {
        return visible.value ? createVNode("div", defaultOptions2.value, [_default]) : null;
      }
    }
    return () => {
      let _slot;
      let trigger_content = vnode_trigger.value === void 0 ? void 0 : cloneVNode(vnode_trigger.value, {
        ref: triggerRoot
      });
      let default_content = createVNode(Transition, {
        "ref": dom,
        "name": props2.transitionName,
        "onBeforeEnter": (el) => {
          getDefaultRootSize(el);
          toGetDefaultPlacement();
        },
        "onAfterEnter": (el) => {
          justNow.value = false;
          emit("after-enter", el);
        }
      }, _isSlot$8(_slot = renderDefaultContent()) ? _slot : {
        default: () => [_slot]
      });
      if (props2.canCloseByClickOutside && !props2.manual) {
        const directive = [[click_outside, {
          handler: hide,
          exclude: [...props2.exclude, defaultRoot.value]
        }]];
        if (trigger_content) {
          trigger_content = withDirectives(trigger_content, directive);
        }
      }
      if (!props2.nearby) {
        const _default_content = function() {
          return default_content;
        }();
        default_content = createVNode(Teleport, {
          "to": "body"
        }, _isSlot$8(default_content) ? default_content : {
          default: () => [_default_content]
        });
      }
      return createVNode(Fragment, null, [trigger_content, props2.hasMask && createVNode(Mask, {
        "show": visible.value,
        "zIndex": zIndex2.value - 1,
        "onUpdate:show": (v2) => {
          visible.value = v2;
        }
      }, null), !props2.disabled && default_content]);
    };
  }
});
function addEvent(el, type4, fn) {
  let arr = isArray(el) ? el : [el];
  arr.forEach((e) => {
    e.addEventListener(type4, fn);
  });
}
function removeEvent(el, type4, fn) {
  let arr = isArray(el) ? el : [el];
  arr.forEach((e) => {
    e.removeEventListener(type4, fn);
  });
}
function useTriggerType(el, triggerType, handler) {
  switch (triggerType) {
    case "click":
      useEvent(el, triggerType, handler);
      break;
    case "hover":
      useEvent(el, eventEnter, handler);
      useEvent(el, eventLeave, handler);
      break;
    case "focus":
      useTabIndex(el);
      useEvent(el, "focus", handler);
      useEvent(el, "blur", handler);
  }
}
var index$E = /* @__PURE__ */ (() => '.w-layer-content{--_layer-border-color: var(--w-color-border);--_layer-background-color: white;--_layer-arrow-x: 5px;--_layer-arrow-y: 5px;--_layer-arrow-size: 4px;--_layer-arrow-gap: 1px;--_layer-color: var(--w-color-font-3);border:1px solid var(--_layer-border-color);max-height:100%;border-radius:var(--w-radius);position:absolute;color:var(--_layer-color);box-shadow:var(--w-box-shadow);background-color:var(--_layer-background-color);transform-origin:var(--_layer-arrow-x) var(--_layer-arrow-y)}.w-layer-content:after,.w-layer-content:before{content:"";position:absolute;height:0;width:0;border-width:var(--_layer-arrow-size);border-style:solid;border-color:transparent}.w-layer-content.w-layer-no-arrow:after,.w-layer-content.w-layer-no-arrow:before{display:none}.w-layer-content.w-layer-center{transform-origin:center center}.w-layer-content.w-layer-client-center{position:fixed}.w-layer-content.w-layer-bottom:before,.w-layer-content.w-layer-bottom-start:before,.w-layer-content.w-layer-bottom-end:before{left:var(--_layer-arrow-x);top:calc(var(--_layer-arrow-size) * -2 - var(--_layer-arrow-gap));border-color:transparent transparent var(--_layer-border-color)}.w-layer-content.w-layer-bottom:after,.w-layer-content.w-layer-bottom-start:after,.w-layer-content.w-layer-bottom-end:after{left:var(--_layer-arrow-x);top:calc(var(--_layer-arrow-size) * -2 - var(--_layer-arrow-gap) + 1px);border-color:transparent transparent var(--_layer-background-color)}.w-layer-content.w-layer-top:before,.w-layer-content.w-layer-top-start:before,.w-layer-content.w-layer-top-end:before{left:var(--_layer-arrow-x);top:calc(var(--_layer-arrow-y) - var(--_layer-arrow-gap));border-color:var(--_layer-border-color) transparent transparent}.w-layer-content.w-layer-top:after,.w-layer-content.w-layer-top-start:after,.w-layer-content.w-layer-top-end:after{left:var(--_layer-arrow-x);top:calc(var(--_layer-arrow-y) - var(--_layer-arrow-gap) - 1px);border-color:var(--_layer-background-color) transparent transparent}.w-layer-content.w-layer-left:before,.w-layer-content.w-layer-left-start:before,.w-layer-content.w-layer-left-end:before{left:calc(var(--_layer-arrow-x) - var(--_layer-arrow-gap));top:var(--_layer-arrow-y);border-color:transparent transparent transparent var(--_layer-border-color)}.w-layer-content.w-layer-left:after,.w-layer-content.w-layer-left-start:after,.w-layer-content.w-layer-left-end:after{left:calc(var(--_layer-arrow-x) - var(--_layer-arrow-gap) - 1px);top:var(--_layer-arrow-y);border-color:transparent transparent transparent var(--_layer-background-color)}.w-layer-content.w-layer-right:before,.w-layer-content.w-layer-right-start:before,.w-layer-content.w-layer-right-end:before{left:calc(var(--_layer-arrow-x) - var(--_layer-arrow-gap) - 1px);top:var(--_layer-arrow-y);border-color:transparent var(--_layer-border-color) transparent transparent}.w-layer-content.w-layer-right:after,.w-layer-content.w-layer-right-start:after,.w-layer-content.w-layer-right-end:after{left:calc(var(--_layer-arrow-x) - var(--_layer-arrow-gap));top:var(--_layer-arrow-y);border-color:transparent var(--_layer-background-color) transparent transparent}\n')();
var Close = defineComponent({
  name: "Close",
  props: {
    ...Icon$1.props,
    name: {
      type: String,
      default: "w-icon-close"
    }
  },
  setup: (props2, ctx) => {
    const iconOptions = computed(() => {
      return {
        name: props2.name,
        size: props2.size,
        class: "w-close",
        fontClassName: props2.fontClassName || "iconfont-linkd"
      };
    });
    return () => createVNode(Icon$1, iconOptions.value, null);
  }
});
var index$D = /* @__PURE__ */ (() => ".w-close{font-size:13px;color:var(--w-color-font-4);transition:var(--w-transition-time);cursor:pointer}.w-close:hover{color:var(--w-color-font-2)}\n")();
var Tooltip = defineComponent({
  inheritAttrs: false,
  components: {
    Layer
  },
  name: "Tooltip",
  props: {
    ...LayerProps,
    trigger: {
      ...LayerProps.trigger,
      default: "hover"
    }
  },
  setup(props2) {
    const d = 6;
    const translate = computed(() => {
      const p = props2.placement;
      let t = "";
      let gap = "0px";
      if (p.indexOf("left") > -1) {
        t = `translateX(${-1 * d}px)`;
        gap = "0px";
      } else if (p.indexOf("right") > -1) {
        t = `translateX(${d}px)`;
        gap = "3px";
      } else if (p.indexOf("bottom") > -1) {
        t = `translateY(${d}px)`;
        gap = "2px";
      } else if (p.indexOf("top") > -1) {
        t = `translateY(${-1 * d}px)`;
      }
      return {
        t,
        gap
      };
    });
    const layerOptions = computed(() => {
      const {
        t,
        gap
      } = translate.value;
      const varStyle = {
        "--_layer-border-color": "transparent",
        "--_layer-background-color": "rgba(0,0,0,.75)",
        "--_layer-color": "rgba(255,255,255,.95)",
        "--_layer-arrow-gap": gap,
        "--_layer-transform": t,
        ...props2.layerCssVar
      };
      return {
        ...useAttrs(),
        ...props2,
        trigger: props2.manual ? "click" : props2.trigger,
        layerCssVar: varStyle,
        layerClass: ["w-tooltip"],
        transitionName: "w-translate"
      };
    });
    return () => {
      return createVNode(Layer, layerOptions.value, useSlots());
    };
  }
});
var index$C = /* @__PURE__ */ (() => ".w-tooltip{padding:var(--w-padding-y) var(--w-padding-x);line-height:var(--w-line-height)}.w-translate-enter-active,.w-translate-leave-active{transition:var(--w-transition-slow-time) var(--w-cubic-bezier-quick);perspective:1000px}.w-translate-leave-active{transition:var(--w-transition-time) var(--w-cubic-bezier);perspective:1000px}.w-translate-enter-from,.w-translate-leave-to{transform:var(--_layer-transform);opacity:0}\n")();
var Trigger = defineComponent({
  name: "Trigger",
  components: {
    Close,
    Icon: Icon$1,
    Loading,
    Tooltip
  },
  props: {
    loading: Boolean,
    active: Boolean,
    clearable: Boolean,
    disabled: Boolean,
    block: Boolean,
    placeholder: [String, Object, Array],
    text: {
      type: [String, Number, Object, Array]
    },
    hasTip: {
      type: Boolean,
      default: true
    }
  },
  emits: ["clear"],
  setup(_, {
    emit,
    slots
  }) {
    const triggerOptions = computed(() => {
      return {
        class: ["w-trigger", {
          "w-trigger-block": _.block,
          "w-trigger-disabled": _.disabled,
          "w-trigger-active": _.active
        }]
      };
    });
    function renderClose() {
      return !_.disabled && _.clearable && (_.text || slots.default) && createVNode(Close, {
        "name": "w-icon-close-fill",
        "onClick": (e) => {
          e.stopPropagation();
          emit("clear");
        }
      }, null);
    }
    return () => {
      var _a, _b;
      let cont = createVNode("div", {
        "class": ["w-trigger-text", "w-ellipsis"]
      }, [(_b = _.text || ((_a = slots.default) == null ? void 0 : _a.call(slots))) != null ? _b : createVNode("span", {
        "class": "w-text-placeholder w-no-select"
      }, [_.placeholder])]);
      let main = createVNode("div", triggerOptions.value, [cont, createVNode("div", {
        "class": "w-trigger-icon"
      }, [renderClose(), _.loading ? createVNode(Loading, {
        "text": "",
        "show": _.loading
      }, null) : createVNode(Icon$1, {
        "name": "w-icon-arrow-down",
        "rotate": _.active
      }, null)])]);
      return main;
    };
  }
});
var index$B = /* @__PURE__ */ (() => ".w-trigger{position:relative;display:inline-flex;align-items:center;justify-content:space-between;height:var(--w-size);padding:0 var(--w-padding-x);outline:0;width:var(--w-form-item-width);border:1px solid var(--w-form-item-border-color);border-radius:var(--w-radius);background-color:var(--w-choose-background);cursor:pointer;transition:var(--w-transition-time)}.w-trigger .w-trigger-text{color:var(--w-color-font-2);flex:1;width:0;-webkit-user-select:none;-moz-user-select:none;user-select:none}.w-trigger .w-trigger-icon{flex-shrink:0}.w-trigger.w-trigger-block{display:flex;flex:1;width:auto}.w-trigger:hover:not(.w-trigger-disabled){border-color:var(--w-form-item-border-color-focus)}.w-trigger.w-trigger-disabled{color:var(--w-color-disabled);background-color:var(--w-form-item-disabled-color);cursor:not-allowed}.w-trigger.w-trigger-active{border-color:var(--w-form-item-border-color-focus)}\n")();
function _isSlot$7(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
var Empty = defineComponent({
  name: "Empty",
  props: {
    ...Icon$1.props,
    size: {
      type: String,
      default: "24px"
    },
    show: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: "\u6682\u65E0\u76F8\u5173\u6570\u636E"
    },
    hasTransition: {
      type: Boolean,
      default: true
    },
    transitionName: {
      type: String,
      default: "w-scale"
    }
  },
  setup(props2, {
    slots
  }) {
    const wrapperOptions = computed(() => {
      return {
        class: "w-empty"
      };
    });
    const iconOptions = computed(() => {
      return {
        name: props2.name || "w-icon-empty",
        color: props2.color,
        class: "w-empty-icon",
        style: {
          "--w-empty-icon-size": props2.size
        }
      };
    });
    return () => {
      var _a, _b;
      let comp = withDirectives(createVNode("div", wrapperOptions.value, [(_b = (_a = slots.default) == null ? void 0 : _a.call(slots)) != null ? _b : createVNode(Fragment, null, [createVNode(Icon$1, iconOptions.value, null), props2.text && createVNode("div", {
        "class": "w-empty-text"
      }, [props2.text])])]), [[vShow, props2.show]]);
      if (props2.hasTransition) {
        const _comp = function() {
          return comp;
        }();
        comp = createVNode(Transition, {
          "name": props2.transitionName
        }, _isSlot$7(comp) ? comp : {
          default: () => [_comp]
        });
      }
      return comp;
    };
  }
});
var index$A = /* @__PURE__ */ (() => ".w-empty{display:flex;flex-direction:column;align-items:center;justify-content:center}.w-empty .w-empty-text{color:var(--w-color-font-2);white-space:nowrap;margin-top:var(--w-gap)}.w-empty .w-empty-icon{--w-empty-icon-size: 14px;display:inline-flex;font-size:var(--w-empty-icon-size);color:var(--w-color-font-2)}\n")();
var Fallback = defineComponent({
  name: "Fallback",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    empty: {
      type: Boolean,
      default: false
    },
    loadingProps: {
      type: Object,
      default: () => ({})
    },
    emptyProps: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props2, {
    slots
  }) {
    const loadingOptions = computed(() => {
      return {
        ...props2.loadingProps,
        hasTransition: false,
        show: true,
        class: "w-fallback"
      };
    });
    const emptyOptions = computed(() => {
      return {
        ...props2.emptyProps,
        hasTransition: false,
        show: true,
        class: "w-fallback"
      };
    });
    return () => {
      const loadingComp = createVNode(Loading, loadingOptions.value, {
        default: slots.loading
      });
      const emptyComp = createVNode(Empty, emptyOptions.value, {
        default: slots.empty
      });
      return createVNode(Transition, {
        "name": "w-scale",
        "mode": "out-in"
      }, {
        default: () => [props2.loading ? loadingComp : props2.empty ? emptyComp : null]
      });
    };
  }
});
var index$z = /* @__PURE__ */ (() => ".w-fallback{padding:20px;min-height:90px}\n")();
function useToggleArray(data, current, keyField) {
  const computedData = computed(() => unref(data));
  const len = computed(() => computedData.value.length);
  const index2 = ref(0);
  const item = ref();
  function _set(current2) {
    if (current2) {
      if ("item" in current2) {
        item.value = unref(current2.item);
        index2.value = computedData.value.findIndex((d) => d === item.value);
      } else if ("index" in current2) {
        index2.value = unref(isRef(current2.index) ? current2.index.value : current2.index);
        item.value = computedData.value[index2.value];
      }
    }
  }
  function _init() {
    _set(current || { index: index2.value });
  }
  function toggle() {
    if (len.value > 0) {
      const nextIndex = (index2.value + 1) % len.value;
      item.value = computedData.value[nextIndex];
      index2.value = nextIndex;
    }
    return {
      item: item.value,
      index: index2.value
    };
  }
  function prev() {
    if (len.value > 0) {
      let prevIndex = index2.value - 1;
      if (prevIndex === -1) {
        prevIndex = computedData.value.length + prevIndex;
      }
      set({ index: prevIndex });
    }
  }
  function set(current2) {
    _set(current2);
  }
  function setByKey(k, localKeyField) {
    const field = localKeyField || keyField;
    if (field) {
      const i = computedData.value.findIndex((el, i2) => {
        if (typeof el === "object") {
          return k === el[field];
        }
      });
      if (i > -1) {
        index2.value = i;
        item.value = computedData.value[i];
      }
    }
  }
  function get() {
    const item2 = computedData.value[index2.value];
    return {
      item: item2,
      index: index2.value
    };
  }
  _init();
  watch([() => current == null ? void 0 : current.index, () => current == null ? void 0 : current.item, computedData], _init);
  return {
    toggle,
    next: toggle,
    prev,
    item,
    index: index2,
    set,
    setByKey,
    get
  };
}
var Checkbox = defineComponent({
  name: "Checkbox",
  components: {
    Icon: Icon$1
  },
  props: {
    modelValue: {
      type: [Boolean, Number, Array],
      default: 0
    },
    disabled: Boolean,
    value: {
      type: [Number, String, Array, Boolean],
      default: () => [0, 1]
    },
    text: String,
    iconSize: String,
    iconColor: String,
    iconName: String,
    gap: {
      type: Boolean,
      default: true
    },
    validateEvent: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props2, ctx) {
    const selectCheck = inject("selectCheck", void 0);
    const parentValue = inject("parentValue", void 0);
    const formItem = inject("formItem", void 0);
    if (isArray(props2.value) || typeof props2.value === "boolean") {
      return checkone(props2, ctx, formItem);
    }
    return more(props2, ctx, formItem, selectCheck, parentValue);
  }
});
function more(props2, ctx, formItem, selectCheck, parentValue) {
  const symbol = computed(() => Symbol(props2.value));
  const data = computed(() => [symbol.value, props2.value]);
  const has = computed(() => (parentValue ? parentValue.value : props2.modelValue).some((v2) => v2 === props2.value));
  const {
    toggle,
    item
  } = useToggleArray(data, reactive({
    item: computed(() => has.value ? props2.value : symbol.value)
  }));
  const isChecked = computed(() => item.value === props2.value);
  const iconProps = useIconProps(isChecked, props2, ctx.slots);
  return () => {
    var _a, _b, _c;
    const p = {
      class: ["w-checkbox", {
        "w-checkbox-gap": props2.gap
      }]
    };
    if (!props2.disabled) {
      p.onClick = (e) => {
        if (!props2.disabled) {
          let a = parentValue ? parentValue.value : props2.modelValue;
          let arr = [...a];
          toggle();
          if (isChecked.value) {
            arr.push(props2.value);
          } else {
            arr = arr.filter((a2) => a2 !== props2.value);
          }
          ctx.emit("update:modelValue", arr);
          if (selectCheck) {
            selectCheck(arr);
          }
          ctx.emit("change", isChecked.value);
          if (formItem && formItem !== void 0) {
            if (props2.validateEvent) {
              formItem == null ? void 0 : formItem.validate("change");
            }
          }
        }
      };
    }
    return createVNode("span", p, [createVNode(Icon$1, iconProps.value, null), (_c = props2.text) != null ? _c : (_b = (_a = ctx.slots).default) == null ? void 0 : _b.call(_a)]);
  };
}
function checkone(props2, ctx, formItem) {
  const {
    toggle,
    item
  } = useToggleArray(computed(() => typeof props2.value === "boolean" ? [true, false] : props2.value), reactive({
    item: computed(() => props2.modelValue)
  }));
  const iconProps = useIconProps(computed(() => item.value === 1 || item.value === true), props2, ctx.slots);
  return () => {
    var _a, _b, _c;
    const p = {
      class: ["w-checkbox", {
        "w-checkbox-gap": props2.gap
      }]
    };
    if (!props2.disabled) {
      p.onClick = (e) => {
        if (!props2.disabled) {
          toggle();
          ctx.emit("update:modelValue", item.value);
          ctx.emit("change", item.value);
          if (formItem && formItem !== void 0) {
            if (props2.validateEvent) {
              formItem == null ? void 0 : formItem.validate("change");
            }
          }
        }
      };
    }
    return createVNode("span", p, [createVNode(Icon$1, iconProps.value, null), (_c = props2.text) != null ? _c : (_b = (_a = ctx.slots).default) == null ? void 0 : _b.call(_a)]);
  };
}
function useIconProps(isChecked, props2, slots) {
  return computed(() => {
    var _a;
    const hasCont = props2.text || ((_a = slots == null ? void 0 : slots.default) == null ? void 0 : _a.call(slots));
    return {
      name: isChecked.value ? "w-icon-checkbox-fill" : props2.disabled ? "w-icon-square" : "w-icon-checkbox",
      class: ["w-checkbox-icon", {
        "w-checkbox-icon-gap": hasCont,
        "w-checkbox-icon-checked": isChecked.value,
        "w-checkbox-icon-disabled": props2.disabled
      }],
      size: props2.iconSize,
      color: props2.iconColor
    };
  });
}
var index$y = /* @__PURE__ */ (() => ".w-checkbox{display:inline-flex;cursor:default;align-items:center}.w-checkbox .w-checkbox-icon{color:var(--w-color-font-3)}.w-checkbox .w-checkbox-icon.w-checkbox-icon-gap{margin-right:var(--w-checkbox-icon-gap)}.w-checkbox .w-checkbox-icon:hover:not(.w-checkbox-icon-disabled){color:var(--w-color-primary)}.w-checkbox .w-checkbox-icon.w-checkbox-icon-checked{color:var(--w-color-primary)}.w-checkbox .w-checkbox-icon.w-checkbox-icon-disabled{cursor:not-allowed;color:var(--w-color-font-4);opacity:.6}.w-checkbox.w-checkbox-gap:not(:last-child){margin-right:var(--w-checkbox-item-gap)}\n")();
function useSearch(sourceData, searchText2, dontSearch, textField, afterSearch) {
  const filterData = ref([]);
  function toSearch(t) {
    var _a, _b;
    if (dontSearch.value === true) {
      return;
    }
    if (typeof t === void 0 || typeof t === "string" && t === "") {
      filterData.value = JSON.parse(JSON.stringify(sourceData.value));
    } else {
      t = t == null ? void 0 : t.trim();
      let isEqual = false;
      let i = 0;
      const len = ((_a = sourceData.value) == null ? void 0 : _a.length) || 0;
      while (i < len) {
        const item = sourceData.value ? sourceData.value[i] : void 0;
        const itemType = typeof item;
        let currentRowText;
        if (itemType === "string" || itemType === "number") {
          currentRowText = item;
        } else {
          if (textField === void 0 || textField === "" || textField === null) {
            console.warn("\u8BF7\u4F20\u5165keyField\u53C2\u6570");
          } else if (isObject(item)) {
            currentRowText = item[textField];
          }
        }
        if (item !== void 0) {
          if (currentRowText === t) {
            filterData.value = [item];
            isEqual = true;
            break;
          } else {
            const ts = (t + "").split(/\s+/g);
            filterData.value = ((_b = sourceData.value) == null ? void 0 : _b.filter((d) => {
              const txt = d[textField];
              return ts.every((v2) => {
                return txt.indexOf(v2) > -1;
              });
            })) || [];
          }
        }
        i++;
      }
      afterSearch && afterSearch(filterData.value.length, false, isEqual, i);
    }
  }
  watch([searchText2, sourceData], ([t, d]) => {
    if (d && d.length) {
      toSearch(t);
    } else {
      filterData.value = [];
    }
  }, { immediate: true, deep: true });
  return filterData;
}
function _isSlot$6(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
var List = defineComponent({
  name: "List",
  inheritAttrs: false,
  components: {
    Fallback,
    Checkbox
  },
  props: {
    data: [Array, Object],
    disabled: Boolean,
    checkable: Function,
    activable: Function,
    searchText: String,
    all: Boolean,
    disabledData: {
      type: Array,
      default: () => []
    },
    keys: {
      type: Array,
      default: () => []
    },
    keyField: {
      type: String,
      default: "Id"
    },
    textField: {
      type: String,
      default: "Name"
    },
    hasCheckbox: {
      type: Boolean,
      default: false
    },
    itemClass: {
      type: [Array, Object, String]
    },
    ...Fallback.props
  },
  emits: [
    "toggle",
    "update:keys",
    "update:all"
  ],
  setup(props2, ctx) {
    const checkedKeys = ref(props2.keys);
    const _st = ref(props2.searchText || "");
    const _isAll = ref(props2.all);
    const hasResult = computed(() => {
      const d = filterData.value;
      const sd = props2.data;
      if (sd.length) {
        return d.length > 0;
      }
      return props2.loading || props2.empty;
    });
    const dontSearch = ref(false);
    const filterData = useSearch(computed(() => props2.data), _st, dontSearch, props2.textField);
    function search(text) {
      _st.value = text;
      setTimeout(toCheckAll);
    }
    function checkAll(checked) {
      const d = filterData.value;
      if (d && isArray(d)) {
        if (checked) {
          checkedKeys.value = d.filter(is_d).map((item) => item[props2.keyField]);
        } else {
          checkedKeys.value = [];
        }
        ctx.emit("update:keys", [...checkedKeys.value]);
      }
      _isAll.value = checked;
    }
    function renderItem(item, index2, {
      isActive,
      isDisabled,
      isChecked
    }) {
      var _a, _b, _c;
      const itemOptions = {
        class: ["w-list-item", {
          "w-list-item-active": isActive,
          "w-list-item-disabled": isDisabled
        }, normalizeClass(props2.itemClass)],
        onClick: () => {
          if (isDisabled || isActive) {
            return;
          }
          ctx.emit("toggle", item, index2);
        }
      };
      const cont = (_c = (_b = (_a = ctx.slots).default) == null ? void 0 : _b.call(_a, {
        item,
        index: index2,
        isActive,
        isDisabled
      })) != null ? _c : getItemValue(item, props2.textField);
      if (props2.hasCheckbox) {
        const checkboxOptions = {
          class: ["w-list-item", {
            "w-list-item-disabled": isDisabled,
            "w-list-item-active": isChecked
          }, normalizeClass(props2.itemClass)],
          modelValue: checkedKeys.value,
          gap: false,
          value: item[props2.keyField],
          disabled: isDisabled,
          "onUpdate:modelValue": (arr) => {
            checkedKeys.value = arr;
            ctx.emit("toggle", item, index2, filterData.value.filter((item2) => checkedKeys.value.some((k) => k == item2[props2.keyField])));
            ctx.emit("update:keys", [...checkedKeys.value]);
          },
          onChange: (b) => {
            if (b) {
              toCheckAll();
            } else {
              _isAll.value = false;
            }
            ctx.emit("update:all", _isAll.value);
          }
        };
        return createVNode(Checkbox, checkboxOptions, _isSlot$6(cont) ? cont : {
          default: () => [cont]
        });
      }
      return createVNode("div", itemOptions, [cont]);
    }
    function renderList2() {
      const d = filterData.value;
      let b = true;
      if (d && isArray(d)) {
        const items = d.map((item, index2) => {
          const isActive = props2.activable && props2.activable(item, index2);
          const isChecked = is_c(item);
          const isDisabled = !is_d(item, index2) || item.disabled || props2.disabledData.includes(item[props2.keyField]);
          if (!isChecked) {
            b = false;
          }
          return renderItem(item, index2, {
            isActive,
            isChecked,
            isDisabled
          });
        });
        if (items.length) {
          _isAll.value = b;
        }
        return items;
      }
    }
    function is_c(item) {
      return props2.hasCheckbox && checkedKeys.value.some((k) => k == item[props2.keyField]);
    }
    function is_d(item, index2) {
      return props2.checkable ? props2.checkable(item, index2) : true;
    }
    function toCheckAll() {
      const keys2 = checkedKeys.value;
      const filters = filterData.value.filter(is_d);
      let b = false;
      if (keys2.length > 0 && filters.length > 0) {
        if (filters.length > keys2.length) {
          b = false;
        } else {
          b = filters.every((item) => keys2.some((_k) => _k == item[props2.keyField]));
        }
      }
      _isAll.value = b;
      ctx.emit("update:all", b);
    }
    function wrapper(cont) {
      var _a, _b, _c, _d;
      return createVNode(Fragment, null, [(_b = (_a = ctx.slots).search) == null ? void 0 : _b.call(_a, {
        search
      }), cont, (_d = (_c = ctx.slots).checkAll) == null ? void 0 : _d.call(_c, {
        checkAll
      })]);
    }
    onMounted(() => {
    });
    watch(() => props2.keys, (arr) => {
      checkedKeys.value = arr;
    });
    watch(() => props2.searchText, (t) => {
      _st.value = t;
    });
    return () => {
      const fallback = createVNode(Fallback, {
        "loading": props2.loading,
        "empty": props2.empty
      }, null);
      return props2.loading || props2.empty ? wrapper(fallback) : hasResult.value ? wrapper(createVNode("div", {
        "class": ["w-list", normalizeClass(ctx.attrs.class)]
      }, [renderList2()])) : wrapper(createVNode(Fallback, {
        "empty": true,
        "emptyProps": {
          text: "\u6CA1\u6709\u5339\u914D\u5230\u76F8\u5173\u6570\u636E"
        }
      }, null));
    };
  }
});
var index$x = /* @__PURE__ */ (() => ".w-list{background-color:#fff;white-space:nowrap;text-overflow:ellipsis}.w-list .w-list-fallback{min-height:70px;overflow:hidden}.w-list-item{height:var(--w-size);line-height:var(--w-size);padding:0 var(--w-padding-x);color:var(--w-color-font-2);cursor:pointer;display:block;transition:var(--w-transition-time)}.w-list-item.w-list-item-between{display:flex;align-items:center;justify-content:space-between}.w-list-item.w-list-item-disabled{color:var(--w-color-disabled);cursor:not-allowed}.w-list-item.w-list-item-active{color:var(--w-color-primary);background-color:var(--w-color-primary-light-9)}.w-list-item:hover:not(.w-list-item-disabled){background-color:var(--w-color-bg)}\n")();
var Cascade = defineComponent({
  name: "Cascade",
  components: {
    Layer,
    Trigger,
    List,
    Icon: Icon$1
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    show: Boolean,
    disabled: Boolean,
    block: Boolean,
    disabledData: {
      type: Array,
      default: () => []
    },
    clearable: Boolean,
    placeholder: String,
    data: {
      type: Array,
      default: () => []
    },
    keyField: {
      type: String,
      default: "id"
    },
    textField: {
      type: String,
      default: "name"
    },
    childField: {
      type: String,
      default: "children"
    },
    checkable: Function,
    sign: {
      type: String,
      default: "-"
    }
  },
  emits: ["update:show", "update:modelValue", "toggle", "clear"],
  setup(_, {
    slots,
    emit
  }) {
    const visible = ref(_.show);
    const formItem = inject("formItem", void 0);
    const path = ref(_.modelValue);
    const current = computed(() => {
      const f = _.keyField;
      const pv = path.value;
      const _d = _.data;
      if (pv && pv.length && _d && _d.length) {
        const one = pv[0];
        const item = _d.filter((row) => row[f] == one[f])[0];
        if (item) {
          return item;
        }
      }
    });
    const layerOptions = computed(() => {
      return {
        layerClass: "w-cascade-layer",
        show: visible.value,
        disabled: _.disabled,
        placement: "bottom-start",
        hasArrow: false,
        gap: 2,
        transitionName: "w-slide-y",
        "onUpdate:show": (b) => {
          visible.value = b;
        }
      };
    });
    const triggerOptions = computed(() => {
      const s = _.sign;
      const text = path.value.reduce((str, obj) => {
        if (str) {
          return `${str}${s}${obj[_.textField]}`;
        }
        return obj[_.textField];
      }, "");
      return {
        active: visible.value,
        block: _.block,
        disabled: _.disabled,
        clearable: _.clearable,
        placeholder: _.placeholder,
        text,
        onClear: clear
      };
    });
    function isSameItem(item, itemInPath) {
      if (_.keyField) {
        return item[_.keyField] === itemInPath[_.keyField];
      } else {
        console.warn("\u8BF7\u4F20\u5165keyField\u53C2\u6570");
        return false;
      }
    }
    function findDetailByKey(k, indexPath) {
      let arr = [];
      function get(data) {
        let i = 0;
        const len = data.length;
        while (i < len) {
          const item = data[i];
          const key = item[_.keyField];
          if (key == k) {
            arr = item[_.childField];
            break;
          } else {
            if (item[_.childField]) {
              get(item[_.childField]);
            }
          }
          i++;
        }
      }
      if (current.value) {
        if (indexPath === 1) {
          return current.value[_.childField];
        }
        get(current.value[_.childField]);
      }
      return arr;
    }
    function renderList2(indexPath) {
      let data = _.data;
      if (indexPath !== 0) {
        const parentIndex = indexPath - 1;
        const k = path.value[parentIndex][_.keyField];
        data = findDetailByKey(k, indexPath);
      }
      if (data && data.length === 0 || !data) {
        return null;
      }
      const listOptions = {
        data,
        disabledData: _.disabledData,
        checkable: _.checkable,
        activable: (item) => {
          if (path.value[indexPath])
            return isSameItem(item, path.value[indexPath]);
        },
        keyField: _.keyField,
        textField: _.textField,
        class: "w-cascade-list",
        itemClass: "w-list-item-between",
        onToggle: (item, index2) => {
          const _item = {
            ...item
          };
          if (indexPath === 0) {
            const one = path.value[0];
            if (one) {
              if (!isSameItem(item, one)) {
                path.value = [_item];
              }
            } else {
              path.value.push(_item);
            }
          } else {
            const curItem = path.value[indexPath];
            if (curItem) {
              if (!isSameItem(item, curItem)) {
                path.value = path.value.slice(0, indexPath).concat([_item]);
              }
            } else {
              path.value.push(_item);
            }
          }
          const copy = JSON.parse(JSON.stringify(path.value));
          emit("update:modelValue", copy);
          emit("toggle", copy);
          formItem == null ? void 0 : formItem.validate("change");
          if (!item[_.childField] || item[_.childField] && item[_.childField].length === 0) {
            visible.value = false;
          }
        }
      };
      const listSlots = {
        default: ({
          item,
          isActive
        }) => {
          return createVNode(Fragment, null, [createVNode("span", null, [item[_.textField]]), item[_.childField] && item[_.childField].length > 0 && createVNode(resolveComponent("icon"), {
            "class": ["w-cascade-icon", {
              "w-cascade-icon-active": isActive
            }],
            "name": "w-icon-arrow-down",
            "rotate": true,
            "deg": -90,
            "direction": "z"
          }, null)]);
        }
      };
      return createVNode(List, listOptions, listSlots);
    }
    function clear() {
      path.value = [];
      emit("update:modelValue", []);
      emit("clear");
      formItem == null ? void 0 : formItem.validate("change");
    }
    watch(() => _.show, (v2) => {
      visible.value = v2;
    });
    watch(visible, (v2) => {
      emit("update:show", v2);
    });
    watch(() => _.modelValue, (a) => {
      path.value = a;
    });
    return () => {
      const layerSlots = {
        trigger: () => createVNode(Trigger, triggerOptions.value, null),
        default: () => {
          return [renderList2(0), path.value.map((item, index2, arr) => {
            return renderList2(index2 + 1);
          })];
        }
      };
      return createVNode(Layer, layerOptions.value, layerSlots);
    };
  }
});
var index$w = /* @__PURE__ */ (() => ".w-cascade-layer{display:flex;align-items:flex-start;max-height:300px}.w-cascade-layer .w-cascade-list{align-self:stretch;max-height:300px;min-width:80px;overflow:auto}.w-cascade-layer .w-cascade-list:first-child{border-top-left-radius:var(--w-radius);border-bottom-left-radius:var(--w-radius)}.w-cascade-layer .w-cascade-list:last-child{border-top-right-radius:var(--w-radius);border-bottom-right-radius:var(--w-radius)}.w-cascade-layer .w-cascade-list:not(:last-child){border-right:1px solid var(--w-color-border)}.w-cascade-layer .w-cascade-list .w-cascade-list-disabled{color:var(--w-color-disabled);cursor:not-allowed}.w-cascade-layer .w-cascade-list .w-cascade-icon{font-size:12px;margin-left:calc(2 * var(--w-gap));transition:left var(--w-transition-time);position:relative;left:0}.w-cascade-layer .w-cascade-list .w-cascade-icon.w-cascade-icon-active{color:var(--w-color-primary);left:7px}\n")();
var CheckBoxGroup = defineComponent({
  name: "CheckBoxGroup",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    disabled: Boolean,
    validateEvent: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props2, ctx) {
    const formItem = inject("formItem", void 0);
    watch(() => props2.modelValue, (v2) => {
      ctx.emit("change", v2);
      if (props2.validateEvent) {
        formItem == null ? void 0 : formItem.validate("change");
      }
    });
    const arr = computed(() => {
      return props2.modelValue;
    });
    provide("parentValue", arr);
    provide("selectCheck", (v2) => {
      ctx.emit("update:modelValue", v2);
    });
    return () => {
      var _a, _b;
      return createVNode("div", null, [(_b = (_a = ctx.slots).default) == null ? void 0 : _b.call(_a)]);
    };
  }
});
var index$v = /* @__PURE__ */ (() => "")();
function useBoundingClientRect(el) {
  const elem = computed(() => getElement(el));
  const rect = reactive({
    height: 0,
    width: 0,
    x: 0,
    y: 0,
    bottom: 0,
    left: 0,
    right: 0,
    top: 0
  });
  function get() {
    if (elem.value && isElement(elem.value))
      Object.assign(rect, getBoundingClientRect(elem.value).toJSON());
  }
  onMounted(get);
  useEvent(window, "resize", get);
  return {
    elem,
    rect
  };
}
function useScroll(elem, scrollCallback, immediate) {
  const el = computed(() => getElement(elem));
  const scrollTop = ref(0);
  const scrollLeft = ref(0);
  const scrollRight = ref(0);
  const scrollBottom = ref(0);
  function get() {
    const _el = el.value;
    if (_el) {
      if (isElement(_el)) {
        scrollTop.value = _el.scrollTop;
        scrollLeft.value = _el.scrollLeft;
        scrollRight.value = _el.scrollWidth - scrollLeft.value - _el.clientWidth;
        scrollBottom.value = _el.scrollHeight - scrollTop.value - _el.clientHeight;
      } else if (isWindow(_el)) {
        const s = getPageScroll();
        const { inner } = getWindowSize();
        scrollTop.value = s.y;
        scrollLeft.value = s.x;
        scrollBottom.value = document.documentElement.scrollHeight - s.y - inner.height;
        scrollRight.value = document.documentElement.scrollWidth - s.x - inner.width;
      }
    }
  }
  function doCallback() {
    scrollCallback == null ? void 0 : scrollCallback({
      scrollTop: scrollTop.value,
      scrollBottom: scrollBottom.value,
      scrollLeft: scrollLeft.value,
      scrollRight: scrollRight.value
    });
  }
  useEvent(el, "scroll", () => {
    get();
    doCallback();
  });
  onMounted(() => {
    get();
    if (immediate) {
      doCallback();
    }
  });
  return { scrollTop, scrollLeft, scrollRight, scrollBottom, getScroll: get };
}
var Virtual = defineComponent({
  name: "Virtual",
  props: {
    sourceData: {
      type: Array,
      default: () => []
    },
    itemHeight: {
      type: Number,
      default: 0
    }
  },
  setup: (props2, ctx) => {
    const root = ref();
    const {
      scrollTop
    } = useScroll(root, handleScroll, true);
    const {
      rect: visibleSize
    } = useBoundingClientRect(root);
    const sourceLength = computed(() => props2.sourceData.length);
    const fromIndex = ref(0);
    const visibleDataLength = computed(() => {
      return Math.ceil(Math.max(visibleSize.height) / (props2.itemHeight || 1));
    });
    const toIndex = computed(() => {
      const to = visibleDataLength.value + fromIndex.value + 1;
      return Math.min(to, sourceLength.value);
    });
    const visibleData = computed(() => props2.sourceData.slice(fromIndex.value, toIndex.value));
    const startPlaceholderHeight = computed(() => {
      return fromIndex.value * props2.itemHeight;
    });
    const endPlaceholderHeight = computed(() => {
      let n = sourceLength.value - 1 - toIndex.value;
      n = n < 0 ? 0 : n;
      return n * props2.itemHeight;
    });
    function handleScroll(e) {
      fromIndex.value = Math.floor(scrollTop.value / props2.itemHeight);
    }
    return () => {
      const d = {
        elem: root.value,
        data: visibleData.value,
        index: {
          from: fromIndex.value,
          to: toIndex.value
        },
        scrollTo: (x, y) => {
          var _a;
          (_a = root.value) == null ? void 0 : _a.scrollTo(x, y);
        }
      };
      const content = renderSlot(ctx.slots, "default", d);
      const contentWrapperOptions = {
        class: ["w-virtual-content"],
        style: {
          paddingTop: startPlaceholderHeight.value + "px",
          paddingBottom: endPlaceholderHeight.value + "px"
        }
      };
      return createVNode("div", {
        "class": "w-virtual",
        "ref": root
      }, [createVNode("div", contentWrapperOptions, [content])]);
    };
  }
});
var index$u = /* @__PURE__ */ (() => ".w-virtual{overflow:auto}.w-virtual .w-virtual-content{position:relative}\n")();
const CurrentLabelKey = Symbol();
const CurrentValueKey = Symbol();
const SetCurrentValueKey = Symbol();
const SetCurrentLabelKey = Symbol();
const ToCloseKey = Symbol();
const ChooseLayerSizeKey = Symbol();
function Placeholder(props2) {
  return createVNode("span", {
    "class": "w-choose-placeholder"
  }, [props2.placeholder]);
}
const props = {
  ...LayerProps,
  bind: {
    type: LayerProps.bind.type,
    default: "v-show"
  },
  placement: {
    type: LayerProps.placement.type,
    default: "bottom-start"
  },
  hasArrow: {
    type: LayerProps.hasArrow.type,
    default: false
  },
  gap: {
    type: LayerProps.gap.type,
    default: 2
  },
  layerClass: {
    type: LayerProps.layerClass.type,
    default: () => "w-choose-layer"
  },
  placeholder: String,
  clearable: {
    type: Boolean,
    default: false
  },
  block: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: [Number, String],
    default: void 0
  },
  mode: {
    type: String,
    default: "default"
  },
  lazyLoad: {
    type: Function
  },
  validateEvent: {
    type: Boolean,
    default: true
  }
};
const Choose = defineComponent({
  name: "Choose",
  inheritAttrs: false,
  components: {
    Layer,
    Virtual,
    Close,
    Icon: Icon$1,
    Fallback
  },
  props,
  emit: ["update:show", "update:modelValue", "change"],
  setup(props2, ctx) {
    const formItem = inject("formItem", void 0);
    computed(() => {
      return (formItem == null ? void 0 : formItem.validateState) || "";
    });
    const transitionName = "w-slide-y";
    const visible = ref(props2.show);
    const data = ref();
    const loading2 = ref(false);
    const txt = ref();
    const triggerRect = ref();
    const layerSize = reactive({
      width: 0,
      height: 0
    });
    provide(ChooseLayerSizeKey, toRefs(layerSize));
    const showCloseBtn = computed(() => {
      if (props2.disabled) {
        return false;
      }
      if (props2.clearable) {
        return props2.modelValue !== void 0 && props2.modelValue !== "";
      }
    });
    const layerContentStyle = computed(() => {
      if (triggerRect.value) {
        return {
          minWidth: triggerRect.value.width + "px"
        };
      }
      return {};
    });
    const layerOptions = computed(() => {
      return {
        bind: props2.bind,
        placement: props2.placement,
        hasArrow: props2.hasArrow,
        gap: props2.gap,
        transitionName,
        layerClass: [props2.layerClass],
        layerStyle: layerContentStyle.value,
        show: visible.value,
        adjustPosition: "top",
        "onUpdate:show": (v2) => {
          visible.value = v2;
        },
        "onGet-trigger-rect": (rect) => {
          triggerRect.value = rect;
        },
        "onGet-layer-size": ({
          width,
          height
        }) => {
          layerSize.width = width;
          layerSize.height = height;
        }
      };
    });
    provide(SetCurrentLabelKey, (v2) => {
      txt.value = v2;
    });
    provide(SetCurrentValueKey, (v2) => {
      ctx.emit("update:modelValue", v2);
      ctx.emit("change", readonly({
        label: txt.value,
        value: v2
      }));
      if (formItem && props2.validateEvent) {
        formItem == null ? void 0 : formItem.validate("change");
      }
    });
    provide(CurrentValueKey, computed(() => props2.modelValue));
    provide(CurrentLabelKey, readonly(txt));
    provide(ToCloseKey, () => {
      visible.value = false;
    });
    watch(() => props2.show, (v2) => {
      visible.value = v2;
    });
    watch(visible, (v2) => {
      ctx.emit("update:show", v2);
      if (v2) {
        toLoad();
      }
    });
    watch(() => props2.modelValue, (v2) => {
      if (v2 === "" || v2 === void 0) {
        txt.value = void 0;
      }
    });
    function renderTrigger() {
      const triggerOptions = mergeProps({
        class: ["w-choose-trigger", [`w-choose-mode-${props2.mode}`], {
          "w-choose-spread": visible.value,
          "w-choose-disabled": props2.disabled,
          "w-choose-block": props2.block
        }]
      }, {
        ...ctx.attrs
      });
      const closeOptions = {
        class: "w-choose-close-btn",
        name: "w-icon-close-fill",
        onClick: (e) => {
          ctx.emit("update:modelValue", void 0);
          txt.value = void 0;
          ctx.emit("change", readonly({
            label: void 0,
            value: void 0
          }));
          if (formItem && props2.validateEvent) {
            formItem == null ? void 0 : formItem.validate("change");
          }
          e.stopPropagation();
        }
      };
      const arrowOptions = {
        class: "w-choose-arrow-btn",
        rotate: visible.value
      };
      return createVNode("div", triggerOptions, [txt.value && props2.modelValue !== void 0 && props2.modelValue !== "" ? createVNode("span", {
        "class": "w-choose-text"
      }, [txt.value]) : createVNode(Placeholder, {
        "placeholder": props2.placeholder
      }, null), showCloseBtn.value ? createVNode(Close, closeOptions, null) : createVNode(Icon$1, mergeProps({
        "name": "w-icon-arrow-down"
      }, arrowOptions), null)]);
    }
    function toLoad() {
      if (props2.lazyLoad) {
        if (data.value === void 0 || isArray(data.value) && data.value.length === 0) {
          loading2.value = true;
          props2.lazyLoad().then((d) => {
            data.value = d;
            loading2.value = false;
          }).catch((err) => {
            loading2.value = false;
          });
        }
      }
    }
    return () => {
      const layerSlots = {
        default: () => {
          var _a, _b, _c, _d;
          let isEmpty = false;
          if (!data.value) {
            isEmpty = true;
          } else {
            if (isArray(data.value) && data.value.length === 0) {
              isEmpty = true;
            }
          }
          const fallback = createVNode(Fallback, {
            "loading": loading2.value,
            "empty": isEmpty,
            "loadingProps": {
              text: "\u52A0\u8F7D\u6570\u636E\u4E2D"
            },
            "emptyProps": {
              text: "\u6682\u65E0\u76F8\u5173\u6570\u636E"
            }
          }, {
            loading: ctx.slots.loading,
            empty: ctx.slots.empty
          });
          const content = (_b = (_a = ctx.slots).default) == null ? void 0 : _b.call(_a, {
            data: data.value,
            loading: loading2.value
          });
          if (props2.lazyLoad) {
            if (loading2.value || isEmpty) {
              return fallback;
            }
            return content;
          } else {
            const cont = (_d = (_c = ctx.slots).default) == null ? void 0 : _d.call(_c);
            return cont;
          }
        },
        trigger: renderTrigger
      };
      const options = layerOptions.value;
      return createVNode(Layer, options, layerSlots);
    };
  }
});
var index$t = /* @__PURE__ */ (() => ".w-choose-trigger{position:relative;display:inline-flex;align-items:center;height:var(--w-size);cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;padding:0 var(--w-padding-x);outline:0;transition:var(--w-transition-time)}.w-choose-trigger.w-choose-disabled{cursor:not-allowed}.w-choose-trigger .w-choose-close-btn{font-size:12px}.w-choose-trigger .w-choose-arrow-btn{pointer-events:none}.w-choose-trigger .w-choose-text,.w-choose-trigger .w-choose-placeholder{color:var(--w-color-font-2);flex:1;width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:var(--w-font-size)}.w-choose-trigger .w-choose-placeholder{color:var(--w-color-placeholder)}.w-choose-trigger.w-choose-mode-default{background-color:var(--w-choose-background);border-radius:var(--w-radius);border:1px solid var(--w-form-item-border-color);width:var(--w-form-item-width)}.w-choose-trigger.w-choose-mode-default.w-choose-block{display:flex;width:auto}.w-choose-trigger.w-choose-mode-default:hover{border-color:var(--w-form-item-border-color-hover)}.w-choose-trigger.w-choose-mode-default.w-choose-spread{border-color:var(--w-form-item-border-color-focus)}.w-choose-trigger.w-choose-mode-default.w-choose-isError{border-color:var(--w-color-danger)}.w-choose-trigger.w-choose-mode-text .w-choose-text{width:auto}.w-choose-layer{background-color:var(--w-choose-background);max-height:360px;overflow:hidden auto;white-space:nowrap;text-overflow:ellipsis}.w-choose-item{height:var(--w-size);line-height:var(--w-size);padding:0 var(--w-padding-x);color:var(--w-color-font-2);cursor:pointer;display:block;transition:var(--w-transition-time)}.w-choose-item.w-choose-item-disabled{color:var(--w-color-disabled);cursor:not-allowed}.w-choose-item:hover:not(.w-choose-item-disabled){background-color:var(--w-color-bg)}.w-choose-item.w-choose-item-active{color:var(--w-color-primary);background-color:var(--w-color-primary-light-9)}\n")();
var ChooseItem = defineComponent({
  props: {
    tag: {
      type: String,
      default: "div"
    },
    value: {
      type: [Number, String],
      default: void 0
    },
    label: {
      type: [Number, String],
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: "ChooseItem",
  setup(props2, {
    emit,
    slots
  }) {
    const currentValue = inject(CurrentValueKey, computed(() => void 0));
    const setCurrentValue = inject(SetCurrentValueKey, () => {
      throw new Error("setCurrentValue\u51FA\u73B0\u95EE\u9898\uFF0C\u8BF7\u68C0\u67E5");
    });
    const setCurrentLabel = inject(SetCurrentLabelKey, () => {
      throw new Error("setCurrentLabel\u51FA\u73B0\u95EE\u9898\uFF0C\u8BF7\u68C0\u67E5");
    });
    const toClose = inject(ToCloseKey, () => {
      throw new Error("toClose\u51FA\u73B0\u95EE\u9898\uFF0C\u8BF7\u68C0\u67E5");
    });
    const isActive = computed(() => {
      return currentValue.value !== void 0 && props2.value === currentValue.value;
    });
    watchEffect(() => {
      if (isActive.value) {
        setCurrentLabel(props2.label);
      }
    });
    onRenderTracked(({
      target,
      key
    }) => {
    });
    return () => {
      var _a;
      const options = {
        class: ["w-choose-item", {
          "w-choose-item-active": isActive.value,
          "w-choose-item-disabled": props2.disabled
        }]
      };
      if (!props2.disabled) {
        options.onClick = (e) => {
          if (!isActive.value) {
            setCurrentLabel(props2.label);
            setCurrentValue(props2.value);
          }
          toClose();
        };
      }
      return createVNode(props2.tag, options, (_a = slots.default) == null ? void 0 : _a.call(slots));
    };
  }
});
var index$s = /* @__PURE__ */ (() => ".w-choose-item{height:var(--w-size);line-height:var(--w-size);padding:0 var(--w-padding-x);color:var(--w-color-font-2);cursor:pointer;display:block;transition:var(--w-transition-time)}.w-choose-item.w-choose-item-disabled{color:var(--w-color-disabled);cursor:not-allowed}.w-choose-item:hover:not(.w-choose-item-disabled){background-color:var(--w-color-bg)}.w-choose-item.w-choose-item-active{color:var(--w-color-primary);background-color:var(--w-color-primary-light-9)}\n")();
var Icon = defineComponent({
  name: "Icon",
  props: {
    name: {
      type: String
    },
    fontClassName: {
      type: String,
      default: "iconfont-linkd"
    },
    color: String,
    size: String,
    rotate: {
      type: Boolean,
      default: false
    },
    deg: {
      type: Number,
      default: 180
    },
    direction: {
      type: String,
      default: "x"
    }
  },
  setup(props2, {
    slots
  }) {
    const iconOptions = computed(() => {
      return {
        class: [props2.fontClassName, "w-icon", props2.name, {
          ["w-icon-rotate-" + props2.direction]: props2.rotate
        }],
        style: {
          "font-size": props2.size,
          color: props2.color,
          "--w-icon-rotate-deg": props2.rotate ? `${props2.deg}deg` : 0
        }
      };
    });
    return () => {
      var _a;
      return createVNode("i", iconOptions.value, [(_a = slots.default) == null ? void 0 : _a.call(slots)]);
    };
  }
});
var index$r = /* @__PURE__ */ (() => ".w-icon{transition:var(--w-transition-time);display:inline-flex;font-size:var(--w-font-size-2);color:var(--w-color-font-4)}.w-icon.w-icon-rotate-x{transform:rotateX(180deg);transform:rotateX(var(--w-icon-rotate-deg, 180deg))}.w-icon.w-icon-rotate-y{transform:rotateY(180deg);transform:rotateY(var(--w-icon-rotate-deg, 180deg))}.w-icon.w-icon-rotate-z{transform:rotate(180deg);transform:rotate(var(--w-icon-rotate-deg, 180deg))}\n")();
var Write = defineComponent({
  name: "Write",
  inheritAttrs: false,
  components: {
    Close,
    Layer
  },
  emits: {
    "update:modelValue": null,
    clear: null,
    search: null
  },
  props: {
    modelValue: {
      type: [Number, String]
    },
    simple: Boolean,
    placeholder: {
      type: String
    },
    clearable: Boolean,
    block: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    maxlength: [String, Number],
    showWordLimit: {
      type: Boolean,
      default: true
    },
    width: {
      type: String
    },
    minHeight: {
      type: String
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: ""
    },
    inputClass: {
      type: [Object, Array, String]
    },
    validate: {
      type: Object,
      default: () => ({
        when: "blur",
        condition: "",
        invalidTip: ""
      })
    }
  },
  setup(props2, ctx) {
    const formItem = inject("formItem", void 0);
    computed(() => {
      return (formItem == null ? void 0 : formItem.validateState) || "";
    });
    const {
      delay
    } = useDelay(300);
    const lastSearchText = ref("");
    const input = ref();
    const isZH = ref(false);
    const showCloseBtn = computed(() => {
      const v2 = props2.modelValue;
      return props2.clearable && isValidValue(v2) && props2.type !== "textarea";
    });
    const inputOptions = computed(() => {
      return {
        ref: input,
        class: props2.type === "textarea" ? ["w-write-textarea "] : ["w-write-input"],
        placeholder: props2.placeholder,
        readonly: props2.readonly,
        disabled: props2.disabled,
        value: props2.modelValue,
        maxlength: props2.maxlength,
        type: props2.type,
        onCompositionstart: (e) => {
          isZH.value = true;
        },
        onInput: (e) => {
          const val = e.target.value;
          if (!isZH.value) {
            ctx.emit("update:modelValue", val, input.value);
            toSearch(val);
          }
        },
        onCompositionend: (e) => {
          setTimeout(() => {
            const val = e.target.value;
            ctx.emit("update:modelValue", val, input.value);
            toSearch(val);
            isZH.value = false;
          });
        },
        onBlur: () => {
          if (formItem && props2.validateEvent) {
            formItem == null ? void 0 : formItem.validate("blur");
          }
        },
        onChange: () => {
          if (formItem && props2.validateEvent) {
            formItem == null ? void 0 : formItem.validate("change");
          }
        },
        ...filterListeners(ctx.attrs)
      };
    });
    const limit = () => {
      var _a, _b;
      if (props2.maxlength) {
        return createVNode("div", {
          "class": "w-write-input-limit"
        }, [((_a = props2.modelValue) == null ? void 0 : _a.toString().length) || 0, createTextVNode("/"), props2.maxlength]);
      } else {
        return createVNode("div", {
          "class": "w-write-input-limit"
        }, [(_b = props2.modelValue) == null ? void 0 : _b.toString().length]);
      }
    };
    const outerOptions = computed(() => {
      return {
        class: ["w-write", normalizeClass(ctx.attrs.class)]
      };
    });
    const layerOptions = computed(() => {
      return {
        manual: true
      };
    });
    function focus() {
      var _a;
      (_a = input.value) == null ? void 0 : _a.focus();
    }
    function select() {
      var _a;
      (_a = input.value) == null ? void 0 : _a.select();
    }
    function toSearch(val) {
      delay(() => {
        if (val !== lastSearchText.value) {
          ctx.emit("search", val, input.value);
          lastSearchText.value = val;
        }
      });
    }
    ctx.expose({
      focus,
      select
    });
    return () => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const inputEl = props2.type == "textarea" ? createVNode("textarea", mergeProps(inputOptions.value, {
        "style": {
          minHeight: props2.minHeight
        }
      }), null) : createVNode("input", inputOptions.value, null);
      const mainInput = createVNode("div", {
        "style": {
          width: props2.width,
          height: props2.type == "textarea" ? "auto" : "",
          paddingLeft: props2.type == "textarea" ? "0px" : "",
          paddingRight: props2.type == "textarea" ? "0px" : ""
        },
        "class": ["w-write-wrapper", normalizeClass(props2.inputClass), {
          "w-write-input-block": props2.block,
          "w-write-input-disabled": props2.disabled,
          "w-write-input-simple": props2.simple
        }]
      }, [(_b = (_a = ctx.slots).prepend) == null ? void 0 : _b.call(_a), inputEl, props2.type === "textarea" && props2.showWordLimit ? limit() : "", showCloseBtn.value && createVNode(Close, {
        "name": "w-icon-close-fill",
        "onClick": (e) => {
          const options = {
            input: input.value
          };
          ctx.emit("update:modelValue", void 0, input.value);
          ctx.emit("clear", options);
          e.stopPropagation();
        }
      }, null), (_d = (_c = ctx.slots).default) == null ? void 0 : _d.call(_c, {
        focus,
        inputElement: input.value
      })]);
      createVNode(Layer, layerOptions.value, {
        trigger: () => mainInput,
        default: () => "\u8F93\u5165\u65E0\u6548"
      });
      return createVNode("div", outerOptions.value, [(_f = (_e = ctx.slots).before) == null ? void 0 : _f.call(_e), mainInput, (_h = (_g = ctx.slots).after) == null ? void 0 : _h.call(_g)]);
    };
  }
});
var index$q = /* @__PURE__ */ (() => ".w-write{position:relative;display:flex;align-items:center}.w-write .w-write-wrapper{position:relative;display:flex;align-items:center;border:1px solid var(--w-color-border);border-radius:var(--w-radius);height:var(--w-size);width:var(--w-form-item-width);transition:var(--w-transition-time)}.w-write .w-write-wrapper .w-write-input,.w-write .w-write-wrapper .w-write-textarea{border:none;height:100%;padding:0 var(--w-padding-x);flex:1;width:0;background-color:transparent}.w-write .w-write-wrapper .w-write-input::-moz-placeholder,.w-write .w-write-wrapper .w-write-textarea::-moz-placeholder{color:var(--w-color-placeholder)}.w-write .w-write-wrapper .w-write-input::placeholder,.w-write .w-write-wrapper .w-write-textarea::placeholder{color:var(--w-color-placeholder)}.w-write .w-write-wrapper:focus-within:not(.w-write-input-simple){border-color:var(--w-form-item-border-color-focus);box-shadow:0 0 6px var(--w-color-primary-light-7)}.w-write .w-write-wrapper.w-write-input-simple:focus-within{box-shadow:none;border-bottom-color:var(--w-form-item-border-color-focus)}.w-write .w-write-wrapper .w-write-textarea{padding:8px var(--w-padding-x);line-height:1.5;color:var(--w-color-font)}.w-write .w-write-wrapper.w-write-input-block{flex:1}.w-write .w-write-wrapper.w-write-input-disabled{background-color:var(--w-form-item-disabled-color)}.w-write .w-write-wrapper.w-write-input-disabled .w-write-input{background-color:transparent;cursor:not-allowed}.w-write .w-write-wrapper.w-write-input-simple{border-top:none;border-left:none;border-right:none;border-radius:0}.w-write .w-write-wrapper .w-write-input-limit{color:#909399;position:absolute;font-size:12px;line-height:14px;bottom:5px;right:10px}.w-write .w-write-wrapper .w-close{font-size:12px;margin:0 10px 0 0}.w-write:hover .w-write-wrapper{border-color:var(--w-form-item-border-color-hover)}\n")();
function useRequest(requestFn, para, manual = false) {
  const loading2 = ref(false);
  const empty2 = ref(false);
  const data = ref();
  async function get() {
    try {
      if (loading2.value) {
        return;
      }
      loading2.value = true;
      data.value = await (requestFn == null ? void 0 : requestFn(para == null ? void 0 : para.value));
      if (isArray(data.value)) {
        empty2.value = data.value.length === 0;
      } else {
        empty2.value = !data.value;
      }
      loading2.value = false;
    } catch (err) {
      loading2.value = false;
    } finally {
    }
  }
  !manual && get();
  return {
    loading: loading2,
    empty: empty2,
    data,
    get
  };
}
const {
  hasCheckbox,
  keys,
  searchText,
  all,
  loading,
  empty,
  ...listProps
} = List.props;
var Choose2 = defineComponent({
  inheritAttrs: false,
  name: "Choose2",
  components: {
    Layer,
    Close,
    Icon,
    Write,
    List,
    Checkbox,
    Btn
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    block: Boolean,
    clearable: Boolean,
    isConfirm: Boolean,
    textPlaceholder: {
      type: String
    },
    placeholder: {
      type: String
    },
    searchPlaceholder: {
      type: String,
      default: "\u5173\u952E\u5B57\u641C\u7D22"
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    lazyLoad: Function,
    validateEvent: {
      type: Boolean,
      default: true
    },
    ...listProps
  },
  emits: ["update:show", "update:modelValue", "clear", "confirm"],
  setup(props2, {
    emit,
    slots
  }) {
    const formItem = inject("formItem", void 0);
    const visible = ref(props2.show);
    const searchText2 = ref("");
    const isCheckAll = ref(false);
    const placeholderText = computed(() => {
      var _a;
      const v2 = props2.modelValue;
      if (v2 && v2.length) {
        return createVNode("span", {
          "class": "w-no-select"
        }, [`\u5DF2\u9009${v2.length}\u9879${(_a = props2.textPlaceholder) != null ? _a : ""}`]);
      }
      return createVNode("span", {
        "class": "w-text-placeholder w-no-select"
      }, [props2.placeholder]);
    });
    const layerOptions = computed(() => {
      return {
        show: visible.value,
        disabled: props2.disabled,
        placement: "bottom-start",
        hasArrow: false,
        gap: 2,
        transitionName: "w-slide-y",
        "onUpdate:show": (b) => {
          visible.value = b;
        }
      };
    });
    const {
      loading: _loading,
      empty: _empty,
      get: _getData
    } = useRequest(props2.lazyLoad, void 0, true);
    const dataListOptions = computed(() => {
      const listPropsKeys = Object.keys(listProps);
      return listPropsKeys.reduce((obj, key) => {
        obj[key] = props2[key];
        return obj;
      }, {
        class: "w-choose2-layer",
        loading: _loading.value,
        empty: _empty.value,
        hasCheckbox: true,
        all: isCheckAll.value,
        searchText: searchText2.value,
        onToggle: (item, index2, arr) => {
        },
        keys: props2.modelValue,
        "onUpdate:keys": (arr) => {
          emit("update:modelValue", arr);
          if (props2.validateEvent) {
            formItem == null ? void 0 : formItem.validate("change");
          }
        },
        "onUpdate:all": (b) => {
          isCheckAll.value = b;
        }
      });
    });
    function renderTrigger() {
      const arrowBtn = createVNode(Icon, {
        "rotate": visible.value,
        "name": "w-icon-arrow-down"
      }, null);
      const closeBtn = !props2.disabled && props2.clearable && props2.modelValue && props2.modelValue.length ? createVNode(Close, {
        "name": "w-icon-close-fill",
        "onClick": (e) => {
          e.stopPropagation();
          clear();
        }
      }, null) : null;
      const triggerOptions = {
        class: ["w-choose2-trigger", {
          "w-choose2-trigger-disabled": props2.disabled,
          "w-choose2-trigger-block": props2.block,
          "w-choose2-trigger-active": visible.value
        }]
      };
      return createVNode("div", triggerOptions, [createVNode("div", null, [placeholderText.value]), createVNode("div", {
        "class": "w-choose2-icon"
      }, [closeBtn, arrowBtn])]);
    }
    function renderContent() {
      if (props2.disabled) {
        return null;
      }
      const listSlots = slots.default && {
        default: ({
          item,
          index: index2
        }) => {
          var _a;
          return (_a = slots.default) == null ? void 0 : _a.call(slots, {
            item,
            index: index2
          });
        },
        search: ({
          search
        }) => {
          const writeOptions = {
            simple: true,
            modelValue: searchText2.value,
            placeholder: props2.searchPlaceholder,
            block: true,
            "onUpdate:modelValue": (v2) => {
              searchText2.value = v2;
              search(v2);
            }
          };
          return createVNode(Write, writeOptions, null);
        },
        checkAll: ({
          checkAll
        }) => {
          var _a;
          const checkOptions = {
            text: "\u5168\u9009",
            value: [false, true],
            modelValue: isCheckAll.value,
            "onUpdate:modelValue": (b) => {
              isCheckAll.value = b;
              checkAll(b);
            }
          };
          const confirm = {
            onClick: () => {
              visible.value = false;
              emit("confirm");
            }
          };
          return createVNode("div", {
            "class": "w-choose2-checkall"
          }, [createVNode(Checkbox, checkOptions, null), slots.confirm ? (_a = slots.confirm) == null ? void 0 : _a.call(slots) : props2.isConfirm ? createVNode(Btn, mergeProps({
            "type": "primary"
          }, confirm), {
            default: () => [createTextVNode("\u786E\u8BA4")]
          }) : ""]);
        }
      };
      return createVNode(List, dataListOptions.value, listSlots);
    }
    function clear() {
      isCheckAll.value = false;
      emit("update:modelValue", []);
      emit("clear");
      if (props2.validateEvent) {
        formItem == null ? void 0 : formItem.validate("change");
      }
    }
    const stopLoadData = watch(visible, (v2) => {
      if (v2) {
        if (props2.data && props2.data.length) {
          stopLoadData();
        } else {
          _getData();
        }
      }
    }, {
      immediate: true
    });
    return () => {
      const layerSlots = {
        trigger: renderTrigger,
        default: renderContent
      };
      return createVNode(Layer, layerOptions.value, layerSlots);
    };
  }
});
var index$p = /* @__PURE__ */ (() => ".w-choose2-trigger{position:relative;display:inline-flex;align-items:center;justify-content:space-between;height:var(--w-size);padding:0 var(--w-padding-x);outline:0;width:var(--w-form-item-width);border:1px solid var(--w-form-item-border-color);border-radius:var(--w-radius);background-color:var(--w-choose-background);cursor:pointer;transition:var(--w-transition-time)}.w-choose2-trigger .w-choose2-text{color:var(--w-color-font-2);flex:1}.w-choose2-trigger .w-choose2-icon{flex-shrink:0}.w-choose2-trigger .w-choose2-icon .w-close{font-size:12px}.w-choose2-trigger.w-choose2-placeholder{color:var(--w-color-font-3)}.w-choose2-trigger.w-choose2-trigger-block{display:flex;flex:1;width:auto}.w-choose2-trigger:hover:not(.w-choose2-trigger-disabled):not(.w-choose2-trigger-active){border-color:var(--w-form-item-border-color-hover)}.w-choose2-trigger.w-choose2-trigger-disabled{color:var(--w-color-disabled);background-color:var(--w-form-item-disabled-color);cursor:not-allowed}.w-choose2-trigger.w-choose2-trigger-active{border-color:var(--w-form-item-border-color-focus)}.w-choose2-search{padding:var(--w-padding-x);border-bottom:1px solid var(--w-color-border)}.w-choose2-checkall{padding:var(--w-padding-x);border-top:1px solid var(--w-color-border);display:flex;justify-content:space-between;align-items:center}.w-choose2-layer{max-height:260px;overflow:auto}\n")();
var _export_sfc = (sfc, props2) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props2) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$1 = {
  name: "Color",
  props: {
    disabled: Boolean,
    clearable: Boolean,
    modelValue: [String, Object],
    showAlpha: Boolean,
    colorFormat: {
      type: String,
      default: "hex"
    },
    preset: {
      type: Array,
      default() {
        return [
          "#D0021B",
          "#F5A623",
          "#F8E71C",
          "#8B572A",
          "#7ED321",
          "#417505",
          "#BD10E0",
          "#9013FE",
          "#4A90E2",
          "#50E3C2",
          "#B8E986",
          "#000000",
          "#4A4A4A",
          "#9B9B9B",
          "#FFFFFF"
        ];
      }
    }
  },
  components: { Layer, Trigger, Btn },
  setup(props2, context) {
    const formItem = inject("formItem", void 0);
    const show = ref(false);
    const refs = {
      saturation_value: ref(null),
      hue_slider: ref(null),
      alpha_slider: ref(null)
    };
    let pointStyle = ref("top: 25%;left: 80%;");
    let hueSliderStyle = ref("left: 0;");
    let alphaSliderStyle = ref("left: calc(100% - 6px);");
    let hue = ref(0);
    let saturation = ref(1);
    let value = ref(1);
    let red = ref(255);
    let green = ref(0);
    let blue = ref(0);
    let alpha = ref(1);
    onMounted(() => {
      if (props2.modelValue) {
        let { r, g, b, a } = parseColor(props2.modelValue);
        red.value = r;
        green.value = g;
        blue.value = b;
        alpha.value = a;
      }
    });
    watch([red, green, blue], (newValue) => {
      let { h: h2, s, v: v2 } = rgb2hsv(red.value, green.value, blue.value);
      hue.value = h2;
      saturation.value = s;
      value.value = v2;
      pointStyle.value = `top: ${100 - v2 * 100}%;left: ${s * 100}%;`;
      hueSliderStyle.value = `left: ${hue.value / 360 * 100}%;`;
    });
    watch(alpha, () => {
      alphaSliderStyle.value = `left: ${alpha.value >= 1 ? "calc(100% - 6px)" : alpha.value * 100 + "%"};`;
    });
    let colorObj = computed(() => {
      let r = red.value;
      let g = green.value;
      let b = blue.value;
      let a = alpha.value;
      let h2 = hue.value;
      let s = saturation.value;
      let v2 = value.value;
      return {
        rgb: `rgba(${r},${g},${b})`,
        rgba: `rgba(${r},${g},${b},${a})`,
        hex6: rgba2hex(r, g, b),
        hex8: rgba2hex(r, g, b, a),
        hsv: `hsv(${h2},${s},${v2})`
      };
    });
    function hexChange(e) {
      var _a;
      let v2 = (_a = e.target) == null ? void 0 : _a.value;
      if (/^#?([0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(v2)) {
        let { r, g, b, a } = hex2rgba(v2);
        red.value = r;
        green.value = g;
        blue.value = b;
        alpha.value = a;
      }
    }
    function redChange(e) {
      var _a;
      let v2 = (_a = e.target) == null ? void 0 : _a.value;
      if (v2 !== "") {
        v2 > 255 && (red.value = 255);
        v2 < 0 && (red.value = 0);
        v2 >= 0 && v2 <= 255 && (red.value = parseInt(v2));
      }
    }
    function greenChange(e) {
      var _a;
      let v2 = (_a = e.target) == null ? void 0 : _a.value;
      if (v2 !== "") {
        v2 > 255 && (green.value = 255);
        v2 < 0 && (green.value = 0);
        v2 >= 0 && v2 <= 255 && (green.value = parseInt(v2));
      }
    }
    function blueChange(e) {
      var _a;
      let v2 = (_a = e.target) == null ? void 0 : _a.value;
      if (v2 !== "") {
        v2 > 255 && (blue.value = 255);
        v2 < 0 && (blue.value = 0);
        v2 >= 0 && v2 <= 255 && (blue.value = parseInt(v2));
      }
    }
    function alphaChange(e) {
      var _a;
      let v2 = (_a = e.target) == null ? void 0 : _a.value;
      if (v2 !== "") {
        v2 = parseFloat(v2);
        alpha.value = v2;
        v2 > 1 && (alpha.value = 1);
        v2 < 0 && (alpha.value = 0);
        v2 >= 0 && v2 <= 1 && (alpha.value = v2);
      }
    }
    function presetChange(item) {
      if (/^#?([0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(item)) {
        let { r, g, b, a } = hex2rgba(item);
        red.value = r;
        green.value = g;
        blue.value = b;
        alpha.value = a;
      }
    }
    function handleChangeSV(e) {
      var _a, _b, _c, _d;
      let w = ((_a = refs.saturation_value.value) == null ? void 0 : _a.clientWidth) || 0;
      let h2 = ((_b = refs.saturation_value.value) == null ? void 0 : _b.clientHeight) || 0;
      let x = refs.saturation_value.value ? e.pageX - ((_c = refs.saturation_value.value) == null ? void 0 : _c.getBoundingClientRect().left) : 0;
      let y = refs.saturation_value.value ? e.pageY - ((_d = refs.saturation_value.value) == null ? void 0 : _d.getBoundingClientRect().top) : 0;
      x = x < w && x > 0 ? x : x > w ? w : 0;
      y = y < h2 && y > 0 ? y : y > h2 ? h2 : 0;
      saturation.value = Math.floor(x / w * 100 + 0.5) / 100;
      value.value = Math.floor((1 - y / h2) * 100 + 0.5) / 100;
      let { r, g, b } = hsv2rgb(hue.value, saturation.value, value.value);
      red.value = r;
      green.value = g;
      blue.value = b;
      pointStyle.value = `top: ${y}px;left: ${x}px;`;
    }
    function mousedownSV(e) {
      handleChangeSV(e);
      window.addEventListener("mousemove", handleChangeSV);
      window.addEventListener("mouseup", mouseupSV);
    }
    function mouseupSV() {
      window.removeEventListener("mousemove", handleChangeSV);
      window.removeEventListener("mouseup", mouseupSV);
    }
    function handleChangeHue(e) {
      var _a, _b;
      let w = ((_a = refs.hue_slider.value) == null ? void 0 : _a.clientWidth) || 0;
      let x = refs.saturation_value.value ? e.pageX - ((_b = refs.saturation_value.value) == null ? void 0 : _b.getBoundingClientRect().left) : 0;
      x = x < w && x > 0 ? x : x > w ? w : 0;
      hue.value = Math.floor(x / w * 360 + 0.5);
      let { r, g, b } = hsv2rgb(hue.value, saturation.value, value.value);
      red.value = r;
      green.value = g;
      blue.value = b;
      hueSliderStyle.value = `left: ${x >= w - 6 ? w - 6 : x}px;`;
    }
    function mousedownHue(e) {
      handleChangeHue(e);
      window.addEventListener("mousemove", handleChangeHue);
      window.addEventListener("mouseup", mouseupHue);
    }
    function mouseupHue(e) {
      window.removeEventListener("mousemove", handleChangeHue);
      window.removeEventListener("mouseup", mouseupHue);
    }
    function handleChangeAlpha(e) {
      var _a, _b;
      let w = ((_a = refs.alpha_slider.value) == null ? void 0 : _a.clientWidth) || 0;
      let x = refs.saturation_value.value ? e.pageX - ((_b = refs.saturation_value.value) == null ? void 0 : _b.getBoundingClientRect().left) : 0;
      x = x < w && x > 0 ? x : x > w ? w : 0;
      alpha.value = Math.floor(x / w * 100 + 0.5) / 100;
      alphaSliderStyle.value = `left: ${x >= w - 6 ? w - 6 : x}px;`;
    }
    function mousedownAlpha(e) {
      handleChangeAlpha(e);
      window.addEventListener("mousemove", handleChangeAlpha);
      window.addEventListener("mouseup", mouseupAlpha);
    }
    function mouseupAlpha(e) {
      window.removeEventListener("mousemove", handleChangeAlpha);
      window.removeEventListener("mouseup", mouseupAlpha);
    }
    function parseColor(color) {
      if (color) {
        let r, g, b, a;
        if (typeof color === "string") {
          let reg = /^(rgb|RGB)/;
          let hex2 = color;
          if (reg.test(color)) {
            var colorArr = color.replace(/(?:rgb|RGB|\(|\))*/g, "").split(",");
            hex2 = "#" + ((1 << 24) + (parseInt(colorArr[0]) << 16) + (parseInt(colorArr[1]) << 8) + parseInt(colorArr[2])).toString(16).slice(1);
          }
          if (/^#?([0-9a-fA-F]{6}|[0-9a-fA-F]{8}|[0-9a-fA-F]{3}|[0-9a-fA-F]{4})$/.test(hex2)) {
            return hex2rgba(hex2);
          }
        } else {
          r = color.r > 255 ? 255 : color.r < 0 ? 0 : color.r;
          g = color.g > 255 ? 255 : color.g < 0 ? 0 : color.g;
          b = color.b > 255 ? 255 : color.b < 0 ? 0 : color.b;
          a = color.a > 1 ? 1 : color.a < 0 ? 0 : color.a;
          return { r, g, b, a };
        }
      } else {
        return null;
      }
    }
    function hsv2rgb(h2, s, v2) {
      h2 === 360 && (h2 = 0);
      let i = Math.floor(h2 / 60) % 6;
      let f = h2 / 60 - i;
      let p = v2 * (1 - s);
      let q = v2 * (1 - s * f);
      let t = v2 * (1 - s * (1 - f));
      let r = 0, g = 0, b = 0;
      if (i === 0) {
        r = v2;
        g = t;
        b = p;
      } else if (i === 1) {
        r = q;
        g = v2;
        b = p;
      } else if (i === 2) {
        r = p;
        g = v2;
        b = t;
      } else if (i === 3) {
        r = p;
        g = q;
        b = v2;
      } else if (i === 4) {
        r = t;
        g = p;
        b = v2;
      } else if (i === 5) {
        r = v2;
        g = p;
        b = q;
      }
      r = Math.floor(r * 255 + 0.5);
      g = Math.floor(g * 255 + 0.5);
      b = Math.floor(b * 255 + 0.5);
      return { r, g, b };
    }
    function rgb2hsv(r, g, b) {
      let r1 = r / 255;
      let g1 = g / 255;
      let b1 = b / 255;
      let cmax = Math.max(r1, g1, b1);
      let cmin = Math.min(r1, g1, b1);
      let d = cmax - cmin;
      let h2 = 0, s = 0, v2 = 0;
      if (d === 0) {
        h2 = 0;
      } else if (cmax === r1) {
        h2 = (60 * (g1 - b1) / d + 360) % 360;
      } else if (cmax === g1) {
        h2 = 60 * ((b1 - r1) / d + 2);
      } else if (cmax === b1) {
        h2 = 60 * ((r1 - g1) / d + 4);
      }
      if (cmax === 0) {
        s = 0;
      } else {
        s = d / cmax;
      }
      v2 = cmax;
      h2 = Math.floor(h2 + 0.5);
      s = Math.floor(s * 100 + 0.5) / 100;
      v2 = Math.floor(v2 * 100 + 0.5) / 100;
      return { h: h2, s, v: v2 };
    }
    function rgba2hex(r, g, b, a = 1) {
      r = parseInt(r);
      let r1 = r.toString(16).length !== 2 ? "0" + r.toString(16) : r.toString(16);
      g = parseInt(g);
      let g1 = g.toString(16).length !== 2 ? "0" + g.toString(16) : g.toString(16);
      b = parseInt(b);
      let b1 = b.toString(16).length !== 2 ? "0" + b.toString(16) : b.toString(16);
      a = parseFloat(a);
      let a1 = "";
      if (a !== 1) {
        let temp = Math.floor(256 * a);
        a1 = temp.toString(16).length !== 2 ? "0" + temp.toString(16) : temp.toString(16);
      }
      return `#${r1}${g1}${b1}${a1}`.toUpperCase();
    }
    function hex2rgba(s) {
      if (/^#?[0-9a-fA-F]{3}$/.test(s)) {
        let b = s.substring(s.length - 1, s.length);
        let g = s.substring(s.length - 2, s.length - 1);
        let r = s.substring(s.length - 3, s.length - 2);
        return hex2rgba(`${r + r}${g + g}${b + b}`);
      }
      if (/^#?[0-9a-fA-F]{4}$/.test(s)) {
        let a = s.substring(s.length - 1, s.length);
        let b = s.substring(s.length - 2, s.length - 1);
        let g = s.substring(s.length - 3, s.length - 2);
        let r = s.substring(s.length - 4, s.length - 3);
        return hex2rgba(`${r + r}${g + g}${b + b}${a + a}`);
      }
      if (/^#?[0-9a-fA-F]{6}$/.test(s)) {
        let b = parseInt("0x" + s.substring(s.length - 2, s.length));
        let g = parseInt("0x" + s.substring(s.length - 4, s.length - 2));
        let r = parseInt("0x" + s.substring(s.length - 6, s.length - 4));
        return { r, g, b, a: 1 };
      }
      if (/^#?[0-9a-fA-F]{8}$/.test(s)) {
        let a = parseInt("0x" + s.substring(s.length - 2, s.length));
        a = a / 255;
        let b = parseInt("0x" + s.substring(s.length - 4, s.length - 2));
        let g = parseInt("0x" + s.substring(s.length - 6, s.length - 4));
        let r = parseInt("0x" + s.substring(s.length - 8, s.length - 6));
        return { r, g, b, a };
      }
    }
    function cancel() {
      context.emit("update:modelValue", "");
      if (props2.modelValue) {
        let { r, g, b, a } = parseColor(props2.modelValue);
        red.value = r;
        green.value = g;
        blue.value = b;
        alpha.value = a;
      } else {
        red.value = 0;
        green.value = 0;
        blue.value = 0;
        alpha.value = 1;
      }
      if (formItem) {
        formItem == null ? void 0 : formItem.validate("change");
      }
      show.value = false;
    }
    function confirm() {
      if (props2.showAlpha) {
        context.emit("update:modelValue", props2.colorFormat === "hsv" ? colorObj.value.hsv : props2.colorFormat === "hex" ? colorObj.value.hex6 : colorObj.value.rgba);
      } else {
        context.emit("update:modelValue", props2.colorFormat === "hsv" ? colorObj.value.hsv : props2.colorFormat === "rgba" ? colorObj.value.rgba : colorObj.value.hex6);
      }
      if (formItem) {
        formItem == null ? void 0 : formItem.validate("change");
      }
      show.value = false;
    }
    const bColor = computed(() => {
      return show.value ? colorObj.value.rgba : props2.modelValue;
    });
    return {
      ...refs,
      pointStyle,
      hueSliderStyle,
      alphaSliderStyle,
      hue,
      saturation,
      value,
      red,
      green,
      blue,
      alpha,
      colorObj,
      hexChange,
      redChange,
      greenChange,
      blueChange,
      alphaChange,
      presetChange,
      mousedownSV,
      mousedownHue,
      mousedownAlpha,
      show,
      cancel,
      confirm,
      bColor
    };
  }
};
const _hoisted_1$1 = { class: "w-color-select" };
const _hoisted_2$1 = /* @__PURE__ */ createElementVNode("div", { class: "w-saturation-value-2" }, null, -1);
const _hoisted_3$1 = /* @__PURE__ */ createElementVNode("div", { class: "w-saturation-value-3" }, null, -1);
const _hoisted_4$1 = { class: "w-color-select-middle" };
const _hoisted_5$1 = { style: { "flex": "auto", "display": "flex", "flex-direction": "column", "justify-content": "space-around" } };
const _hoisted_6$1 = { class: "w-color-diamond" };
const _hoisted_7$1 = { class: "w-color-value" };
const _hoisted_8 = { class: "w-color-hex" };
const _hoisted_9 = ["value"];
const _hoisted_10 = /* @__PURE__ */ createElementVNode("p", null, "Hex", -1);
const _hoisted_11 = { class: "w-rgba-r" };
const _hoisted_12 = ["value"];
const _hoisted_13 = /* @__PURE__ */ createElementVNode("p", null, "R", -1);
const _hoisted_14 = { class: "w-rgba-g" };
const _hoisted_15 = ["value"];
const _hoisted_16 = /* @__PURE__ */ createElementVNode("p", null, "G", -1);
const _hoisted_17 = { class: "w-rgba-b" };
const _hoisted_18 = ["value"];
const _hoisted_19 = /* @__PURE__ */ createElementVNode("p", null, "B", -1);
const _hoisted_20 = {
  key: 0,
  class: "w-rgba-a"
};
const _hoisted_21 = ["value"];
const _hoisted_22 = /* @__PURE__ */ createElementVNode("p", null, "A", -1);
const _hoisted_23 = { class: "w-preset" };
const _hoisted_24 = ["onClick"];
const _hoisted_25 = { class: "w-color-btn" };
const _hoisted_26 = /* @__PURE__ */ createTextVNode("\u53D6\u6D88");
const _hoisted_27 = /* @__PURE__ */ createTextVNode("\u786E\u8BA4");
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Trigger = resolveComponent("Trigger");
  const _component_Btn = resolveComponent("Btn");
  const _component_Layer = resolveComponent("Layer");
  return openBlock(), createBlock(_component_Layer, {
    placement: "bottom-start",
    transitionName: "w-slide-y",
    "gap:": "2",
    show: $setup.show,
    "onUpdate:show": _cache[8] || (_cache[8] = ($event) => $setup.show = $event)
  }, {
    trigger: withCtx(() => [
      createVNode(_component_Trigger, {
        style: normalizeStyle(`background-color:${$setup.bColor}`),
        disabled: $props.disabled,
        class: "w-color-picker-v2"
      }, null, 8, ["style", "disabled"])
    ]),
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$1, [
        createElementVNode("div", {
          class: "w-saturation-value",
          ref: "saturation_value",
          onMousedown: _cache[0] || (_cache[0] = (...args) => $setup.mousedownSV && $setup.mousedownSV(...args))
        }, [
          createElementVNode("div", {
            style: normalizeStyle(`background-color: hsl(${$setup.hue}, 100%, 50%);`)
          }, [
            createElementVNode("div", {
              class: "w-point",
              style: normalizeStyle($setup.pointStyle)
            }, null, 4)
          ], 4),
          _hoisted_2$1,
          _hoisted_3$1
        ], 544),
        createElementVNode("div", _hoisted_4$1, [
          createElementVNode("div", _hoisted_5$1, [
            createElementVNode("div", {
              class: "w-hue-slider",
              ref: "hue_slider",
              onMousedown: _cache[1] || (_cache[1] = (...args) => $setup.mousedownHue && $setup.mousedownHue(...args))
            }, [
              createElementVNode("div", {
                class: "w-color-slider",
                style: normalizeStyle($setup.hueSliderStyle)
              }, null, 4)
            ], 544),
            $props.showAlpha ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "w-alpha-slider",
              ref: "alpha_slider",
              onMousedown: _cache[2] || (_cache[2] = (...args) => $setup.mousedownAlpha && $setup.mousedownAlpha(...args))
            }, [
              createElementVNode("div", {
                class: "w-color-slider",
                style: normalizeStyle($setup.alphaSliderStyle)
              }, null, 4),
              createElementVNode("div", {
                style: normalizeStyle(`background: linear-gradient(to right, rgba(0,0,0,0), ${$setup.colorObj.rgb});width: 100%;height: 100%`)
              }, null, 4)
            ], 544)) : createCommentVNode("v-if", true)
          ]),
          createElementVNode("div", _hoisted_6$1, [
            createElementVNode("div", {
              style: normalizeStyle(`background-color: ${$setup.colorObj.rgba};width: 100%;height: 100%;box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15), inset 0 0 4px rgba(0, 0, 0, .25);`)
            }, null, 4)
          ])
        ]),
        createElementVNode("div", _hoisted_7$1, [
          createElementVNode("div", _hoisted_8, [
            createElementVNode("label", null, [
              createElementVNode("input", {
                value: $setup.colorObj.hex8,
                onInput: _cache[3] || (_cache[3] = (...args) => $setup.hexChange && $setup.hexChange(...args)),
                spellcheck: "false"
              }, null, 40, _hoisted_9)
            ]),
            _hoisted_10
          ]),
          createElementVNode("div", _hoisted_11, [
            createElementVNode("label", null, [
              createElementVNode("input", {
                value: $setup.red,
                onInput: _cache[4] || (_cache[4] = (...args) => $setup.redChange && $setup.redChange(...args))
              }, null, 40, _hoisted_12)
            ]),
            _hoisted_13
          ]),
          createElementVNode("div", _hoisted_14, [
            createElementVNode("label", null, [
              createElementVNode("input", {
                value: $setup.green,
                onInput: _cache[5] || (_cache[5] = (...args) => $setup.greenChange && $setup.greenChange(...args))
              }, null, 40, _hoisted_15)
            ]),
            _hoisted_16
          ]),
          createElementVNode("div", _hoisted_17, [
            createElementVNode("label", null, [
              createElementVNode("input", {
                value: $setup.blue,
                onInput: _cache[6] || (_cache[6] = (...args) => $setup.blueChange && $setup.blueChange(...args))
              }, null, 40, _hoisted_18)
            ]),
            _hoisted_19
          ]),
          $props.showAlpha ? (openBlock(), createElementBlock("div", _hoisted_20, [
            createElementVNode("label", null, [
              createElementVNode("input", {
                value: $setup.alpha,
                onInput: _cache[7] || (_cache[7] = (...args) => $setup.alphaChange && $setup.alphaChange(...args))
              }, null, 40, _hoisted_21)
            ]),
            _hoisted_22
          ])) : createCommentVNode("v-if", true)
        ]),
        createElementVNode("ul", _hoisted_23, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.preset, (item, index2) => {
            return openBlock(), createElementBlock("li", {
              key: index2,
              style: normalizeStyle(`background-color: ${item}`),
              onClick: ($event) => $setup.presetChange(item)
            }, null, 12, _hoisted_24);
          }), 128))
        ])
      ]),
      createElementVNode("div", _hoisted_25, [
        createVNode(_component_Btn, { onClick: $setup.cancel }, {
          default: withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        }, 8, ["onClick"]),
        createVNode(_component_Btn, {
          type: "primary",
          onClick: $setup.confirm
        }, {
          default: withCtx(() => [
            _hoisted_27
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["show"]);
}
var ColorPicker = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render], ["__file", "/Users/qiguoqing/Desktop/yuou/will-ui/src/packages/components/color/ColorPicker.vue"]]);
var index$o = /* @__PURE__ */ (() => '.w-color-picker{height:250px;width:250px;--hue: 0;--saturation: 100%;--luminosity: 50%}.w-color-picker .w-color-panel{height:150px;background:transparent;position:relative}.w-color-picker .w-color-panel:before,.w-color-picker .w-color-panel:after{content:"";position:absolute;top:0;left:0;width:100%;height:100%}.w-color-picker .w-color-panel:before{background:linear-gradient(to right,white,transparent)}.w-color-picker .w-color-panel:after{background:linear-gradient(to top,black,transparent)}.w-color-picker .w-color-hue-slider{height:10px;background-image:linear-gradient(90deg,#f00,#ff0,#0f0,#0ff,#00f,#f0f,#f00)}.w-color-select{position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%;background:#fff;padding:10px}.w-saturation-value{cursor:pointer;width:100%;height:200px;position:relative;margin-bottom:10px;box-shadow:1px 1px 1px #0000001a}.w-saturation-value>div{position:absolute;top:0;left:0;width:100%;height:100%}.w-point{box-sizing:border-box;width:6px;height:6px;background-color:transparent;border:2px solid #ccc;border-radius:50%;transform:translate(-50%,-50%);position:absolute;z-index:9}.w-saturation-value-2{background:linear-gradient(to right,white,#ffffff00)}.w-saturation-value-3{background:linear-gradient(to top,black,#ffffff00)}.w-color-select-middle{width:100%;display:flex;margin-bottom:10px}.w-hue-slider{position:relative;height:10px;width:100%;background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red);box-shadow:1px 1px 1px #0000001a}.w-alpha-slider{position:relative;height:10px;box-shadow:1px 1px 1px #0000001a;background:#fff url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAWElEQVRIiWM8fubkfwYygKWJOSM5+mCAhRLNoxaPWjxq8ajFoxbTyeL/DAfJ0Xjs3Cl7Siwmu4Yht1aDgZEYx6MWj1o8avGoxaMWD3qLya5X//4nqx6HAQC7RBGFzolqTAAAAABJRU5ErkJggg==);background-size:10px 10px}.w-color-slider{position:absolute;box-shadow:0 0 2px #0009;box-sizing:border-box;width:6px;height:100%;background-color:#fff}.w-color-diamond{position:relative;margin-left:5px;width:26px;height:26px;border-radius:3px;overflow:hidden;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAWElEQVRIiWM8fubkfwYygKWJOSM5+mCAhRLNoxaPWjxq8ajFoxbTyeL/DAfJ0Xjs3Cl7Siwmu4Yht1aDgZEYx6MWj1o8avGoxaMWD3qLya5X//4nqx6HAQC7RBGFzolqTAAAAABJRU5ErkJggg==);background-size:10px 10px}.w-color-value{width:100%;display:flex;justify-content:space-between}.w-color-value div{padding:0 3px;text-align:center}.w-color-value input{font-size:12px;box-sizing:border-box;width:34px;height:24px;padding:0;margin:0;outline:none;text-align:center;border-radius:3px;border:1px solid #ccc}.w-color-value p{font-size:12px;margin:3px 0 0}.w-color-value .w-rgba-a{padding-right:0}.w-color-value .w-color-hex{flex:1;padding-left:0}.w-color-value .w-color-hex input{width:100%;height:24px}.w-preset{width:100%;padding:0;margin:10px 0 0;list-style:none;display:flex;flex-wrap:wrap;justify-content:flex-start}.w-preset li{width:20px;height:20px;margin-right:6px;margin-bottom:6px;border:1px solid #ccc;border-radius:6px}.w-color-btn{width:100%;padding:10px;display:flex;align-items:center;justify-content:flex-end}.w-color-picker-v2{width:28px;height:28px}.w-color-picker-v2 .w-trigger-icon{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}\n')();
function _isSlot$5(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
var Drawer = defineComponent({
  name: "Drawer",
  components: {
    Mask
  },
  props: {
    bind: {
      type: String,
      default: "v-if"
    },
    show: Boolean,
    hasMask: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: "right"
    },
    to: {
      type: HTMLElement,
      default: () => document.body
    },
    canCloseByClickMask: {
      type: Boolean,
      default: true
    },
    headerClass: [String, Object, Array],
    bodyClass: [String, Object, Array],
    footerClass: [String, Object, Array],
    isConfirm: Boolean,
    afterClose: Function
  },
  emits: ["update:show"],
  setup(props2, {
    attrs,
    emit,
    slots
  }) {
    const center = ref();
    const visible = ref(props2.show);
    const {
      zIndex: zIndex2,
      add: add2
    } = useGlobalZIndex();
    const drawOptions = computed(() => {
      let o = {
        class: ["w-drawer", `w-drawer--${props2.placement}`]
      };
      if (props2.placement !== "center") {
        o.style = {
          zIndex: zIndex2.value
        };
      }
      return o;
    });
    function close2() {
      visible.value = false;
    }
    function show() {
      add2();
      visible.value = true;
    }
    function afterLeave() {
      var _a;
      (_a = props2.afterClose) == null ? void 0 : _a.call(props2);
    }
    onMounted(() => {
      if (props2.isConfirm) {
        visible.value = true;
      }
    });
    watch(() => props2.show, (v2) => {
      visible.value = v2;
    });
    watch(visible, (v2) => {
      emit("update:show", v2);
    });
    return () => {
      var _a, _b, _c, _d;
      let mask2 = null;
      if (props2.hasMask) {
        const maskOptions = {
          show: visible.value,
          canCloseByClickSelf: props2.canCloseByClickMask,
          "onUpdate:show": (v2) => {
            visible.value = v2;
          },
          zIndex: zIndex2.value - 1
        };
        mask2 = createVNode(Mask, maskOptions, null);
      }
      let main = createVNode("div", drawOptions.value, [slots.header && createVNode("div", {
        "class": ["w-drawer-header", props2.headerClass]
      }, [(_a = slots.header) == null ? void 0 : _a.call(slots, {
        close: close2
      })]), createVNode("div", {
        "class": ["w-drawer-body", props2.bodyClass]
      }, [(_b = slots.default) == null ? void 0 : _b.call(slots, {
        close: close2
      })]), slots.footer && createVNode("div", {
        "class": ["w-drawer-footer", props2.footerClass]
      }, [(_c = slots.footer) == null ? void 0 : _c.call(slots, {
        close: close2
      })])]);
      if (props2.placement === "center") {
        const wrapperProps = {
          class: "w-drawer-center-wrapper",
          style: {
            zIndex: zIndex2.value
          },
          ref: center
        };
        if (props2.canCloseByClickMask) {
          wrapperProps.onClick = (e) => {
            if (e.target === center.value) {
              close2();
            }
          };
        }
        main = createVNode("div", wrapperProps, [main]);
      }
      if (props2.bind === "v-if") {
        main = visible.value && main;
      } else if (props2.bind === "v-show") {
        main = withDirectives(main, [[vShow, visible.value]]);
      }
      return createVNode(Fragment, null, [(_d = slots.trigger) == null ? void 0 : _d.call(slots, {
        close: close2,
        show
      }), mask2, createVNode(Teleport, {
        "to": props2.to
      }, {
        default: () => [createVNode(Transition, {
          "name": `w-drawer-transition--${props2.placement}`,
          "onAfter-leave": afterLeave
        }, _isSlot$5(main) ? main : {
          default: () => [main]
        })]
      })]);
    };
  }
});
var drawer = /* @__PURE__ */ (() => ".w-drawer-transition--right-enter-active,.w-drawer-transition--left-enter-active,.w-drawer-transition--top-enter-active,.w-drawer-transition--bottom-enter-active,.w-drawer-transition--center-enter-active{transition:transform var(--w-transition-slow-time) var(--w-cubic-bezier-quick),opacity var(--w-transition-slow-time) var(--w-cubic-bezier-quick)}.w-drawer-transition--right-leave-active,.w-drawer-transition--left-leave-active,.w-drawer-transition--top-leave-active,.w-drawer-transition--bottom-leave-active,.w-drawer-transition--center-leave-active{transition:transform var(--w-transition-time) var(--w-cubic-bezier),opacity var(--w-transition-time) var(--w-cubic-bezier)}.w-drawer-transition--right-enter-from,.w-drawer-transition--right-leave-to{transform:translate(100%);opacity:0}.w-drawer-transition--left-enter-from,.w-drawer-transition--left-leave-to{transform:translate(-100%);opacity:0}.w-drawer-transition--top-enter-from,.w-drawer-transition--top-leave-to{transform:translateY(-100%);opacity:0}.w-drawer-transition--bottom-enter-from,.w-drawer-transition--bottom-leave-to{transform:translateY(100%);opacity:0}.w-drawer-transition--center-enter-from,.w-drawer-transition--center-leave-to{transform:scale(1.25);opacity:0}.w-drawer{--w-drawer-max-size: calc(var(--w-gap) * 3);position:fixed;background-color:#fff;display:flex;flex-direction:column;opacity:1}.w-drawer.w-drawer--center{position:relative;max-width:calc(100vw - var(--w-drawer-max-size));max-height:calc(100vh - var(--w-drawer-max-size));overflow:auto;box-shadow:var(--w-box-shadow)}.w-drawer.w-drawer--right{right:0;top:0;bottom:0;max-width:calc(100vw - var(--w-drawer-max-size));overflow:auto hidden;box-shadow:-3px 0 10px #00000026}.w-drawer.w-drawer--left{left:0;top:0;bottom:0;max-width:calc(100vw - var(--w-drawer-max-size));overflow:auto hidden;box-shadow:3px 0 10px #00000026}.w-drawer.w-drawer--top{right:0;top:0;left:0;max-height:calc(100vh - var(--w-drawer-max-size));overflow:hidden auto;box-shadow:0 3px 10px #00000026}.w-drawer.w-drawer--bottom{right:0;bottom:0;left:0;max-height:calc(100vh - var(--w-drawer-max-size));overflow:hidden auto;box-shadow:0 -3px 10px #00000026}.w-drawer .w-drawer-header,.w-drawer .w-drawer-footer{flex-shrink:0}.w-drawer .w-drawer-body{overflow:auto;height:0;flex:1}.w-drawer-center-wrapper{display:flex;align-items:center;justify-content:center;position:fixed;top:0;bottom:0;right:0;left:0;border-radius:var(--w-radius)}.w-drawer-center-wrapper .w-drawer.w-drawer--center{border-radius:var(--w-radius)}\n")();
var index$n = /* @__PURE__ */ (() => ".w-confirm-header{padding:10px var(--w-gap);display:flex;justify-content:space-between;align-items:center}.w-confirm-header>span{font-size:16px}.w-confirm-body{min-width:420px;min-height:44px;padding:var(--w-gap)}.w-confirm-footer{display:flex;padding:10px var(--w-gap);justify-content:flex-end;align-items:center}\n")();
let ConfirmInstance;
let ConfirmWrapper;
function open$1(options = { content: "", ok: () => {
} }) {
  const wrapper = document.createElement("template");
  const vm = createVNode(Drawer, {
    placement: "center",
    isConfirm: true,
    canCloseByClickMask: true,
    headerClass: "w-confirm-header",
    bodyClass: "w-confirm-body",
    footerClass: "w-confirm-footer",
    afterClose: destroy
  }, {
    default: ({ close: close2 }) => {
      let cont = null;
      if (typeof options.content === "function") {
        cont = options.content(close2);
      } else {
        cont = options.content;
      }
      return cont;
    },
    header: ({ close: close2 }) => {
      var _a;
      return [
        h("span", {}, (_a = options.title) != null ? _a : "\u63D0\u793A"),
        h(Close, {
          onClick: () => {
            var _a2;
            close2();
            (_a2 = options.cancel) == null ? void 0 : _a2.call(options);
          }
        })
      ];
    },
    footer: ({ close: close2 }) => {
      return [
        h(Btn, {
          onClick: () => {
            var _a;
            close2();
            (_a = options.cancel) == null ? void 0 : _a.call(options);
          }
        }, {
          default: () => {
            var _a;
            return (_a = options.cancelText) != null ? _a : "\u53D6\u6D88";
          }
        }),
        h(Btn, {
          type: "primary",
          onClick: () => {
            var _a;
            close2();
            (_a = options.ok) == null ? void 0 : _a.call(options);
          }
        }, { default: () => {
          var _a;
          return (_a = options.okText) != null ? _a : "\u786E\u5B9A";
        } })
      ];
    }
  });
  const ins = createApp(vm);
  ins.mount(wrapper);
  document.body.appendChild(wrapper);
  ConfirmInstance = ins;
  ConfirmWrapper = wrapper;
}
function destroy() {
  document.body.removeChild(ConfirmWrapper);
  ConfirmInstance.unmount();
}
function install$2(app) {
  app.config.globalProperties.$confirm = open$1;
}
var index$m = { install: install$2, open: open$1 };
function useDate(date4, fmt = "yyyy-MM-dd") {
  const dayNum = 42;
  const dayMap = readonly(/* @__PURE__ */ new Map([
    [1, "\u4E00"],
    [2, "\u4E8C"],
    [3, "\u4E09"],
    [4, "\u56DB"],
    [5, "\u4E94"],
    [6, "\u516D"],
    [0, "\u65E5"]
  ]));
  const yearPanelLength = 16;
  const currentDate = computed(() => parse$1(unref(date4)));
  const year = computed(() => getYear(currentDate.value));
  const month = computed(() => getMonth$1(currentDate.value));
  const day = computed(() => getDate(currentDate.value));
  function addMonths$1(date22, n = 1) {
    return addMonths(parse$1(date22), n);
  }
  function addYears$1(date22, n = 1) {
    return addYears(parse$1(date22), n);
  }
  function format2(date22, formart) {
    return format$1(parse$1(date22 || currentDate.value, formart), formart || unref(fmt));
  }
  function formatDate(date22, formart) {
    if (date22 !== void 0 && date22 !== "") {
      if (isDate(date22) || isNumber(date22)) {
        return parse$1(date22, formart);
      } else if (isString(date22)) {
        const arr = date22.trim().split(/\s+/);
        const [y, m = 1, d = 1] = arr[0].split("-");
        const [hh, mm, ss] = arr[1] ? arr[1].split(":") : [0, 0, 0];
        return parse$1(new Date(+y, Number(m) - 1, +d, +hh || 0, +mm || 0, +ss || 0), formart);
      }
    }
  }
  function getDaysInMonth$1(date22) {
    return getDaysInMonth(parse$1(date22 || currentDate.value));
  }
  function getStartDayInMonth(date22) {
    return getDay(startOfMonth(parse$1(date22 || currentDate.value)));
  }
  function getDaysInPanel(date22) {
    const parse_date = parse$1(date22 || currentDate.value);
    const curYear = getYear$1(parse_date);
    const curMonth = getMonth$1(parse_date);
    const cur = Array.from({ length: getDaysInMonth$1(parse_date) }, (item, index2) => [curYear, curMonth, index2 + 1]);
    const d = getStartDayInMonth(parse_date);
    const prevDate = addMonths(parse_date, -1);
    const prevYear = getYear$1(prevDate);
    const prevMonth = getMonth$1(prevDate);
    const nextDate = addMonths(parse_date, 1);
    const nextYear = getYear$1(nextDate);
    const nextMonth = getMonth$1(nextDate);
    const prevDays = Array.from({ length: getDaysInMonth$1(prevDate) }, (item, index2) => index2 + 1);
    let _d = d - 1;
    if (_d === -1) {
      _d = 6;
    }
    const prev = _d === 0 ? [] : prevDays.slice(-1 * _d).map((d2) => [prevYear, prevMonth, d2]);
    const next = Array.from({ length: dayNum - cur.length - prev.length }, (item, index2) => [nextYear, nextMonth, index2 + 1]);
    return {
      prev,
      cur,
      next
    };
  }
  function getMonth$1(date22) {
    return getMonth(parse$1(date22 || currentDate.value)) + 1;
  }
  function getYear$1(date22) {
    return getYear(parse$1(date22 || currentDate.value));
  }
  function getYearsInPanel(_year) {
    const num = yearPanelLength;
    const y = _year || year.value;
    const r = getRandomInt(5, 12);
    const prev = Array.from({ length: r }, (item, index2) => y - index2).reverse();
    const next = Array.from({ length: num - r }, (item, index2) => y + 1 + index2);
    return {
      years: prev.concat(next),
      from: prev[0],
      to: next[next.length - 1]
    };
  }
  function isSameDay$1(a, b) {
    return isSameDay(parse$1(a), parse$1(b));
  }
  function isSameMonth$1(a, b) {
    return isSameMonth(parse$1(a), parse$1(b));
  }
  function isToday(date22) {
    return isSameDay(parse$1(date22 || currentDate.value), Date.now());
  }
  function parse$1(date22, formatString) {
    if (typeof date22 === "string") {
      return parse(date22, formatString || unref(fmt), new Date());
    } else if (date22 === void 0) {
      return new Date();
    }
    return new Date(date22);
  }
  function isMinDayThanDate(givenDate, minDate) {
    let b = false, f = "yyyy-MM-dd";
    b = Number(parse$1(givenDate, f)) - Number(parse$1(minDate, f)) < 0;
    return b;
  }
  function isMaxDayThanDate(givenDate, minDate) {
    let b = false, f = "yyyy-MM-dd";
    b = Number(parse$1(givenDate, f)) - Number(parse$1(minDate, f)) > 0;
    return b;
  }
  function isMinMonthThanDate(givenDate, minDate) {
    let b = false, f = "yyyy-MM";
    const { year: givenYear, month: givenMonth } = getYearAndMonth(givenDate, f);
    const { year: minYear, month: minMonth } = getYearAndMonth(minDate, f);
    if (givenYear < minYear) {
      b = true;
    } else {
      if (givenMonth < minMonth) {
        b = true;
      }
    }
    return b;
  }
  function isMaxMonthThanDate(givenDate, maxDate) {
    let b = false, f = "yyyy-MM";
    const { year: givenYear, month: givenMonth } = getYearAndMonth(givenDate, f);
    const { year: maxYear, month: maxMonth } = getYearAndMonth(maxDate, f);
    if (givenYear > maxYear) {
      b = true;
    } else {
      if (givenMonth > maxMonth) {
        b = true;
      }
    }
    return b;
  }
  function isMinYearThanDate(givenDate, minDate) {
    let b = false, f = "yyyy-MM";
    const { year: givenYear } = getYearAndMonth(givenDate, f);
    const { year: minYear } = getYearAndMonth(minDate, f);
    if (givenYear < minYear) {
      b = true;
    }
    return b;
  }
  function isMaxYearThanDate(givenDate, maxDate) {
    let b = false, f = "yyyy-MM";
    const { year: givenYear } = getYearAndMonth(givenDate, f);
    const { year: maxYear } = getYearAndMonth(maxDate, f);
    if (givenYear > maxYear) {
      b = true;
    }
    return b;
  }
  function getYearAndMonth(d, formart) {
    const da = parse$1(d, formart);
    return { year: da.getFullYear(), month: da.getMonth() + 1 };
  }
  return {
    addMonths: addMonths$1,
    addYears: addYears$1,
    day,
    dayMap,
    format: format2,
    formatDate,
    month,
    year,
    yearPanelLength,
    getDaysInMonth: getDaysInMonth$1,
    getDaysInPanel,
    getYearsInPanel,
    getStartDayInMonth,
    getMonth: getMonth$1,
    getYear: getYear$1,
    isSameDay: isSameDay$1,
    isSameMonth: isSameMonth$1,
    isToday,
    isMaxDayThanDate,
    isMinDayThanDate,
    isMaxMonthThanDate,
    isMinMonthThanDate,
    isMinYearThanDate,
    isMaxYearThanDate,
    parse: parse$1
  };
}
function getRandomInt(from, to) {
  return Math.floor(Math.random() * (to - from)) + from;
}
var Days = defineComponent({
  name: "Days",
  props: {
    date: {
      type: [Number, Date, String]
    },
    displayDate: {
      type: [Number, Date, String]
    },
    format: {
      type: String,
      default: "yyyy-MM-dd"
    },
    max: {
      type: [Number, Date, String]
    },
    min: {
      type: [Number, Date, String]
    }
  },
  emits: {
    "toggle-day": (stringDate, date4) => {
      return true;
    }
  },
  setup(props2, {
    slots,
    emit
  }) {
    const {
      day,
      dayMap,
      format: format2,
      getDaysInPanel,
      isSameDay: isSameDay2,
      isToday,
      isMinDayThanDate,
      isMaxDayThanDate
    } = useDate(computed(() => props2.displayDate), computed(() => props2.format));
    function compareDate(d) {
      const min = props2.min, max = props2.max;
      if (min || max) {
        let isMin = false, isMax = false;
        if (min) {
          isMin = isMinDayThanDate(d, min);
        }
        if (max) {
          isMax = isMaxDayThanDate(d, max);
        }
        return isMin || isMax;
      }
      return false;
    }
    function renderDayItem(days, isCurrentMonth = false) {
      return days.map(([y, m, d]) => {
        const itemDate = new Date(y, m - 1, d);
        const isDisabled = compareDate(itemDate);
        const _isToday = isToday(itemDate);
        const _isSelected = isSameDay2(itemDate, props2.date) && props2.date !== void 0;
        const dOptions = {
          title: `${_isToday ? "\u4ECA\u65E5" : ""}${y}-${m}-${d}`,
          class: ["w-date-item", "w-date-item-day", "w-date-item-circle", {
            "w-date-item-not-current": !isCurrentMonth,
            "w-date-item-today": _isToday,
            "w-date-item-selected": _isSelected,
            "w-date-item-disabled": isDisabled
          }],
          onClick: (e) => {
            if (isDisabled) {
              return;
            }
            const ymd = format2(itemDate, "yyyy-MM-dd");
            emit("toggle-day", ymd, itemDate);
          }
        };
        return createVNode("div", dOptions, [_isToday ? [createVNode("span", null, [d]), createVNode("span", null, [createTextVNode("\u4ECA\u65E5")])] : d]);
      });
    }
    function renderDaysList() {
      const {
        prev,
        cur,
        next
      } = getDaysInPanel();
      return [renderDayItem(prev), renderDayItem(cur, true), renderDayItem(next)];
    }
    onMounted(() => {
    });
    return () => {
      return createVNode("div", {
        "class": "w-days"
      }, [renderDaysList()]);
    };
  }
});
const monthMap = readonly(/* @__PURE__ */ new Map([[1, "\u4E00\u6708"], [2, "\u4E8C\u6708"], [3, "\u4E09\u6708"], [4, "\u56DB\u6708"], [5, "\u4E94\u6708"], [6, "\u516D\u6708"], [7, "\u4E03\u6708"], [8, "\u516B\u6708"], [9, "\u4E5D\u6708"], [10, "\u5341\u6708"], [11, "\u5341\u4E00\u6708"], [12, "\u5341\u4E8C\u6708"]]));
var Months = defineComponent({
  name: "Months",
  props: {
    date: {
      type: [Date, String, Number]
    },
    displayDate: {
      type: [Date, String, Number]
    },
    max: {
      type: [Number, Date, String]
    },
    min: {
      type: [Number, Date, String]
    }
  },
  emits: {
    "toggle-month": (yearMonth) => {
      return yearMonth instanceof Date;
    }
  },
  setup(props2, {
    emit,
    slots
  }) {
    const {
      isSameMonth: isSameMonth2,
      year,
      isMinMonthThanDate,
      isMaxMonthThanDate
    } = useDate(computed(() => props2.displayDate));
    function compareDate(d) {
      const min = props2.min, max = props2.max;
      if (min || max) {
        let isMin = false, isMax = false;
        if (min) {
          isMin = isMinMonthThanDate(d, min);
        }
        if (max) {
          isMax = isMaxMonthThanDate(d, max);
        }
        return isMin || isMax;
      }
      return false;
    }
    function renderMonthList() {
      let ms = [];
      for (const [k, v2] of monthMap) {
        const isSelected = props2.date && isSameMonth2(props2.date, new Date(year.value, k - 1));
        const isCur = isSameMonth2(new Date(), new Date(year.value, k - 1));
        const isDisabled = compareDate(new Date(year.value, k - 1));
        const p = {
          class: ["w-months-item", {
            "w-months-item-selected": isSelected,
            "w-months-item-current": isCur,
            "w-months-item-disabled": isDisabled
          }],
          onClick: () => {
            if (isDisabled) {
              return;
            }
            const d = new Date(year.value, k - 1);
            emit("toggle-month", d);
          }
        };
        ms.push(createVNode("div", p, [isCur ? [createVNode("span", null, [v2]), createVNode("span", null, [createTextVNode("\u672C\u6708")])] : v2]));
      }
      return createVNode("div", {
        "class": "w-months"
      }, [ms]);
    }
    return renderMonthList;
  }
});
var Years = defineComponent({
  props: {
    date: {
      type: [Number, Date, String]
    },
    displayDate: {
      type: [Number, Date, String]
    },
    from: Number,
    to: Number,
    max: {
      type: [Number, Date, String]
    },
    min: {
      type: [Number, Date, String]
    }
  },
  emits: {
    "toggle-year": (year) => {
      return year >= 1700;
    },
    "get-from-to": (from, to) => {
      if (from || to) {
        return true;
      }
    }
  },
  setup(props2, {
    emit,
    slots
  }) {
    const {
      isMinYearThanDate,
      isMaxYearThanDate,
      getYearsInPanel,
      yearPanelLength
    } = useDate(computed(() => props2.displayDate));
    const {
      year: selectedYear
    } = useDate(computed(() => props2.date));
    const list = computed(() => {
      if (props2.from && props2.to) {
        const a = Array.from({
          length: yearPanelLength
        }, (item, index2) => index2 + props2.from);
        return a;
      }
      return [];
    });
    function compareDate(d) {
      const min = props2.min, max = props2.max;
      if (min || max) {
        let isMin = false, isMax = false;
        if (min) {
          isMin = isMinYearThanDate(d, min);
        }
        if (max) {
          isMax = isMaxYearThanDate(d, max);
        }
        return isMin || isMax;
      }
      return false;
    }
    function renderYearList() {
      const {
        years: yearList,
        from,
        to
      } = getYearsInPanel();
      emit("get-from-to", props2.from || from, props2.to || to);
      let ms = [];
      for (const v2 of list.value.length ? list.value : yearList) {
        const isCur = new Date().getFullYear() === v2;
        const isSelected = props2.date === void 0 ? false : selectedYear.value === v2;
        const isDisabled = compareDate(new Date(v2, 0));
        const p = {
          class: ["w-months-item", {
            "w-months-item-current": isCur,
            "w-months-item-selected": isSelected,
            "w-months-item-disabled": isDisabled
          }],
          onClick: () => {
            if (isDisabled) {
              return;
            }
            emit("toggle-year", v2);
          }
        };
        ms.push(createVNode("div", p, [isCur ? [createVNode("span", null, [v2]), createVNode("span", null, [createTextVNode("\u4ECA\u5E74")])] : v2]));
      }
      return createVNode("div", {
        "class": "w-months"
      }, [ms]);
    }
    return renderYearList;
  }
});
function useMousePositionInElement(elem, triggerEvent = "click") {
  const x = ref();
  const y = ref();
  function handleEvent(e) {
    const elemRect = getBoundingClientRect(elem);
    x.value = e.clientX - elemRect.x;
    y.value = e.clientY - elemRect.y;
  }
  function reset() {
    x.value = void 0;
    y.value = void 0;
  }
  useEvent(elem, triggerEvent, handleEvent);
  useEvent(elem, "mouseleave", reset);
  return { x, y };
}
function _isSlot$4(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
var Toggle = defineComponent({
  inheritAttrs: false,
  name: "Toggle",
  props: {
    dynamic: Boolean,
    data: {
      type: Array,
      default: () => []
    },
    item: {
      type: String
    },
    index: {
      type: Number,
      default: 0
    },
    itemClass: {
      type: [String, Array, Object]
    },
    transform: {
      type: String,
      default: "scale"
    },
    scale: {
      type: Object,
      default: () => ({
        from: 0,
        to: 2
      })
    },
    direction: {
      type: String,
      default: "x"
    },
    carousel: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 3600
    }
  },
  emits: {
    afterToggle: ({
      prev,
      next,
      delay
    }) => {
      return true;
    },
    wheel: (options) => {
      return true;
    }
  },
  setup(props2, {
    attrs,
    slots,
    emit,
    expose
  }) {
    const rootElement = ref();
    const isMounted = ref(false);
    const {
      delay
    } = useDelay(props2.duration);
    const isPrev = ref(false);
    const {
      x,
      y
    } = useMousePositionInElement(rootElement, "click");
    const {
      prev: _prev,
      next: _next,
      item,
      index: index2,
      set
    } = useToggleArray(computed(() => props2.data));
    const name = computed(() => {
      const t = props2.transform;
      if (t === "scale") {
        if (isPrev.value) {
          return "w-toggle-scale-prev";
        }
        return "w-toggle-scale";
      } else if (t === "translate") {
        if (props2.direction === "y") {
          if (isPrev.value) {
            return "w-toggle-translate-y-prev";
          }
          return "w-toggle-translate-y";
        } else {
          if (isPrev.value) {
            return "w-toggle-translate-prev";
          }
          return "w-toggle-translate";
        }
      }
    });
    const klass = computed(() => {
      props2.transform;
      return ["w-toggle", {
        "w-overflow-hidden": isMounted.value
      }];
    });
    const options = computed(() => {
      return mergeProps({
        class: klass.value,
        style: {
          "--__scale-from": props2.transform === "scale" && props2.scale.from,
          "--__scale-to": props2.transform === "scale" && props2.scale.to,
          "--__origin-x": x.value === void 0 ? "center" : `${x.value}px`,
          "--__origin-y": y.value === void 0 ? "center" : `${y.value}px`
        },
        onWheel: (e) => {
          e.preventDefault();
          e.stopPropagation();
          emit("wheel", {
            event: e,
            prev,
            next,
            delay
          });
        }
      }, attrs);
    });
    const itemOptions = computed(() => {
      props2.transform;
      return mergeProps({
        class: "w-toggle-item"
      }, {
        class: normalizeClass(props2.itemClass)
      });
    });
    function prev() {
      isPrev.value = true;
      if (props2.dynamic)
        ;
      else {
        _prev();
      }
    }
    function next() {
      isPrev.value = false;
      if (props2.dynamic)
        ;
      else {
        _next();
      }
    }
    function afterToggle() {
      emit("afterToggle", {
        prev,
        next,
        delay
      });
    }
    expose({
      prev,
      next
    });
    watch(() => props2.index, (i) => {
      if (!props2.dynamic) {
        set({
          index: props2.index
        });
      }
    }, {
      immediate: true
    });
    onMounted(async () => {
      await delay(200);
      isMounted.value = true;
      if (props2.carousel) {
        afterToggle();
      }
    });
    return () => {
      var _a;
      let _slot;
      const dynamicPart = props2.dynamic && createVNode(TransitionGroup, {
        "name": name.value,
        "onAfterEnter": afterToggle
      }, _isSlot$4(_slot = props2.data.map((el, i) => {
        var _a2;
        const k = isObject(el) ? JSON.stringify(el) : isBoolean(el) ? Number(el) : el;
        return createVNode("div", mergeProps(itemOptions.value, {
          "key": k
        }), [(_a2 = slots.default) == null ? void 0 : _a2.call(slots, {
          item: el,
          index: i,
          prev,
          next
        })]);
      })) ? _slot : {
        default: () => [_slot]
      });
      const staticPart = props2.data.map((el, i) => {
        return createVNode(Transition, {
          "name": name.value,
          "onAfterEnter": afterToggle
        }, {
          default: () => {
            var _a2;
            return [i === index2.value && createVNode("div", itemOptions.value, [(_a2 = slots.default) == null ? void 0 : _a2.call(slots, {
              item: el,
              index: i,
              prev,
              next
            })])];
          }
        });
      });
      return createVNode(Fragment, null, [(_a = slots.use) == null ? void 0 : _a.call(slots, {
        ...props2,
        prev,
        next,
        item: unref(item),
        index: index2
      }), createVNode("div", mergeProps(options.value, {
        "ref": rootElement
      }), [props2.dynamic ? dynamicPart : staticPart])]);
    };
  }
});
var index$l = /* @__PURE__ */ (() => ".w-toggle-scale-enter-active,.w-toggle-scale-leave-active,.w-toggle-scale-prev-leave-active{transition:opacity var(--w-transition-slow-time) var(--w-cubic-bezier),transform var(--w-transition-slow-time) var(--w-cubic-bezier)}.w-toggle-scale-prev-enter-active{transition:opacity var(--w-transition-slow-time) var(--w-cubic-bezier-quick),transform var(--w-transition-slow-time) var(--w-cubic-bezier-quick)}.w-toggle-scale-enter-from{opacity:0;transform:scale(var(--__scale-from))}.w-toggle-scale-leave-to,.w-toggle-scale-prev-enter-from{opacity:0;transform:scale(var(--__scale-to))}.w-toggle-scale-prev-leave-to{opacity:0;transform:scale(var(--__scale-from))}.w-toggle-translate-enter-active,.w-toggle-translate-leave-active,.w-toggle-translate-prev-enter-active,.w-toggle-translate-prev-leave-active,.w-toggle-translate-y-enter-active,.w-toggle-translate-y-leave-active,.w-toggle-translate-y-prev-enter-active,.w-toggle-translate-y-prev-leave-active{transition:transform var(--w-transition-slow-time) var(--w-cubic-bezier)}.w-toggle-translate-enter-from{transform:translate(100%)}.w-toggle-translate-leave-to,.w-toggle-translate-prev-enter-from{transform:translate(-100%)}.w-toggle-translate-prev-leave-to{transform:translate(100%)}.w-toggle-translate-y-enter-from{transform:translateY(100%)}.w-toggle-translate-y-leave-to,.w-toggle-translate-y-prev-enter-from{transform:translateY(-100%)}.w-toggle-translate-y-prev-leave-to{transform:translateY(100%)}.w-toggle{position:relative}.w-toggle .w-toggle-item{position:absolute;top:0;left:0;right:0;bottom:0;transform-origin:center center;transform-origin:var(--__origin-x, center) var(--__origin-y, center)}\n")();
var dial = /* @__PURE__ */ (() => ".w-time-dial{width:100%;height:100%}.w-time-dial .w-time-dial-title,.w-time-dial .w-time-dial-btn{-webkit-user-select:none;-moz-user-select:none;user-select:none;display:flex;align-items:center;height:var(--w-size)}.w-time-dial .w-time-dial-title>span,.w-time-dial .w-time-dial-btn>span,.w-time-dial .w-time-dial-title>i,.w-time-dial .w-time-dial-btn>i{flex:1;display:flex;justify-content:center;text-align:center}.w-time-dial .w-time-dial-btn{height:auto}.w-time-dial .w-time-dial-btn>i{cursor:pointer}.w-time-dial .w-time-dial-btn>i:hover{color:var(--w-color-font-2)}.w-time-dial .w-time-dial-list{--__dial-list-height:calc(100% - 66px);display:flex;height:var(--__dial-list-height);justify-content:center}.w-time-dial .w-time-dial-list .w-dial-item{flex:1;display:flex;height:100%}.w-time-dial .w-time-dial-list .w-dial-item .w-dial-toggle-item{display:flex;align-items:center;justify-content:center;flex-direction:column}.w-time-dial .w-time-dial-list .w-dial-item .w-dial-item-item{height:calc(100% / 6);display:flex;align-items:center;justify-content:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;transition:var(--w-transition-time);border-radius:var(--w-radius);color:var(--w-color-font-2);border:1px solid transparent;width:30px}.w-time-dial .w-time-dial-list .w-dial-item .w-dial-item-item.w-dial-item-readonly{color:var(--w-color-font-4)}.w-time-dial .w-time-dial-list .w-dial-item .w-dial-item-item:hover:not(.w-dial-item-readonly){cursor:pointer}.w-time-dial .w-time-dial-list .w-dial-item .w-dial-item-item:hover:not(.w-dial-item-selected):not(.w-dial-item-readonly){background-color:var(--w-color-bg);color:var(--w-color-font-1)}.w-time-dial .w-time-dial-list .w-dial-item .w-dial-item-item.w-dial-item-selected{background-color:var(--w-color-primary-light-8);border:1px solid var(--w-color-primary-light-6);color:var(--w-color-primary);font-weight:700}\n")();
const _hoisted_1 = { class: "w-time-dial" };
const _hoisted_2 = { class: "w-time-dial-title" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { key: 2 };
const _hoisted_6 = {
  key: 0,
  class: "w-time-dial-list"
};
const _hoisted_7 = ["onClick"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  props: {
    format: { type: null, required: false, default: "HH:mm:ss" },
    value: { type: String, required: false }
  },
  emits: ["change"],
  setup(__props, { emit }) {
    const props2 = __props;
    const [h2, m, s] = useHms(props2);
    const isMounted = ref(false);
    const bottom_btn = ref();
    const top_btn = ref();
    const createNumberArray = (total, size = 6) => Array.from({ length: total / size }, (el, i) => Array.from({ length: size }, (item, index2) => (i * size + index2).toString().padStart(2, "0")));
    const has = computed(() => {
      const f = props2.format;
      const m2 = f.indexOf("mm") > -1;
      const h22 = f.indexOf("HH") > -1;
      const s2 = f.indexOf("ss") > -1;
      return { m: m2, h: h22, s: s2 };
    });
    const can = computed(() => {
      const v2 = props2.value;
      const len = v2 == null ? void 0 : v2.length;
      if (len) {
        let h22 = true, m2 = false, s2 = false;
        if (len >= 2) {
          m2 = true;
        }
        if (len >= 5) {
          s2 = true;
        }
        return { h: h22 && has.value.h, m: m2 && has.value.m, s: s2 && has.value.s };
      }
      return { h: false, m: false, s: false };
    });
    const arr = computed(() => {
      const a = [];
      if (has.value.h) {
        a.push(createNumberArray(24));
        if (has.value.m) {
          a.push(createNumberArray(60));
          if (has.value.s) {
            a.push(createNumberArray(60));
          }
        }
      }
      return a;
    });
    const toggleOptions = {
      class: "w-dial-item",
      transform: "translate",
      direction: "y",
      itemClass: "w-dial-toggle-item"
    };
    function handleWheel(i, {
      event,
      prev,
      next,
      delay
    }) {
      if (event.deltaY > 0) {
        delay(next, 100);
      } else {
        delay(prev, 100);
      }
    }
    function handleClick(i, v2) {
      console.log(v2, "vvv");
      const arr2 = [];
      if (i === 0) {
        if (has.value.h)
          h2.value = v2;
      } else if (i === 1) {
        if (can.value.m)
          m.value = v2;
        else {
          return;
        }
      } else {
        if (can.value.s)
          s.value = v2;
        else {
          return;
        }
      }
      if (h2.value) {
        arr2.push(h2.value);
      }
      if (m.value) {
        arr2.push(m.value);
      }
      if (s.value) {
        arr2.push(s.value);
      }
      emit("change", arr2.join(":"));
    }
    function getIndex(i) {
      if (i === 0) {
        if (h2.value === void 0) {
          return 0;
        } else {
          const j = parseInt("" + Number(h2.value) / 6);
          return j;
        }
      } else if (i === 1) {
        if (m.value === void 0) {
          return 0;
        } else {
          return parseInt("" + Number(m.value) / 6);
        }
      } else if (i === 2) {
        if (s.value === void 0) {
          return 0;
        } else {
          return parseInt("" + Number(s.value) / 6);
        }
      }
    }
    onMounted(() => {
      isMounted.value = true;
    });
    function useHms(props22) {
      const h22 = ref();
      const m2 = ref();
      const s2 = ref();
      watchEffect(() => {
        [h22.value, m2.value, s2.value] = (props22.value || "").split(":");
      });
      return [h22, m2, s2];
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", _hoisted_2, [
          unref(has).h ? (openBlock(), createElementBlock("span", _hoisted_3, "\u65F6")) : createCommentVNode("v-if", true),
          unref(has).m ? (openBlock(), createElementBlock("span", _hoisted_4, "\u5206")) : createCommentVNode("v-if", true),
          unref(has).s ? (openBlock(), createElementBlock("span", _hoisted_5, "\u79D2")) : createCommentVNode("v-if", true)
        ]),
        createElementVNode("div", {
          class: "w-time-dial-btn",
          ref_key: "top_btn",
          ref: top_btn
        }, null, 512),
        isMounted.value ? (openBlock(), createElementBlock("div", _hoisted_6, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(arr), (a, i) => {
            return openBlock(), createBlock(unref(Toggle), mergeProps(toggleOptions, {
              data: a,
              index: getIndex(i),
              onWheel: ($event) => handleWheel(i, $event)
            }), {
              default: withCtx(({ item }) => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(item, (n) => {
                  return openBlock(), createElementBlock("div", {
                    class: normalizeClass([
                      "w-dial-item-item",
                      {
                        "w-dial-item-readonly": i === 0 && !unref(has).h || i === 1 && !unref(can).m || i === 2 && !unref(can).s,
                        "w-dial-item-selected": i === 0 && unref(h2) == n || i === 1 && unref(m) == n || i === 2 && unref(s) == n
                      }
                    ]),
                    onClick: ($event) => handleClick(i, n)
                  }, toDisplayString(n), 11, _hoisted_7);
                }), 256))
              ]),
              use: withCtx(({ prev, next }) => [
                (openBlock(), createBlock(Teleport, { to: top_btn.value }, [
                  createVNode(unref(Icon$1), {
                    name: "w-icon-sort-down",
                    size: "18px",
                    rotate: "",
                    onClick: prev
                  }, null, 8, ["onClick"])
                ], 8, ["to"])),
                (openBlock(), createBlock(Teleport, { to: bottom_btn.value }, [
                  createVNode(unref(Icon$1), {
                    name: "w-icon-sort-down",
                    size: "18px",
                    onClick: next
                  }, null, 8, ["onClick"])
                ], 8, ["to"]))
              ]),
              _: 2
            }, 1040, ["data", "index", "onWheel"]);
          }), 256))
        ])) : createCommentVNode("v-if", true),
        createElementVNode("div", {
          class: "w-time-dial-btn",
          ref_key: "bottom_btn",
          ref: bottom_btn
        }, null, 512)
      ]);
    };
  }
});
var Dial = /* @__PURE__ */ _export_sfc(_sfc_main, [["__file", "/Users/qiguoqing/Desktop/yuou/will-ui/src/packages/components/time/Dial.vue"]]);
var FormatViewMap = /* @__PURE__ */ ((FormatViewMap2) => {
  FormatViewMap2["yyyy"] = "year";
  FormatViewMap2["yyyy-MM"] = "month";
  FormatViewMap2["yyyy-MM-dd"] = "day";
  FormatViewMap2["yyyy-MM-dd HH:mm:ss"] = "time";
  FormatViewMap2["yyyy-MM-dd HH:mm"] = "time";
  FormatViewMap2["yyyy-MM-dd HH"] = "time";
  return FormatViewMap2;
})(FormatViewMap || {});
function useDateView(format2) {
  const currentView = ref("day");
  const currentFormat = computed(() => FormatViewMap[format2.value]);
  const isYear = computed(() => currentView.value === "year");
  const isMonth = computed(() => currentView.value === "month");
  const isDay = computed(() => currentView.value === "day");
  const isTime = computed(() => currentView.value === "time");
  function setCurrentView(view) {
    currentView.value = view;
  }
  function toSetByFormat() {
    const f = unref(format2);
    setCurrentView(FormatViewMap[f]);
  }
  watchEffect(() => {
    toSetByFormat();
  });
  return {
    currentView: readonly(currentView),
    isYear,
    isMonth,
    isDay,
    isTime,
    formatIsYear: computed(() => currentFormat.value === "year"),
    formatIsMonth: computed(() => currentFormat.value === "month"),
    formatIsDay: computed(() => currentFormat.value === "day"),
    formatIsTime: computed(() => currentFormat.value === "time"),
    getFormatView: () => currentFormat.value,
    setCurrentView
  };
}
function useBarText(isYear, isMonth, isDay, isTime, displayDate, ft) {
  const { year, month, day } = useDate(displayDate);
  return computed(() => {
    const y = year.value + "\u5E74";
    const m = month.value + "\u6708";
    if (isDay.value) {
      return y + m;
    } else if (isMonth.value) {
      return y;
    } else if (isYear.value) {
      return `${ft.from}-${ft.to}`;
    } else if (isTime.value) {
      return y + m + day.value + "\u65E5";
    }
  });
}
function useDateText(format2, date4) {
  const { formatDate, format: fm, year } = useDate(date4);
  return computed(() => {
    const d = date4.value;
    const f = format2.value;
    if (d === void 0) {
      return "";
    } else {
      const _d = formatDate(d);
      if (_d) {
        const y = _d.getFullYear();
        _d.getMonth() + 1;
        _d.getDate();
        if (f === "yyyy") {
          return y + "\u5E74";
        } else if (f === "yyyy-MM" || f === "yyyy-MM-dd") {
          return fm(_d, f);
        } else if (f.indexOf("HH") > -1) {
          return fm(_d, f);
        }
      }
    }
  });
}
function useFormatDate(format2, theDate) {
  const { parse: parse2, format: _f, formatDate } = useDate(theDate, format2);
  const selectedDate = computed(() => {
    format2.value;
    const currentDate = theDate.value;
    return formatDate(currentDate);
  });
  return {
    selectedDate,
    formatDate,
    getStringDate: (date4, f) => {
      if (date4 === void 0) {
        return void 0;
      } else {
        const _d = formatDate(date4);
        return _f(_d, f || format2.value);
      }
    }
  };
}
const renderPrevIcon = (handleClick) => createVNode(Icon$1, {
  "name": "w-icon-sort-down",
  "class": "w-date-control-bar-icon",
  "rotate": true,
  "onClick": handleClick
}, null);
const renderNextIcon = (handleClick) => createVNode(Icon$1, {
  "name": "w-icon-sort-down",
  "class": "w-date-control-bar-icon",
  "onClick": handleClick
}, null);
const renderWeekTitleList = (dayMap) => {
  const days = [];
  for (const [k, v2] of dayMap) {
    days.push(createVNode("b", {
      "class": ["w-week-title-item"]
    }, [v2]));
  }
  return createVNode("div", {
    "class": "w-week-title"
  }, [days]);
};
var DatePicker = defineComponent({
  name: "DatePicker",
  components: {
    Layer,
    Trigger,
    Icon: Icon$1,
    Days,
    Months,
    Years,
    Toggle,
    Dial
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    block: Boolean,
    placeholder: {
      type: [String, Object, Array],
      default: "\u8BF7\u9009\u62E9\u65E5\u671F"
    },
    modelValue: {
      type: [Number, Date, String],
      default: void 0
    },
    format: {
      type: String,
      default: "yyyy-MM-dd"
    },
    max: {
      type: [Number, Date, String]
    },
    min: {
      type: [Number, Date, String]
    },
    adjustPosition: {
      type: String,
      default: "auto"
    },
    validateEvent: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:show", "update:modelValue"],
  setup(props2, {
    emit,
    slots,
    expose
  }) {
    const formItem = inject("formItem", void 0);
    const ctrlIcon = ref();
    const visible = ref(props2.show);
    const showIcon = ref(false);
    const toggleComponent = ref();
    const {
      currentView,
      isYear,
      isDay,
      isMonth,
      isTime,
      formatIsDay,
      formatIsMonth,
      formatIsYear,
      formatIsTime,
      getFormatView,
      setCurrentView
    } = useDateView(computed(() => props2.format));
    const isUpDown = ref(false);
    const yearPanel = reactive({
      from: 0,
      to: 0
    });
    const {
      selectedDate,
      getStringDate,
      formatDate
    } = useFormatDate(computed(() => props2.format), computed(() => props2.modelValue));
    const displayDate = ref(formatDate(props2.modelValue) || new Date());
    const {
      addMonths: addMonths2,
      addYears: addYears2,
      dayMap,
      format: format2,
      year: displayYear,
      yearPanelLength,
      month: displayMonth
    } = useDate(displayDate, computed(() => props2.format));
    const text = useDateText(computed(() => props2.format), computed(() => props2.modelValue));
    const timeFormat = computed(() => {
      let f = "HH:mm:ss";
      const _f = props2.format;
      if (formatIsTime.value) {
        f = _f.split(/\s+/)[1];
      }
      return f;
    });
    const timeValue = computed(() => {
      if (isTime.value) {
        const d = selectedDate.value;
        if (d) {
          const h2 = d.getHours(), m = d.getMinutes(), s = d.getSeconds();
          const hh = h2.toString().padStart(2, "0");
          const mm = m.toString().padStart(2, "0");
          const ss = s.toString().padStart(2, "0");
          return [hh, mm, ss];
        } else {
          return ["00", "00", "00"];
        }
      }
    });
    const dataList = ref([{
      datetype: "day",
      val: Number(displayDate.value)
    }]);
    const barText = useBarText(isYear, isMonth, isDay, isTime, displayDate, yearPanel);
    const layerOptions = computed(() => {
      return {
        adjustPosition: props2.adjustPosition,
        immediate: true,
        show: visible.value,
        disabled: props2.disabled,
        placement: "bottom-start",
        gap: 2,
        hasArrow: false,
        transitionName: "w-slide-y",
        layerClass: "w-date-picker",
        "onUpdate:show": (b) => {
          visible.value = b;
          nextTick(() => {
            showIcon.value = b;
          });
        }
      };
    });
    function renderTrigger() {
      const triggerOptions = {
        placeholder: props2.placeholder,
        disabled: props2.disabled,
        block: props2.block,
        clearable: props2.clearable,
        text: text.value,
        active: visible.value,
        onClear: () => {
          clear();
        }
      };
      return createVNode(Trigger, triggerOptions, null);
    }
    function renderContent() {
      const bar = renderControlBar();
      const transform = isUpDown.value ? "translate" : "scale";
      let toggleOptions = {
        ref: toggleComponent,
        class: isDay.value || isTime.value ? "w-date-days" : isMonth.value || isYear.value ? "w-date-months" : "",
        dynamic: true,
        data: dataList.value,
        direction: "y",
        transform,
        scale: {
          from: 0.75,
          to: 1.8
        },
        onWheel({
          event,
          delay
        }) {
          if (event.deltaY > 0) {
            delay(toNext, 100);
          } else {
            delay(toPrev, 100);
          }
        }
      };
      return createVNode(Fragment, null, [bar, createVNode(Toggle, toggleOptions, {
        default: ({
          item,
          index: index2
        }) => {
          var _a;
          if (item.datetype === "day") {
            return createVNode(Days, {
              "date": selectedDate.value,
              "displayDate": item.val,
              "format": props2.format,
              "min": props2.min,
              "max": props2.max,
              "onToggle-day": (stringDate) => {
                var _a2;
                if (formatIsDay.value) {
                  emit("update:modelValue", stringDate);
                  visible.value = false;
                  if (props2.validateEvent) {
                    formItem == null ? void 0 : formItem.validate("change");
                  }
                } else if (formatIsTime.value) {
                  isUpDown.value = false;
                  (_a2 = toggleComponent.value) == null ? void 0 : _a2.next();
                  dataList.value.push({
                    datetype: "time",
                    val: ""
                  });
                  dataList.value.shift();
                  setCurrentView("time");
                  const hms = createTimeByFormat();
                  let sd = stringDate;
                  if (hms) {
                    sd = sd + " " + hms;
                  }
                  emit("update:modelValue", sd);
                  if (props2.validateEvent) {
                    formItem == null ? void 0 : formItem.validate("change");
                  }
                }
              }
            }, null);
          } else if (item.datetype === "time") {
            return createVNode(Dial, {
              "format": timeFormat.value,
              "value": (_a = timeValue.value) == null ? void 0 : _a.join(":"),
              "onChange": (hms) => {
                const sd = selectedDate.value;
                if (sd) {
                  const d = format2(sd, "yyyy-MM-dd");
                  if (hms) {
                    emit("update:modelValue", d + " " + hms);
                    if (props2.validateEvent) {
                      formItem == null ? void 0 : formItem.validate("change");
                    }
                  }
                }
              }
            }, null);
          } else if (item.datetype === "month") {
            return createVNode(Months, {
              "date": selectedDate.value,
              "displayDate": displayDate.value,
              "min": props2.min,
              "max": props2.max,
              "onToggle-month": (toggleDate) => {
                var _a2;
                if (formatIsDay.value || formatIsTime.value) {
                  isUpDown.value = false;
                  (_a2 = toggleComponent.value) == null ? void 0 : _a2.next();
                  dataList.value.push({
                    datetype: "day",
                    val: Number(toggleDate)
                  });
                  setCurrentView("day");
                  displayDate.value = toggleDate;
                  dataList.value.shift();
                } else if (formatIsMonth.value) {
                  emit("update:modelValue", getStringDate(toggleDate));
                  visible.value = false;
                  if (props2.validateEvent) {
                    formItem == null ? void 0 : formItem.validate("change");
                  }
                }
              }
            }, null);
          } else {
            return createVNode(Years, {
              "from": yearPanel.from,
              "to": yearPanel.to,
              "date": selectedDate.value,
              "displayDate": displayDate.value,
              "min": props2.min,
              "max": props2.max,
              "onGet-from-to": (from, to) => {
                yearPanel.from = from;
                yearPanel.to = to;
              },
              "onToggle-year": (y) => {
                var _a2;
                if (formatIsYear.value) {
                  emit("update:modelValue", y + "");
                  visible.value = false;
                  if (props2.validateEvent) {
                    formItem == null ? void 0 : formItem.validate("change");
                  }
                } else {
                  isUpDown.value = false;
                  (_a2 = toggleComponent.value) == null ? void 0 : _a2.next();
                  dataList.value.push({
                    datetype: "month",
                    val: ""
                  });
                  displayDate.value = new Date(y, 0);
                  setCurrentView("month");
                  dataList.value.shift();
                }
              }
            }, null);
          }
        },
        use: () => isDay.value && renderWeekTitleList(dayMap)
      })]);
    }
    function renderControlBar() {
      return createVNode("div", {
        "class": "w-date-control-bar",
        "ref": ctrlIcon
      }, [createVNode("div", {
        "class": [isYear.value ? "w-date-control-bar-disabled" : "w-date-control-bar-y-m"],
        "onClick": () => {
          var _a, _b, _c;
          if (isDay.value) {
            isUpDown.value = false;
            (_a = toggleComponent.value) == null ? void 0 : _a.prev();
            dataList.value.unshift({
              datetype: "month",
              val: displayMonth.value
            });
            setCurrentView("month");
            dataList.value.pop();
          } else if (isMonth.value) {
            isUpDown.value = false;
            (_b = toggleComponent.value) == null ? void 0 : _b.prev();
            dataList.value.unshift({
              datetype: "year",
              val: displayYear.value
            });
            setCurrentView("year");
            dataList.value.pop();
            yearPanel.from = 0;
            yearPanel.to = 0;
          } else if (isTime.value) {
            isUpDown.value = false;
            (_c = toggleComponent.value) == null ? void 0 : _c.prev();
            dataList.value.unshift({
              datetype: "day",
              val: Number(displayDate.value)
            });
            setCurrentView("day");
            dataList.value.pop();
          }
        }
      }, [barText.value]), isTime.value ? createVNode(Btn, {
        "mode": "text",
        "text": "\u786E\u5B9A",
        "onClick": () => {
          visible.value = false;
        }
      }, null) : [renderPrevIcon(toPrev), renderNextIcon(toNext)]]);
    }
    function createTimeByFormat() {
      const f = timeFormat.value;
      const yms = timeValue.value;
      if (yms) {
        if (f === "HH") {
          return yms[0];
        } else if (f === "HH:mm") {
          return yms.slice(0, 2).join(":");
        } else if (f === "HH:mm:ss") {
          return yms.join(":");
        }
      }
    }
    function toPrev() {
      var _a;
      isUpDown.value = true;
      const view = currentView.value;
      (_a = toggleComponent.value) == null ? void 0 : _a.prev();
      if (view === "day") {
        const am = addMonths2(displayDate.value, -1);
        dataList.value.unshift({
          datetype: view,
          val: Number(am)
        });
        dataList.value.pop();
        displayDate.value = am;
      } else if (view === "month") {
        const ay = addYears2(displayDate.value, -1);
        const a = Number(ay);
        dataList.value.unshift({
          datetype: view,
          val: a
        });
        dataList.value.pop();
        displayDate.value = ay;
      } else {
        yearPanel.from = yearPanel.from - yearPanelLength;
        yearPanel.to = yearPanel.to - yearPanelLength;
        dataList.value.unshift({
          datetype: view,
          val: Number(new Date())
        });
        dataList.value.pop();
      }
    }
    function toNext() {
      var _a;
      isUpDown.value = true;
      const view = currentView.value;
      (_a = toggleComponent.value) == null ? void 0 : _a.next();
      if (view === "day") {
        const am = addMonths2(displayDate.value);
        const a = Number(am);
        dataList.value.push({
          datetype: view,
          val: a
        });
        dataList.value.shift();
        displayDate.value = am;
      } else if (view === "month") {
        const ay = addYears2(displayDate.value, 1);
        const a = Number(ay);
        dataList.value.push({
          datetype: view,
          val: a
        });
        dataList.value.shift();
        displayDate.value = ay;
      } else {
        yearPanel.from = yearPanel.from + yearPanelLength;
        yearPanel.to = yearPanel.to + yearPanelLength;
        dataList.value.push({
          datetype: view,
          val: Number(new Date())
        });
        dataList.value.shift();
      }
    }
    function clear() {
      var _a;
      if (isTime.value) {
        (_a = toggleComponent.value) == null ? void 0 : _a.prev();
        dataList.value.unshift({
          datetype: "day",
          val: Number(displayDate.value)
        });
        dataList.value.pop();
        setCurrentView("day");
      }
      emit("update:modelValue", void 0);
      if (props2.validateEvent) {
        formItem == null ? void 0 : formItem.validate("change");
      }
    }
    watch(() => props2.show, (b) => {
      visible.value = b;
    });
    watch(visible, (b) => {
      if (b) {
        let fv = getFormatView();
        const _fv = fv === "time" ? "day" : fv;
        if (selectedDate.value) {
          displayDate.value = selectedDate.value;
          dataList.value = [{
            datetype: _fv,
            val: format2(selectedDate.value, props2.format)
          }];
        } else {
          displayDate.value = new Date();
          dataList.value = [{
            datetype: _fv,
            val: Number(new Date())
          }];
        }
        setCurrentView(_fv);
      }
      emit("update:show", b);
    });
    watch(() => props2.modelValue, (d) => {
      if (d !== void 0) {
        displayDate.value = selectedDate.value;
      }
    });
    return () => createVNode(Layer, layerOptions.value, {
      trigger: renderTrigger,
      default: renderContent
    });
  }
});
var index$k = /* @__PURE__ */ (() => ".w-days{display:flex;flex-wrap:wrap;height:100%}.w-date-item{flex:0 0 auto;width:calc(100% / 7);height:calc(100% / 6);display:flex;align-items:center;justify-content:center;flex-direction:column;color:var(--w-color-font-2);-webkit-user-select:none;-moz-user-select:none;user-select:none}.w-date-item.w-date-item-not-current{color:var(--w-color-font-3)}.w-date-item.w-date-item-circle{border-radius:100%}.w-date-item.w-date-item-day{transition:var(--w-transition-time);cursor:pointer}.w-date-item.w-date-item-day:hover:not(.w-date-item-today):not(.w-date-item-selected):not(.w-date-item-disabled){background-color:var(--w-color-bg);color:var(--w-color-font-1)}.w-date-item.w-date-item-day.w-date-item-today{border:1px solid var(--w-color-primary-light-6);color:var(--w-color-primary)}.w-date-item.w-date-item-day.w-date-item-selected{border:1px solid var(--w-color-primary-light-6);background-color:var(--w-color-primary-light-8);color:var(--w-color-primary);font-weight:700}.w-date-item.w-date-item-day.w-date-item-disabled{color:var(--w-color-font-4);cursor:not-allowed}.w-date-item.w-date-item-day:active:not(.w-date-item-disabled){box-shadow:inset 0 0 50px var(--w-color-font-4)}.w-months{display:flex;flex-wrap:wrap;height:100%;align-content:space-evenly}.w-months-item{width:25%;height:25%;display:flex;align-items:center;justify-content:center;flex-direction:column;color:var(--w-color-font-2);-webkit-user-select:none;-moz-user-select:none;user-select:none;border-radius:100%;transition:background-color var(--w-transition-time);cursor:pointer}.w-months-item:hover:not(.w-months-item-current):not(.w-months-item-selected):not(.w-months-item-disabled){background-color:var(--w-color-bg)}.w-months-item.w-months-item-current{color:var(--w-color-primary);border:1px solid var(--w-color-primary-light-6);justify-content:space-evenly}.w-months-item.w-months-item-selected{border:1px solid var(--w-color-primary-light-6);background-color:var(--w-color-primary-light-8);color:var(--w-color-primary);font-weight:700}.w-months-item.w-months-item-disabled{color:var(--w-color-font-4);cursor:not-allowed}.w-date-picker{padding:var(--w-gap);--__week-height: var(--w-size);--__width: calc(var(--w-date-picker-panel-width) - var(--w-gap) * 2);--__height: calc( var(--w-date-picker-panel-height) - var(--w-gap) * 2 - var(--__week-height) )}.w-date-picker .w-date-days{height:var(--__height);width:var(--__width)}.w-date-picker .w-date-months{width:var(--__width);height:calc(var(--__height) + var(--__week-height))}.w-date-picker .w-date-control-bar{height:var(--w-size);display:flex;align-items:stretch}.w-date-picker .w-date-control-bar .w-date-control-bar-disabled{-webkit-user-select:none;-moz-user-select:none;user-select:none;display:flex;align-items:center;flex:1;font-size:14px;padding:0 var(--w-padding-x)}.w-date-picker .w-date-control-bar .w-date-control-bar-y-m,.w-date-picker .w-date-control-bar .w-date-control-bar-icon{-webkit-user-select:none;-moz-user-select:none;user-select:none;display:flex;align-items:center;flex:1;padding:0 var(--w-padding-x);border-radius:var(--w-radius);cursor:pointer;color:var(--w-color-font-1);transition:var(--w-transition-time);font-size:14px}.w-date-picker .w-date-control-bar .w-date-control-bar-y-m:hover,.w-date-picker .w-date-control-bar .w-date-control-bar-icon:hover{background-color:var(--w-color-bg)}.w-date-picker .w-date-control-bar .w-date-control-bar-y-m:active,.w-date-picker .w-date-control-bar .w-date-control-bar-icon:active{background-color:var(--w-color-font-4)}.w-date-picker .w-date-control-bar .w-date-control-bar-icon{flex:0 0 var(--w-size);justify-content:center;padding:0;font-size:20px;color:var(--w-color-font-3)}.w-date-picker .w-date-control-bar .w-date-control-bar-icon:first-of-type{margin-left:var(--w-gap)}.w-date-picker .w-date-panel{display:flex;width:var(--__width)}.w-date-picker .w-week-title{display:flex;align-items:center;flex-wrap:nowrap;height:var(--__week-height)}.w-date-picker .w-week-title .w-week-title-item{flex:1;text-align:center;color:var(--w-color-font-2);-webkit-user-select:none;-moz-user-select:none;user-select:none}\n")();
var _props$2 = {
  model: { type: Object },
  titleWidth: {
    type: [String, Number],
    default: ""
  },
  titlePosition: {
    type: String,
    values: ["left", "right", "top"],
    default: "right"
  },
  legendPosition: {
    type: String,
    values: ["left", "right", "center"],
    default: "left"
  },
  title: { type: String, default: "" },
  fieldset: {
    type: Boolean,
    default: false
  },
  border: {
    type: [String, Number],
    default: ""
  },
  errorBorder: Boolean,
  errorPosition: {
    type: String,
    default: "bottom"
  },
  disabled: Boolean,
  inline: Boolean,
  rules: {
    type: Object
  },
  labelWidth: {
    type: [String, Number]
  }
};
var Form = defineComponent({
  name: "Form",
  props: {
    ..._props$2
  },
  emit: ["validate"],
  setup(props2, {
    emit,
    slots,
    expose
  }) {
    const fields = [];
    function addField(v2) {
      if (v2) {
        fields.push(v2);
      }
    }
    function removeField(v2) {
      if (v2.prop) {
        fields.splice(fields.indexOf(v2), 1);
      }
    }
    const validate = (callback) => {
      if (!props2.model) {
        return;
      }
      let promise;
      if (typeof callback !== "function") {
        promise = new Promise((resolve, reject) => {
          callback = function(valid2, invalidFields2) {
            if (valid2) {
              resolve(true);
            } else {
              reject(invalidFields2);
            }
          };
        });
      }
      if (!fields.length) {
        callback == null ? void 0 : callback(true);
      }
      let valid = true;
      let count = 0;
      let invalidFields = {};
      for (const field of fields) {
        field.validate("", (message, field2) => {
          if (message) {
            valid = false;
          }
          invalidFields = {
            ...invalidFields,
            ...field2
          };
          if (++count === fields.length) {
            callback == null ? void 0 : callback(valid, invalidFields);
          }
        });
      }
      return promise;
    };
    const resetFields = () => {
      if (!props2.model) {
        return;
      }
      fields.forEach((field) => {
        field.resetField();
      });
    };
    const clearValidate = (prop = []) => {
      let fieldList = [];
      if (prop && prop.length) {
        if (typeof prop === "string") {
          fieldList = fields.filter((field) => prop === field.prop);
        } else {
          fieldList = fields.filter((field) => prop.indexOf(field.prop) > -1);
        }
      } else {
        fieldList = fields;
      }
      fieldList.forEach((item) => {
        item.clearValidate();
      });
    };
    const fieldsetStyle = computed(() => {
      let style = {};
      if (props2.fieldset) {
        if (typeof props2.border === "string") {
          if (props2.border !== "") {
            style["border"] = props2.border;
          }
        } else {
          style["border"] = `${props2.border}px`;
        }
      } else {
        style["border"] = 0;
      }
      return style;
    });
    const legendStyle = computed(() => {
      let style = {};
      style["text-align"] = props2.legendPosition;
      return style;
    });
    provide("formData", reactive({
      ...toRefs(props2),
      emit,
      addField,
      removeField,
      clearValidate
    }));
    expose({
      clearValidate,
      resetFields,
      validate
    });
    return () => {
      var _a;
      return createVNode("form", {
        "onSubmit": (e) => {
          e.preventDefault();
          return false;
        }
      }, [createVNode("fieldset", {
        "style": fieldsetStyle.value,
        "disabled": props2.disabled,
        "class": props2.inline ? "w-form-inline" : "w-form"
      }, [createVNode("legend", {
        "style": legendStyle.value
      }, [props2.title]), (_a = slots.default) == null ? void 0 : _a.call(slots)])]);
    };
  }
});
var index$j = /* @__PURE__ */ (() => ".w-form{padding:10px;overflow:hidden}.w-form-inline{display:flex;flex-wrap:wrap;align-items:center}\n")();
var _props$1 = {
  required: {
    type: Boolean,
    default: void 0
  },
  label: String,
  prop: String,
  labelWidth: {
    type: [String, Number],
    default: ""
  },
  showMessage: { type: Boolean, default: true },
  rules: { type: Array },
  error: String,
  position: {
    type: String,
    values: ["top", "bottom", "center"],
    default: "center"
  }
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
var formatRegExp = /%[sdj%]/g;
var warning = function warning2() {
};
if (typeof process !== "undefined" && process.env && true && typeof window !== "undefined" && typeof document !== "undefined") {
  warning = function warning3(type4, errors) {
    if (typeof console !== "undefined" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING === "undefined") {
      if (errors.every(function(e) {
        return typeof e === "string";
      })) {
        console.warn(type4, errors);
      }
    }
  };
}
function convertFieldsError(errors) {
  if (!errors || !errors.length)
    return null;
  var fields = {};
  errors.forEach(function(error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}
function format(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var i = 0;
  var len = args.length;
  if (typeof template === "function") {
    return template.apply(null, args);
  }
  if (typeof template === "string") {
    var str = template.replace(formatRegExp, function(x) {
      if (x === "%%") {
        return "%";
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case "%s":
          return String(args[i++]);
        case "%d":
          return Number(args[i++]);
        case "%j":
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return "[Circular]";
          }
          break;
        default:
          return x;
      }
    });
    return str;
  }
  return template;
}
function isNativeStringType(type4) {
  return type4 === "string" || type4 === "url" || type4 === "hex" || type4 === "email" || type4 === "date" || type4 === "pattern";
}
function isEmptyValue(value, type4) {
  if (value === void 0 || value === null) {
    return true;
  }
  if (type4 === "array" && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type4) && typeof value === "string" && !value) {
    return true;
  }
  return false;
}
function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;
  function count(errors) {
    results.push.apply(results, errors || []);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }
  arr.forEach(function(a) {
    func(a, count);
  });
}
function asyncSerialArray(arr, func, callback) {
  var index2 = 0;
  var arrLength = arr.length;
  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index2;
    index2 = index2 + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }
  next([]);
}
function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function(k) {
    ret.push.apply(ret, objArr[k] || []);
  });
  return ret;
}
var AsyncValidationError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(AsyncValidationError2, _Error);
  function AsyncValidationError2(errors, fields) {
    var _this;
    _this = _Error.call(this, "Async Validation Error") || this;
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }
  return AsyncValidationError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function asyncMap(objArr, option, func, callback, source) {
  if (option.first) {
    var _pending = new Promise(function(resolve, reject) {
      var next = function next2(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve(source);
      };
      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next);
    });
    _pending["catch"](function(e) {
      return e;
    });
    return _pending;
  }
  var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function(resolve, reject) {
    var next = function next2(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve(source);
      }
    };
    if (!objArrKeys.length) {
      callback(results);
      resolve(source);
    }
    objArrKeys.forEach(function(key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending["catch"](function(e) {
    return e;
  });
  return pending;
}
function isErrorObj(obj) {
  return !!(obj && obj.message !== void 0);
}
function getValue(value, path) {
  var v2 = value;
  for (var i = 0; i < path.length; i++) {
    if (v2 == void 0) {
      return v2;
    }
    v2 = v2[path[i]];
  }
  return v2;
}
function complementError(rule, source) {
  return function(oe) {
    var fieldValue;
    if (rule.fullFields) {
      fieldValue = getValue(source, rule.fullFields);
    } else {
      fieldValue = source[oe.field || rule.fullField];
    }
    if (isErrorObj(oe)) {
      oe.field = oe.field || rule.fullField;
      oe.fieldValue = fieldValue;
      return oe;
    }
    return {
      message: typeof oe === "function" ? oe() : oe,
      fieldValue,
      field: oe.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if (typeof value === "object" && typeof target[s] === "object") {
          target[s] = _extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}
var required$1 = function required(rule, value, source, errors, options, type4) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type4 || rule.type))) {
    errors.push(format(options.messages.required, rule.fullField));
  }
};
var whitespace = function whitespace2(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === "") {
    errors.push(format(options.messages.whitespace, rule.fullField));
  }
};
var urlReg;
var getUrlRegex = function() {
  if (urlReg) {
    return urlReg;
  }
  var word = "[a-fA-F\\d:]";
  var b = function b2(options) {
    return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : "";
  };
  var v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
  var v6seg = "[a-fA-F\\d]{1,4}";
  var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim();
  var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
  var v4exact = new RegExp("^" + v4 + "$");
  var v6exact = new RegExp("^" + v6 + "$");
  var ip = function ip2(options) {
    return options && options.exact ? v46Exact : new RegExp("(?:" + b(options) + v4 + b(options) + ")|(?:" + b(options) + v6 + b(options) + ")", "g");
  };
  ip.v4 = function(options) {
    return options && options.exact ? v4exact : new RegExp("" + b(options) + v4 + b(options), "g");
  };
  ip.v6 = function(options) {
    return options && options.exact ? v6exact : new RegExp("" + b(options) + v6 + b(options), "g");
  };
  var protocol = "(?:(?:[a-z]+:)?//)";
  var auth = "(?:\\S+(?::\\S*)?@)?";
  var ipv4 = ip.v4().source;
  var ipv6 = ip.v6().source;
  var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
  var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
  var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
  var port = "(?::\\d{2,5})?";
  var path = '(?:[/?#][^\\s"]*)?';
  var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
  urlReg = new RegExp("(?:^" + regex + "$)", "i");
  return urlReg;
};
var pattern$2 = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  "float": function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === "number";
  },
  object: function object(value) {
    return typeof value === "object" && !types.array(value);
  },
  method: function method(value) {
    return typeof value === "function";
  },
  email: function email(value) {
    return typeof value === "string" && value.length <= 320 && !!value.match(pattern$2.email);
  },
  url: function url(value) {
    return typeof value === "string" && value.length <= 2048 && !!value.match(getUrlRegex());
  },
  hex: function hex(value) {
    return typeof value === "string" && !!value.match(pattern$2.hex);
  }
};
var type$1 = function type(rule, value, source, errors, options) {
  if (rule.required && value === void 0) {
    required$1(rule, value, source, errors, options);
    return;
  }
  var custom = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
  } else if (ruleType && typeof value !== rule.type) {
    errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
};
var range = function range2(rule, value, source, errors, options) {
  var len = typeof rule.len === "number";
  var min = typeof rule.min === "number";
  var max = typeof rule.max === "number";
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === "number";
  var str = typeof value === "string";
  var arr = Array.isArray(value);
  if (num) {
    key = "number";
  } else if (str) {
    key = "string";
  } else if (arr) {
    key = "array";
  }
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    val = value.replace(spRegexp, "_").length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
};
var ENUM$1 = "enum";
var enumerable$1 = function enumerable(rule, value, source, errors, options) {
  rule[ENUM$1] = Array.isArray(rule[ENUM$1]) ? rule[ENUM$1] : [];
  if (rule[ENUM$1].indexOf(value) === -1) {
    errors.push(format(options.messages[ENUM$1], rule.fullField, rule[ENUM$1].join(", ")));
  }
};
var pattern$1 = function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === "string") {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
};
var rules = {
  required: required$1,
  whitespace,
  type: type$1,
  range,
  "enum": enumerable$1,
  pattern: pattern$1
};
var string = function string2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "string");
    if (!isEmptyValue(value, "string")) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
      rules.pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        rules.whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
};
var method2 = function method3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var number2 = function number3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === "") {
      value = void 0;
    }
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var _boolean = function _boolean2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var regexp2 = function regexp3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var integer2 = function integer3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var floatFn = function floatFn2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var array2 = function array3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((value === void 0 || value === null) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "array");
    if (value !== void 0 && value !== null) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var object2 = function object3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var ENUM = "enum";
var enumerable2 = function enumerable3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules[ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var pattern2 = function pattern3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "string")) {
      rules.pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var date2 = function date3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "date") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "date")) {
      var dateObject;
      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }
      rules.type(rule, dateObject, source, errors, options);
      if (dateObject) {
        rules.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
};
var required2 = function required3(rule, value, callback, source, options) {
  var errors = [];
  var type4 = Array.isArray(value) ? "array" : typeof value;
  rules.required(rule, value, source, errors, options, type4);
  callback(errors);
};
var type2 = function type3(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, ruleType);
    if (!isEmptyValue(value, ruleType)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var any = function any2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
  }
  callback(errors);
};
var validators = {
  string,
  method: method2,
  number: number2,
  "boolean": _boolean,
  regexp: regexp2,
  integer: integer2,
  "float": floatFn,
  array: array2,
  object: object2,
  "enum": enumerable2,
  pattern: pattern2,
  date: date2,
  url: type2,
  hex: type2,
  email: type2,
  required: required2,
  any
};
function newMessages() {
  return {
    "default": "Validation error on field %s",
    required: "%s is required",
    "enum": "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      "boolean": "%s is not a %s",
      integer: "%s is not an %s",
      "float": "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();
var Schema = /* @__PURE__ */ function() {
  function Schema2(descriptor) {
    this.rules = null;
    this._messages = messages;
    this.define(descriptor);
  }
  var _proto = Schema2.prototype;
  _proto.define = function define(rules2) {
    var _this = this;
    if (!rules2) {
      throw new Error("Cannot configure a schema with no rules");
    }
    if (typeof rules2 !== "object" || Array.isArray(rules2)) {
      throw new Error("Rules must be an object");
    }
    this.rules = {};
    Object.keys(rules2).forEach(function(name) {
      var item = rules2[name];
      _this.rules[name] = Array.isArray(item) ? item : [item];
    });
  };
  _proto.messages = function messages2(_messages) {
    if (_messages) {
      this._messages = deepMerge(newMessages(), _messages);
    }
    return this._messages;
  };
  _proto.validate = function validate(source_, o, oc) {
    var _this2 = this;
    if (o === void 0) {
      o = {};
    }
    if (oc === void 0) {
      oc = function oc2() {
      };
    }
    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === "function") {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback(null, source);
      }
      return Promise.resolve(source);
    }
    function complete(results) {
      var errors = [];
      var fields = {};
      function add2(e) {
        if (Array.isArray(e)) {
          var _errors;
          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }
      for (var i = 0; i < results.length; i++) {
        add2(results[i]);
      }
      if (!errors.length) {
        callback(null, source);
      } else {
        fields = convertFieldsError(errors);
        callback(errors, fields);
      }
    }
    if (options.messages) {
      var messages$1 = this.messages();
      if (messages$1 === messages) {
        messages$1 = newMessages();
      }
      deepMerge(messages$1, options.messages);
      options.messages = messages$1;
    } else {
      options.messages = this.messages();
    }
    var series = {};
    var keys2 = options.keys || Object.keys(this.rules);
    keys2.forEach(function(z) {
      var arr = _this2.rules[z];
      var value = source[z];
      arr.forEach(function(r) {
        var rule = r;
        if (typeof rule.transform === "function") {
          if (source === source_) {
            source = _extends({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === "function") {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }
        rule.validator = _this2.getValidationMethod(rule);
        if (!rule.validator) {
          return;
        }
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this2.getType(rule);
        series[z] = series[z] || [];
        series[z].push({
          rule,
          value,
          source,
          field: z
        });
      });
    });
    var errorFields = {};
    return asyncMap(series, options, function(data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === "object" || rule.type === "array") && (typeof rule.fields === "object" || typeof rule.defaultField === "object");
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;
      function addFullField(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + "." + key,
          fullFields: rule.fullFields ? [].concat(rule.fullFields, [key]) : [key]
        });
      }
      function cb(e) {
        if (e === void 0) {
          e = [];
        }
        var errorList = Array.isArray(e) ? e : [e];
        if (!options.suppressWarning && errorList.length) {
          Schema2.warning("async-validator:", errorList);
        }
        if (errorList.length && rule.message !== void 0) {
          errorList = [].concat(rule.message);
        }
        var filledErrors = errorList.map(complementError(rule, source));
        if (options.first && filledErrors.length) {
          errorFields[rule.field] = 1;
          return doIt(filledErrors);
        }
        if (!deep) {
          doIt(filledErrors);
        } else {
          if (rule.required && !data.value) {
            if (rule.message !== void 0) {
              filledErrors = [].concat(rule.message).map(complementError(rule, source));
            } else if (options.error) {
              filledErrors = [options.error(rule, format(options.messages.required, rule.field))];
            }
            return doIt(filledErrors);
          }
          var fieldsSchema = {};
          if (rule.defaultField) {
            Object.keys(data.value).map(function(key) {
              fieldsSchema[key] = rule.defaultField;
            });
          }
          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          var paredFieldsSchema = {};
          Object.keys(fieldsSchema).forEach(function(field) {
            var fieldSchema = fieldsSchema[field];
            var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [fieldSchema];
            paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
          });
          var schema = new Schema2(paredFieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function(errs) {
            var finalErrors = [];
            if (filledErrors && filledErrors.length) {
              finalErrors.push.apply(finalErrors, filledErrors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }
      var res;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        try {
          res = rule.validator(rule, data.value, cb, data.source, options);
        } catch (error) {
          console.error == null ? void 0 : console.error(error);
          if (!options.suppressValidatorError) {
            setTimeout(function() {
              throw error;
            }, 0);
          }
          cb(error.message);
        }
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function() {
          return cb();
        }, function(e) {
          return cb(e);
        });
      }
    }, function(results) {
      complete(results);
    }, source);
  };
  _proto.getType = function getType(rule) {
    if (rule.type === void 0 && rule.pattern instanceof RegExp) {
      rule.type = "pattern";
    }
    if (typeof rule.validator !== "function" && rule.type && !validators.hasOwnProperty(rule.type)) {
      throw new Error(format("Unknown rule type %s", rule.type));
    }
    return rule.type || "string";
  };
  _proto.getValidationMethod = function getValidationMethod(rule) {
    if (typeof rule.validator === "function") {
      return rule.validator;
    }
    var keys2 = Object.keys(rule);
    var messageIndex = keys2.indexOf("message");
    if (messageIndex !== -1) {
      keys2.splice(messageIndex, 1);
    }
    if (keys2.length === 1 && keys2[0] === "required") {
      return validators.required;
    }
    return validators[this.getType(rule)] || void 0;
  };
  return Schema2;
}();
Schema.register = function register(type4, validator) {
  if (typeof validator !== "function") {
    throw new Error("Cannot register a validator by type, validator is not a function");
  }
  validators[type4] = validator;
};
Schema.warning = warning;
Schema.messages = messages;
Schema.validators = validators;
var FormItem = defineComponent({
  name: "FormItem",
  props: {
    ..._props$1
  },
  emit: ["validate"],
  setup(props2, ctx) {
    const formData = inject("formData");
    const message = ref("");
    const validateState = ref("");
    const labelStyle = computed(() => {
      var _a, _b;
      const ret = {};
      if (formData.labelPosition === "top")
        return ret;
      const labelWidth = isWidth(props2.labelWidth || formData.labelWidth);
      if (((_b = (_a = ctx.slots).label) == null ? void 0 : _b.call(_a)) || props2.label) {
        if (labelWidth) {
          ret.width = labelWidth;
        }
      } else {
        ret.width = "0px";
      }
      if (props2.position === "top") {
        ret.alignItems = "flex-start";
      } else if (props2.position === "bottom") {
        ret.alignItems = "flex-end";
      } else {
        ret.alignItems = "center";
      }
      return ret;
    });
    function isWidth(value) {
      if (typeof value === "string") {
        return value;
      } else if (typeof value === "number") {
        return `${value}px`;
      }
      return "";
    }
    computed(() => {
      if (formData.rules && props2.prop) {
        let rule = formData.rules[props2.prop];
        if (rule) {
          return rule[0].trigger;
        }
      }
    });
    function getRules() {
      let formRules = [];
      let selfRules = props2.rules || [];
      let requiredRule = props2.required !== void 0 ? {
        required: props2.required
      } : [];
      if (props2.prop && formData.rules) {
        formRules = formData.rules[props2.prop];
      }
      let totalRules = [];
      return totalRules.concat(formRules, selfRules).concat(requiredRule);
    }
    const resetField = () => {
      validateState.value = "";
      message.value = "";
      formData.model;
      fieldValue.value;
    };
    function getFilteredRule(trigger) {
      const rules2 = getRules();
      return rules2.filter((rule) => {
        if (!rule.trigger || trigger === "")
          return true;
        if (Array.isArray(rule.trigger)) {
          return rule.trigger.indexOf(trigger) > -1;
        } else {
          return rule.trigger === trigger;
        }
      }).map((rule) => ({
        ...rule
      }));
    }
    const fieldValue = computed(() => {
      const model = formData.model;
      if (!model || !props2.prop) {
        return;
      }
      let name = props2.prop;
      return model[name];
    });
    const validate = (trigger, callback) => {
      try {
        if (props2.prop) {
          const rules2 = getFilteredRule(trigger);
          if ((!rules2 || !rules2.length) && props2.required === void 0) {
            return;
          }
          const descriptor = {};
          if (rules2 && rules2.length > 0) {
            rules2.forEach((rule) => {
              delete rule.trigger;
            });
          }
          descriptor[props2.prop] = rules2;
          const validator = new Schema(descriptor);
          const model = {};
          model[props2.prop] = fieldValue.value;
          validator.validate(model, {
            firstFields: true
          }, (errors, invalidFields) => {
            var _a;
            validateState.value = !errors ? "success" : "error";
            if (errors) {
              message.value = props2.error ? props2.error : errors[0].message ? errors[0].message : `${props2.prop} is required`;
            } else {
              message.value = "";
            }
            if (callback) {
              callback == null ? void 0 : callback(message.value, invalidFields);
            }
            (_a = formData.emit) == null ? void 0 : _a.call(formData, "validate", props2.prop, !errors, message.value || null);
          });
        }
      } catch (error) {
        console.error(error);
      }
    };
    const clearValidate = () => {
      validateState.value = "";
      message.value = "";
    };
    const titlePosition = computed(() => {
      if (formData.titlePosition === "right") {
        return {
          style: "",
          labelStyle: "w-form-item-label-default"
        };
      } else if (formData.titlePosition === "left") {
        return {
          style: "",
          labelStyle: "w-form-item-label-left"
        };
      } else if (formData.titlePosition === "top") {
        return {
          style: {
            display: "block",
            marginBottom: "20px"
          },
          labelStyle: "w-form-item-label-top"
        };
      }
    });
    const required4 = computed(() => {
      if (props2.required) {
        return true;
      } else {
        if (props2.prop && formData.rules) {
          let rule = formData.rules[props2.prop];
          if (rule && rule[0].required) {
            return true;
          } else {
            return false;
          }
        } else if (props2.rules) {
          let isRequired = props2.rules.filter((item) => item.required);
          return isRequired.length > 0 ? true : false;
        } else {
          return false;
        }
      }
    });
    const formItem = reactive({
      ...toRefs(props2),
      validateState,
      validate,
      clearValidate,
      resetField
    });
    ctx.expose({
      validate,
      clearValidate,
      resetField
    });
    provide("formItem", formItem);
    onMounted(() => {
      if (props2.prop) {
        formData == null ? void 0 : formData.addField(formItem);
      }
    });
    onUpdated(() => {
    });
    onUnmounted(() => {
      formData == null ? void 0 : formData.removeField(formItem);
    });
    return () => {
      var _a, _b, _c, _d, _e, _f;
      return createVNode("div", {
        "class": "w-form-item",
        "style": (_a = titlePosition.value) == null ? void 0 : _a.style
      }, [createVNode("div", {
        "style": labelStyle.value,
        "class": ["w-form-item-label", (_b = titlePosition.value) == null ? void 0 : _b.labelStyle, required4.value ? "w-form-item-label-required" : ""]
      }, [createVNode("label", null, [((_d = (_c = ctx.slots).label) == null ? void 0 : _d.call(_c)) || props2.label])]), createVNode("div", {
        "class": "w-form-item-content"
      }, [createVNode("div", {
        "class": ["w-form-item-wrapper", validateState.value === "error" && formData.errorBorder ? "w-form-item-wrapper\u2014error" : ""]
      }, [(_f = (_e = ctx.slots).default) == null ? void 0 : _f.call(_e)]), createVNode(Transition, null, {
        default: () => {
          var _a2, _b2;
          return [((_b2 = (_a2 = ctx.slots).message) == null ? void 0 : _b2.call(_a2, message.value)) || props2.showMessage && message.value ? createVNode("div", {
            "class": ["w-form-item-error", formData.errorPosition === "right" ? "w-form-item-error-right" : "w-form-item-error-bottom"]
          }, [message.value]) : ""];
        }
      })])]);
    };
  }
});
var index$i = /* @__PURE__ */ (() => '.w-form-item{display:flex;margin-bottom:18px}.w-form-item .w-form-item-label{width:80px;display:flex;justify-content:flex-end;align-items:center}.w-form-item .w-form-item-label-required:before{content:"*";color:var(--w-color-danger);margin-right:4px}.w-form-item .w-form-item-label-default{justify-content:flex-end}.w-form-item .w-form-item-label-left{justify-content:flex-start}.w-form-item .w-form-item-label-top{display:block;margin-bottom:5px}.w-form-item .w-form-item-content{position:relative;padding:1px 11px}.w-form-item .w-form-item-content .w-form-item-wrapper{display:inline-flex;flex-grow:1;align-items:center;justify-content:center;background-image:none;border-radius:var(--w-radius);transition:var(--w-transition-time)}.w-form-item .w-form-item-content .w-form-item-wrapper\\2014 error{border:1px solid var(--w-color-danger)}.w-form-item .w-form-item-content .is-error{border-color:red}.w-form-item .w-form-item-content .w-form-item-error{position:absolute;min-width:200px;padding-top:2px;height:14px;line-height:14px;color:var(--w-color-danger)}.w-form-item .w-form-item-content .w-form-item-error-bottom{top:100%;left:11px}.w-form-item .w-form-item-content .w-form-item-error-right{left:100%;top:50%;transform:translateY(-50%)}.w-form-item--default{margin-bottom:18px;font-size:var(--w-font-size)}\n')();
var Match = defineComponent({
  name: "Match",
  inheritAttrs: false,
  components: {
    Write,
    Layer,
    Icon: Icon$1,
    Close,
    List
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    placement: {
      ...LayerProps.placement,
      default: "bottom-start"
    },
    adjustPosition: LayerProps.adjustPosition,
    gap: {
      ...LayerProps.gap,
      default: 2
    },
    show: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: [String, Number],
      default: void 0
    },
    text: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "\u8BF7\u8F93\u5165\u5173\u952E\u5B57"
    },
    readonly: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    block: {
      type: Boolean
    },
    keyField: {
      type: String,
      default: "Id"
    },
    textField: {
      type: String,
      default: "Name"
    },
    checkable: Function,
    lazyLoad: Function,
    request: Function
  },
  emits: ["update:show", "update:modelValue", "update:text", "change", "search"],
  setup(props2, ctx) {
    const formItem = inject("formItem", void 0);
    const transitionName = "w-slide-y";
    const searchText2 = ref("");
    const dontSearch = ref(false);
    const {
      data: reqData,
      loading: loading2,
      empty: empty2,
      get: getData
    } = useRequest(props2.request, searchText2, true);
    const filterData = useSearch(computed(() => {
      if (props2.request) {
        return reqData.value;
      } else {
        return JSON.parse(JSON.stringify(props2.data));
      }
    }), searchText2, dontSearch, props2.textField, afterSearch);
    const {
      loading: isLoading,
      empty: lazyEmpty,
      get: lazyGet
    } = useRequest(props2.lazyLoad, ref(""), true);
    const isEmpty = computed(() => {
      return filterData.value.length === 0 || lazyEmpty.value;
    });
    const triggerRect = ref();
    const visible = ref(props2.show);
    const layerContentStyle = computed(() => {
      if (triggerRect.value) {
        return {
          minWidth: triggerRect.value.width + "px"
        };
      }
      return {};
    });
    const layerOptions = computed(() => {
      return {
        manual: true,
        hasArrow: false,
        transitionName,
        show: visible.value,
        gap: props2.gap,
        adjustPosition: props2.adjustPosition,
        layerClass: ["w-match-layer"],
        layerStyle: layerContentStyle.value,
        "onUpdate:show": (v2) => {
          visible.value = v2;
        },
        placement: props2.placement,
        "onGet-trigger-rect": (rect) => {
          triggerRect.value = rect;
        }
      };
    });
    watch(() => props2.show, (v2) => {
      visible.value = v2;
    });
    watch(visible, (v2) => {
      ctx.emit("update:show", v2);
    });
    watch([() => props2.data, () => props2.modelValue], ([d, v2]) => {
      if (d && d.length && isValidValue(v2)) {
        const item = d.filter((_d) => {
          return getItemValue(_d, props2.keyField) === v2;
        })[0];
        if (item) {
          const _text = getItemValue(item, props2.textField);
          if (searchText2.value === "" || searchText2.value !== _text) {
            dontSearch.value = true;
            searchText2.value = _text;
          }
        }
      } else {
        if (!props2.request) {
          ctx.emit("update:modelValue", void 0);
        }
        dontSearch.value = false;
      }
      if (!v2) {
        searchText2.value = "";
        ctx.emit("update:modelValue", void 0);
      }
    }, {
      immediate: true
    });
    const stopWatchText = watch(() => props2.text, (t) => {
      if (props2.lazyLoad) {
        if (!props2.data || isArray(props2.data) && props2.data.length === 0) {
          searchText2.value = t;
        } else {
          stopWatchText();
        }
      }
    }, {
      immediate: true
    });
    function _clear() {
      ctx.emit("update:modelValue", void 0);
      ctx.emit("update:text", "");
      ctx.emit("change", {
        item: void 0,
        index: void 0
      });
      formItem == null ? void 0 : formItem.validate("change");
    }
    function afterSearch(resultLength, isFullData, isEqual, index2) {
      if (!isFullData) {
        if (resultLength > 0) {
          if (isEqual) {
            const item = filterData.value[0];
            toEmit(item, index2);
          } else {
            _clear();
          }
        }
      }
      visible.value = true;
    }
    function toEmit(item, index2) {
      const _key = getItemValue(item, props2.keyField);
      const _text = getItemValue(item, props2.textField);
      searchText2.value = _text;
      ctx.emit("update:text", _text);
      ctx.emit("update:modelValue", _key);
      ctx.emit("change", {
        item,
        index: index2
      });
      formItem == null ? void 0 : formItem.validate("change");
    }
    function toLoad() {
      var _a;
      if (props2.lazyLoad && ((_a = props2.data) == null ? void 0 : _a.length) === 0) {
        lazyGet();
      }
    }
    function renderTrigger() {
      const writeOptions = {
        class: ["w-match", {
          "w-match-block": props2.block
        }],
        clearable: true,
        block: props2.block,
        placeholder: props2.placeholder,
        modelValue: searchText2.value,
        "onUpdate:modelValue": (v2, input) => {
        },
        onSearch: (val) => {
          searchText2.value = val;
          dontSearch.value = false;
          if (props2.request) {
            if (val !== "") {
              visible.value = true;
              getData();
            } else {
              visible.value = false;
            }
          } else {
            toLoad();
          }
          ctx.emit("search", {
            val,
            clear: () => {
              searchText2.value = "";
              _clear();
            }
          });
        },
        onClear: () => {
          dontSearch.value = false;
          if (props2.request) {
            visible.value = false;
          }
          searchText2.value = "";
          _clear();
        }
      };
      const writeSlots = {
        default: ({
          focus
        }) => {
          if (!props2.request) {
            const arrowOptions = {
              class: ["w-cursor-pointer", "w-match-icon"],
              name: "w-icon-arrow-down",
              rotate: visible.value,
              onClick: (e) => {
                toLoad();
                visible.value = !visible.value;
                if (visible.value) {
                  focus();
                }
                e.stopPropagation();
              }
            };
            return createVNode(Icon$1, arrowOptions, null);
          }
        }
      };
      return createVNode(Write, writeOptions, writeSlots);
    }
    useEvent(document, "click", () => {
      visible.value = false;
    });
    return () => {
      const layerSlots = {
        trigger: renderTrigger,
        default: () => {
          const listOptions = {
            data: filterData.value,
            keyField: props2.keyField,
            textField: props2.textField,
            loading: props2.request ? loading2.value : isLoading.value,
            empty: isEmpty.value,
            checkable: props2.checkable,
            activable: (item, index2) => {
              return getItemValue(item, props2.keyField) === props2.modelValue;
            },
            onToggle: (item, index2) => {
              const key = getItemValue(item, props2.keyField);
              if (key !== props2.modelValue) {
                dontSearch.value = true;
                toEmit(item, index2);
              }
              visible.value = false;
            }
          };
          return createVNode(List, listOptions, {
            default: ctx.slots.default
          });
        }
      };
      return createVNode(Layer, layerOptions.value, layerSlots);
    };
  }
});
var index$h = /* @__PURE__ */ (() => ".w-match{display:inline-flex;-webkit-user-select:none;-moz-user-select:none;user-select:none}.w-match .w-match-block{display:flex}.w-match .w-close{transform:translate(3px)}.w-match .w-match-icon{margin-right:8px}.w-match-layer{background-color:var(--w-choose-background);max-height:360px;overflow:hidden auto;white-space:nowrap;text-overflow:ellipsis}.w-match-layer .w-choose-fallback{min-height:70px;overflow:hidden}.w-match-item{height:var(--w-size);line-height:var(--w-size);padding:0 var(--w-padding-x);color:var(--w-color-font-2);cursor:pointer;display:block;transition:var(--w-transition-time)}.w-match-item.w-match-item-disabled{color:var(--w-color-disabled);cursor:not-allowed}.w-match-item:hover:not(.w-match-item-disabled){color:var(--w-color-primary)}.w-match-item.w-match-item-active{color:var(--w-color-primary);background-color:var(--w-color-primary-light-5)}\n")();
var MainNotice = defineComponent({
  inheritAttrs: false,
  name: "Notice",
  components: {
    Icon: Icon$1,
    Close
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: "top-end"
    },
    duration: {
      type: Number,
      default: 4500
    },
    manual: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:show", "after-enter", "after-leave", "close", "get-uid"],
  setup(props2, {
    emit,
    slots,
    attrs,
    expose
  }) {
    const ins = getCurrentInstance();
    const noticeHeight = ref(0);
    const visible = ref(props2.show);
    emit("close", close2);
    emit("get-uid", ins == null ? void 0 : ins.uid);
    watch(() => props2.show, (s) => {
      visible.value = s;
    });
    watch(visible, (v2) => {
      emit("update:show", v2);
      if (v2) {
        if (!props2.manual) {
          setTimeout(() => {
            visible.value = false;
          }, props2.duration);
        }
      }
    });
    onMounted(() => {
      visible.value = true;
    });
    function close2() {
      visible.value = false;
    }
    expose({
      close: close2
    });
    return () => {
      const wrapper = {
        style: {
          "--__notice-item-height": noticeHeight.value ? noticeHeight.value + "px" : ""
        },
        class: ["w-notice-item", `w-notice-item--${props2.placement}`]
      };
      return createVNode(Transition, {
        "name": "w-notice-transition",
        "onAfter-enter": (el) => {
          noticeHeight.value = getBoundingClientRect(el).height;
          emit("after-enter", el);
        },
        "onAfter-leave": (el) => {
          emit("after-leave", el, ins == null ? void 0 : ins.uid);
        }
      }, {
        default: () => {
          var _a;
          return [visible.value && createVNode("div", wrapper, [(_a = slots.default) == null ? void 0 : _a.call(slots), createVNode(Close, {
            "size": "14",
            "name": "w-icon-close",
            "class": "w-notice-close",
            "onClick": close2
          }, null)])];
        }
      });
    };
  }
});
let WRAPPERS = {};
function createNoticeWrapper(placement) {
  const { zIndex: zIndex2, add: add2 } = useGlobalZIndex();
  if (placement in WRAPPERS) {
    const el2 = WRAPPERS[placement];
    el2.style.zIndex = add2() + "";
    return el2;
  }
  const el = document.createElement("div");
  const id = `notice_container_${new Date() - 0}`;
  const klass = "w-notice w-notice--" + placement;
  el.id = id;
  el.className = klass;
  el.style.zIndex = zIndex2.value + "";
  WRAPPERS[placement] = el;
  document.body.appendChild(el);
  return el;
}
function clearNoticeWrapper() {
  for (const p in WRAPPERS) {
    if (WRAPPERS[p]) {
      document.body.removeChild(WRAPPERS[p]);
      delete WRAPPERS[p];
    }
  }
}
var index$g = /* @__PURE__ */ (() => ".w-notice{position:fixed;display:flex;align-items:flex-end}.w-notice.w-notice--top{flex-direction:column;top:0;left:50%;transform:translate(-50%)}.w-notice.w-notice--bottom{flex-direction:column-reverse;bottom:0;left:50%;transform:translate(-50%)}.w-notice.w-notice--top-end{flex-direction:column;top:0;right:var(--w-gap)}.w-notice.w-notice--bottom-end{flex-direction:column-reverse;bottom:0;right:var(--w-gap)}.w-notice-item{position:relative;box-shadow:var(--w-notice-box-shadow);border-radius:var(--w-radius);background-color:#fff;height:auto;height:var(--__notice-item-height, auto)}@supports ((-webkit-backdrop-filter: blur(15px)) or (backdrop-filter: blur(15px))){.w-notice-item{background-color:#fff9;-webkit-backdrop-filter:blur(15px);backdrop-filter:blur(15px)}}.w-notice-item.w-notice-item--top,.w-notice-item.w-notice-item--top-end{margin-top:var(--w-gap)}.w-notice-item.w-notice-item--bottom,.w-notice-item.w-notice-item--bottom-end{margin-bottom:var(--w-gap)}.w-notice-item.w-notice-transition-enter-active{transition:transform var(--w-transition-slow-time) var(--w-notice-cubic-bezier),opacity var(--w-transition-slow-time) var(--w-notice-cubic-bezier)}.w-notice-item.w-notice-transition-leave-active{transition:height var(--w-transition-time) var(--w-cubic-bezier),margin-top var(--w-transition-time) var(--w-cubic-bezier),margin-bottom var(--w-transition-time) var(--w-cubic-bezier),opacity var(--w-transition-time) var(--w-cubic-bezier)}.w-notice-item.w-notice-transition-enter-from{transform:translate(100%);opacity:0}.w-notice-item.w-notice-transition-leave-to{height:0;opacity:0;margin-top:0;margin-bottom:0;overflow:hidden}.w-notice-item .w-notice-close{top:2px;right:6px;position:absolute}.w-notice.w-notice--top .w-notice-item.w-notice-transition-enter-from{transform:translateY(-100%)}.w-notice.w-notice--bottom .w-notice-item.w-notice-transition-enter-from{transform:translateY(100%)}\n")();
const NoticeAppMap = /* @__PURE__ */ new Map();
const defaultOptions = {
  content: "\u9ED8\u8BA4\u7684\u901A\u77E5",
  placement: "top-end",
  duration: 4500,
  manual: false
};
function open(options) {
  var _a, _b, _c;
  const placement = options.placement || defaultOptions.placement;
  const manual = (_a = options.manual) != null ? _a : defaultOptions.manual;
  const duration = (_b = options.duration) != null ? _b : defaultOptions.duration;
  const content = (_c = options.content) != null ? _c : defaultOptions.content;
  const afterClose = options.afterClose;
  const itemWrapper = document.createElement("div");
  const noticeWrapper = createNoticeWrapper(placement);
  let _close = () => {
  };
  const vm = createVNode(MainNotice, {
    placement,
    manual,
    duration,
    "onAfter-enter": (el) => {
    },
    "onAfter-leave": (el, uid) => {
      _destroy(noticeWrapper, itemWrapper, notice);
      if (NoticeAppMap.size === 0) {
        clearNoticeWrapper();
      }
    },
    onClose: (close2) => {
      _close = close2;
    },
    "onGet-uid": (uid) => {
      NoticeAppMap.set(uid, { noticeWrapper, close: _close, afterClose });
    }
  }, {
    default: () => {
      if (typeof content === "function") {
        return _renderContent(_close, content);
      } else {
        return content;
      }
    }
  });
  const notice = createApp(vm);
  notice.mount(itemWrapper);
  noticeWrapper.appendChild(itemWrapper);
  return notice;
}
function close(app) {
  var _a;
  const uid = (_a = app._instance) == null ? void 0 : _a.uid;
  if (uid !== void 0) {
    if (NoticeAppMap.has(uid)) {
      const n = NoticeAppMap.get(uid);
      if (n) {
        n.close();
        if (n.afterClose) {
          n.afterClose();
        }
        NoticeAppMap.delete(uid);
      }
    }
  }
}
function _destroy(noticeWrapper, wrapper, app_notice) {
  app_notice.unmount();
  noticeWrapper.removeChild(wrapper);
}
function _renderContent(close2, content) {
  return content(close2);
}
function install$1(app) {
  app.config.globalProperties.$notice = open;
}
var index$f = { install: install$1, open, close };
function useCount({ init, step } = { init: 0, step: 1 }) {
  const count = ref(unref(init));
  const _step = ref(step || 1);
  function add2(delta) {
    if (typeof delta === "number") {
      count.value += delta != null ? delta : _step.value;
    } else {
      count.value += _step.value;
    }
    count.value = resolveAccuracy(count.value);
    return count.value;
  }
  function reset(num) {
    count.value = num != null ? num : 0;
  }
  function set(num) {
    count.value = num;
  }
  function get() {
    return count.value;
  }
  return {
    count,
    add: add2,
    reset,
    get,
    set
  };
}
var Num = defineComponent({
  name: "Number",
  inheritAttrs: false,
  components: {
    Write,
    Tooltip: Layer,
    Icon: Icon$1
  },
  emits: {
    "update:modelValue": null,
    change: (e) => true
  },
  props: {
    modelValue: {
      type: [Number, String]
    },
    block: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    maxlength: [String, Number],
    width: String,
    max: Number,
    min: Number,
    step: {
      type: Number,
      default: 1
    },
    hasBtn: {
      type: Boolean,
      default: true
    },
    validateEvent: {
      type: Boolean,
      default: true
    }
  },
  setup(props2, ctx) {
    inject("formItem", void 0);
    const {
      add: add2,
      count,
      set
    } = useCount({
      init: computed(() => {
        var _a;
        return (_a = Number(props2.modelValue)) != null ? _a : 0;
      })
    });
    const isZH = ref(false);
    const numberOptions = computed(() => {
      return {
        inputClass: "w-number",
        block: props2.block,
        readonly: props2.readonly,
        disabled: props2.disabled,
        modelValue: props2.modelValue,
        width: props2.width,
        "onUpdate:modelValue": (v2, elem) => {
          let _v = v2;
          if (_v === "-") {
            return;
          } else if (_v === void 0 || _v === "") {
            emitValue(void 0, elem);
            return;
          } else {
            _v = isOutofRange(Number(_v));
            elem.value = _v + "";
          }
          emitValue(_v, elem);
        },
        onCompositionstart: (e) => {
          isZH.value = true;
        },
        onCompositionend: (e) => {
          const elem = e.target;
          setTimeout(() => {
            toValidate(elem);
            isZH.value = false;
          });
        },
        onKeypress: (e) => {
          const val = e.target.value;
          if (!validOnKeypress(val, e.keyCode)) {
            e.preventDefault();
          }
        },
        onPaste: (e) => {
          const elem = e.target;
          setTimeout(() => {
            toValidate(elem);
          });
        },
        ...filterListeners(ctx.attrs)
      };
    });
    function emitValue(v2, inputElement) {
      ctx.emit("update:modelValue", v2, inputElement);
    }
    function toValidate(elem) {
      let v2 = elem.value;
      if (v2 !== void 0) {
        v2 += "";
        const validValue = v2.match(/(-?\d+\.?)(\d+)?/g);
        if (v2 !== "-") {
          if (validValue !== null) {
            v2 = validValue[0];
          } else {
            v2 = "";
          }
        }
      }
      if (v2 === "") {
        emitValue(void 0, elem);
        elem.value = "";
      } else {
        const _v = isOutofRange(Number(v2));
        emitValue(_v, elem);
        elem.value = _v + "";
      }
      return elem.value;
    }
    function toAdd(elem) {
      add2(props2.step);
      emitValue(isOutofRange(count.value), elem);
    }
    function toMinus(elem) {
      add2(props2.step * -1);
      emitValue(isOutofRange(count.value), elem);
    }
    function isOutofRange(v2) {
      if (props2.max !== void 0 && v2 > props2.max) {
        set(props2.max);
        return props2.max;
      }
      if (props2.min !== void 0 && v2 < props2.min) {
        set(props2.min);
        return props2.min;
      }
      return v2;
    }
    watch(() => props2.modelValue, (v2) => {
      if (v2 === void 0 || v2 === "") {
        set(0);
      } else {
        set(Number(v2));
      }
    }, {
      immediate: true
    });
    return () => {
      if (props2.hasBtn) {
        const writeSlots = {
          default: ({
            inputElement
          }) => {
            const disabledClass = {
              "w-number-btn-disabled": props2.disabled
            };
            const addBtnOptions = {
              class: ["w-number-btn w-number-btn-rotate", disabledClass],
              name: "w-icon-sort-down"
            };
            const minusBtnOptions = {
              class: ["w-number-btn", disabledClass],
              name: "w-icon-sort-down"
            };
            if (!props2.disabled) {
              addBtnOptions.onClick = () => {
                toAdd(inputElement);
              };
              minusBtnOptions.onClick = () => {
                toMinus(inputElement);
              };
            }
            return createVNode("div", {
              "class": "w-number-btn-wrapper"
            }, [createVNode(Icon$1, addBtnOptions, null), createVNode(Icon$1, minusBtnOptions, null)]);
          }
        };
        return createVNode(Write, numberOptions.value, writeSlots);
      }
      return createVNode(Write, numberOptions.value, null);
    };
  }
});
function validOnKeypress(val, keyCode) {
  let b = false;
  if (val === "") {
    if (isNumberCode(keyCode) || isMinusCode(keyCode)) {
      b = true;
    }
  } else if (val.length === 1) {
    if (val === "-") {
      if (isNumberCode(keyCode)) {
        b = true;
      }
    } else if (isNumberVal(val)) {
      if (isNumberCode(keyCode) || isDotCode(keyCode)) {
        b = true;
      }
    }
  } else {
    if (hasDot(val)) {
      if (isNumberCode(keyCode)) {
        b = true;
      }
    } else {
      if (isNumberCode(keyCode) || isDotCode(keyCode)) {
        b = true;
      }
    }
  }
  return b;
}
function isNumberCode(keyCode) {
  return keyCode < 58 && keyCode > 47;
}
function isMinusCode(keyCode) {
  return keyCode === 45;
}
function isDotCode(keyCode) {
  return keyCode === 46;
}
function isNumberVal(val) {
  return /\d/.test(val);
}
function hasDot(val) {
  return val.indexOf(".") > -1;
}
var index$e = /* @__PURE__ */ (() => ".w-number{padding-right:0!important;overflow:hidden}.w-number-btn-wrapper{display:flex;flex-direction:column;align-self:stretch;border-left:1px solid var(--w-form-item-border-color)}.w-number-btn-wrapper .w-number-btn{flex:1;height:0;color:var(--w-color-font-3);cursor:pointer;background-color:var(--w-color-bg);transition:var(--w-transition-time)}.w-number-btn-wrapper .w-number-btn:first-child{box-shadow:0 -1px var(--w-color-font-4)}.w-number-btn-wrapper .w-number-btn.w-number-btn-disabled{cursor:not-allowed;color:var(--w-color-font-4)}.w-number-btn-wrapper .w-number-btn:hover:not(.w-number-btn-disabled){color:var(--w-color-primary);background-color:var(--w-color-primary-light-8)}.w-number-btn-wrapper .w-number-btn.w-number-btn-rotate{transform:rotateX(180deg)}\n")();
var Pagination = defineComponent({
  name: "Pagination",
  components: {
    Choose,
    Btn,
    Tooltip,
    Num,
    ChooseItem
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    pageIndex: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    },
    sizes: {
      type: Array,
      default: () => [20, 50, 80, 100, 200]
    },
    align: {
      type: String,
      default: "right"
    },
    bordered: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: "total,prev,pager,next,sizes,jumper"
    },
    hideWhenNoData: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:pageIndex", "update:pageSize", "changePageIndex", "changePageSize"],
  setup(props2, {
    emit,
    attrs,
    slots
  }) {
    const dot = ref("...");
    const outsize = ref(10);
    const max = ref(5);
    const max2 = ref(7);
    const pi = ref(props2.pageIndex);
    const ps = ref(props2.pageSize);
    const p_number = ref();
    const lout = computed(() => props2.layout.toLocaleLowerCase().split(","));
    const totalPages = computed(() => Math.ceil(props2.total / ps.value));
    const pagers = computed(() => {
      const t = totalPages.value, oz = outsize.value, v_max = max.value, v_max2 = max2.value, p = pi.value, v_dot = dot.value;
      if (t > oz) {
        let arr = [];
        if (t - p >= v_max && p > v_max) {
          for (let i = p - 2; i <= p + 2; i++) {
            arr.push(i);
          }
          arr.push(v_dot, t);
          arr.unshift(1, v_dot);
        } else {
          if (p <= v_max) {
            for (let i = 1; i <= v_max2; i++) {
              arr.push(i);
            }
            arr.push(v_dot, t);
          } else if (t - p < v_max) {
            for (let i = t; i > t - v_max2; i--) {
              arr.unshift(i);
            }
            arr.unshift(1, v_dot);
          }
        }
        return arr;
      } else {
        return Array.apply(null, {
          length: t
        }).map((el, i) => i + 1);
      }
    });
    const chooseProps = computed(() => {
      const o = {
        modelValue: ps.value,
        clearable: false,
        mode: props2.bordered ? "default" : "text",
        "onUpdate:modelValue": (size) => {
          ps.value = size;
          pi.value = 1;
          emit("update:pageSize", size);
          emit("changePageSize", size);
          changePage();
        }
      };
      return o;
    });
    const numProps = computed(() => ({
      min: 1,
      modelValue: p_number.value,
      "onUpdate:modelValue": (p) => {
        if (p !== void 0) {
          p_number.value = Number(p);
        }
      },
      onKeyup: (e) => {
        if (e.key.toLowerCase() === "enter") {
          toJump();
        }
      },
      width: "60px"
    }));
    watch(() => [props2.pageIndex, props2.pageSize], ([i, s]) => {
      pi.value = i;
      ps.value = s;
    });
    watch(pi, (v2) => {
      emit("update:pageIndex", v2);
    });
    watch(ps, (v2) => {
      emit("update:pageSize", v2);
    });
    function toJump() {
      const p = Number(p_number.value);
      if (isNaN(p)) {
        return;
      }
      if (p < 1 || p > totalPages.value) {
        return;
      }
      if (p !== pi.value) {
        pi.value = p;
        changePage();
      }
    }
    function toNext() {
      if (pi.value < totalPages.value) {
        pi.value += 1;
        changePage();
      }
    }
    function toPrev() {
      if (pi.value > 1) {
        pi.value -= 1;
        changePage();
      }
    }
    function changePage() {
      emit("changePageIndex", pi.value);
    }
    function showItem(item) {
      return lout.value.indexOf(item) > -1;
    }
    function setOrder(item) {
      return lout.value.indexOf(item);
    }
    return () => {
      const chooseSlots = {
        default: () => {
          return props2.sizes.map((s) => {
            const label = `${s}\u6761/\u9875`;
            const itemSlots = {
              default: () => {
                return label;
              }
            };
            const itemProps = {
              key: label,
              label,
              value: s
            };
            return createVNode(ChooseItem, itemProps, itemSlots);
          });
        }
      };
      let goProps = {
        onClick: toJump,
        mode: props2.bordered ? "line" : "text"
      };
      let goSlots = {
        default: () => "Go"
      };
      let btn = createVNode(Btn, goProps, goSlots);
      const all_pages = pagers.value.map((p, i) => {
        const isDisabled = p === dot.value;
        const ps2 = {
          class: {
            "w-pagination--disabled": isDisabled,
            "w-pagination--active": p === pi.value
          },
          onClick: () => {
            if (!isDisabled && pi.value !== p) {
              pi.value = p;
              nextTick(changePage);
            }
          }
        };
        return createVNode("span", ps2, [p]);
      });
      if (props2.total == 0 && props2.hideWhenNoData) {
        return null;
      }
      return createVNode("ol", {
        "class": ["w-pagination", `w-pagination__${props2.align}`, {
          "w-pagination--bordered": props2.bordered
        }]
      }, [showItem("total") && createVNode("li", {
        "class": "w-pagination-total",
        "style": {
          order: setOrder("total")
        }
      }, [createTextVNode("\u5171 "), props2.total, createTextVNode(" \u6761")]), createVNode("li", {
        "class": "w-pagination-pager",
        "style": {
          order: setOrder("pager")
        }
      }, [showItem("prev") && createVNode(Tooltip, {
        "placement": "top"
      }, {
        trigger: () => createVNode("span", {
          "class": ["w-pagination-prev", {
            ["w-pagination--disabled"]: pi.value === 1
          }],
          "onClick": toPrev
        }, null),
        default: () => "\u4E0A\u4E00\u9875"
      }), showItem("pager") && all_pages, showItem("next") && createVNode(Tooltip, {
        "placement": "top"
      }, {
        trigger: () => createVNode("span", {
          "class": ["w-pagination-next", {
            ["w-pagination--disabled"]: pi.value === totalPages.value
          }],
          "onClick": toNext
        }, null),
        default: () => "\u4E0B\u4E00\u9875"
      })]), showItem("sizes") && createVNode("li", {
        "class": "w-pagination-sizes",
        "style": {
          order: setOrder("sizes")
        }
      }, [createVNode(Choose, chooseProps.value, chooseSlots)]), showItem("jumper") && [createVNode("li", {
        "style": {
          order: setOrder("jumper")
        }
      }, [createVNode("span", null, [createTextVNode("\u524D\u5F80\u2002")]), createVNode(Num, numProps.value, null), createVNode("span", null, [createTextVNode("\u2002\u9875")])]), createVNode("li", {
        "class": "w-pagination-go",
        "style": {
          order: setOrder("jumper")
        }
      }, [btn])]]);
    };
  }
});
var index$d = /* @__PURE__ */ (() => 'ol.w-pagination{list-style:none;padding:0;margin:var(--w-gap) 0;display:flex;align-items:center;-webkit-user-select:none;-moz-user-select:none;user-select:none}ol.w-pagination.w-pagination__right{justify-content:flex-end}ol.w-pagination.w-pagination__left{justify-content:flex-start}ol.w-pagination.w-pagination__center{justify-content:center}ol.w-pagination li{display:inline-flex;align-items:center;flex-shrink:0}ol.w-pagination li.w-pagination-pager>span{display:inline-flex;align-items:center;justify-content:center;width:var(--w-size);height:var(--w-size);color:var(--w-color-font-2);transition:var(--w-transition-time);cursor:pointer;flex-shrink:0;border-radius:var(--w-radius)}ol.w-pagination li.w-pagination-pager>span:first-child{border-radius:var(--w-radius) 0 0 var(--w-radius)}ol.w-pagination li.w-pagination-pager>span:last-child{border-radius:0 var(--w-radius) var(--w-radius) 0}ol.w-pagination li.w-pagination-pager>span.w-pagination--disabled{cursor:not-allowed}ol.w-pagination li.w-pagination-pager>span.w-pagination-prev,ol.w-pagination li.w-pagination-pager>span.w-pagination-next{position:relative}ol.w-pagination li.w-pagination-pager>span.w-pagination-prev:after,ol.w-pagination li.w-pagination-pager>span.w-pagination-next:after{content:"";position:absolute;border-width:1px;border-style:solid;border-color:var(--w-color-font-2) transparent transparent var(--w-color-font-2);transform:rotate(-45deg);width:6px;height:6px;top:0;bottom:0;margin:auto}ol.w-pagination li.w-pagination-pager>span.w-pagination-next:after{transform:rotate(135deg);left:11px}ol.w-pagination li.w-pagination-pager>span:hover{z-index:2}ol.w-pagination li.w-pagination-pager>span:hover:not(.w-pagination--disabled):not(.w-pagination--active){background-color:var(--w-color-bg);font-weight:700}ol.w-pagination li.w-pagination-pager>span.w-pagination--active{color:var(--w-color-primary);position:relative;z-index:1;font-weight:700;background-color:var(--w-color-primary-light-8)}ol.w-pagination li.w-pagination-go{margin-left:var(--w-gap)}ol.w-pagination.w-pagination--bordered li.w-pagination-sizes{width:90px;margin-left:var(--w-pagination-pager-gap);margin-right:var(--w-pagination-pager-gap)}ol.w-pagination.w-pagination--bordered li.w-pagination-pager{margin-left:var(--w-pagination-pager-gap);margin-right:var(--w-pagination-pager-gap)}ol.w-pagination.w-pagination--bordered li.w-pagination-pager>span{border:1px solid var(--w-pagination-border-color)}ol.w-pagination.w-pagination--bordered li.w-pagination-pager>span:hover:not(.w-pagination--disabled):not(.w-pagination--active){border-color:var(--w-pagination-border-hover-color);color:var(--w-color-primary);background-color:transparent;font-weight:700}ol.w-pagination.w-pagination--bordered li.w-pagination-pager>span.w-pagination--active{color:var(--w-color-primary);font-weight:700;background-color:transparent;border-color:var(--w-color-primary)}ol.w-pagination.w-pagination--bordered li.w-pagination-pager>span+span{margin-left:var(--w-pagination-pager-gap)}\n')();
var Popup = defineComponent({
  inheritAttrs: false,
  name: "Popup",
  components: {
    Layer,
    Close,
    Btn
  },
  emits: ["update:show", "after-ok", "after-cancel", "after-enter"],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: [String, Object, Array],
    width: {
      type: String,
      default: "600px"
    },
    okText: {
      type: String,
      default: "\u786E\u5B9A"
    },
    cancelText: {
      type: String,
      default: "\u53D6\u6D88"
    },
    beforeOk: Function,
    beforeCancel: Function,
    hasHeader: {
      type: Boolean,
      default: true
    },
    hasFooter: {
      type: Boolean,
      default: true
    },
    hasMask: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Object,
      default: () => ({
        show: false
      })
    }
  },
  setup: (props2, ctx) => {
    var _a;
    const {
      zIndex: zIndex2,
      add: add2
    } = useGlobalZIndex();
    const isAfterEnter = ref(false);
    const showLoading = ref((_a = props2.loading.show) != null ? _a : false);
    const layerStyle = computed(() => {
      if (style.value) {
        return {
          width: props2.width,
          ...style.value
        };
      } else {
        return {
          width: props2.width
        };
      }
    });
    const layerOptions = computed(() => {
      return {
        layerClass: "w-popup",
        layerStyle: layerStyle.value,
        show: props2.show,
        placement: "client-center",
        trigger: "click",
        canCloseByClickOutside: false,
        hasMask: props2.hasMask,
        "onUpdate:show": (v2) => {
          if (!v2) {
            isAfterEnter.value = false;
          } else {
            add2();
          }
          style.value = {};
          ctx.emit("update:show", v2);
        },
        "onAfter-enter": (el) => {
          ctx.emit("after-enter", el);
        }
      };
    });
    const style = ref();
    const layer = ref();
    function startFn(ev) {
      ev.preventDefault();
      let disX = ev.clientX - layer.value.dom.offsetLeft;
      let disY = ev.clientY - layer.value.dom.offsetTop;
      document.onmousemove = function(e) {
        e.preventDefault();
        var x = e.clientX;
        var y = e.clientY;
        style.value = {
          left: x - disX + "px!important",
          top: y - disY + "px!important"
        };
        document.onmouseup = function() {
          document.onmousemove = null;
        };
      };
    }
    function setLoading(b) {
      showLoading.value = b;
    }
    async function handleCancel(options) {
      var _a2, _b;
      setLoading(false);
      try {
        await ((_a2 = props2.beforeCancel) == null ? void 0 : _a2.call(props2));
        (_b = options.hide) == null ? void 0 : _b.call(options);
        ctx.emit("after-cancel", options);
      } catch (err) {
      } finally {
      }
    }
    function cancelBtn(options) {
      const p = {
        mode: "line",
        onClick: () => {
          handleCancel(options);
        }
      };
      return createVNode(Btn, p, {
        default: () => [props2.cancelText]
      });
    }
    function okBtn(options) {
      const p = {
        type: "primary",
        disabled: showLoading.value,
        onClick: async () => {
          var _a2;
          try {
            await ((_a2 = props2.beforeOk) == null ? void 0 : _a2.call(props2));
          } catch (err) {
          } finally {
            ctx.emit("after-ok", options);
          }
        }
      };
      return createVNode(Btn, p, {
        default: () => [props2.okText]
      });
    }
    function renderLoading() {
      const loadingOptions = {
        ...props2.loading,
        show: showLoading.value,
        transitionName: "w-fade-white",
        class: "w-popup-loading",
        style: {
          "z-index": zIndex2.value
        }
      };
      return createVNode(Loading, loadingOptions, null);
    }
    watch(() => props2.show, (v2) => {
      console.log("111");
    });
    watch(() => props2.loading.show, (v2) => {
      showLoading.value = v2 != null ? v2 : false;
    });
    return () => {
      const layerSlots = {
        trigger: ctx.slots.trigger,
        default: (e) => {
          var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j;
          const options = {
            ...e,
            setLoading
          };
          const header = props2.hasHeader && ((_c = (_b = (_a2 = ctx.slots).header) == null ? void 0 : _b.call(_a2, options)) != null ? _c : createVNode("div", {
            "class": "w-popup-header",
            "onMousedown": (e2) => {
              startFn(e2);
            }
          }, [createVNode("b", {
            "class": "w-popup-title"
          }, [props2.title]), createVNode("div", {
            "class": "w-popup-drag"
          }, null), createVNode(Close, {
            "onClick": () => {
              handleCancel(options);
            }
          }, null)]));
          const body = createVNode("div", {
            "class": ["w-popup-body", isAfterEnter.value ? "w-overflow-auto" : ""]
          }, [(_e = (_d = ctx.slots).default) == null ? void 0 : _e.call(_d, options)]);
          const footer = props2.hasFooter && ((_j = (_g = (_f = ctx.slots).footer) == null ? void 0 : _g.call(_f, options)) != null ? _j : createVNode("div", {
            "class": "w-popup-footer"
          }, [createVNode("div", null, [(_i = (_h = ctx.slots)["footer-prepend"]) == null ? void 0 : _i.call(_h, options)]), createVNode("div", null, [cancelBtn(options), okBtn(options)])]));
          return [header, body, footer, renderLoading()];
        }
      };
      return createVNode(Layer, mergeProps(layerOptions.value, {
        "ref": layer
      }), layerSlots);
    };
  }
});
var index$c = /* @__PURE__ */ (() => ".w-popup{--w-popup-header-height: var(--w-size);min-width:var(--w-popup-min-width);min-height:var(--w-popup-min-height);max-height:calc(100% - var(--w-size) * 2);border:1px solid var(--w-popup-border-color);display:flex;flex-direction:column}.w-popup .w-popup-header{height:var(--w-popup-header-height);line-height:var(--w-popup-header-height);padding:0 var(--w-padding-x);display:flex;align-items:center;justify-content:space-between;flex-shrink:0}.w-popup .w-popup-header .w-popup-title{font-size:14px;color:var(--w-color-font-1)}.w-popup .w-popup-header .w-popup-drag{flex:1;height:100%;cursor:move}.w-popup .w-popup-body{position:relative;padding:var(--w-padding-x);font-size:var(--w-font-size);overflow:auto;flex:1}.w-popup .w-popup-footer{padding:var(--w-padding-x);display:flex;align-items:center;justify-content:space-between;flex-shrink:0}.w-popup .w-popup-loading{position:absolute;top:var(--w-popup-header-height);bottom:0;left:0;right:0;background-color:var(--w-fade-white-background-color)}\n")();
const DefaultIcons = {
  default: "w-icon-radio",
  checked: "w-icon-radio-fill",
  disabled: "w-icon-ball"
};
var Radio = defineComponent({
  name: "Radio",
  props: {
    modelValue: {
      type: [Number, String, Boolean]
    },
    value: [Number, String, Boolean],
    disabled: Boolean,
    text: [Number, String],
    icons: {
      type: Object,
      default: () => DefaultIcons
    },
    gap: {
      type: Boolean,
      default: true
    },
    validateEvent: {
      type: Boolean,
      default: true
    }
  },
  emits: ["change", "click", "update:modelValue"],
  setup(props2, {
    emit,
    slots
  }) {
    const formItem = inject("formItem", void 0);
    const radioClick = inject("radioClick", void 0);
    const currentValue = inject("currentValue", void 0);
    const transValue = computed(() => {
      const v2 = props2.value;
      if (isBoolean(v2)) {
        return Number(v2);
      }
      return v2;
    });
    const transModelValue = computed(() => {
      const v2 = currentValue ? currentValue.value : props2.modelValue;
      if (isBoolean(v2)) {
        return Number(v2);
      }
      return v2;
    });
    const symbol = computed(() => Symbol(transValue.value));
    const data = computed(() => [symbol.value, transValue.value]);
    const isChecked = computed(() => transModelValue.value === transValue.value);
    const {
      set
    } = useToggleArray(data, reactive({
      item: computed(() => isChecked.value ? transValue.value : symbol.value)
    }));
    const iconProps = computed(() => {
      const _icons = {
        ...DefaultIcons,
        ...props2.icons
      };
      return {
        name: isChecked.value ? _icons.checked : props2.disabled ? _icons.disabled : _icons.default,
        class: ["w-radio-icon", {
          "w-radio-icon-checked": isChecked.value,
          "w-radio-icon-disabled": props2.disabled
        }]
      };
    });
    return () => {
      var _a, _b;
      const p = {
        class: ["w-radio", {
          "w-radio-gap": props2.gap
        }]
      };
      if (!props2.disabled) {
        p.onClick = (e) => {
          set({
            item: transValue.value
          });
          emit("update:modelValue", props2.value);
          emit("click", props2.value);
          if (radioClick) {
            radioClick(props2.value);
          }
          if (props2.validateEvent) {
            formItem == null ? void 0 : formItem.validate("change");
          }
        };
      }
      return createVNode("span", p, [createVNode(Icon$1, iconProps.value, null), (_b = props2.text) != null ? _b : (_a = slots.default) == null ? void 0 : _a.call(slots)]);
    };
  }
});
var index$b = /* @__PURE__ */ (() => ".w-radio{display:inline-flex;cursor:default;align-items:center}.w-radio .w-radio-icon{color:var(--w-color-font-3);margin-right:var(--w-radio-icon-gap)}.w-radio .w-radio-icon:hover:not(.w-radio-icon-disabled){color:var(--w-color-primary)}.w-radio .w-radio-icon.w-radio-icon-checked{color:var(--w-color-primary)}.w-radio .w-radio-icon.w-radio-icon-disabled{cursor:not-allowed;color:var(--w-color-font-4);opacity:.6}.w-radio.w-radio-gap:not(:last-child){margin-right:var(--w-checkbox-item-gap)}\n")();
var RadioGroup = defineComponent({
  props: {
    modelValue: {
      type: [String, Number, Boolean]
    }
  },
  emits: ["update:modelValue", "change", "click"],
  setup(props2, ctx) {
    watch(() => props2.modelValue, (v2) => {
      ctx.emit("change", v2);
    });
    const selectRadio = computed(() => {
      return props2.modelValue;
    });
    provide("radioClick", (v2) => {
      ctx.emit("update:modelValue", v2);
      ctx.emit("click", v2);
    });
    provide("currentValue", selectRadio);
    return () => {
      var _a, _b;
      return createVNode("div", {
        "class": "w-radio-group"
      }, [(_b = (_a = ctx.slots).default) == null ? void 0 : _b.call(_a)]);
    };
  }
});
var index$a = /* @__PURE__ */ (() => ".w-rodio-group{display:flex;align-items:center}\n")();
var Cell = defineComponent({
  components: {
    Icon: Icon$1
  },
  props: {
    isInThead: Boolean,
    sorter: {
      type: [Boolean, Number],
      default: void 0
    },
    tag: {
      type: String,
      default: "td"
    },
    align: {
      type: String
    },
    isNarrow: Boolean,
    notBold: Boolean,
    resizeWidth: Boolean,
    colIndex: Number,
    colSpan: {
      type: Number,
      default: 1
    },
    rowSpan: {
      type: Number,
      default: 1
    },
    col: {
      type: Object
    }
  },
  setup(props2, {
    slots
  }) {
    const tdRoot = ref(null);
    const start = reactive({
      x: 0,
      y: 0
    });
    const end = reactive({
      x: 0,
      y: 0
    });
    const beforeResize = inject("beforeResize");
    const inResizing = inject("inResizing");
    const afterResize = inject("afterResize");
    const currentSorter = inject("currentSorter");
    const updateSorter = inject("updateSorter");
    const cellProps = computed(() => {
      let o = {
        ref: tdRoot,
        colspan: props2.colSpan,
        rowspan: props2.rowSpan,
        "data-col-index": props2.colIndex,
        class: ["w-cell", {
          "w-cell--center": props2.align === "center",
          "w-cell--right": props2.align === "right",
          "w-cell--narrow": props2.isNarrow,
          "w-cell--not-bold": props2.notBold
        }]
      };
      return o;
    });
    function toResize(e) {
      end.x = e.clientX;
      inResizing(props2.colIndex, end.x - start.x);
    }
    function handleMouseup(e) {
      afterResize(props2.colIndex, e.clientX - start.x);
      start.x = 0;
      end.x = 0;
      document.removeEventListener("mousemove", toResize);
      document.removeEventListener("mouseup", handleMouseup);
    }
    function toSort() {
      var _a;
      updateSorter((_a = props2.col) == null ? void 0 : _a.field);
    }
    onMounted(() => {
    });
    return () => {
      var _a, _b;
      let line = null;
      let sorter = null;
      if (props2.resizeWidth) {
        const lineProps = {
          class: "w-cell-resize-line",
          onMousedown: (e) => {
            start.x = e.clientX;
            beforeResize(tdRoot.value);
            document.addEventListener("mousemove", toResize);
            document.addEventListener("mouseup", handleMouseup);
          },
          onClick: (e) => {
            e.preventDefault();
          }
        };
        line = createVNode("span", lineProps, null);
      }
      if (props2.sorter !== void 0) {
        sorter = createVNode("div", {
          "class": "w-cell-sorter",
          "onClick": (e) => {
            toSort();
            e.preventDefault();
            e.stopPropagation();
          }
        }, [createVNode(Icon$1, {
          "name": "w-icon-sort-down",
          "class": ["w-cell-sorter-icon w-cell-sorter-up", {
            "w-cell-sorter--0": currentSorter.field === ((_a = props2.col) == null ? void 0 : _a.field) && currentSorter.sorter === 0
          }]
        }, null), createVNode(Icon$1, {
          "name": "w-icon-sort-down",
          "class": ["w-cell-sorter-icon w-cell-sorter-down ", {
            "w-cell-sorter--1": currentSorter.field === ((_b = props2.col) == null ? void 0 : _b.field) && currentSorter.sorter === 1
          }]
        }, null)]);
      }
      return createVNode(props2.tag, cellProps.value, {
        default: () => {
          var _a2;
          return [(_a2 = slots.default) == null ? void 0 : _a2.call(slots), line, sorter];
        }
      });
    };
  }
});
const PRESET_INDEX = "__preset_index__";
const PRESET_CHECKBOX = "__preset_checkbox__";
const PRESET_RADIO = "__preset_radio__";
const PRESET_ACTION = "__preset_action__";
const PRESET_FIELDS = {
  index: { field: PRESET_INDEX, style: { width: 40 } },
  checkbox: { field: PRESET_CHECKBOX, style: { width: 40 } },
  radio: { field: PRESET_RADIO, style: { width: 40 } },
  action: { field: PRESET_ACTION, style: { width: 42 } }
};
const IS_PRESET = (field) => {
  let b = false;
  for (const o in PRESET_FIELDS) {
    if (PRESET_FIELDS[o].field === field) {
      b = true;
      break;
    }
  }
  return b;
};
const IS_INDEX = (field) => PRESET_INDEX === field;
const IS_CHECKBOX = (field) => PRESET_CHECKBOX === field;
const IS_RADIO = (field) => PRESET_RADIO === field;
function useTdWidth(isAuto, inner, bodyColumns) {
  const a = ref(0);
  const tdWidths = computed(() => {
    let totalTdWidth = a.value - a.value;
    let totalStretchWidth = 0;
    const wrapperWidth = inner.value ? Math.floor(inner.value.clientWidth) : window.innerWidth;
    let widths = bodyColumns.value.map((col, index2) => {
      var _a;
      let style = typeof col.style === "function" ? col.style(null, null, {}) : col.style;
      let w = (_a = style == null ? void 0 : style.width) != null ? _a : 120;
      if (hasUnit(w)) {
        if (getUnit(w) !== "px") {
          w = parseFloat(w) * 12;
        }
      }
      totalTdWidth += w;
      if (!IS_PRESET(col.field) && !col.lockWidth) {
        totalStretchWidth += w;
      }
      return w;
    });
    if (isAuto.value) {
      if (wrapperWidth > totalTdWidth) {
        const restWidth = wrapperWidth - totalTdWidth;
        widths = bodyColumns.value.map((col, i) => {
          if (IS_PRESET(col.field) || col.lockWidth) {
            return widths[i];
          } else {
            return widths[i] + Math.floor(restWidth * (widths[i] / totalStretchWidth));
          }
        });
      }
    }
    return widths;
  });
  function adjust() {
    a.value += 1;
  }
  useEvent(window, "resize", adjust);
  return { tdWidths, adjustTdWidths: adjust };
}
function useColumns(columns, opts) {
  const col_index = computed(() => ({
    name: opts.value.indexContent,
    ...PRESET_FIELDS.index
  }));
  const col_checkbox = { ...PRESET_FIELDS.checkbox };
  const col_radio = { ...PRESET_FIELDS.radio };
  let cols = computed(() => {
    let _columns = columns.value;
    let validCols = [];
    if (typeof _columns === "function") {
      _columns = _columns();
    }
    _columns = _columns.forEach((c) => {
      if (isObject(c)) {
        validCols.push(c);
      } else if (isFunction(c)) {
        let f = c();
        if (isObject(f)) {
          validCols.push(f);
        }
      }
    });
    let arr = [];
    if (opts.value.hasIndex || opts.value.hasAction) {
      arr.push(col_index.value);
    }
    if (opts.value.hasCheckbox) {
      arr.push(col_checkbox);
    } else if (opts.value.hasRadio) {
      arr.push(col_radio);
    }
    return [...arr, ...validCols];
  });
  return cols;
}
function useFixed(tableRoot, innerTable, leftFixed, rightFixed, hasSum) {
  const { scrollTop, scrollBottom, scrollLeft, scrollRight, getScroll } = useScroll(innerTable, () => {
    nextTick(setFixed);
  }, true);
  const showTopShadow = ref(false);
  const showBottomShadow = ref(false);
  const showLeftShadow = ref(false);
  const showRightShadow = ref(false);
  const leftOffset = ref([]);
  const rightOffset = ref([]);
  const leftShadowPosition = ref(-1e3);
  const rightShadowPosition = ref(-1e3);
  const leftNumber = computed(() => {
    if (leftFixed.value) {
      return Number(leftFixed.value);
    }
    return 0;
  });
  const rightNumber = computed(() => {
    if (rightFixed.value) {
      return Number(rightFixed.value);
    }
    return 0;
  });
  function getTdsAndThs() {
    const scrollTarget = getElement(innerTable.value);
    const trs = [...scrollTarget.querySelectorAll(".w-sheet-tbody>.w-sheet>tbody>tr")];
    const ths = [
      ...scrollTarget.querySelectorAll(".w-sheet-thead>.w-sheet>thead>tr>th.w-cell--sticky")
    ];
    const footThs = hasSum.value ? [
      ...scrollTarget.querySelectorAll(".w-sheet-tfoot>.w-sheet>tfoot>tr>th.w-cell--sticky")
    ].slice(0, leftNumber.value) : [];
    const firstRowtds = trs.length ? [...trs[0].querySelectorAll("td")] : [];
    const firstRowLeftTds = firstRowtds.slice(0, leftNumber.value);
    const firstRowRightTds = firstRowtds.slice(-1 * rightNumber.value);
    let rightThs = [];
    let rightTfootThs = [];
    if (rightNumber.value > 0) {
      rightThs = [
        ...scrollTarget.querySelectorAll(".w-sheet-thead>.w-sheet>thead>tr>th.w-cell--sticky")
      ].slice(rightNumber.value * -1);
      rightTfootThs = [
        ...scrollTarget.querySelectorAll(".w-sheet-tfoot>.w-sheet>tfoot>tr>th")
      ].slice(rightNumber.value * -1);
    }
    return {
      trs,
      firstRowLeftTds,
      firstRowRightTds,
      ths,
      footThs,
      rightThs,
      rightTfootThs
    };
  }
  function reset() {
    leftOffset.value = [];
    rightOffset.value = [];
    const { trs, firstRowLeftTds, firstRowRightTds, ths, footThs } = getTdsAndThs();
    trs.forEach((tr, i) => {
      if (i === 0) {
        const _tds = tr.querySelectorAll("td");
        const tds = Array.from(_tds);
        const leftTds = tds.slice(0, leftNumber.value);
        const rightTds = tds.slice(-1 * rightNumber.value);
        leftTds.forEach((td) => {
          td.classList.remove("w-cell--sticky");
          td.style.removeProperty("left");
        });
        rightTds.forEach((td) => {
          td.classList.remove("w-cell--sticky");
          td.style.removeProperty("right");
        });
      }
    });
    getScroll();
    nextTick(() => {
      setFixed();
    });
  }
  function setFixed(e) {
    getElement(e ? e.target : innerTable.value);
    if (leftNumber.value !== 0 || rightNumber.value !== 0) {
      const { trs, firstRowLeftTds, firstRowRightTds, ths, footThs, rightThs, rightTfootThs } = getTdsAndThs();
      if (leftNumber.value !== 0) {
        if (scrollLeft.value > 0) {
          if (firstRowLeftTds.length) {
            if (leftOffset.value.length === 0) {
              let leftPosition = 0;
              leftOffset.value = firstRowLeftTds.map((td, i, arr) => {
                const l = td.offsetLeft - 1;
                if (i === arr.length - 1) {
                  leftPosition = l + parseInt(getStyle(td, "width"));
                }
                return l;
              });
              leftShadowPosition.value = leftPosition - 1;
            }
            trs.forEach((tr) => {
              if (leftOffset.value.length) {
                const tds = [...tr.querySelectorAll("td")].slice(0, leftOffset.value.length);
                tds.forEach((td, i) => {
                  td.style.left = leftOffset.value[i] + "px";
                  td.classList.add("w-cell--sticky");
                });
              }
            });
            ths.forEach((th, i) => {
              th.style.left = leftOffset.value[i] + "px";
              if (hasSum.value && footThs.length) {
                if (footThs[i]) {
                  footThs[i].style.left = th.style.left;
                }
              }
            });
          }
          showLeftShadow.value = true;
        } else {
          showLeftShadow.value = false;
        }
      }
      if (rightNumber.value !== 0) {
        if (scrollRight.value > 0) {
          if (rightOffset.value.length === 0) {
            let t = 0;
            rightOffset.value = firstRowRightTds.reverse().map((td, i, arr) => {
              if (i === 0) {
                t += getBoundingClientRect(td).width;
                return 0;
              } else {
                let right = t;
                t += getBoundingClientRect(td).width;
                return right;
              }
            }).reverse();
          }
          trs.forEach((tr, idx) => {
            if (rightOffset.value.length) {
              const tds = [...tr.querySelectorAll("td")].slice(-1 * rightOffset.value.length);
              tds.forEach((td, i) => {
                td.style.right = rightOffset.value[i] + "px";
                td.classList.add("w-cell--sticky");
              });
            }
          });
          rightThs.forEach((th, i) => {
            th.style.right = rightOffset.value[i] + "px";
            th.classList.add("w-cell--sticky");
            if (i === 0) {
              rightShadowPosition.value = th.offsetLeft + 1 - scrollLeft.value;
            }
          });
          rightTfootThs.forEach((th, i) => {
            th.style.right = rightOffset.value[i] + "px";
            th.classList.add("w-cell--sticky");
          });
          showRightShadow.value = true;
        } else {
          showRightShadow.value = false;
        }
      }
    }
    showTopShadow.value = scrollTop.value > 0;
    showBottomShadow.value = scrollBottom.value > 0;
  }
  useEvent(window, "resize", reset);
  return {
    showLeftShadow,
    showRightShadow,
    showBottomShadow,
    showTopShadow,
    leftShadowPosition,
    rightShadowPosition,
    reset
  };
}
function _isSlot$3(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
var Thead = defineComponent({
  name: "SheetThead",
  components: {
    Cell,
    Checkbox,
    Radio
  },
  props: {
    totalTbodyColumns: {
      type: Number,
      default: 0
    },
    columns: Array,
    indexContent: [String, Object],
    checkKey: String,
    radioKey: String,
    hasAction: Boolean,
    resize: Boolean
  },
  setup(props2, {
    attrs,
    emit,
    slots
  }) {
    const isCheckedAll = inject("isCheckedAll");
    const setCheckAll = inject("setCheckAll");
    const _leftFixed = computed(() => {
      const l = inject("leftFixed");
      if (l.value) {
        return Number(l.value);
      }
      return 0;
    });
    const _rightFixed = computed(() => {
      const r = inject("rightFixed");
      if (r.value) {
        return Number(r.value);
      }
      return 0;
    });
    function getRowspan(obj, max) {
      if (obj.children && obj.children.length !== 0) {
        return 1;
      }
      return max - obj.__level;
    }
    function getColspan(obj) {
      let arr = [], fn = (obj2) => {
        if (obj2.children && obj2.children.length) {
          obj2.children.forEach((c) => {
            fn(c);
          });
        } else {
          arr.push(obj2);
        }
      };
      fn(obj);
      return arr.length || 1;
    }
    function renderTableHead() {
      var _a;
      let colIndex = 0;
      let columns = (_a = props2.columns) != null ? _a : [];
      let maxRowLength = 0;
      let __index = 0;
      let addIndex = (col, colChildren) => {
        if (colChildren.children && colChildren.children.length) {
          col.__index = col.__index + colChildren.children.length - 1;
          colChildren.children.forEach((c) => {
            addIndex(col, c);
          });
        }
      };
      let addLevel = (cols, i) => {
        cols.forEach((col) => {
          col.__index = __index++;
          col.__level = i;
          if (maxRowLength < i) {
            maxRowLength = i;
          }
          if (col.children && col.children.length) {
            addIndex(col, col);
            __index--;
            addLevel(col.children, col.__level + 1);
          }
        });
      };
      addLevel(columns, 0);
      maxRowLength += 1;
      let trs = Array.apply(null, {
        length: maxRowLength
      }).map(() => []);
      let renderTd = (columns2) => {
        columns2.forEach((col, i, arr) => {
          const isPreset = IS_PRESET(col.field);
          let content = null;
          if (typeof col.name === "function") {
            content = col.name();
          } else {
            content = col.name;
          }
          if (isPreset) {
            if (IS_INDEX(col.field)) {
              content = props2.indexContent;
            }
            if (IS_CHECKBOX(col.field)) {
              const checkboxProps = {
                gap: false,
                iconSize: "16px",
                modelValue: isCheckedAll.value,
                "onUpdate:modelValue": (v2) => {
                  setCheckAll(v2);
                }
              };
              content = createVNode(Checkbox, checkboxProps, null);
            } else if (IS_RADIO(col.field)) {
              content = "";
            }
          }
          const colspan = getColspan(col);
          const rowspan = getRowspan(col, maxRowLength);
          const cellProps = {
            isInThead: true,
            colspan,
            rowspan,
            notBold: isPreset,
            isNarrow: isPreset,
            align: isPreset || colspan > 1 ? "center" : "",
            resizeWidth: props2.resize && colspan == 1,
            colIndex: colspan == 1 ? colIndex : void 0,
            tag: "th",
            sorter: (() => {
              let b = void 0;
              if ("field" in col && "sorter" in col) {
                b = col.sorter;
              }
              return b;
            })(),
            col,
            class: [
              {
                "w-cell--sticky": _leftFixed.value > colIndex || _rightFixed.value > props2.totalTbodyColumns - colIndex - 1
              }
            ]
          };
          const _con = createVNode(Cell, cellProps, _isSlot$3(content) ? content : {
            default: () => [content]
          });
          trs[col.__level].push(_con);
          if (colspan == 1) {
            colIndex += 1;
          }
          if (col.children && col.children.length) {
            renderTd(col.children);
          }
        });
      };
      renderTd(columns);
      return trs.map((tr) => createVNode("tr", null, [tr]));
    }
    return () => {
      return renderTableHead();
    };
  }
});
function filterValidColumns(columns) {
  if (typeof columns === "function") {
    columns = columns();
  }
  let arr = [];
  columns.forEach((col) => {
    if (!!col && isObject(col)) {
      arr.push(col);
    } else if (typeof col === "function") {
      const c = col();
      if (!!c && isObject(c))
        arr.push(c);
    }
  });
  return arr;
}
function createTbodyColumns(columns) {
  let tbodyColumns = [];
  const cols = filterValidColumns(columns);
  const fn = (arr) => {
    arr.forEach((col) => {
      if (col.children && col.children.length) {
        fn(col.children);
      } else {
        tbodyColumns.push(col);
        if (col.sum !== false)
          ;
      }
    });
  };
  fn(cols);
  return tbodyColumns;
}
function getAlign(col) {
  const align = col.align || "";
  if (typeof align === "string") {
    return {
      thead: align,
      tbody: align,
      tfoot: align
    };
  } else {
    if (align.length) {
      let [a, b, c] = align;
      return {
        thead: a || "",
        tbody: b || "",
        tfoot: c || ""
      };
    }
  }
}
function getSelectedKey(row, checkboxKey) {
  let cks = checkboxKey;
  let arrKeys = [];
  if (cks.indexOf(",") > -1) {
    arrKeys = cks.split(/\s*,\s*/);
  } else {
    arrKeys.push(cks);
  }
  return arrKeys.map((k) => row[k]).join(",");
}
function _isSlot$2(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
var Tbody = defineComponent({
  name: "SheetTbody",
  components: {
    Cell,
    Icon: Icon$1
  },
  emits: {
    "after-render": () => {
      return true;
    }
  },
  props: {
    columns: Array,
    data: Array,
    from: Number,
    to: Number,
    hasIndex: Boolean,
    hasAction: [Boolean, Array, String],
    pageIndex: {
      type: [String, Number]
    },
    pageSize: {
      type: [String, Number]
    },
    tbodySlots: Object,
    checkKey: String,
    hasCheckbox: Boolean,
    hasRadio: Boolean,
    isCheckedAll: Number,
    checkable: Function,
    canHighlight: Boolean,
    highlightKey: String
  },
  setup(props2, {
    emit,
    attrs
  }) {
    const toEmit = inject("toEmit");
    const modelValue = inject("modelValue");
    const updateModelValue = inject("updateModelValue");
    const toggleRadio = inject("toggleRadio");
    const toggleSelect = inject("toggleSelect");
    const hasKey = inject("hasKey");
    const highlight = inject("highlight");
    const toggleHighlight = inject("toggleHighlight");
    const total = ref([]);
    const pi = computed(() => props2.pageIndex ? Number(props2.pageIndex) : 0);
    const ps = computed(() => props2.pageSize ? Number(props2.pageSize) : 0);
    const hasAddAction = computed(() => {
      const a = props2.hasAction;
      if (a) {
        return a === "add" || a === true || Array.isArray(a) && a.indexOf("add") > -1;
      }
    });
    const hasDeleteAction = computed(() => {
      const a = props2.hasAction;
      if (a) {
        return a === "delete" || a === true || Array.isArray(a) && a.indexOf("delete") > -1;
      }
    });
    function renderTd(row, col, index2, iCol, checked, isChecked, disabled) {
      var _a;
      const tdProps = {
        align: (_a = getAlign(col)) == null ? void 0 : _a.tbody,
        colIndex: iCol,
        colSpan: col.colSpan || 1,
        rowSpan: col.rowSpan || 1
      };
      let cont;
      if (IS_PRESET(col.field)) {
        tdProps.align = "center";
        tdProps.isNarrow = true;
        if (IS_PRESET(col.field)) {
          const isCheckbox = IS_CHECKBOX(col.field);
          const isRadio = IS_RADIO(col.field);
          if (IS_INDEX(col.field)) {
            cont = index2 + 1;
            if (pi.value && ps.value) {
              cont = ps.value * (pi.value - 1) + cont;
            }
            if (props2.from !== void 0) {
              cont = cont + props2.from;
            }
            if (props2.hasAction) {
              const actionSlot = props2.tbodySlots && props2.tbodySlots.action && props2.tbodySlots.action({
                row,
                index: index2
              });
              const addProps = {
                name: "w-icon-add",
                class: "w-cell-action-add",
                onClick: (e) => {
                  toEmit("add", row, props2.from === void 0 ? index2 : props2.from + index2);
                  e.stopPropagation();
                }
              };
              const deleteProps = {
                name: "w-icon-delete",
                class: "w-cell-action-delete",
                onClick: (e) => {
                  toEmit("delete", row, props2.from === void 0 ? index2 : props2.from + index2);
                  e.stopPropagation();
                }
              };
              const actionContent = actionSlot != null ? actionSlot : [hasAddAction.value && createVNode(Icon$1, addProps, null), hasDeleteAction.value && createVNode(Icon$1, deleteProps, null)];
              cont = [createVNode("div", {
                "class": "w-cell-index"
              }, [cont]), createVNode("span", null, [createTextVNode("\u3000")]), createVNode("div", {
                "class": "w-cell-action"
              }, [actionSlot != null ? actionSlot : actionContent])];
            }
          } else if (isCheckbox || isRadio) {
            let iconName = isCheckbox ? "w-icon-checkbox" : "w-icon-radio";
            if (checked || isChecked && disabled) {
              iconName = isCheckbox ? "w-icon-checkbox-fill" : "w-icon-radio-fill";
            }
            if (disabled && !isChecked) {
              iconName = isCheckbox ? "w-icon-square" : "w-icon-ball";
            }
            cont = createVNode(Icon$1, {
              "name": iconName,
              "class": ["w-sheet-check-icon", {
                "w-sheet-check-icon--checked": checked || isChecked,
                "w-sheet-check-icon--disabled": disabled
              }]
            }, null);
          }
        }
      } else if (col.render) {
        cont = col.render(row, index2);
      } else if (col.slot) {
        if (props2.tbodySlots && props2.tbodySlots[col.slot]) {
          cont = props2.tbodySlots[col.slot]({
            row,
            index: index2
          });
        }
      } else if (col.field) {
        cont = row[col.field];
      }
      return createVNode(Cell, tdProps, _isSlot$2(cont) ? cont : {
        default: () => [cont]
      });
    }
    function renderTr(row, index2) {
      var _a, _b, _c;
      const trProps = {};
      let checkValue = "";
      let hValue;
      let checked = false;
      let isChecked = false;
      let disabled = false;
      if (props2.hasRadio || props2.hasCheckbox || props2.canHighlight) {
        checkValue = getSelectedKey(row, (_a = props2.checkKey) != null ? _a : "Id");
        hValue = getSelectedKey(row, (_b = props2.highlightKey) != null ? _b : "Id");
        checked = props2.hasCheckbox ? hasKey(checkValue) : checkValue == modelValue.value;
        const isHigh = props2.canHighlight && hValue == highlight.value;
        trProps.class = {
          "w-sheet-tr--checked": checked,
          "w-sheet-tr--highlight": isHigh
        };
        if (props2.checkable) {
          ({
            checked: isChecked,
            disabled
          } = props2.checkable(row, index2));
        }
        if (!disabled) {
          trProps.onClick = () => {
            if (props2.hasCheckbox) {
              toggleSelect(checkValue, checked);
            } else if (props2.hasRadio) {
              if (!checked) {
                updateModelValue(checkValue);
                toggleRadio({
                  row,
                  index: index2
                });
              }
            }
            if (props2.canHighlight && !isHigh) {
              toggleHighlight(hValue);
            }
          };
        }
      }
      const tds = ((_c = props2.columns) != null ? _c : []).map((col, iCol) => {
        return renderTd(row, col, index2, iCol, checked, isChecked, disabled);
      });
      return createVNode("tr", trProps, [tds]);
    }
    function renderBody() {
      var _a;
      nextTick(() => {
        emit("after-render");
      });
      total.value = [];
      return ((_a = props2.data) != null ? _a : []).map((row, i) => {
        return renderTr(row, i);
      });
    }
    return renderBody;
  }
});
function _isSlot$1(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
var Tfoot = defineComponent({
  name: "SheetTfoot",
  components: {
    Cell
  },
  props: {
    hasSum: Boolean,
    columns: Array,
    data: Array
  },
  setup(props2) {
    const _leftFixed = computed(() => {
      const l = inject("leftFixed");
      if (l.value) {
        return Number(l.value);
      }
      return 0;
    });
    function renderTd() {
      var _a;
      return (_a = props2.columns) == null ? void 0 : _a.map((col, i) => {
        var _a2, _b;
        let cont = null;
        if (col.sum !== false && col.sum !== void 0) {
          let t = 0;
          (_a2 = props2.data) == null ? void 0 : _a2.forEach((item) => {
            let n = item[col.field] - 0;
            t += n;
          });
          if (typeof col.sum === "function") {
            cont = col.sum(t);
          } else {
            cont = t;
          }
        }
        const tdProps = {
          class: [{
            "w-cell--sticky": _leftFixed.value > i
          }],
          tag: "th",
          align: (_b = getAlign(col)) == null ? void 0 : _b.tfoot
        };
        if (IS_PRESET(col.field)) {
          tdProps.align = "center";
          tdProps.isNarrow = true;
          if (IS_INDEX(col.field)) {
            cont = "\u5408\u8BA1";
          }
        }
        return createVNode(Cell, tdProps, _isSlot$1(cont) ? cont : {
          default: () => [cont]
        });
      });
    }
    return () => {
      if (props2.hasSum) {
        return createVNode("tr", null, [renderTd()]);
      }
    };
  }
});
var _props = {
  data: Array,
  columns: [Array, Function],
  stripe: Boolean,
  hover: { type: Boolean, default: true },
  nowrap: { type: Boolean, default: true },
  height: String,
  bordered: { type: Boolean, default: false },
  trBordered: { type: Boolean, default: false },
  maxHeight: String,
  autoWidth: Boolean,
  hasCheckbox: Boolean,
  checkable: Function,
  checkKey: { type: String, default: "id" },
  keys: { type: Array, default: () => [] },
  hasRadio: Boolean,
  modelValue: [String, Number],
  hasAction: [Boolean, Array, String],
  hasIndex: Boolean,
  indexContent: { type: String, default: "#" },
  pageSize: [String, Number],
  pageIndex: [String, Number],
  resize: { type: Boolean, default: true },
  canHighlight: Boolean,
  highlightKey: { type: String, default: "id" },
  highlight: [String, Number],
  leftFixed: [Number, String],
  rightFixed: [Number, String]
};
const MIN_WIDTH = 32;
const EMITS = ["update:modelValue", "update:keys", "after-checked", "after-radio", "update:highlight", "sort"];
const TBODYEMITS = ["add", "delete"];
var Sheet = defineComponent({
  name: "Sheet",
  components: {
    Thead,
    Tbody,
    Tfoot,
    Virtual
  },
  props: _props,
  emits: [...EMITS, ...TBODYEMITS],
  setup(props2, {
    emit,
    attrs,
    slots
  }) {
    const resizeWidths = /* @__PURE__ */ new Map();
    const resizing = ref(false);
    const resizeLineLeft = ref(-1e4);
    const oldResizeLineLeft = ref(-1e4);
    const currentSorter = reactive({
      field: "",
      sorter: true
    });
    const {
      set,
      get,
      toggle
    } = useToggleArray([true, 0, 1], {
      item: true
    });
    const isCheckedAll = ref(0);
    const selectedKeys = ref([]);
    const tableRoot = ref();
    const tableRootLeft = ref(0);
    const inner = ref();
    const innerElem = computed(() => getElement(inner));
    const innerProps = computed(() => {
      let o = {
        ref: inner,
        class: ["w-sheet-inner-container", "w-sheet--min-content", {
          "w-sheet--nowrap": props2.nowrap,
          "w-sheet--stripe": props2.stripe,
          "w-sheet--hover": props2.hover,
          "w-sheet--has-action": props2.hasAction,
          "w-sheet--has-top-shadow": showTopShadow.value,
          "w-sheet--has-bottom-shadow": showBottomShadow.value
        }],
        style: {
          height: props2.height,
          maxHeight: props2.maxHeight
        }
      };
      return o;
    });
    const finalColumns = useColumns(computed(() => props2.columns), computed(() => ({
      indexContent: props2.indexContent,
      hasIndex: props2.hasIndex,
      hasCheckbox: props2.hasCheckbox,
      checkKey: props2.checkKey,
      hasRadio: props2.hasRadio,
      hasAction: props2.hasAction
    })));
    const tbodyColumns = computed(() => createTbodyColumns(finalColumns.value));
    const hasSum = computed(() => {
      let has = false;
      let i = 0;
      let len = tbodyColumns.value.length;
      while (i < len) {
        const col = tbodyColumns.value[i];
        if (col.sum !== false && col.sum !== void 0) {
          has = true;
          break;
        }
        i++;
      }
      return has;
    });
    const {
      showLeftShadow,
      showRightShadow,
      leftShadowPosition,
      rightShadowPosition,
      showTopShadow,
      showBottomShadow,
      reset
    } = useFixed(tableRoot, innerElem, computed(() => props2.leftFixed), computed(() => props2.rightFixed), hasSum);
    const {
      tdWidths,
      adjustTdWidths
    } = useTdWidth(computed(() => props2.autoWidth), innerElem, tbodyColumns);
    const theadProps = computed(() => {
      let o = {
        totalTbodyColumns: tbodyColumns.value.length,
        columns: finalColumns.value,
        indexContent: props2.indexContent,
        checkKey: props2.checkKey,
        resize: props2.resize
      };
      return o;
    });
    const tbodyProps = computed(() => {
      let o = {
        columns: tbodyColumns.value,
        hasIndex: props2.hasIndex,
        hasAction: props2.hasAction,
        pageSize: props2.pageSize,
        pageIndex: props2.pageIndex,
        tbodySlots: slots,
        hasCheckbox: props2.hasCheckbox,
        hasRadio: props2.hasRadio,
        checkKey: props2.checkKey,
        isCheckedAll: isCheckedAll.value,
        checkable: props2.checkable,
        canHighlight: props2.canHighlight,
        highlightKey: props2.highlightKey,
        "onAfter-render": () => {
          adjustTdWidths();
          nextTick(reset);
        }
      };
      return o;
    });
    const tfootProps = computed(() => {
      let o = {
        hasSum: hasSum.value,
        columns: tbodyColumns.value,
        data: props2.data
      };
      return o;
    });
    provide("toEmit", (eventName, ...opts) => {
      emit(eventName, ...opts);
    });
    provide("modelValue", readonly(computed(() => props2.modelValue)));
    provide("updateModelValue", (k) => {
      emit("update:modelValue", k);
    });
    provide("isCheckedAll", readonly(isCheckedAll));
    provide("setCheckAll", setCheckAll);
    provide("selectedKeys", readonly(selectedKeys));
    provide("hasKey", (k) => {
      return selectedKeys.value.some((sv) => sv === k);
    });
    provide("toggleRadio", ({
      row,
      index: index2
    }) => {
      emit("after-radio", {
        row,
        index: index2
      });
    });
    provide("toggleSelect", (k, checked) => {
      if (checked) {
        selectedKeys.value = selectedKeys.value.filter((el) => el !== k);
      } else {
        selectedKeys.value.push(k);
      }
      let b = checkAllSelected();
      isCheckedAll.value = b;
      afterChecked();
    });
    provide("highlight", readonly(computed(() => props2.highlight)));
    provide("toggleHighlight", (v2) => {
      emit("update:highlight", v2);
    });
    provide("leftFixed", readonly(computed(() => props2.leftFixed)));
    provide("rightFixed", readonly(computed(() => props2.rightFixed)));
    provide("beforeResize", (tdElem) => {
      resizing.value = true;
      tableRoot.value.classList.add("w-no-select");
      tableRootLeft.value = getBoundingClientRect(tableRoot.value).left;
      const tdRight = getBoundingClientRect(tdElem).right;
      const x = tdRight != null ? tdRight : 0;
      resizeLineLeft.value = x - 1 - tableRootLeft.value;
      oldResizeLineLeft.value = resizeLineLeft.value;
    });
    provide("inResizing", (colIndex, dx = 0) => {
      resizeLineLeft.value = dx + oldResizeLineLeft.value;
    });
    provide("afterResize", (colIndex, dWidth) => {
      var _a, _b;
      resizing.value = false;
      tableRoot.value.classList.remove("w-no-select");
      resizeLineLeft.value = -1e4;
      if (dWidth === 0) {
        return;
      }
      const k = tbodyColumns.value[colIndex];
      const oldWidth = resizeWidths.has(k) ? resizeWidths.get(k) : tdWidths.value[colIndex];
      let newWidth = oldWidth + dWidth;
      if (newWidth <= MIN_WIDTH) {
        newWidth = MIN_WIDTH;
      }
      resizeWidths.set(tbodyColumns.value[colIndex], newWidth);
      if (!!props2.leftFixed || !!props2.rightFixed) {
        let n = (_a = Number(props2.leftFixed)) != null ? _a : 0;
        let rightN = (_b = Number(props2.rightFixed)) != null ? _b : 0;
        if (n > 0 && colIndex < n || rightN > 0) {
          reset();
        }
      }
    });
    provide("currentSorter", readonly(currentSorter));
    provide("updateSorter", (field) => {
      if (field === currentSorter.field) {
        currentSorter.sorter = toggle().item;
      } else {
        currentSorter.field = field;
        set({
          item: 0
        });
        currentSorter.sorter = get().item;
      }
      emit("sort", currentSorter);
    });
    function colGroup(widths) {
      return createVNode("colgroup", null, [widths.map((w, i) => {
        const k = tbodyColumns.value[i];
        const has = resizeWidths.has(k);
        const ww = has ? resizeWidths.get(k) : w;
        return createVNode("col", {
          "style": {
            width: ww + "px"
          }
        }, null);
      })]);
    }
    function setCheckAll(b) {
      isCheckedAll.value = b;
      const checkedKeys = [...selectedKeys.value];
      const _data = props2.data;
      if (b) {
        if (_data && _data.length) {
          _data.forEach((row, index2) => {
            let k = getSelectedKey(row, props2.checkKey);
            let canPush = !checkedKeys.some((_k) => _k == k);
            if (canPush) {
              if (props2.checkable) {
                const {
                  disabled
                } = props2.checkable(row, index2);
                if (!disabled) {
                  selectedKeys.value.push(k);
                }
              } else {
                selectedKeys.value.push(k);
              }
            }
          });
        }
      } else {
        const _keys = [];
        _data.forEach((row, index2) => {
          const k = getSelectedKey(row, props2.checkKey);
          if (props2.checkable) {
            const {
              disabled
            } = props2.checkable(row, index2);
            if (!disabled) {
              _keys.push(k);
            }
          } else {
            _keys.push(k);
          }
        });
        selectedKeys.value = selectedKeys.value.filter((_k) => !_keys.some((e) => e == _k));
      }
      afterChecked();
    }
    const propsData = computed(() => {
      return props2.data;
    });
    function checkAllSelected() {
      var _a;
      const keys2 = selectedKeys.value;
      const d = ((_a = propsData.value) != null ? _a : []).filter((row, index2) => {
        if (props2.checkable) {
          const {
            disabled
          } = props2.checkable(row, index2);
          return !disabled;
        }
        return true;
      });
      if (d && d.length && keys2.length) {
        let checked = 1;
        if (d.length <= keys2.length) {
          let i = 0;
          while (i < d.length) {
            const row = d[i];
            const k = getSelectedKey(row, props2.checkKey);
            if (!keys2.some((_k) => _k == k)) {
              checked = 0;
              break;
            }
            i++;
          }
        } else {
          checked = 0;
        }
        return checked;
      }
      return 0;
    }
    function afterChecked() {
      var _a;
      let arr = ((_a = props2.data) != null ? _a : []).filter((row, index2) => {
        const k = getSelectedKey(row, props2.checkKey);
        if (props2.checkable) {
          const {
            disabled
          } = props2.checkable(row, index2);
          if (!disabled) {
            return selectedKeys.value.some((s) => s == k);
          }
          return false;
        }
        return selectedKeys.value.some((s) => s == k);
      });
      emit("after-checked", arr);
    }
    watch(selectedKeys, (ks) => {
      if (!isSameArray(ks, props2.keys)) {
        emit("update:keys", ks);
      }
    }, {
      deep: true
    });
    watch(() => props2.keys, (ks) => {
      if (!isSameArray(ks, selectedKeys.value)) {
        selectedKeys.value = ks;
        if (ks && ks.length === 0) {
          isCheckedAll.value = 0;
        }
      }
    }, {
      deep: true,
      immediate: true
    });
    watch(tbodyColumns, () => {
      nextTick(reset);
    });
    watch(() => props2.data, (i) => {
      if (i && props2.hasCheckbox) {
        const b = checkAllSelected();
        isCheckedAll.value = b;
      }
    });
    onMounted(() => {
      if (innerElem.value && isElement(innerElem.value)) {
        innerElem.value.scrollLeft = 0;
        innerElem.value.scrollTop = 0;
      }
    });
    return () => {
      const thead = createVNode(Thead, theadProps.value, null);
      const tbody = (data, from, to) => createVNode(Tbody, mergeProps({
        "data": data,
        "from": from,
        "to": to
      }, tbodyProps.value), null);
      const innerTable = ({
        data,
        index: index2
      }) => createVNode(Fragment, null, [createVNode("div", {
        "class": "w-sheet-thead"
      }, [createVNode("table", {
        "class": "w-sheet"
      }, [colGroup(tdWidths.value), createVNode("thead", null, [thead])])]), createVNode("div", {
        "class": "w-sheet-tbody"
      }, [createVNode("table", {
        "class": "w-sheet"
      }, [colGroup(tdWidths.value), createVNode("tbody", null, [tbody(data, index2 ? index2.from : void 0, index2 ? index2.to : void 0)])])]), hasSum.value && createVNode("div", {
        "class": "w-sheet-tfoot"
      }, [createVNode("table", {
        "class": "w-sheet"
      }, [colGroup(tdWidths.value), createVNode("tfoot", null, [createVNode(Tfoot, tfootProps.value, null)])])])]);
      const table = (content) => createVNode("div", {
        "class": ["w-sheet-container", {
          "w-sheet-bordered": props2.bordered,
          "w-sheet-tr-bordered": props2.trBordered
        }],
        "ref": tableRoot
      }, [content, withDirectives(createVNode("div", {
        "class": "w-sheet-resize-line",
        "style": {
          left: resizeLineLeft.value + "px"
        }
      }, null), [[vShow, resizing.value]]), withDirectives(createVNode("div", {
        "class": "w-sheet-left-fixed-shadow-line",
        "style": {
          left: leftShadowPosition.value + "px"
        }
      }, null), [[vShow, !!props2.leftFixed && showLeftShadow.value && props2.data]]), withDirectives(createVNode("div", {
        "class": "w-sheet-right-fixed-shadow-line",
        "style": {
          left: rightShadowPosition.value + "px"
        }
      }, null), [[vShow, !!props2.rightFixed && showRightShadow.value && props2.data]])]);
      return table(createVNode("div", innerProps.value, [innerTable({
        data: props2.data
      })]));
    };
  }
});
function isSameArray(arr1, arr2) {
  if (arr1.length === arr2.length) {
    if (arr1.length === 0) {
      return true;
    }
    let i = 0;
    let b = true;
    while (i < arr1.length) {
      const k = arr1[i];
      if (!arr2.some((item) => item === k)) {
        b = false;
        break;
      }
      i++;
    }
    return b;
  }
  return false;
}
var index$9 = /* @__PURE__ */ (() => ".w-sheet-container{overflow:hidden;position:relative;border-radius:var(--w-radius)}.w-sheet-container .w-sheet-inner-container{overflow:auto}.w-sheet-container .w-sheet-inner-container .w-sheet{border-collapse:collapse}.w-sheet-container .w-sheet-inner-container .w-cell{padding:var(--w-sheet-td-padding);height:var(--w-sheet-td-height);color:var(--w-color-font-2);text-align:left;position:relative;transition:background-color var(--w-transition-time)}.w-sheet-container .w-sheet-inner-container .w-cell.w-cell--sticky{position:-webkit-sticky;position:sticky;background-color:var(--w-sheet-tr-background-color);z-index:1;box-shadow:1px 1px var(--w-sheet-td-border-color)}.w-sheet-container .w-sheet-inner-container .w-cell.w-cell--narrow{padding:var(--w-sheet-td-narrow-padding)}.w-sheet-container .w-sheet-inner-container .w-cell.w-cell--center{text-align:center}.w-sheet-container .w-sheet-inner-container .w-cell.w-cell--right{text-align:right}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-index,.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-action{display:flex;align-items:center;justify-content:center;position:absolute;width:100%;height:100%;top:0;left:0}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-action{color:var(--w-color-font-3);transform:translate(100%);visibility:hidden}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-action .w-cell-action-add{font-size:1.2em;cursor:pointer}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-action .w-cell-action-add:hover{color:var(--w-color-primary)}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-action .w-cell-action-delete{font-size:1.2em;cursor:pointer}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-action .w-cell-action-delete:hover{color:var(--w-color-danger)}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-resize-line{position:absolute;top:0;right:0;height:100%;width:8px;cursor:w-resize;z-index:0}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-sorter{position:absolute;right:5px;top:0;bottom:0;width:20px;height:24px;display:flex;border-radius:calc(2 * var(--w-radius));flex-direction:column;margin:auto;cursor:pointer;transition:background-color var(--w-transition-quick-time)}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-sorter .w-cell-sorter-icon{color:var(--w-color-font-3);display:inline-flex;position:absolute;font-size:19px;width:19px;height:21px}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-sorter:hover{background-color:#fff}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-sorter:hover .w-cell-sorter-icon{color:var(--w-color-font-2)}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-sorter .w-cell-sorter-up{transform:rotate(180deg);top:-4px;left:0px}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-sorter .w-cell-sorter-up.w-cell-sorter--0{color:var(--w-color-primary)}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-sorter .w-cell-sorter-down{top:5px}.w-sheet-container .w-sheet-inner-container .w-cell .w-cell-sorter .w-cell-sorter-down.w-cell-sorter--1{color:var(--w-color-primary)}.w-sheet-container .w-sheet-inner-container .w-sheet-tfoot{position:-webkit-sticky;position:sticky;bottom:0;background-color:var(--w-sheet-tfoot-background-color);min-width:-webkit-min-content;min-width:-moz-min-content;min-width:min-content;width:100%;z-index:2}.w-sheet-container .w-sheet-inner-container .w-sheet-tfoot tfoot{background-color:var(--w-sheet-tfoot-background-color)}.w-sheet-container .w-sheet-inner-container .w-sheet-tfoot tfoot .w-cell{border-color:var(--w-sheet-tfoot-th-border-color);color:var(--w-color-font-1)}.w-sheet-container .w-sheet-inner-container .w-sheet-tfoot tfoot .w-cell.w-cell--sticky{background-color:var(--w-sheet-tfoot-background-color);box-shadow:1px 1px var(--w-sheet-tfoot-th-border-color)}.w-sheet-container .w-sheet-inner-container .w-sheet-tfoot tfoot .w-cell.w-cell--not-bold{font-weight:400}.w-sheet-container .w-sheet-inner-container.w-sheet--min-content .w-sheet-tbody{width:-webkit-min-content;width:-moz-min-content;width:min-content}.w-sheet-container .w-sheet-inner-container.w-sheet--min-content .w-sheet{width:-webkit-min-content;width:-moz-min-content;width:min-content;table-layout:fixed}.w-sheet-container .w-sheet-inner-container.w-sheet--nowrap .w-sheet{white-space:nowrap}.w-sheet-container .w-sheet-inner-container.w-sheet--nowrap .w-cell{overflow:hidden;text-overflow:ellipsis}.w-sheet-container .w-sheet-inner-container.w-sheet--stripe .w-sheet-tbody .w-sheet tr td.w-cell{background-color:var(--w-sheet-tr-background-color)}.w-sheet-container .w-sheet-inner-container.w-sheet--stripe .w-sheet-tbody .w-sheet tr:nth-child(2n) td.w-cell{background-color:var(--w-sheet-tr-stripe-color)}.w-sheet-container .w-sheet-inner-container .w-sheet-tbody .w-sheet tr.w-sheet-tr--highlight td.w-cell{background-color:var(--w-sheet-tr-highlight-background-color)}.w-sheet-container .w-sheet-inner-container .w-sheet-tbody .w-sheet tr.w-sheet-tr--checked td.w-cell{background-color:var(--w-sheet-tr-checked-background-color)}.w-sheet-container .w-sheet-inner-container .w-sheet-tbody .w-sheet tr.w-sheet-tr--highlight:nth-child(2n) td.w-cell{background-color:var(--w-sheet-tr-highlight-background-color)}.w-sheet-container .w-sheet-inner-container .w-sheet-tbody .w-sheet tr.w-sheet-tr--checked:nth-child(2n) td.w-cell{background-color:var(--w-sheet-tr-checked-background-color)}.w-sheet-container .w-sheet-inner-container.w-sheet--hover .w-sheet-tbody .w-sheet tr{transition:var(--w-transition-quick-time)}.w-sheet-container .w-sheet-inner-container.w-sheet--hover .w-sheet-tbody .w-sheet tr:hover td.w-cell{background-color:var(--w-sheet-tr-hover-color)}.w-sheet-container .w-sheet-inner-container.w-sheet--has-action .w-sheet-tbody .w-sheet tr:hover .w-cell .w-cell-index{transform:translate(-100%)}.w-sheet-container .w-sheet-inner-container.w-sheet--has-action .w-sheet-tbody .w-sheet tr:hover .w-cell .w-cell-action{transform:translate(0);visibility:visible}.w-sheet-container .w-sheet-inner-container.w-sheet--has-top-shadow .w-sheet-thead{box-shadow:0 1px #00000008,0 3px 7px #0000001a}.w-sheet-container .w-sheet-inner-container.w-sheet--has-bottom-shadow .w-sheet-tfoot{box-shadow:inset 0 1px #0000000d,0 -1px 5px #0000001a}.w-sheet-container .w-sheet-resize-line,.w-sheet-container .w-sheet-left-fixed-shadow-line,.w-sheet-container .w-sheet-right-fixed-shadow-line{position:absolute;height:100%;left:-10000px;top:0;z-index:2}.w-sheet-container .w-sheet-resize-line{width:1px;background-color:var(--w-color-danger-5);box-shadow:0 1px 1px 2px #00000008}.w-sheet-container .w-sheet-left-fixed-shadow-line,.w-sheet-container .w-sheet-right-fixed-shadow-line{width:15px;pointer-events:none;left:-10000px;z-index:2}.w-sheet-container .w-sheet-left-fixed-shadow-line{background-image:linear-gradient(90deg,rgba(0,0,0,.07) 5%,transparent 70%)}.w-sheet-container .w-sheet-right-fixed-shadow-line{transform:translate(-15px);background-image:linear-gradient(-90deg,rgba(0,0,0,.07) 5%,transparent 70%)}.w-sheet-container.w-sheet-bordered{border:1px solid var(--w-sheet-container-border-color)}.w-sheet-container.w-sheet-bordered .w-sheet-inner-container{margin:-1px}.w-sheet-container.w-sheet-bordered .w-sheet-inner-container .w-cell{border:1px solid var(--w-sheet-td-border-color)}.w-sheet-container.w-sheet-tr-bordered .w-sheet-inner-container .w-sheet-tbody .w-sheet tr td.w-cell,.w-sheet-container.w-sheet-tr-bordered .w-sheet-inner-container .w-sheet-tfoot .w-sheet tr td.w-cell,.w-sheet-container.w-sheet-tr-bordered .w-sheet-inner-container .w-sheet-tbody .w-sheet tr th.w-cell,.w-sheet-container.w-sheet-tr-bordered .w-sheet-inner-container .w-sheet-tfoot .w-sheet tr th.w-cell{border-bottom:1px solid var(--w-sheet-td-border-color)}.w-sheet-inner-container .w-sheet-thead{position:-webkit-sticky;position:sticky;top:0;background-color:var(--w-sheet-thead-background-color);min-width:-webkit-min-content;min-width:-moz-min-content;min-width:min-content;width:100%;z-index:2}.w-sheet-inner-container .w-sheet-thead thead{background-color:var(--w-sheet-thead-background-color)}.w-sheet-inner-container .w-sheet-thead thead .w-cell{border-color:var(--w-sheet-thead-th-border-color);color:var(--w-color-font-1)}.w-sheet-inner-container .w-sheet-thead thead .w-cell.w-cell--sticky{background-color:var(--w-sheet-thead-background-color);box-shadow:1px 1px var(--w-sheet-thead-th-border-color)}.w-sheet-inner-container .w-sheet-thead thead .w-cell.w-cell--not-bold{font-weight:400}.w-sheet-check-icon{font-size:12px;color:var(--w-color-font-4);transform:scale(1.3);display:inline-flex}.w-sheet-check-icon.w-sheet-check-icon--checked{color:var(--w-color-primary)}.w-sheet-check-icon.w-sheet-check-icon--disabled{cursor:not-allowed;opacity:.35}@-moz-document url-prefix(){.w-cell--sticky{box-shadow:-1px -1px var(--w-sheet-td-border-color)!important}th.w-cell--sticky{box-shadow:-1px -1px var(--w-sheet-thead-th-border-color)!important}.w-cell-sorter-up{left:.8px!important}}\n")();
function _isSlot(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
var SlideDown = defineComponent({
  name: "SlideDown",
  props: {
    duration: {
      type: [Number, String],
      default: 350
    },
    timingFunction: {
      type: String,
      default: "ease-out"
    }
  },
  data() {
    return {
      height: "",
      paddingTop: "",
      paddingBottom: "",
      marginBottom: "",
      marginTop: "",
      borderTopWidth: "",
      borderBottomWidth: ""
    };
  },
  methods: {
    isAppear(el) {
      let t;
      return new Promise((res) => {
        t = setInterval(() => {
          if (document.body.contains(el)) {
            clearInterval(t);
            res(1);
          }
        }, 0);
      });
    },
    setProperty(el) {
      this.height = getStyle(el, "height");
      this.paddingTop = getStyle(el, "paddingTop");
      this.paddingBottom = getStyle(el, "paddingBottom");
      this.marginBottom = getStyle(el, "marginBottom");
      this.marginTop = getStyle(el, "marginTop");
      this.borderTopWidth = getStyle(el, "borderTopWidth");
      this.borderBottomWidth = getStyle(el, "borderBottomWidth");
    },
    beforeEnter(el) {
      if (document.body.contains(el)) {
        let _pnode = el.parentNode;
        if (_pnode) {
          const pnode = _pnode;
          pnode.dataset.oldHeight = getStyle(pnode, "height");
          pnode.dataset.oldOverflow = getStyle(pnode, "overflow");
          setStyle(pnode, {
            height: pnode.dataset.oldHeight,
            overflow: "hidden"
          });
        }
        setStyle(el, {
          display: "block",
          visibility: "hidden"
        });
        this.setProperty(el);
        setStyle(el, {
          display: "none",
          visibility: "visible",
          height: 0,
          opacity: 0,
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: 0,
          marginBottom: 0,
          borderBottomWidth: 0,
          borderTopWidth: 0,
          overflow: "hidden"
        });
        _pnode.removeAttribute("style");
      } else {
        let wrapper = document.createElement("div");
        wrapper.style.cssText = "height:0;overflow:hidden;";
        wrapper.appendChild(el);
        document.body.appendChild(wrapper);
        this.setProperty(el);
        document.body.removeChild(wrapper);
        setStyle(el, {
          height: 0,
          opacity: 0,
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: 0,
          marginBottom: 0,
          borderBottomWidth: 0,
          borderTopWidth: 0,
          overflow: "hidden"
        });
      }
    },
    enter(el) {
      this.isAppear(el).then(() => {
        setStyle(el, {
          height: this.height,
          opacity: 1,
          paddingTop: this.paddingTop,
          paddingBottom: this.paddingBottom,
          marginTop: this.marginTop,
          marginBottom: this.marginBottom,
          borderBottomWidth: this.borderBottomWidth,
          borderTopWidth: this.borderTopWidth,
          transition: this.duration + "ms " + this.timingFunction,
          overflow: "hidden"
        });
      });
    },
    beforeLeave(el) {
      this.setProperty(el);
      setStyle(el, {
        height: this.height,
        opacity: 1,
        paddingBottom: this.paddingBottom,
        paddingTop: this.paddingTop,
        marginTop: this.marginTop,
        marginBottom: this.marginBottom,
        borderBottomWidth: this.borderBottomWidth,
        borderTopWidth: this.borderTopWidth,
        transition: this.duration + "ms " + this.timingFunction,
        overflow: "hidden"
      });
    },
    leave(el) {
      setTimeout(() => {
        setStyle(el, {
          height: 0,
          opacity: 0,
          paddingBottom: 0,
          paddingTop: 0,
          marginTop: 0,
          marginBottom: 0,
          borderBottomWidth: 0,
          borderTopWidth: 0,
          overflow: "hidden"
        });
      });
    },
    afterLeave(el) {
      el.removeAttribute("style");
      setStyle(el, {
        display: "none"
      });
      this.$emit("after-transition");
    },
    afterEnter(el) {
      el.removeAttribute("style");
      this.$emit("after-transition");
    }
  },
  render() {
    const children = this.$slots.default;
    return createVNode(Transition, {
      "duration": {
        enter: this.duration,
        leave: this.duration
      },
      "enterFromClass": "",
      "enterToClass": "",
      "enterActiveClass": "",
      "leaveFromClass": "",
      "leaveToClass": "",
      "leaveActiveClass": "",
      "onBeforeEnter": this.beforeEnter,
      "onEnter": this.enter,
      "onAfterEnter": this.afterEnter,
      "onBeforeLeave": this.beforeLeave,
      "onLeave": this.leave,
      "onAfterLeave": this.afterLeave
    }, _isSlot(children) ? children : {
      default: () => [children]
    });
  }
});
function useMouse(callbackHandler) {
  const doc2 = document;
  const client = reactive({ x: 0, y: 0 });
  const page = reactive({ x: 0, y: 0 });
  function handler(e) {
    ({
      clientX: client.x,
      clientY: client.y,
      pageX: page.x,
      pageY: page.y
    } = e);
    if (callbackHandler) {
      const {
        mousemove: mm,
        mousedown: md,
        mouseup: mu,
        mouseover: mo
      } = callbackHandler;
      if (e.type === "mousemove") {
        mm == null ? void 0 : mm(e);
      }
      if (e.type === "mousedown") {
        md == null ? void 0 : md(e);
      }
      if (e.type === "mouseover") {
        mo == null ? void 0 : mo(e);
      }
      if (e.type === "mouseup") {
        mu == null ? void 0 : mu(e);
      }
    }
  }
  useEvent(doc2, "mousemove", handler);
  useEvent(doc2, "mousedown", handler);
  useEvent(doc2, "mouseup", handler);
  useEvent(doc2, "mouseover", handler);
  return {
    client,
    page
  };
}
var Slider = defineComponent({
  name: "Slider",
  components: {
    Tooltip,
    Num
  },
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 2
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 30
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    tip: {
      type: Function
    },
    direction: {
      type: Object,
      default: () => ({
        x: true,
        y: false
      })
    },
    fill: {
      type: Boolean,
      default: true
    },
    hasInput: Boolean,
    invalidateTip: {
      type: String,
      default: "\u6240\u8F93\u5165\u7684\u503C\u65E0\u6548\uFF0C\u8BF7\u62D6\u52A8\u63A7\u5236\u9600\u91CD\u65B0\u8F93\u5165\uFF01"
    }
  },
  emits: {
    input: (value, percent) => {
      if (typeof value === "number" && (percent === void 0 || typeof percent === "number")) {
        return true;
      }
    },
    "update:modelValue": (v2) => {
      return typeof v2 === "number";
    }
  },
  setup(props2, {
    emit,
    slots
  }) {
    getCurrentInstance();
    const {
      client
    } = useMouse({
      mousemove: inMousemove,
      mouseup: inMouseup
    });
    const multiples = 1e4;
    const step_big = computed(() => multiples * props2.step);
    const min_big = computed(() => multiples * props2.min);
    const max_big = computed(() => multiples * props2.max);
    const all_steps_big = computed(() => {
      const arr = [];
      let i = min_big.value;
      while (i <= max_big.value) {
        arr.push(i);
        i += step_big.value;
      }
      if (arr[arr.length - 1] !== max_big.value) {
        arr.push(max_big.value);
      }
      return arr;
    });
    const dragging = ref(false);
    const currentXValue = ref(props2.modelValue * multiples);
    const currentYValue = ref(props2.modelValue * multiples);
    const inputValue = ref();
    const rod = ref();
    const root = ref();
    const rootSize = reactive({
      width: 0,
      height: 0
    });
    const dx = ref(0);
    const dy = ref(0);
    const pos = reactive({
      left: 0,
      top: 0
    });
    const display = ref(false);
    const widthRange = computed(() => {
      const len = all_steps_big.value.length - 1;
      const ranges = all_steps_big.value.map((v2, i) => {
        return i / len;
      });
      return ranges;
    });
    const tipContent = computed(() => {
      if (props2.showTooltip) {
        const {
          x,
          y
        } = props2.direction;
        const xValue = currentXValue.value / multiples;
        const yValue = currentYValue.value / multiples;
        let v2;
        if (props2.tip) {
          v2 = props2.tip({
            x: xValue,
            y: yValue
          });
        } else {
          if (x && y) {
            v2 = `${xValue}\uFF0C${yValue}`;
          } else {
            if (x) {
              v2 = xValue;
            } else if (y) {
              v2 = yValue;
            }
          }
        }
        return v2;
      }
    });
    const sliderOptions = computed(() => {
      let klass = "";
      const {
        x,
        y
      } = props2.direction;
      if (x && y) {
        klass = "w-slider-xy";
      } else if (x) {
        klass = "w-slider-x";
      } else if (y) {
        klass = "w-slider-y";
      }
      return mergeProps({
        class: ["w-slider", klass]
      }, {
        ref: root
      });
    });
    const tooltipOptions = computed(() => {
      const {
        x,
        y
      } = props2.direction;
      return {
        placement: x ? "top" : "left",
        adjustPosition: x ? "top" : "left",
        manual: true,
        realTime: true,
        show: (dragging.value || display.value) && props2.showTooltip
      };
    });
    const showInvalidTip = ref(false);
    watch(() => props2.modelValue, (v2) => {
      const {
        x,
        y
      } = props2.direction;
      if (x && y)
        ;
      else {
        if (x) {
          currentXValue.value = v2 * multiples;
        } else if (y) {
          currentYValue.value = v2 * multiples;
        }
        inputValue.value = v2;
        setPositionByModelValue(v2);
      }
    });
    watch(currentXValue, (v2) => {
      if (props2.direction.x && !props2.direction.y) {
        emit("update:modelValue", v2 / multiples);
      }
    });
    watch(currentYValue, (v2) => {
      if (props2.direction.y && !props2.direction.x) {
        emit("update:modelValue", v2 / multiples);
      }
    });
    onMounted(() => {
      if (root.value) {
        setPositionByModelValue(props2.modelValue);
      }
    });
    function startMousedown(e) {
      if (root.value && rod.value) {
        const rect = getBoundingClientRect(root.value);
        rootSize.width = rect.width;
        rootSize.height = rect.height;
        const {
          left,
          top
        } = getOffset(rod.value, root.value);
        dx.value = client.x - left;
        dy.value = client.y - top;
      }
      dragging.value = true;
    }
    function inMousemove(e) {
      if (dragging.value) {
        const {
          x,
          y
        } = props2.direction;
        let top = client.y - dy.value;
        let left = client.x - dx.value;
        if (x) {
          let j = 0;
          if (left < 0) {
            left = 0;
          } else if (left > rootSize.width) {
            left = rootSize.width;
          }
          const percentLeft = left / rootSize.width;
          if (percentLeft === 1) {
            j = all_steps_big.value.length - 1;
          } else if (percentLeft === 0) {
            j = 0;
          } else {
            j = getPosByRange(percentLeft);
          }
          pos.left = widthRange.value[j];
          currentXValue.value = all_steps_big.value[j];
        }
        if (y) {
          let j = 0;
          if (top < 0) {
            top = 0;
          } else if (top > rootSize.height) {
            top = rootSize.height;
          }
          const percentTop = top / rootSize.height;
          if (percentTop === 1) {
            j = all_steps_big.value.length - 1;
          } else if (percentTop === 0) {
            j = 0;
          } else {
            j = getPosByRange(percentTop);
          }
          pos.top = widthRange.value[j];
          currentYValue.value = all_steps_big.value[j];
        }
        showInvalidTip.value = false;
      }
    }
    function inMouseup(e) {
      dragging.value = false;
    }
    function getPosByRange(per, which = "left") {
      const allWidthPercent = widthRange.value;
      let _j = 0;
      let i = 0;
      const len = allWidthPercent.length;
      if (per === 0) {
        return 0;
      } else if (per === 1) {
        return len - 1;
      }
      while (i < len) {
        const currentWidthPercent = allWidthPercent[i];
        if (per === currentWidthPercent) {
          _j = i;
          break;
        } else if (per < currentWidthPercent) {
          _j = i - 1;
          break;
        }
        i++;
      }
      if (_j < 0) {
        _j = 0;
      } else if (_j > len - 1) {
        _j = len - 1;
      }
      return _j;
    }
    function setPositionByModelValue(v2) {
      const {
        x,
        y
      } = props2.direction;
      const allValue = all_steps_big.value.map((v3) => v3 / multiples);
      const i = allValue.findIndex((_v) => _v === v2);
      if (i > -1) {
        if (x) {
          pos.left = widthRange.value[i];
        } else if (y) {
          pos.top = widthRange.value[i];
        }
      }
    }
    function validateInput(v2) {
      const allValues = all_steps_big.value.map((v3) => v3 / multiples);
      return allValues.includes(v2);
    }
    return () => {
      const {
        x,
        y
      } = props2.direction;
      const rodPosition = {};
      const progressSize = {};
      if (x) {
        rodPosition.left = pos.left * 100 + "%";
        progressSize.width = pos.left * 100 + "%";
      }
      if (y) {
        rodPosition.top = pos.top * 100 + "%";
        progressSize.height = pos.top * 100 + "%";
      }
      let _rod = createVNode("div", {
        "class": "w-slider-rod",
        "ref": rod,
        "style": rodPosition
      }, [createVNode(Tooltip, tooltipOptions.value, {
        trigger: () => createVNode("div", {
          "class": ["w-slider-for-tip", {
            "rod-in-dragging": dragging.value
          }],
          "onMousedown": startMousedown,
          "onMouseenter": () => {
            display.value = true;
          },
          "onMouseleave": () => {
            display.value = false;
          }
        }, null),
        default: () => tipContent.value
      })]);
      const progress = props2.fill && createVNode("div", {
        "class": "w-slider-progress",
        "style": progressSize
      }, null);
      const main = createVNode("div", sliderOptions.value, [progress, _rod]);
      const num = () => createVNode(Num, {
        "has-btn": false,
        "width": "45px",
        "max": props2.max,
        "min": props2.min,
        "step": props2.step,
        "modelValue": props2.modelValue,
        "onUpdate:modelValue": (v2, elem) => {
          inputValue.value = v2;
        },
        "onKeyup": (e) => {
          const v2 = parseFloat(e.target.value);
          if (!isNaN(v2) && v2 !== void 0 && e.key === "Enter") {
            e.target.blur();
          }
        },
        "onBlur": (e) => {
          const v2 = parseFloat(e.target.value);
          if (!isNaN(v2)) {
            if (validateInput(v2)) {
              showInvalidTip.value = false;
              setPositionByModelValue(v2);
              emit("update:modelValue", v2);
            } else {
              showInvalidTip.value = true;
            }
          }
        }
      }, null);
      if (props2.hasInput && (!x || !y)) {
        return createVNode("div", {
          "class": "w-slider-has-input"
        }, [main, createVNode(Tooltip, {
          "real-time": true,
          "manual": true,
          "placement": "top",
          "adjustPosition": "bottom",
          "show": showInvalidTip.value
        }, {
          trigger: num,
          default: () => props2.invalidateTip
        })]);
      } else {
        return main;
      }
    };
  }
});
var index$8 = /* @__PURE__ */ (() => ".w-slider-has-input{display:flex;align-items:center}.w-slider-has-input .w-slider.w-slider-x{flex:1;margin-right:var(--w-gap)}.w-slider.w-slider-x{--slider-width: auto;--slider-height: 8px;--slider-radius: calc(var(--slider-height) / 2);--slider-rod-size: calc(8px + var(--slider-height))}.w-slider.w-slider-y{--slider-width: 8px;--slider-height: 200px;--slider-radius: calc(var(--slider-width) / 2);--slider-rod-size: calc(8px + var(--slider-width))}.w-slider.w-slider-xy{--slider-width: 200px;--slider-height: 200px;--slider-radius: 0;--slider-rod-size: 7px}.w-slider{background:var(--w-color-font-5);height:var(--slider-height);border-radius:var(--slider-radius);position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--slider-width)}.w-slider .w-slider-progress{position:absolute;width:100%;height:100%;left:0;top:0;background-color:var(--w-color-primary-light-0);border-radius:var(--slider-radius)}.w-slider .w-slider-rod{width:var(--slider-rod-size);height:var(--slider-rod-size);position:absolute}.w-slider .w-slider-rod:active{cursor:-webkit-grabbing;cursor:grabbing}.w-slider .w-slider-rod .w-slider-for-tip{position:absolute;width:100%;height:100%;background-color:#fff;background-image:linear-gradient(135deg,white,var(--w-color-font-4));border-radius:100%;border:2px solid var(--w-color-primary-light-0);cursor:-webkit-grab;cursor:grab;transition:var(--w-transition-time)}.w-slider .w-slider-rod .w-slider-for-tip:hover,.w-slider .w-slider-rod .w-slider-for-tip.rod-in-dragging{transform:scale(1.2);box-shadow:0 1px 4px #0009}.w-slider.w-slider-xy .w-slider-rod .w-slider-for-tip{background-color:transparent;border:2px solid var(--w-color-font-4)}.w-slider.w-slider-x .w-slider-rod{left:0;top:calc((var(--slider-rod-size) - var(--slider-height)) / -2);transform:translate(-50%)}.w-slider.w-slider-y .w-slider-rod{top:0;left:calc((var(--slider-rod-size) - var(--slider-width)) / -2);transform:translateY(-50%)}\n")();
function isOn(v2) {
  return Number(v2) >= 1 || v2 === true;
}
function isInterceptProperty(prop) {
  return ["width", "height"].indexOf(prop) > -1;
}
var Switch = defineComponent({
  name: "Switch",
  inheritAttrs: false,
  props: {
    data: {
      type: Array,
      default: () => [0, 1]
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: 0
    },
    disabled: Boolean,
    readonly: Boolean,
    onColor: {
      type: [String, Array]
    },
    offColor: [String, Array],
    validateEvent: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props2, {
    emit,
    attrs,
    slots
  }) {
    const formItem = inject("formItem", void 0);
    const {
      item: value,
      toggle
    } = useToggleArray(props2.data, reactive({
      item: computed(() => props2.modelValue)
    }));
    const _isOn = computed(() => isOn(value.value));
    function toToggle() {
      toggle();
      const _v = value.value;
      emit("update:modelValue", _v);
      emit("change", _v);
      if (props2.validateEvent) {
        formItem == null ? void 0 : formItem.validate("change");
      }
    }
    const ps = computed(() => {
      let _sty = {};
      let {
        style,
        klass,
        ...rest
      } = attrs;
      let sty = style;
      if (sty) {
        for (const pr in sty) {
          if (isInterceptProperty(pr)) {
            _sty[`--__switch-${pr}`] = sty[pr];
          } else {
            _sty[pr] = sty[pr];
          }
        }
      }
      const o = {
        class: ["w-switch", {
          "w-switch--on": _isOn.value,
          "w-switch--disabled": props2.disabled
        }, klass],
        style: _sty,
        ...rest
      };
      if (props2.onColor) {
        if (typeof props2.onColor === "string") {
          o.style["--__on-color"] = props2.onColor;
        } else {
          o.style["--__on-color"] = props2.onColor[0];
          o.style["--__on-valve-color"] = props2.onColor[1];
        }
      }
      if (props2.offColor) {
        if (typeof props2.offColor === "string") {
          o.style["--__off-color"] = props2.offColor;
        } else {
          o.style["--__off-color"] = props2.offColor[0];
          o.style["--__off-valve-color"] = props2.offColor[1];
        }
      }
      if (!props2.disabled && !props2.readonly) {
        o.onClick = toToggle;
      }
      return o;
    });
    watch(() => props2.modelValue, (v2) => {
      value.value = v2;
    });
    return () => {
      var _a, _b;
      return createVNode("i", ps.value, [_isOn.value ? (_a = slots.on) == null ? void 0 : _a.call(slots) : (_b = slots.off) == null ? void 0 : _b.call(slots)]);
    };
  }
});
var index$7 = /* @__PURE__ */ (() => '.w-switch{--__width: var(--__switch-width, var(--w-switch-width));--__height: var(--__switch-height, var(--w-switch-height));--__on-color: var(--w-color-primary);--__off-color: var(--w-switch-bg-color);--__on-valve-color: var(--w-switch-valve-color);--__off-valve-color: var(--w-switch-valve-color);font-style:normal;display:inline-flex;align-items:center;justify-content:flex-start;padding:0 10px;position:relative;width:var(--__width);height:var(--__height);background-color:var(--__off-color);border-radius:calc(var(--__height) / 2);-webkit-user-select:none;-moz-user-select:none;user-select:none;transition:background-color var(--w-transition-time);cursor:default;color:#fff}.w-switch:after{--__valve-size: calc(var(--__height) - 2px);content:"";position:absolute;width:var(--__valve-size);height:var(--__valve-size);border-radius:100%;left:calc(var(--__width) - var(--__valve-size) - 1px);top:calc((var(--__height) - var(--__valve-size)) / 2);background-color:var(--__off-valve-color);box-shadow:var(--w-switch-valve-box-shadow);transition:left var(--w-transition-time)}.w-switch.w-switch--on{background-color:var(--__on-color);justify-content:flex-end}.w-switch.w-switch--on:after{border-color:var(--__on-color);left:1px;background-color:var(--__on-valve-color)}.w-switch.w-switch--disabled{opacity:.5;cursor:not-allowed}\n')();
const validate_hms = (hms) => {
  if (hms === void 0) {
    return true;
  } else {
    const len = hms.length;
    const [_h, _m, _s] = hms.split(":");
    if (len === 2 || len === 5 || len === 8) {
      const h2 = +_h;
      const isValidHour = h2 >= 0 && h2 < 24;
      if (len === 2) {
        return isValidHour;
      } else if (len === 5) {
        const m = +_m;
        return isValidHour && m >= 0 && m < 60;
      } else {
        const m = +_m;
        const s = +_s;
        return isValidHour && m >= 0 && m < 60 && s >= 0 && s < 60;
      }
    }
    return false;
  }
};
var TimePicker = defineComponent({
  name: "TimePicker",
  components: {
    Trigger,
    Layer,
    Dial
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    block: Boolean,
    placeholder: {
      type: [String, Object, Array],
      default: "\u8BF7\u9009\u62E9\u65F6\u95F4"
    },
    modelValue: {
      type: String,
      default: void 0,
      validator: validate_hms
    },
    format: {
      type: String,
      default: "HH:mm:ss"
    },
    validateEvent: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:show", "update:modelValue"],
  setup(props2, {
    slots,
    emit
  }) {
    const formItem = inject("formItem", void 0);
    const visible = ref(props2.show);
    const text = computed(() => {
      return props2.modelValue || "";
    });
    const layerOptions = computed(() => {
      return {
        immediate: true,
        show: visible.value,
        disabled: props2.disabled,
        placement: "bottom-start",
        gap: 2,
        hasArrow: false,
        transitionName: "w-slide-y",
        layerClass: "w-time-picker",
        "onUpdate:show": (b) => {
          visible.value = b;
        }
      };
    });
    function clear() {
      emit("update:modelValue", void 0);
      if (props2.validateEvent) {
        formItem == null ? void 0 : formItem.validate("change");
      }
    }
    function renderTrigger() {
      const triggerOptions = {
        placeholder: props2.placeholder,
        disabled: props2.disabled,
        block: props2.block,
        clearable: props2.clearable,
        text: text.value,
        active: visible.value,
        onClear: () => {
          clear();
        }
      };
      return createVNode(Trigger, triggerOptions, null);
    }
    function renderContent() {
      return createVNode(Dial, {
        "format": props2.format,
        "value": props2.modelValue,
        "onChange": (v2) => {
          emit("update:modelValue", v2);
          if (props2.validateEvent) {
            formItem == null ? void 0 : formItem.validate("change");
          }
        }
      }, null);
    }
    watch(() => props2.show, (b) => {
      visible.value = b;
    });
    watch(visible, (b) => {
      emit("update:show", b);
    });
    return () => createVNode(Layer, layerOptions.value, {
      trigger: renderTrigger,
      default: renderContent
    });
  }
});
var index$6 = /* @__PURE__ */ (() => ".w-time-picker{padding:var(--w-gap);padding-top:4px;width:var(--w-time-picker-panel-width);height:var(--w-time-picker-panel-height);--__width: calc(var(--w-time-picker-panel-width) - var(--w-gap) * 2)}\n")();
const TreeProps = {
  data: {
    type: Array,
    default: () => []
  },
  node: {
    type: Array,
    default: () => []
  },
  itemHeight: {
    type: [String, Number],
    default: "30"
  },
  childName: {
    type: String,
    default: "childs"
  },
  keyField: {
    type: String,
    default: "Id"
  },
  textField: {
    type: String,
    default: "Name"
  },
  parentField: {
    type: String,
    default: "atpid"
  },
  levelField: {
    type: String,
    default: "Levels"
  },
  indentedWidth: {
    type: [String, Number],
    default: "15"
  },
  hasCheckbox: {
    type: Boolean,
    default: true
  },
  rows: {
    type: Array,
    default: () => []
  },
  keys: {
    type: Array,
    default: () => []
  },
  allKeys: {
    type: Array,
    default: () => []
  },
  parentData: {
    type: Object,
    default: null
  }
};
const TreeEmits = ["update:modelValue", "update:allKeys", "update:keys", "update:rows", "getChildsDatas", "updateParentMethod"];
var Tree = defineComponent({
  inheritAttrs: false,
  props: TreeProps,
  emits: TreeEmits,
  setup(props2, ctx) {
    const parentData = computed(() => {
      return props2.parentData;
    });
    const allKeys = ref([]);
    const comAllKeys = computed(() => {
      if (props2.parentData) {
        return props2.allKeys;
      } else {
        return allKeys.value;
      }
    });
    watch(() => comAllKeys.value, (v2) => {
      ctx.emit("update:keys", v2);
    });
    const rowsArr = ref([]);
    function getRow(data) {
      data.forEach((it) => {
        if (it[props2.keyField]) {
          if (comAllKeys.value.includes(it[props2.keyField])) {
            let t = JSON.parse(JSON.stringify(it));
            delete t[props2.childName];
            rowsArr.value.push(t);
          }
        }
        if (it[props2.childName]) {
          getRow(it[props2.childName]);
        }
      });
      return rowsArr.value;
    }
    watch(() => props2.keys, (v2) => {
      if (v2) {
        if (props2.data) {
          rowsArr.value = [];
          let arr = getRow(props2.data);
          ctx.emit("update:rows", arr);
        }
      }
    }, {
      deep: true
    });
    const refChild = ref({});
    const comData = computed(() => {
      return props2.node.length ? props2.node : props2.data;
    });
    ctx.expose({
      checkedChildByParent
    });
    function handlerAllkeys(v2) {
      if (props2.parentData) {
        ctx.emit("update:allKeys", v2);
      } else {
        allKeys.value = v2;
      }
    }
    function onUnFoldOrFold(curItem) {
      curItem.isOpen = !curItem.isOpen;
      curItem.checked = goSelectedByPropsKeys(curItem);
      if (curItem.isOpen) {
        if (!curItem.childs) {
          curItem.childs = [];
          ctx.emit("getChildsDatas", curItem, (itemWidthChilds) => {
            checkedChildByParent(itemWidthChilds);
          });
        } else {
          checkedChildByParent(curItem);
        }
      }
    }
    function goSelectedByPropsKeys(curItem) {
      if (comAllKeys.value.filter((item) => item == curItem[props2.keyField]).length) {
        return true;
      } else {
        return false;
      }
    }
    function checkedChildByParent(parentItem) {
      console.log(parentItem, props2.parentData);
      ({
        ...refChild.value
      });
      let allkeysArr = [];
      allkeysArr = allkeysArr.concat(comAllKeys.value);
      let keysArr = [];
      let rowsArr2 = [];
      keysArr = keysArr.concat(props2.keys);
      rowsArr2 = rowsArr2.concat(props2.rows);
      if (parentItem.checked) {
        !~allkeysArr.indexOf(parentItem[props2.keyField]) && allkeysArr.push(parentItem[props2.keyField]);
        if (props2.parentData) {
          let len = props2.parentData.childs.filter((v2) => v2.checked).length;
          if (!allkeysArr.includes(props2.parentData[props2.keyField])) {
            if (len === props2.parentData.childs.length) {
              allkeysArr.push(props2.parentData[props2.keyField]);
              parentData.value.checked = true;
            }
          }
        }
      } else {
        if (props2.parentData) {
          let j = allkeysArr.indexOf(props2.parentData[props2.parentField]);
          if (j > -1) {
            allkeysArr.splice(j, 1);
            parentData.value.checked = false;
          }
          let i = allkeysArr.indexOf(props2.parentData[props2.keyField]);
          if (i > -1) {
            allkeysArr.splice(i, 1);
          }
        }
        let allkeysArrIndex = allkeysArr.indexOf(parentItem[props2.keyField]);
        if (allkeysArrIndex != -1) {
          allkeysArr.splice(allkeysArrIndex, 1);
        }
      }
      if (parentItem.childs && parentItem.childs.length) {
        if (parentItem.checked) {
          let getId = function(data) {
            data.forEach((item) => {
              if (allkeysArr.indexOf(item[props2.keyField]) === -1) {
                item.checked = true;
                allkeysArr.push(item[props2.keyField]);
              }
              if (item.childs) {
                getId(item.childs);
              }
            });
          };
          getId(parentItem.childs);
        } else {
          let deleteId = function(data) {
            data.forEach((item) => {
              let allKeyindex = allkeysArr.indexOf(item[props2.keyField]);
              if (allKeyindex != -1) {
                allkeysArr.splice(allKeyindex, 1);
                if (item.childs) {
                  deleteId(item.childs);
                }
              }
            });
          };
          deleteId(parentItem.childs);
        }
      }
      handlerAllkeys(allkeysArr);
    }
    function isCheckParentByChild(childItem) {
      if (!props2.parentData) {
        return;
      }
      let allkeysArr = [];
      allkeysArr = allkeysArr.concat(comAllKeys.value);
      let keysArr = [];
      keysArr = keysArr.concat(props2.keys);
      let rowsArr2 = [];
      rowsArr2 = rowsArr2.concat(props2.rows);
      childItem.checked = goSelectedByPropsKeys(childItem);
      if (childItem.checked) {
        let allBrotherChecked = props2.parentData.childs.every((item) => goSelectedByPropsKeys(item));
        if (allBrotherChecked) {
          props2.parentData.checked = true;
          !~allkeysArr.indexOf(props2.parentData[props2.keyField]) && allkeysArr.push(props2.parentData[props2.keyField]);
          !~keysArr.indexOf(props2.parentData[props2.keyField]) && keysArr.push(props2.parentData[props2.keyField]);
          !~rowsArr2.indexOf(props2.parentData[props2.textField]) && rowsArr2.push(props2.parentData[props2.textField]);
          props2.parentData.childs.forEach((item) => {
            let keyIndex = keysArr.indexOf(item[props2.keyField]);
            if (keyIndex === -1) {
              keysArr.splice(keyIndex, 1);
              rowsArr2.splice(keyIndex, 1);
            }
          });
        }
      } else {
        let allkeysArrIndex = allkeysArr.indexOf(props2.parentData[props2.keyField]);
        if (allkeysArrIndex != -1) {
          allkeysArr.splice(allkeysArrIndex, 1);
        }
        let keyIndex = keysArr.indexOf(props2.parentData[props2.keyField]);
        if (keyIndex != -1) {
          keysArr.splice(keyIndex, 1);
          rowsArr2.splice(keyIndex, 1);
        }
        props2.parentData.childs.forEach((item) => {
          if (item.checked = goSelectedByPropsKeys(item)) {
            let index2 = keysArr.indexOf(item[props2.keyField]);
            if (index2 == -1) {
              keysArr.push(item[props2.keyField]);
              rowsArr2.push(item[props2.textField]);
            }
          }
        });
      }
      handlerAllkeys(allkeysArr);
      setTimeout(() => {
        ctx.emit("updateParentMethod", props2.parentData);
      });
    }
    function renderCheckbox(item) {
      const checkboxOptions = {
        value: item[props2.keyField],
        modelValue: comAllKeys.value,
        "onUpdate:modelValue": (v2) => {
          function getId(data) {
            data.forEach((item2) => {
              if (v2.indexOf(item2[props2.keyField]) > -1) {
                item2.checked = true;
              } else {
                item2.checked = false;
              }
              if (item2.childs) {
                getId(item2.childs);
              }
            });
          }
          getId(comData.value);
          handlerAllkeys(v2);
        },
        onChange: (b) => {
          item.checked = b;
          checkedChildByParent(item);
        },
        onClick: (e) => {
          e.stopPropagation();
          e.preventDefault();
        }
      };
      return createVNode(Checkbox, checkboxOptions, null);
    }
    return () => {
      return createVNode("ul", {
        "class": "w-tree",
        "style": [{
          "padding-left": props2.parentData ? props2.indentedWidth + "px" : "0px"
        }]
      }, [comData.value.map((item) => {
        return createVNode("li", {
          "class": "w-tree-item",
          "style": [{
            "line-height": props2.itemHeight + "px"
          }],
          "onClick": withModifiers(() => {
            onUnFoldOrFold(item);
          }, ["stop"])
        }, [createVNode("span", {
          "class": [{
            unfold: item.isOpen
          }, "iconfont-linkd w-icon-sort-down"]
        }, null), props2.hasCheckbox ? renderCheckbox(item) : null, createVNode("span", {
          "class": "con"
        }, [createTextVNode(" "), item[props2.textField]]), item.isOpen && item.childs && item.childs.length ? createVNode(Tree, {
          "ref": refChild,
          "hasCheckbox": props2.hasCheckbox,
          "indentedWidth": props2.indentedWidth,
          "itemHeight": props2.itemHeight,
          "allKeys": comAllKeys.value,
          "keys": props2.keys,
          "rows": props2.rows,
          "onUpdateParentMethod": (v2) => {
            isCheckParentByChild(v2);
          },
          "onUpdate:allKeys": (v2) => {
            handlerAllkeys(v2);
          },
          "onUpdate:keys": (v2) => {
            ctx.emit("update:keys", v2);
          },
          "onUpdate:rows": (v2) => {
          },
          "onGetChildsDatas": (parentNode, callback) => {
            ctx.emit("getChildsDatas", parentNode, (itemWidthChilds) => {
              checkedChildByParent(itemWidthChilds);
            });
          },
          "key-field": props2.keyField,
          "textField": props2.textField,
          "levelField": props2.levelField,
          "parentData": item,
          "node": item.childs
        }, null) : null]);
      })]);
    };
  }
});
var index$5 = /* @__PURE__ */ (() => ".w-tree{list-style:none;padding-left:10px}.w-tree .w-tree-item .w-icon-sort-down{margin-right:4px;color:#c7c0c0}.w-tree .w-tree-item .unfold{display:inline-block;transform:rotate(-90deg)}.w-tree .w-tree-item .w-icon-sort-down:hover{color:#666}\n")();
var Steps = defineComponent({
  name: "Steps",
  props: {
    active: {
      type: Number
    },
    activeColor: {
      type: String,
      default: "#000"
    },
    color: {
      type: String,
      default: "#909399"
    },
    space: {
      type: String
    },
    direction: {
      type: String,
      value: ["horizontal", "vertical"],
      default: "horizontal"
    }
  },
  setup(props2, ctx) {
    const uidList = ref([]);
    function getUid(id) {
      if (!uidList.value.includes(id)) {
        uidList.value.push(id);
      }
    }
    const uid = ref();
    watch(() => props2.active, (v2) => {
      if (v2) {
        uidList.value = Array.from(new Set(uidList.value)).sort((a, b) => a - b);
        uid.value = uidList.value[v2];
      }
    }, {
      immediate: true
    });
    onUpdated(() => {
      uidList.value = [];
    });
    const actives = computed(() => {
      return props2.active;
    });
    provide("getUid", getUid);
    provide("_props", reactive({
      ...toRefs(props2),
      uid,
      uidList,
      actives
    }));
    return () => {
      var _a, _b;
      return createVNode("div", {
        "class": props2.direction === "horizontal" ? "w-steps" : "w-steps-vertical"
      }, [" ", (_b = (_a = ctx.slots).default) == null ? void 0 : _b.call(_a)]);
    };
  }
});
var index$4 = /* @__PURE__ */ (() => ".w-steps{width:100%;display:flex}.w-steps-vertical{height:100%;display:flex;flex-direction:column}\n")();
var Step = defineComponent({
  name: "Step",
  props: {
    title: {
      type: String
    },
    icon: {
      type: String
    },
    width: {
      type: String
    },
    height: {
      type: String
    }
  },
  component: {
    Icon: Icon$1
  },
  setup(props2, ctx) {
    const getUid = inject("getUid");
    const _props2 = inject("_props");
    const index2 = computed(() => {
      var _a;
      if (getCurrentInstance()) {
        let uid = (_a = getCurrentInstance()) == null ? void 0 : _a.uid;
        getUid(uid);
        return _props2.uidList.indexOf(uid) + 1;
      }
    });
    const space = computed(() => {
      if (_props2.uidList) {
        if (_props2.space) {
          return _props2.space;
        } else {
          return (100 / (_props2.uidList.length - 1)).toFixed(2) + "%";
        }
      }
    });
    const color = computed(() => {
      if (index2.value <= _props2.actives) {
        return _props2.activeColor;
      } else {
        return _props2.color;
      }
    });
    const backgroundColor = computed(() => {
      if (_props2.actives > index2.value) {
        return _props2.activeColor;
      } else {
        return _props2.color;
      }
    });
    const style = computed(() => {
      if (index2.value !== _props2.uidList.length) {
        return {
          "flex-basis": space.value,
          "flex-shrink": 1
        };
      } else {
        if (_props2.direction === "horizontal") {
          return {
            "flex-basis": "auto",
            "flex-shrink": 1,
            "max-width": (100 / _props2.uidList.length).toFixed(2) + "%"
          };
        } else {
          return {
            "flex-basis": "auto",
            "flex-shrink": 1,
            "flex-grow": 0
          };
        }
      }
    });
    return () => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
      return createVNode(Fragment, null, [_props2.direction === "horizontal" ? createVNode("div", {
        "class": "w-step",
        "style": style.value
      }, [createVNode("div", {
        "class": "w-step-line-box"
      }, [_props2.uidList.length !== index2.value ? createVNode("div", {
        "class": "w-step-line",
        "style": {
          backgroundColor: backgroundColor.value
        }
      }, null) : "", createVNode("div", {
        "class": "w-step-line-text",
        "style": {
          width: props2.width ? props2.width : props2.icon ? "40px" : ""
        }
      }, [createVNode("div", {
        "class": [props2.icon ? "is-icon" : ((_b = (_a = ctx.slots).icon) == null ? void 0 : _b.call(_a)) ? "" : "is-text", , "w-step-line-icon"],
        "style": {
          color: color.value
        }
      }, [((_d = (_c = ctx.slots).icon) == null ? void 0 : _d.call(_c)) ? (_f = (_e = ctx.slots).icon) == null ? void 0 : _f.call(_e) : props2.icon ? createVNode(Icon$1, {
        "name": props2.icon,
        "style": {
          color: color.value,
          "font-size": "24px"
        }
      }, null) : index2.value <= _props2.actives ? ctx.slots.complete ? (_h = (_g = ctx.slots).complete) == null ? void 0 : _h.call(_g) : createVNode(Icon$1, {
        "style": {
          color: color.value,
          "font-size": "18px"
        },
        "name": "w-icon-duihao"
      }, null) : index2.value])])]), createVNode("div", {
        "class": "w-step-title",
        "style": {
          color: color.value
        }
      }, [((_j = (_i = ctx.slots).title) == null ? void 0 : _j.call(_i)) || props2.title])]) : createVNode("div", {
        "class": "w-step w-step-vertical",
        "style": style.value
      }, [createVNode("div", {
        "class": "w-step-line-vertical-box"
      }, [_props2.uidList.length !== index2.value ? createVNode("div", {
        "class": "w-step-vertical-line",
        "style": {
          backgroundColor: backgroundColor.value
        }
      }, null) : "", createVNode("div", {
        "class": "w-step-line-text",
        "style": {
          height: ((_l = (_k = ctx.slots).icon) == null ? void 0 : _l.call(_k)) || props2.height ? props2.height : props2.icon ? "40px" : ""
        }
      }, [createVNode("div", {
        "class": [props2.icon ? "is-icon" : ((_n = (_m = ctx.slots).icon) == null ? void 0 : _n.call(_m)) ? "" : "is-text", "w-step-line-icon"],
        "style": {
          color: color.value,
          height: "100%"
        }
      }, [((_p = (_o = ctx.slots).icon) == null ? void 0 : _p.call(_o)) || props2.icon ? createVNode(Icon$1, {
        "name": props2.icon,
        "style": {
          color: color.value,
          "font-size": "24px"
        }
      }, null) : index2.value <= _props2.actives ? createVNode(Icon$1, {
        "style": {
          color: color.value,
          "font-size": "18px"
        },
        "name": "w-icon-duihao"
      }, null) : index2.value])])]), createVNode("div", {
        "class": "w-step-title",
        "style": {
          color: color.value
        }
      }, [((_r = (_q = ctx.slots).title) == null ? void 0 : _r.call(_q)) || props2.title])])]);
    };
  }
});
var index$3 = /* @__PURE__ */ (() => ".w-step{flex-shrink:0}.w-step .w-step-line-box,.w-step .w-step-line-vertical-box{width:100%;position:relative}.w-step .w-step-line-box .w-step-line,.w-step .w-step-line-vertical-box .w-step-line{position:absolute;height:2px;top:11px;left:0;right:0}.w-step .w-step-line-box .w-step-line-text,.w-step .w-step-line-vertical-box .w-step-line-text{width:24px;height:24px;position:relative;z-index:1;background-color:#fff}.w-step .w-step-line-box .w-step-line-text .w-step-line-icon,.w-step .w-step-line-vertical-box .w-step-line-text .w-step-line-icon{z-index:1;display:inline-flex;justify-content:center;align-items:center;width:100%;height:24px;font-size:14px;box-sizing:border-box;transition:.15}.w-step .w-step-line-box .w-step-line-text .is-text,.w-step .w-step-line-vertical-box .w-step-line-text .is-text{border-radius:50%;border:2px solid;border-color:inherit}.w-step .w-step-title{width:100%;font-size:16px;line-height:38px;word-wrap:break-word}.w-step-vertical{display:flex}.w-step-vertical .w-step-line-vertical-box{width:auto;height:100%;display:flex;position:relative;flex-grow:0}.w-step-vertical .w-step-line-vertical-box .w-step-vertical-line{position:absolute;width:2px;top:0;bottom:0;left:11px}.w-step-vertical .w-step-title{overflow:hidden;line-height:24px;padding-left:10px;flex-grow:1}\n")();
var BtnGroup = defineComponent({
  name: "BtnGroup",
  props: {
    type: {
      type: String,
      default: "primary"
    }
  },
  setup(props2, ctx) {
    provide("BtnGroupKey", reactive({
      type: toRef(props2, "type")
    }));
    return () => {
      var _a, _b;
      return createVNode("div", {
        "class": "w-btn-group"
      }, [(_b = (_a = ctx.slots).default) == null ? void 0 : _b.call(_a)]);
    };
  }
});
var index$2 = /* @__PURE__ */ (() => ".w-btn-group{display:inline-block;vertical-align:middle}.w-btn-group .w-btn-primary:first-child{border-right-color:#ffffff80;border-top-right-radius:0;border-bottom-right-radius:0}.w-btn-group .w-btn-primary:not(:first-child):not(:last-child){border-left-color:var(--w-button-divide-border-color);border-right-color:var(--w-button-divide-border-color);border-radius:0}.w-btn-group .w-btn-primary:last-child{border:1px solid transparent;border-left-color:var(--w-button-divide-border-color);border-top-left-radius:0;border-bottom-left-radius:0}.w-btn-group .w-btn:not(:last-child){border:1px solid transparent;margin-right:-1px}\n")();
var VTree = defineComponent({
  name: "selectTree",
  props: {
    ...LayerProps,
    data: {
      type: Array,
      default: () => []
    },
    node: {
      type: Array,
      default: () => []
    },
    itemHeight: {
      type: Number,
      default: 30
    },
    childName: {
      type: String,
      default: "childs"
    },
    keyField: {
      type: String,
      default: "Id"
    },
    textField: {
      type: String,
      default: "Name"
    },
    parentField: {
      type: String,
      default: "atpid"
    },
    levelField: {
      type: String,
      default: "Levels"
    },
    indentedWidth: {
      type: Number,
      default: 15
    },
    hasCheckbox: {
      type: Boolean,
      default: true
    },
    row: {
      type: Object,
      default: () => []
    },
    key: {
      type: String,
      default: ""
    },
    rows: {
      type: Array,
      default: () => []
    },
    keys: {
      type: Array,
      default: () => []
    },
    allKeys: {
      type: Array,
      default: () => []
    },
    parentData: {
      type: Object,
      default: null
    },
    lazy: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 0
    },
    separator: {
      type: String,
      default: "-"
    },
    disabled: Boolean,
    block: Boolean,
    clearable: Boolean,
    placeholder: {
      type: String,
      default: "\u8BF7\u9009\u62E9"
    },
    textPlaceholder: {
      type: String,
      default: "\u8BF7\u9009\u62E9"
    },
    show: {
      type: Boolean,
      default: false
    },
    listHeight: {
      type: String,
      default: "300px"
    },
    tagsTooltip: Boolean
  },
  emits: ["update:modelValue", "update:allKeys", "update:keys", "update:rows", "update:key", "update:row", "getChildsDatas", "updateParentMethod", "update:show"],
  components: {
    Checkbox,
    Icon: Icon$1,
    Virtual,
    Layer,
    Close,
    List,
    Tooltip
  },
  setup(props2, ctx) {
    const allKey = ref();
    const loading2 = ref(false);
    const currentId = ref();
    const visible = ref(props2.show);
    onMounted(() => {
      if (!props2.keys.length && props2.rows.length) {
        let key2 = [];
        let rows = props2.rows.forEach((it) => {
          key2.push(it[props2.keyField]);
          it.isOpen = false;
          it.isChild = false;
          it.disabled = false;
          it.checked = true;
        });
        allKey.value = key2;
        ctx.emit("update:keys", key2);
        ctx.emit("update:rows", rows);
      }
    });
    function treeToArray(tree) {
      return tree.reduce((res, item) => {
        const children = item[props2.childName];
        if (children && children.length) {
          item.isChild = true;
        } else {
          item.isChild = false;
        }
        delete item[props2.childName];
        const {
          ...i
        } = item;
        return res.concat(i, children && children.length ? treeToArray(children) : []);
      }, []);
    }
    const allData = ref();
    const saveChildrenData = ref();
    watch(() => props2.data, (v2) => {
      if (v2 && v2.length) {
        allData.value = treeToArray(props2.data).map((item) => {
          if (!item.isOpen) {
            item.isOpen = false;
          }
          if (!item.checked) {
            item.checked = false;
          }
          return item;
        });
        saveChildrenData.value = {
          p: JSON.parse(JSON.stringify(allData.value))
        };
      }
    }, {
      deep: true,
      immediate: true
    });
    watch(() => props2.keys, (v2) => {
      if (v2 && v2.length) {
        let rows = [];
        let saveChildrenDatas = JSON.parse(JSON.stringify(saveChildrenData.value));
        for (const key2 in saveChildrenDatas) {
          saveChildrenDatas[key2].forEach((item, index2) => {
            if (v2.includes(item[props2.keyField])) {
              saveChildrenData.value[key2][index2].checked = true;
              rows.push(item);
            } else {
              saveChildrenData.value[key2][index2].checked = false;
            }
          });
        }
        ctx.emit("update:rows", [...rows]);
      } else {
        ctx.emit("update:rows", []);
      }
    }, {
      deep: true,
      immediate: true
    });
    function dealSelect(v2, item) {
      for (const key2 in saveChildrenData.value) {
        saveChildrenData.value[key2].forEach((it) => {
          if (it.Wid && allKey.value.includes(it.Wid)) {
            if (item[props2.keyField] === it.Wid) {
              if (allKey.value) {
                if (v2) {
                  let i = allKey.value.indexOf(it[props2.keyField]);
                  if (i > -1) {
                    allKey.value.splice(i, 1);
                  }
                } else {
                  let i = allKey.value.indexOf(it[props2.keyField]);
                  if (i === -1) {
                    allKey.value.push(it[props2.keyField]);
                  }
                }
              }
            }
          }
        });
      }
    }
    function recursion(id, parentField) {
      let arr = [];
      for (const key2 in saveChildrenData.value) {
        saveChildrenData.value[key2].forEach((item) => {
          arr.push(item);
        });
      }
      let childrenId = arr.filter((it) => it[props2.parentField] === parentField);
      if (childrenId && childrenId.length) {
        let childrenIds = childrenId.map((it) => it[props2.keyField]);
        let existence = allKey.value.filter((it) => childrenIds.includes(it));
        if (!allKey.value.includes(parentField)) {
          if (childrenIds.length === existence.length) {
            allKey.value.push(parentField);
          }
        } else {
          let i = allKey.value.indexOf(parentField);
          if (childrenIds.length !== existence.length) {
            allKey.value.splice(i, 1);
          }
        }
      }
      let parent = arr.filter((it) => it[props2.keyField] === parentField);
      if (parent && parent.length) {
        recursion(parentField, parent[0][props2.parentField]);
      }
    }
    function recursion2(id) {
      let arr = [];
      for (const key2 in saveChildrenData.value) {
        saveChildrenData.value[key2].forEach((item) => {
          arr.push(item);
        });
      }
      let childrenId = arr.filter((it) => it[props2.parentField] === id);
      if (childrenId && childrenId.length) {
        let childrenIds = childrenId.map((it) => it[props2.keyField]);
        allKey.value = allKey.value.filter((it) => !childrenIds.includes(it));
        childrenId.forEach((it) => {
          if (it.isChild) {
            recursion2(it[props2.keyField]);
          }
        });
      }
    }
    function childrenData(item, v2) {
      if (v2) {
        if (item.isChild) {
          allData.value = allData.value.map((it, index2) => {
            if (item[props2.keyField] === it[props2.parentField]) {
              if (!allKey.value.includes(it[props2.keyField])) {
                it.checked = true;
                allKey.value.push(it[props2.keyField]);
                return it;
              }
            }
            return it;
          });
        }
        dealSelect(false, item);
      } else {
        if (item.isChild) {
          allData.value.forEach((it, index2) => {
            if (item[props2.keyField] === it[props2.parentField]) {
              if (allKey.value) {
                let i = allKey.value.indexOf(it[props2.keyField]);
                if (i > -1) {
                  allData.value[index2].checked = false;
                  allKey.value.splice(i, 1);
                }
              }
            }
          });
          dealSelect(true, item);
        }
        if (item[props2.parentField]) {
          let i = allKey.value.indexOf(item[props2.parentField]);
          if (i > -1) {
            allData.value[i].checked = false;
            allKey.value.splice(i, 1);
          }
        }
        let j = allKey.value.indexOf(item[props2.keyField]);
        if (j > -1) {
          allKey.value.splice(j, 1);
        }
        recursion2(item[props2.keyField]);
      }
      allData.value.filter((item2) => item2.checked).map((item2) => item2[props2.keyField]);
      ctx.emit("update:keys", allKey.value || []);
    }
    function renderCheckbox(item, index2) {
      const checkboxOptions = {
        value: item[props2.keyField],
        modelValue: props2.keys,
        disabled: item.disabled,
        "onUpdate:modelValue": (v2) => {
          allKey.value = v2;
        },
        onChange: (b) => {
          allData.value = allData.value.map((v2) => {
            if (v2[props2.keyField] === item[props2.keyField]) {
              v2.checked = b;
            }
            return v2;
          });
          childrenData(item, b);
          recursion(item[props2.keyField], item[props2.parentField]);
        },
        onClick: (e) => {
          e.stopPropagation();
          e.preventDefault();
        }
      };
      return createVNode(Checkbox, checkboxOptions, null);
    }
    ref([]);
    const textValue = ref("");
    function radioChange(it) {
      if (!it.isChild) {
        let name = function(id) {
          let p;
          for (const key2 in saveChildrenData.value) {
            saveChildrenData.value[key2].forEach((item) => {
              if (item[props2.keyField] === id) {
                row.push(item);
                text.push(item[props2.keyField]);
                p = item[props2.parentField];
              }
            });
          }
          if (p) {
            name(p);
          }
        };
        let row = [];
        let text = [];
        name(it[props2.keyField]);
        ctx.emit("update:key", text.reverse().join(props2.separator));
        ctx.emit("update:row", row.reverse());
      }
    }
    watch(() => props2.row, (v2) => {
      if (v2 && v2.length) {
        console.log(v2, ";;;");
        textValue.value = v2.map((p) => {
          return p[props2.textField];
        }).join(props2.separator);
      }
    }, {
      immediate: true
    });
    const selectKey = ref("");
    watch(() => props2.key, (v2) => {
      console.log(v2, "vvvv");
      selectKey.value = v2;
    });
    function clickItem(item) {
      let index2 = allData.value.map((it) => it[props2.keyField]).indexOf(item[props2.keyField]);
      allData.value[index2].isOpen = !allData.value[index2].isOpen;
      if (allData.value[index2].isOpen) {
        if (!saveChildrenData.value || !Object.keys(saveChildrenData.value).includes(item[props2.keyField]) && props2.lazy) {
          if (props2.level) {
            if (props2.level < item[props2.levelField]) {
              return;
            }
          }
          loading2.value = true;
          return ctx.emit("getChildsDatas", item, (v2) => {
            if (v2) {
              let Wid = item.Wid || item[props2.keyField];
              v2 = v2.map((it) => {
                it.Wid = Wid;
                it.isChild = false;
                it.isOpen = false;
                it.disabled = it.disabled ? it.disabled : item.disabled;
                return it;
              });
              item.isChild = true;
              allData.value[index2].isChild = true;
              for (const key2 in saveChildrenData.value) {
                saveChildrenData.value[key2].forEach((v3, j) => {
                  if (v3[props2.keyField] == item[props2.keyField]) {
                    saveChildrenData.value[key2][j].isChild = true;
                  }
                });
              }
              saveChildrenData.value[item[props2.keyField]] = v2;
              allData.value.splice(index2 + 1, 0, ...v2);
            } else {
              item.isChild = false;
              allData.value[index2].isChild = false;
            }
            if (allKey.value && allKey.value.includes(item[props2.keyField])) {
              childrenData(item, allKey.value.includes(item[props2.keyField]));
            }
            loading2.value = false;
          });
        } else {
          if (saveChildrenData.value[item[props2.keyField]]) {
            let arr = saveChildrenData.value[item[props2.keyField]].map((v2) => {
              v2.isOpen = false;
              return v2;
            });
            allData.value.splice(index2 + 1, 0, ...arr);
          }
          if (allKey.value && allKey.value.includes(item[props2.keyField])) {
            return childrenData(item, allKey.value.includes(item[props2.keyField]));
          }
        }
      } else {
        allData.value = allData.value.filter((v2) => {
          if (item[props2.keyField] !== v2[props2.parentField] && item[props2.keyField] !== v2.Wid) {
            return v2;
          }
        });
        return;
      }
    }
    function innerTree({
      data: visibleData,
      index: {
        from,
        to
      },
      scrollTo
    }) {
      if (!visibleData || !visibleData.length) {
        return null;
      }
      return visibleData.map((item, index2) => {
        return createVNode("li", {
          "key": item[props2.keyField],
          "style": [{
            "line-height": props2.itemHeight + "px",
            "padding-left": (item[props2.levelField] - 2) * props2.indentedWidth + "px"
          }]
        }, [props2.level >= item[props2.levelField] ? loading2.value && currentId.value === item[props2.keyField] ? createVNode("div", {
          "class": "w-tree-loading"
        }, null) : createVNode("span", {
          "name": loading2.value && currentId.value === item[props2.keyField] ? "w-icon-loading" : "w-icon-sort-down",
          "onClick": (e) => {
            clickItem(JSON.parse(JSON.stringify(item)));
            currentId.value = item[props2.keyField];
            e.stopPropagation();
            e.preventDefault();
          },
          "class": [{
            unfold: item.isOpen
          }, "iconfont-linkd w-icon-sort-down"]
        }, null) : "", props2.hasCheckbox ? renderCheckbox(item) : null, createVNode("span", {
          "class": props2.key.split(props2.separator).includes(item[props2.keyField]) ? "con w-tree-text w-tree-text-active" : "con w-tree-text",
          "onClick": (e) => {
            if (!props2.hasCheckbox) {
              radioChange(item);
            }
            e.stopPropagation();
            e.preventDefault();
          }
        }, [item[props2.textField]])]);
      });
    }
    const key = ref(0);
    const layerOptions = computed(() => {
      return {
        show: visible.value,
        disabled: props2.disabled,
        placement: "bottom-start",
        hasArrow: false,
        bind: "v-show",
        transitionName: "w-slide-y",
        "onUpdate:show": (b) => {
          visible.value = b;
          key.value++;
          ctx.emit("update:show", b);
        }
      };
    });
    const placeholderText = computed(() => {
      const rows = props2.rows;
      if (rows && rows.length && props2.hasCheckbox) {
        if (!props2.tagsTooltip) {
          return rows.map((it) => {
            return createVNode("span", {
              "class": "w-tag",
              "onClick": (e) => {
                e.stopPropagation();
                e.preventDefault();
              }
            }, [it[props2.textField], createVNode(Close, {
              "name": "w-icon-close-fill",
              "size": "12px",
              "style": "padding-left:5px",
              "onClick": (e) => {
                let keys2 = JSON.parse(JSON.stringify(props2.keys));
                JSON.parse(JSON.stringify(props2.rows));
                let index2 = keys2.indexOf(it[props2.keyField]);
                if (index2 > -1) {
                  keys2.splice(index2, 1);
                }
                e.stopPropagation();
              }
            }, null)]);
          });
        } else {
          let tip = rows.slice(1, rows.length).map((it) => {
            return createVNode("span", {
              "class": "w-tag",
              "onClick": (e) => {
                e.stopPropagation();
                e.preventDefault();
              }
            }, [it[props2.textField], createVNode(Close, {
              "name": "w-icon-close-fill",
              "size": "12px",
              "style": "padding-left:5px",
              "onClick": (e) => {
                allData.value = allData.value.map((v2) => {
                  if (v2[props2.keyField] === it[props2.keyField]) {
                    v2.checked = false;
                  }
                  return v2;
                });
                childrenData(it, false);
                recursion(it[props2.keyField], it[props2.parentField]);
                e.stopPropagation();
                e.preventDefault();
              }
            }, null)]);
          });
          let slot = {
            trigger: () => {
              return rows.length - 1 ? createVNode("span", {
                "class": "w-tag",
                "onClick": (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }
              }, [rows.length - 1, "+"]) : null;
            },
            default: () => {
              return rows.length - 1 ? createVNode("div", {
                "class": "w-tag-tip"
              }, [createVNode("div", null, [createTextVNode(" "), tip])]) : null;
            }
          };
          return createVNode(Fragment, null, [createVNode("span", {
            "class": "w-tag",
            "onClick": (e) => {
              e.stopPropagation();
              e.preventDefault();
            }
          }, [rows[0][props2.textField], createVNode(Close, {
            "name": "w-icon-close-fill",
            "size": "12px",
            "style": "padding-left:5px",
            "onClick": (e) => {
              let keys2 = JSON.parse(JSON.stringify(props2.keys));
              JSON.parse(JSON.stringify(props2.rows));
              let index2 = keys2.indexOf(v[0][props2.keyField]);
              let it = v[0];
              if (index2 > -1 && !it.isChild) {
                keys2.splice(index2, 1);
                recursion(it[props2.keyField], it[props2.parentField]);
                ctx.emit("update:keys", keys2);
              } else {
                allData.value = allData.value.map((v2) => {
                  if (v2[props2.keyField] === it[props2.keyField]) {
                    v2.checked = false;
                  }
                  return v2;
                });
                childrenData(it, false);
                recursion(it[props2.keyField], it[props2.parentField]);
              }
              e.stopPropagation();
              e.preventDefault();
            }
          }, null)]), rows.length - 1 ? createVNode(Tooltip, null, slot) : null]);
        }
      } else {
        if (textValue.value) {
          return textValue.value;
        }
      }
      return createVNode("span", {
        "class": "w-text-placeholder w-no-select"
      }, [props2.placeholder]);
    });
    function renderTrigger() {
      const arrowBtn = createVNode(Icon$1, {
        "rotate": visible.value,
        "name": "w-icon-arrow-down"
      }, null);
      const closeBtn = !props2.disabled && props2.clearable && (props2.keys.length || props2.key.length) ? createVNode(Close, {
        "name": "w-icon-close-fill",
        "onClick": (e) => {
          ctx.emit("update:keys", []);
          ctx.emit("update:key", "");
          ctx.emit("update:rows", []);
          ctx.emit("update:row", []);
          e.stopPropagation();
        }
      }, null) : null;
      const triggerOptions = {
        class: ["w-choose2-trigger", {
          "w-choose2-trigger-disabled": props2.disabled,
          "w-choose2-trigger-block": props2.block
        }]
      };
      return createVNode("div", triggerOptions, [createVNode("div", null, [placeholderText.value]), createVNode("div", {
        "class": "w-choose2-icon"
      }, [closeBtn, arrowBtn])]);
    }
    function renderContent() {
      if (props2.disabled) {
        return null;
      }
      return createVNode(Virtual, {
        "class": "w-v-tree",
        "style": [{
          paddingRight: "10px",
          height: props2.listHeight,
          minWidth: "180px"
        }],
        "sourceData": allData.value,
        "itemHeight": props2.itemHeight
      }, innerTree);
    }
    return () => {
      const layerSlots = {
        trigger: renderTrigger,
        default: renderContent
      };
      return createVNode(Layer, mergeProps({
        "key": key.value
      }, layerOptions.value), layerSlots);
    };
  }
});
var index$1 = /* @__PURE__ */ (() => ".w-v-tree{list-style:none;padding-left:10px}.w-v-tree .w-v-icon-sort-down{margin-right:4px;color:#c7c0c0}.w-v-tree .unfold{display:inline-block;transform:rotate(-90deg)}.w-v-tree .w-icon-sort-down:hover{color:#666}.w-v-tree .w-tree-text{cursor:pointer}.w-v-tree .w-tree-text-active{color:var(--w-color-primary)}.w-v-tree .w-tree-loading{position:relative;display:inline-block;width:12px;height:12px;margin-right:4px;border:1px solid #000;border-top-color:#0003;border-right-color:#0003;border-bottom-color:#0003;border-radius:100%;-webkit-animation:circle infinite .75s linear;animation:circle infinite .75s linear}@-webkit-keyframes circle{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes circle{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@-webkit-keyframes loading{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes loading{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.w-choose2-trigger{min-height:var(--w-size);height:auto!important}.w-tag{display:inline-flex;align-items:center;max-width:100%;margin:2px 0 2px 6px;text-overflow:ellipsis;color:#909399;background:#f0f2f5;height:24px;padding:0 9px;font-size:12px;line-height:1;border-width:1px;border-style:solid;border-radius:4px;box-sizing:border-box;white-space:nowrap;border-color:transparent}.w-tag-tip{max-width:280px;max-height:200px}.w-tag-tip>div{width:100%;height:100%;overflow:auto}.w-layer-content{background-color:#fff;overflow:auto}\n")();
var components = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  Btn,
  Cascade,
  Checkbox,
  CheckboxGroup: CheckBoxGroup,
  Choose,
  ChooseItem,
  Choose2,
  Close,
  Color: ColorPicker,
  Confirm: index$m,
  Date: DatePicker,
  Drawer,
  Empty,
  Fallback,
  Form,
  FormItem,
  Icon: Icon$1,
  Layer,
  List,
  Loading,
  Mask,
  Match,
  Notice: index$f,
  Number: Num,
  Pagination,
  Popup,
  Radio,
  RadioGroup,
  Sheet,
  SlideDown,
  Slider,
  Switch,
  Time: TimePicker,
  Toggle,
  Tooltip,
  Tree,
  Trigger,
  Virtual,
  Write,
  Steps,
  Step,
  BtnGroup,
  SelectTree: VTree
});
function useChildComponentsCollector() {
  const currentInstance = getCurrentInstance();
  computed(() => {
    if (currentInstance == null ? void 0 : currentInstance.uid) {
      return Symbol(currentInstance.uid);
    }
  });
  const container = ref(/* @__PURE__ */ new Map());
  function collector(ins) {
    if (ins !== null) {
      const _uid = Symbol(ins.uid);
      container.value.set(_uid, ins);
    }
  }
  function remove() {
  }
  onMounted(() => {
    collector(currentInstance);
  });
  onUnmounted(remove);
  return {
    container,
    collector
  };
}
function useComponentClass() {
}
function useDrag(options) {
}
function useParentNode(elem) {
  const parentNode = ref();
  const { el } = useElement(elem);
  function getPNode() {
    let _node;
    const _el = el.value;
    if (_el === void 0) {
      console.warn("\u83B7\u53D6\u7684\u8282\u70B9\u4E3Aundefined");
    } else {
      _node = _el.parentNode;
      const position = getStyle(_node, "position");
      if (position === "static") {
        _node.style.position = "relative";
      }
      parentNode.value = _node;
    }
  }
  onMounted(getPNode);
  onUpdated(getPNode);
  return {
    parentNode
  };
}
const install = function(app) {
  const _components = Object.keys(components).map((key) => components[key]);
  _components.forEach((component) => {
    if (component.hasOwnProperty("name") && component.hasOwnProperty("setup")) {
      app.component(component.name, component);
    }
  });
  const directives = _directives;
  for (const name in directives) {
    app.directive(name, directives[name]);
  }
};
var index = {
  install
};
export { Btn, BtnGroup, Cascade, Checkbox, CheckBoxGroup as CheckboxGroup, Choose, Choose2, ChooseItem, Close, ColorPicker as Color, index$m as Confirm, DatePicker as Date, Drawer, Empty, Fallback, Form, FormItem, Icon$1 as Icon, Layer, List, Loading, Mask, Match, index$f as Notice, Num as Number, Pagination, Popup, Radio, RadioGroup, VTree as SelectTree, Sheet, SlideDown, Slider, Step, Steps, Switch, TimePicker as Time, Toggle, Tooltip, Tree, Trigger, Virtual, Write, index as default, useBoundingClientRect, useChildComponentsCollector, useComponentClass, useCount, useDate, useDelay, useDrag, useElement, useEvent, useGlobalZIndex, useMouse, useMousePositionInElement, useParentNode, useRequest, useScroll, useSearch, useSlot, useTabIndex };
